var fr = Object.defineProperty;
var Cr = (t, e, n) => e in t ? fr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var i = (t, e, n) => Cr(t, typeof e != "symbol" ? e + "" : e, n);
var lt = function(t, e) {
  return lt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var s in r) Object.prototype.hasOwnProperty.call(r, s) && (n[s] = r[s]);
  }, lt(t, e);
};
function K(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  lt(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var b = function() {
  return b = Object.assign || function(e) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, b.apply(this, arguments);
};
function dt(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, r = Object.getOwnPropertySymbols(t); s < r.length; s++)
      e.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[s]) && (n[r[s]] = t[r[s]]);
  return n;
}
function k(t, e, n, r) {
  function s(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function l(d) {
      try {
        c(r.next(d));
      } catch (h) {
        a(h);
      }
    }
    function u(d) {
      try {
        c(r.throw(d));
      } catch (h) {
        a(h);
      }
    }
    function c(d) {
      d.done ? o(d.value) : s(d.value).then(l, u);
    }
    c((r = r.apply(t, e || [])).next());
  });
}
function m(t, e) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, s, o, a;
  return a = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function l(c) {
    return function(d) {
      return u([c, d]);
    };
  }
  function u(c) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (n = 0)), n; ) try {
      if (r = 1, s && (o = c[0] & 2 ? s.return : c[0] ? s.throw || ((o = s.return) && o.call(s), 0) : s.next) && !(o = o.call(s, c[1])).done) return o;
      switch (s = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return n.label++, { value: c[1], done: !1 };
        case 5:
          n.label++, s = c[1], c = [0];
          continue;
        case 7:
          c = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            n = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            n.label = c[1];
            break;
          }
          if (c[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = c;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(c);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      c = e.call(t, n);
    } catch (d) {
      c = [6, d], s = 0;
    } finally {
      r = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function H(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function R(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), s, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(s = r.next()).done; ) o.push(s.value);
  } catch (l) {
    a = { error: l };
  } finally {
    try {
      s && !s.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}
function x(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, s = e.length, o; r < s; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function he(t) {
  return this instanceof he ? (this.v = t, this) : new he(t);
}
function yr(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), s, o = [];
  return s = {}, a("next"), a("throw"), a("return"), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function a(p) {
    r[p] && (s[p] = function(C) {
      return new Promise(function(y, _) {
        o.push([p, C, y, _]) > 1 || l(p, C);
      });
    });
  }
  function l(p, C) {
    try {
      u(r[p](C));
    } catch (y) {
      h(o[0][3], y);
    }
  }
  function u(p) {
    p.value instanceof he ? Promise.resolve(p.value.v).then(c, d) : h(o[0][2], p);
  }
  function c(p) {
    l("next", p);
  }
  function d(p) {
    l("throw", p);
  }
  function h(p, C) {
    p(C), o.shift(), o.length && l(o[0][0], o[0][1]);
  }
}
function mr(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof H == "function" ? H(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = t[o] && function(a) {
      return new Promise(function(l, u) {
        a = t[o](a), s(l, u, a.done, a.value);
      });
    };
  }
  function s(o, a, l, u) {
    Promise.resolve(u).then(function(c) {
      o({ value: c, done: l });
    }, a);
  }
}
var kr = "Event tracked successfully", wr = "Unexpected error occurred", _r = "Event rejected due to exceeded retry count", Sr = "Event skipped due to optOut config", br = "Event rejected due to missing API key", Ar = "Invalid API key", Ir = "Client not initialized", L;
(function(t) {
  t.Unknown = "unknown", t.Skipped = "skipped", t.Success = "success", t.RateLimit = "rate_limit", t.PayloadTooLarge = "payload_too_large", t.Invalid = "invalid", t.Failed = "failed", t.Timeout = "Timeout", t.SystemError = "SystemError";
})(L || (L = {}));
var ve = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = L.Unknown), { event: t, code: e, message: n };
}, fe = function(t) {
  return t ? (
    // a random number from 0 to 15
    (t ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    t / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      fe
    )
  );
}, Tr = (
  /** @class */
  function() {
    function t(e) {
      this.client = e, this.queue = [], this.applying = !1, this.plugins = [];
    }
    return t.prototype.register = function(e, n) {
      var r, s;
      return k(this, void 0, void 0, function() {
        return m(this, function(o) {
          switch (o.label) {
            case 0:
              return this.plugins.some(function(a) {
                return a.name === e.name;
              }) ? (n.loggerProvider.warn("Plugin with name ".concat(e.name, " already exists, skipping registration")), [
                2
                /*return*/
              ]) : (e.name === void 0 && (e.name = fe(), n.loggerProvider.warn(`Plugin name is undefined. 
      Generating a random UUID for plugin name: `.concat(e.name, `. 
      Set a name for the plugin to prevent it from being added multiple times.`))), e.type = (r = e.type) !== null && r !== void 0 ? r : "enrichment", [4, (s = e.setup) === null || s === void 0 ? void 0 : s.call(e, n, this.client)]);
            case 1:
              return o.sent(), this.plugins.push(e), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.deregister = function(e, n) {
      var r;
      return k(this, void 0, void 0, function() {
        var s, o;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return s = this.plugins.findIndex(function(l) {
                return l.name === e;
              }), s === -1 ? (n.loggerProvider.warn("Plugin with name ".concat(e, " does not exist, skipping deregistration")), [
                2
                /*return*/
              ]) : (o = this.plugins[s], this.plugins.splice(s, 1), [4, (r = o.teardown) === null || r === void 0 ? void 0 : r.call(o)]);
            case 1:
              return a.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.reset = function(e) {
      this.applying = !1;
      var n = this.plugins;
      n.map(function(r) {
        var s;
        return (s = r.teardown) === null || s === void 0 ? void 0 : s.call(r);
      }), this.plugins = [], this.client = e;
    }, t.prototype.push = function(e) {
      var n = this;
      return new Promise(function(r) {
        n.queue.push([e, r]), n.scheduleApply(0);
      });
    }, t.prototype.scheduleApply = function(e) {
      var n = this;
      this.applying || (this.applying = !0, setTimeout(function() {
        n.apply(n.queue.shift()).then(function() {
          n.applying = !1, n.queue.length > 0 && n.scheduleApply(0);
        });
      }, e));
    }, t.prototype.apply = function(e) {
      return k(this, void 0, void 0, function() {
        var n, r, s, o, a, l, u, C, y, c, d, h, p, C, y, _, S, v, g, f, w, A;
        return m(this, function(I) {
          switch (I.label) {
            case 0:
              if (!e)
                return [
                  2
                  /*return*/
                ];
              n = R(e, 1), r = n[0], s = R(e, 2), o = s[1], a = this.plugins.filter(function(E) {
                return E.type === "before";
              }), I.label = 1;
            case 1:
              I.trys.push([1, 6, 7, 8]), l = H(a), u = l.next(), I.label = 2;
            case 2:
              return u.done ? [3, 5] : (C = u.value, C.execute ? [4, C.execute(b({}, r))] : [3, 4]);
            case 3:
              if (y = I.sent(), y === null)
                return o({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = y, I.label = 4;
            case 4:
              return u = l.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return c = I.sent(), g = { error: c }, [3, 8];
            case 7:
              try {
                u && !u.done && (f = l.return) && f.call(l);
              } finally {
                if (g) throw g.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              d = this.plugins.filter(function(E) {
                return E.type === "enrichment" || E.type === void 0;
              }), I.label = 9;
            case 9:
              I.trys.push([9, 14, 15, 16]), h = H(d), p = h.next(), I.label = 10;
            case 10:
              return p.done ? [3, 13] : (C = p.value, C.execute ? [4, C.execute(b({}, r))] : [3, 12]);
            case 11:
              if (y = I.sent(), y === null)
                return o({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = y, I.label = 12;
            case 12:
              return p = h.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return _ = I.sent(), w = { error: _ }, [3, 16];
            case 15:
              try {
                p && !p.done && (A = h.return) && A.call(h);
              } finally {
                if (w) throw w.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return S = this.plugins.filter(function(E) {
                return E.type === "destination";
              }), v = S.map(function(E) {
                var O = b({}, r);
                return E.execute(O).catch(function(P) {
                  return ve(O, 0, String(P));
                });
              }), Promise.all(v).then(function(E) {
                var O = R(E, 1), P = O[0], W = P || ve(r, 100, "Event not tracked, no destination plugins on the instance");
                o(W);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.flush = function() {
      return k(this, void 0, void 0, function() {
        var e, n, r, s = this;
        return m(this, function(o) {
          switch (o.label) {
            case 0:
              return e = this.queue, this.queue = [], [4, Promise.all(e.map(function(a) {
                return s.apply(a);
              }))];
            case 1:
              return o.sent(), n = this.plugins.filter(function(a) {
                return a.type === "destination";
              }), r = n.map(function(a) {
                return a.flush && a.flush();
              }), [4, Promise.all(r)];
            case 2:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), Et = "-", xe = "AMP", Er = "".concat(xe, "_unsent"), mn = "https://api2.amplitude.com/2/httpapi", Or = "https://api.eu.amplitude.com/2/httpapi", Pr = "https://api2.amplitude.com/batch", Rr = "https://api.eu.amplitude.com/batch", Mr = 1e3, pt = function(t) {
  if (Object.keys(t).length > Mr)
    return !1;
  for (var e in t) {
    var n = t[e];
    if (!kn(e, n))
      return !1;
  }
  return !0;
}, kn = function(t, e) {
  var n, r;
  if (typeof t != "string")
    return !1;
  if (Array.isArray(e)) {
    var s = !0;
    try {
      for (var o = H(e), a = o.next(); !a.done; a = o.next()) {
        var l = a.value;
        if (Array.isArray(l))
          return !1;
        if (typeof l == "object")
          s = s && pt(l);
        else if (!["number", "string"].includes(typeof l))
          return !1;
        if (!s)
          return !1;
      }
    } catch (u) {
      n = { error: u };
    } finally {
      try {
        a && !a.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
  } else {
    if (e == null)
      return !1;
    if (typeof e == "object")
      return pt(e);
    if (!["number", "string", "boolean"].includes(typeof e))
      return !1;
  }
  return !0;
}, ge = (
  /** @class */
  function() {
    function t() {
      this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
    }
    return t.prototype.getUserProperties = function() {
      return b({}, this._properties);
    }, t.prototype.set = function(e, n) {
      return this._safeSet(B.SET, e, n), this;
    }, t.prototype.setOnce = function(e, n) {
      return this._safeSet(B.SET_ONCE, e, n), this;
    }, t.prototype.append = function(e, n) {
      return this._safeSet(B.APPEND, e, n), this;
    }, t.prototype.prepend = function(e, n) {
      return this._safeSet(B.PREPEND, e, n), this;
    }, t.prototype.postInsert = function(e, n) {
      return this._safeSet(B.POSTINSERT, e, n), this;
    }, t.prototype.preInsert = function(e, n) {
      return this._safeSet(B.PREINSERT, e, n), this;
    }, t.prototype.remove = function(e, n) {
      return this._safeSet(B.REMOVE, e, n), this;
    }, t.prototype.add = function(e, n) {
      return this._safeSet(B.ADD, e, n), this;
    }, t.prototype.unset = function(e) {
      return this._safeSet(B.UNSET, e, Et), this;
    }, t.prototype.clearAll = function() {
      return this._properties = {}, this._properties[B.CLEAR_ALL] = Et, this;
    }, t.prototype._safeSet = function(e, n, r) {
      if (this._validate(e, n, r)) {
        var s = this._properties[e];
        return s === void 0 && (s = {}, this._properties[e] = s), s[n] = r, this._propertySet.add(n), !0;
      }
      return !1;
    }, t.prototype._validate = function(e, n, r) {
      return this._properties[B.CLEAR_ALL] !== void 0 || this._propertySet.has(n) ? !1 : e === B.ADD ? typeof r == "number" : e !== B.UNSET && e !== B.REMOVE ? kn(n, r) : !0;
    }, t;
  }()
), B;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.ADD = "$add", t.APPEND = "$append", t.PREPEND = "$prepend", t.REMOVE = "$remove", t.PREINSERT = "$preInsert", t.POSTINSERT = "$postInsert", t.UNSET = "$unset", t.CLEAR_ALL = "$clearAll";
})(B || (B = {}));
var ht;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.ADD = "$add", t.APPEND = "$append", t.PREPEND = "$prepend", t.REMOVE = "$remove", t.PREINSERT = "$preInsert", t.POSTINSERT = "$postInsert", t.UNSET = "$unset", t.CLEAR_ALL = "$clearAll";
})(ht || (ht = {}));
var ue;
(function(t) {
  t.IDENTIFY = "$identify", t.GROUP_IDENTIFY = "$groupidentify", t.REVENUE = "revenue_amount";
})(ue || (ue = {}));
var Fr = function(t, e, n) {
  var r = typeof t == "string" ? { event_type: t } : t;
  return b(b(b({}, r), n), e && { event_properties: e });
}, wn = function(t, e) {
  var n = b(b({}, e), { event_type: ue.IDENTIFY, user_properties: t.getUserProperties() });
  return n;
}, Dr = function(t, e, n, r) {
  var s, o = b(b({}, r), { event_type: ue.GROUP_IDENTIFY, group_properties: n.getUserProperties(), groups: (s = {}, s[t] = e, s) });
  return o;
}, Ur = function(t, e, n) {
  var r, s = new ge();
  s.set(t, e);
  var o = b(b({}, n), { event_type: ue.IDENTIFY, user_properties: s.getUserProperties(), groups: (r = {}, r[t] = e, r) });
  return o;
}, Lr = function(t, e) {
  return b(b({}, e), { event_type: ue.REVENUE, event_properties: t.getEventProperties() });
}, q = function(t) {
  return {
    promise: t || Promise.resolve()
  };
}, Nr = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = "$default"), this.initializing = !1, this.isReady = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new Tr(this), this.name = e;
    }
    return t.prototype._init = function(e) {
      return k(this, void 0, void 0, function() {
        return m(this, function(n) {
          switch (n.label) {
            case 0:
              return this.config = e, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
            case 1:
              return n.sent(), this.isReady = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.runQueuedFunctions = function(e) {
      return k(this, void 0, void 0, function() {
        var n, r, s, o, a, l, u, c;
        return m(this, function(d) {
          switch (d.label) {
            case 0:
              n = this[e], this[e] = [], d.label = 1;
            case 1:
              d.trys.push([1, 8, 9, 10]), r = H(n), s = r.next(), d.label = 2;
            case 2:
              return s.done ? [3, 7] : (o = s.value, a = o(), a && "promise" in a ? [4, a.promise] : [3, 4]);
            case 3:
              return d.sent(), [3, 6];
            case 4:
              return [4, a];
            case 5:
              d.sent(), d.label = 6;
            case 6:
              return s = r.next(), [3, 2];
            case 7:
              return [3, 10];
            case 8:
              return l = d.sent(), u = { error: l }, [3, 10];
            case 9:
              try {
                s && !s.done && (c = r.return) && c.call(r);
              } finally {
                if (u) throw u.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 10:
              return this[e].length ? [4, this.runQueuedFunctions(e)] : [3, 12];
            case 11:
              d.sent(), d.label = 12;
            case 12:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.track = function(e, n, r) {
      var s = Fr(e, n, r);
      return q(this.dispatch(s));
    }, t.prototype.identify = function(e, n) {
      var r = wn(e, n);
      return q(this.dispatch(r));
    }, t.prototype.groupIdentify = function(e, n, r, s) {
      var o = Dr(e, n, r, s);
      return q(this.dispatch(o));
    }, t.prototype.setGroup = function(e, n, r) {
      var s = Ur(e, n, r);
      return q(this.dispatch(s));
    }, t.prototype.revenue = function(e, n) {
      var r = Lr(e, n);
      return q(this.dispatch(r));
    }, t.prototype.add = function(e) {
      return this.isReady ? this._addPlugin(e) : (this.q.push(this._addPlugin.bind(this, e)), q());
    }, t.prototype._addPlugin = function(e) {
      return q(this.timeline.register(e, this.config));
    }, t.prototype.remove = function(e) {
      return this.isReady ? this._removePlugin(e) : (this.q.push(this._removePlugin.bind(this, e)), q());
    }, t.prototype._removePlugin = function(e) {
      return q(this.timeline.deregister(e, this.config));
    }, t.prototype.dispatchWithCallback = function(e, n) {
      if (!this.isReady)
        return n(ve(e, 0, Ir));
      this.process(e).then(n);
    }, t.prototype.dispatch = function(e) {
      return k(this, void 0, void 0, function() {
        var n = this;
        return m(this, function(r) {
          return this.isReady ? [2, this.process(e)] : [2, new Promise(function(s) {
            n.dispatchQ.push(n.dispatchWithCallback.bind(n, e, s));
          })];
        });
      });
    }, t.prototype.process = function(e) {
      return k(this, void 0, void 0, function() {
        var s, n, r, s;
        return m(this, function(o) {
          switch (o.label) {
            case 0:
              return o.trys.push([0, 2, , 3]), this.config.optOut ? [2, ve(e, 0, Sr)] : [4, this.timeline.push(e)];
            case 1:
              return s = o.sent(), s.code === 200 ? this.config.loggerProvider.log(s.message) : s.code === 100 ? this.config.loggerProvider.warn(s.message) : this.config.loggerProvider.error(s.message), [2, s];
            case 2:
              return n = o.sent(), r = String(n), this.config.loggerProvider.error(r), s = ve(e, 0, r), [2, s];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setOptOut = function(e) {
      if (!this.isReady) {
        this.q.push(this._setOptOut.bind(this, !!e));
        return;
      }
      this._setOptOut(e);
    }, t.prototype._setOptOut = function(e) {
      this.config.optOut = !!e;
    }, t.prototype.flush = function() {
      return q(this.timeline.flush());
    }, t;
  }()
), Vr = (
  /** @class */
  function() {
    function t() {
      this.productId = "", this.quantity = 1, this.price = 0;
    }
    return t.prototype.setProductId = function(e) {
      return this.productId = e, this;
    }, t.prototype.setQuantity = function(e) {
      return e > 0 && (this.quantity = e), this;
    }, t.prototype.setPrice = function(e) {
      return this.price = e, this;
    }, t.prototype.setRevenueType = function(e) {
      return this.revenueType = e, this;
    }, t.prototype.setCurrency = function(e) {
      return this.currency = e, this;
    }, t.prototype.setRevenue = function(e) {
      return this.revenue = e, this;
    }, t.prototype.setReceipt = function(e) {
      return this.receipt = e, this;
    }, t.prototype.setReceiptSig = function(e) {
      return this.receiptSig = e, this;
    }, t.prototype.setEventProperties = function(e) {
      return pt(e) && (this.properties = e), this;
    }, t.prototype.getEventProperties = function() {
      var e = this.properties ? b({}, this.properties) : {};
      return e[Y.REVENUE_PRODUCT_ID] = this.productId, e[Y.REVENUE_QUANTITY] = this.quantity, e[Y.REVENUE_PRICE] = this.price, e[Y.REVENUE_TYPE] = this.revenueType, e[Y.REVENUE_CURRENCY] = this.currency, e[Y.REVENUE] = this.revenue, e[Y.RECEIPT] = this.receipt, e[Y.RECEIPT_SIG] = this.receiptSig, e;
    }, t;
  }()
), Y;
(function(t) {
  t.REVENUE_PRODUCT_ID = "$productId", t.REVENUE_QUANTITY = "$quantity", t.REVENUE_PRICE = "$price", t.REVENUE_TYPE = "$revenueType", t.REVENUE_CURRENCY = "$currency", t.REVENUE = "$revenue", t.RECEIPT = "$receipt", t.RECEIPT_SIG = "$receiptSig";
})(Y || (Y = {}));
var Br = function(t, e) {
  var n = Math.max(e, 1);
  return t.reduce(function(r, s, o) {
    var a = Math.floor(o / n);
    return r[a] || (r[a] = []), r[a].push(s), r;
  }, []);
}, z;
(function(t) {
  t[t.None = 0] = "None", t[t.Error = 1] = "Error", t[t.Warn = 2] = "Warn", t[t.Verbose = 3] = "Verbose", t[t.Debug = 4] = "Debug";
})(z || (z = {}));
var Ie = "Amplitude Logger ", _n = (
  /** @class */
  function() {
    function t() {
      this.logLevel = z.None;
    }
    return t.prototype.disable = function() {
      this.logLevel = z.None;
    }, t.prototype.enable = function(e) {
      e === void 0 && (e = z.Warn), this.logLevel = e;
    }, t.prototype.log = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < z.Verbose || console.log("".concat(Ie, "[Log]: ").concat(e.join(" ")));
    }, t.prototype.warn = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < z.Warn || console.warn("".concat(Ie, "[Warn]: ").concat(e.join(" ")));
    }, t.prototype.error = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < z.Error || console.error("".concat(Ie, "[Error]: ").concat(e.join(" ")));
    }, t.prototype.debug = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this.logLevel < z.Debug || console.log("".concat(Ie, "[Debug]: ").concat(e.join(" ")));
    }, t;
  }()
), Re = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: z.Warn,
    loggerProvider: new _n(),
    offline: !1,
    optOut: !1,
    serverUrl: mn,
    serverZone: "US",
    useBatch: !1
  };
}, Hr = (
  /** @class */
  function() {
    function t(e) {
      var n, r, s, o;
      this._optOut = !1;
      var a = Re();
      this.apiKey = e.apiKey, this.flushIntervalMillis = (n = e.flushIntervalMillis) !== null && n !== void 0 ? n : a.flushIntervalMillis, this.flushMaxRetries = e.flushMaxRetries || a.flushMaxRetries, this.flushQueueSize = e.flushQueueSize || a.flushQueueSize, this.instanceName = e.instanceName || a.instanceName, this.loggerProvider = e.loggerProvider || a.loggerProvider, this.logLevel = (r = e.logLevel) !== null && r !== void 0 ? r : a.logLevel, this.minIdLength = e.minIdLength, this.plan = e.plan, this.ingestionMetadata = e.ingestionMetadata, this.offline = e.offline !== void 0 ? e.offline : a.offline, this.optOut = (s = e.optOut) !== null && s !== void 0 ? s : a.optOut, this.serverUrl = e.serverUrl, this.serverZone = e.serverZone || a.serverZone, this.storageProvider = e.storageProvider, this.transportProvider = e.transportProvider, this.useBatch = (o = e.useBatch) !== null && o !== void 0 ? o : a.useBatch, this.loggerProvider.enable(this.logLevel);
      var l = Sn(e.serverUrl, e.serverZone, e.useBatch);
      this.serverZone = l.serverZone, this.serverUrl = l.serverUrl;
    }
    return Object.defineProperty(t.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(e) {
        this._optOut = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
), Wr = function(t, e) {
  return t === "EU" ? e ? Rr : Or : e ? Pr : mn;
}, Sn = function(t, e, n) {
  if (t === void 0 && (t = ""), e === void 0 && (e = Re().serverZone), n === void 0 && (n = Re().useBatch), t)
    return { serverUrl: t, serverZone: void 0 };
  var r = ["US", "EU"].includes(e) ? e : Re().serverZone;
  return {
    serverZone: r,
    serverUrl: Wr(r, n)
  };
}, bn = (
  /** @class */
  function() {
    function t() {
      this.sdk = {
        metrics: {
          histogram: {}
        }
      };
    }
    return t.prototype.recordHistogram = function(e, n) {
      this.sdk.metrics.histogram[e] = n;
    }, t;
  }()
);
function xr(t) {
  return t instanceof Error ? t.message : String(t);
}
function Te(t) {
  var e = "";
  try {
    "body" in t && (e = JSON.stringify(t.body, null, 2));
  } catch {
  }
  return e;
}
var Qr = (
  /** @class */
  function() {
    function t() {
      this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduleId = null, this.scheduledTimeout = 0, this.flushId = null, this.queue = [];
    }
    return t.prototype.setup = function(e) {
      var n;
      return k(this, void 0, void 0, function() {
        var r, s = this;
        return m(this, function(o) {
          switch (o.label) {
            case 0:
              return this.config = e, this.storageKey = "".concat(Er, "_").concat(this.config.apiKey.substring(0, 10)), [4, (n = this.config.storageProvider) === null || n === void 0 ? void 0 : n.get(this.storageKey)];
            case 1:
              return r = o.sent(), r && r.length > 0 && Promise.all(r.map(function(a) {
                return s.execute(a);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, t.prototype.execute = function(e) {
      var n = this;
      return e.insert_id || (e.insert_id = fe()), new Promise(function(r) {
        var s = {
          event: e,
          attempts: 0,
          callback: function(o) {
            return r(o);
          },
          timeout: 0
        };
        n.queue.push(s), n.schedule(n.config.flushIntervalMillis), n.saveEvents();
      });
    }, t.prototype.removeEventsExceedFlushMaxRetries = function(e) {
      var n = this;
      return e.filter(function(r) {
        return r.attempts += 1, r.attempts < n.config.flushMaxRetries ? !0 : (n.fulfillRequest([r], 500, _r), !1);
      });
    }, t.prototype.scheduleEvents = function(e) {
      var n = this;
      e.forEach(function(r) {
        n.schedule(r.timeout === 0 ? n.config.flushIntervalMillis : r.timeout);
      });
    }, t.prototype.schedule = function(e) {
      var n = this;
      if (!this.config.offline && (this.scheduleId === null || this.scheduleId && e > this.scheduledTimeout)) {
        this.scheduleId && clearTimeout(this.scheduleId), this.scheduledTimeout = e, this.scheduleId = setTimeout(function() {
          n.queue = n.queue.map(function(r) {
            return r.timeout = 0, r;
          }), n.flush(!0);
        }, e);
        return;
      }
    }, t.prototype.resetSchedule = function() {
      this.scheduleId = null, this.scheduledTimeout = 0;
    }, t.prototype.flush = function(e) {
      return e === void 0 && (e = !1), k(this, void 0, void 0, function() {
        var n, r, s, o = this;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return this.config.offline ? (this.resetSchedule(), this.config.loggerProvider.debug("Skipping flush while offline."), [
                2
                /*return*/
              ]) : this.flushId ? (this.resetSchedule(), this.config.loggerProvider.debug("Skipping flush because previous flush has not resolved."), [
                2
                /*return*/
              ]) : (this.flushId = this.scheduleId, this.resetSchedule(), n = [], r = [], this.queue.forEach(function(l) {
                return l.timeout === 0 ? n.push(l) : r.push(l);
              }), s = Br(n, this.config.flushQueueSize), [4, s.reduce(function(l, u) {
                return k(o, void 0, void 0, function() {
                  return m(this, function(c) {
                    switch (c.label) {
                      case 0:
                        return [4, l];
                      case 1:
                        return c.sent(), [4, this.send(u, e)];
                      case 2:
                        return [2, c.sent()];
                    }
                  });
                });
              }, Promise.resolve())]);
            case 1:
              return a.sent(), this.flushId = null, this.scheduleEvents(this.queue), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.send = function(e, n) {
      return n === void 0 && (n = !0), k(this, void 0, void 0, function() {
        var r, s, o, a, l;
        return m(this, function(u) {
          switch (u.label) {
            case 0:
              if (!this.config.apiKey)
                return [2, this.fulfillRequest(e, 400, br)];
              r = {
                api_key: this.config.apiKey,
                events: e.map(function(c) {
                  var d = c.event;
                  d.extra;
                  var h = dt(d, ["extra"]);
                  return h;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
                request_metadata: this.config.requestMetadata
              }, this.config.requestMetadata = new bn(), u.label = 1;
            case 1:
              return u.trys.push([1, 3, , 4]), s = Sn(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(s, r)];
            case 2:
              return o = u.sent(), o === null ? (this.fulfillRequest(e, 0, wr), [
                2
                /*return*/
              ]) : n ? (this.handleResponse(o, e), [3, 4]) : ("body" in o ? this.fulfillRequest(e, o.statusCode, "".concat(o.status, ": ").concat(Te(o))) : this.fulfillRequest(e, o.statusCode, o.status), [
                2
                /*return*/
              ]);
            case 3:
              return a = u.sent(), l = xr(a), this.config.loggerProvider.error(l), this.handleResponse({ status: L.Failed, statusCode: 0 }, e), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.handleResponse = function(e, n) {
      var r = e.status;
      switch (r) {
        case L.Success: {
          this.handleSuccessResponse(e, n);
          break;
        }
        case L.Invalid: {
          this.handleInvalidResponse(e, n);
          break;
        }
        case L.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(e, n);
          break;
        }
        case L.RateLimit: {
          this.handleRateLimitResponse(e, n);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(r, "' provided for ").concat(n.length, ' events"}')), this.handleOtherResponse(n);
          break;
        }
      }
    }, t.prototype.handleSuccessResponse = function(e, n) {
      this.fulfillRequest(n, e.statusCode, kr);
    }, t.prototype.handleInvalidResponse = function(e, n) {
      var r = this;
      if (e.body.missingField || e.body.error.startsWith(Ar)) {
        this.fulfillRequest(n, e.statusCode, e.body.error);
        return;
      }
      var s = x(x(x(x([], R(Object.values(e.body.eventsWithInvalidFields)), !1), R(Object.values(e.body.eventsWithMissingFields)), !1), R(Object.values(e.body.eventsWithInvalidIdLengths)), !1), R(e.body.silencedEvents), !1).flat(), o = new Set(s), a = n.filter(function(u, c) {
        if (o.has(c)) {
          r.fulfillRequest([u], e.statusCode, e.body.error);
          return;
        }
        return !0;
      });
      a.length > 0 && this.config.loggerProvider.warn(Te(e));
      var l = this.removeEventsExceedFlushMaxRetries(a);
      this.scheduleEvents(l);
    }, t.prototype.handlePayloadTooLargeResponse = function(e, n) {
      if (n.length === 1) {
        this.fulfillRequest(n, e.statusCode, e.body.error);
        return;
      }
      this.config.loggerProvider.warn(Te(e)), this.config.flushQueueSize /= 2;
      var r = this.removeEventsExceedFlushMaxRetries(n);
      this.scheduleEvents(r);
    }, t.prototype.handleRateLimitResponse = function(e, n) {
      var r = this, s = Object.keys(e.body.exceededDailyQuotaUsers), o = Object.keys(e.body.exceededDailyQuotaDevices), a = e.body.throttledEvents, l = new Set(s), u = new Set(o), c = new Set(a), d = n.filter(function(p, C) {
        if (p.event.user_id && l.has(p.event.user_id) || p.event.device_id && u.has(p.event.device_id)) {
          r.fulfillRequest([p], e.statusCode, e.body.error);
          return;
        }
        return c.has(C) && (p.timeout = r.throttleTimeout), !0;
      });
      d.length > 0 && this.config.loggerProvider.warn(Te(e));
      var h = this.removeEventsExceedFlushMaxRetries(d);
      this.scheduleEvents(h);
    }, t.prototype.handleOtherResponse = function(e) {
      var n = this, r = e.map(function(o) {
        return o.timeout = o.attempts * n.retryTimeout, o;
      }), s = this.removeEventsExceedFlushMaxRetries(r);
      this.scheduleEvents(s);
    }, t.prototype.fulfillRequest = function(e, n, r) {
      this.removeEvents(e), e.forEach(function(s) {
        return s.callback(ve(s.event, n, r));
      });
    }, t.prototype.saveEvents = function() {
      if (this.config.storageProvider) {
        var e = this.queue.map(function(n) {
          return n.event;
        });
        this.config.storageProvider.set(this.storageKey, e);
      }
    }, t.prototype.removeEvents = function(e) {
      this.queue = this.queue.filter(function(n) {
        return !e.some(function(r) {
          return r.event.insert_id === n.event.insert_id;
        });
      }), this.saveEvents();
    }, t;
  }()
), Kr = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: Gr(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, t;
  }()
), Gr = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, qr = (
  /** @class */
  function() {
    function t() {
      this.queue = [];
    }
    return t.prototype.logEvent = function(e) {
      this.receiver ? this.receiver(e) : this.queue.length < 512 && this.queue.push(e);
    }, t.prototype.setEventReceiver = function(e) {
      this.receiver = e, this.queue.length > 0 && (this.queue.forEach(function(n) {
        e(n);
      }), this.queue = []);
    }, t;
  }()
), re = function() {
  return re = Object.assign || function(e) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, re.apply(this, arguments);
}, Me = function(t, e) {
  var n = ["string", "number", "boolean", "undefined"], r = typeof t, s = typeof e;
  if (r !== s)
    return !1;
  for (var o = 0, a = n; o < a.length; o++) {
    var l = a[o];
    if (l === r)
      return t === e;
  }
  if (t == null && e == null)
    return !0;
  if (t == null || e == null || t.length !== e.length)
    return !1;
  var u = Array.isArray(t), c = Array.isArray(e);
  if (u !== c)
    return !1;
  if (u && c) {
    for (var d = 0; d < t.length; d++)
      if (!Me(t[d], e[d]))
        return !1;
  } else {
    var h = Object.keys(t).sort(), p = Object.keys(e).sort();
    if (!Me(h, p))
      return !1;
    var C = !0;
    return Object.keys(t).forEach(function(y) {
      Me(t[y], e[y]) || (C = !1);
    }), C;
  }
  return !0;
}, zr = "$set", $r = "$unset", jr = "$clearAll";
Object.entries || (Object.entries = function(t) {
  for (var e = Object.keys(t), n = e.length, r = new Array(n); n--; )
    r[n] = [e[n], t[e[n]]];
  return r;
});
var Jr = (
  /** @class */
  function() {
    function t() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return t.prototype.editIdentity = function() {
      var e = this, n = re({}, this.identity.userProperties), r = re(re({}, this.identity), { userProperties: n });
      return {
        setUserId: function(s) {
          return r.userId = s, this;
        },
        setDeviceId: function(s) {
          return r.deviceId = s, this;
        },
        setUserProperties: function(s) {
          return r.userProperties = s, this;
        },
        setOptOut: function(s) {
          return r.optOut = s, this;
        },
        updateUserProperties: function(s) {
          for (var o = r.userProperties || {}, a = 0, l = Object.entries(s); a < l.length; a++) {
            var u = l[a], c = u[0], d = u[1];
            switch (c) {
              case zr:
                for (var h = 0, p = Object.entries(d); h < p.length; h++) {
                  var C = p[h], y = C[0], _ = C[1];
                  o[y] = _;
                }
                break;
              case $r:
                for (var S = 0, v = Object.keys(d); S < v.length; S++) {
                  var y = v[S];
                  delete o[y];
                }
                break;
              case jr:
                o = {};
                break;
            }
          }
          return r.userProperties = o, this;
        },
        commit: function() {
          return e.setIdentity(r), this;
        }
      };
    }, t.prototype.getIdentity = function() {
      return re({}, this.identity);
    }, t.prototype.setIdentity = function(e) {
      var n = re({}, this.identity);
      this.identity = re({}, e), Me(n, this.identity) || this.listeners.forEach(function(r) {
        r(e);
      });
    }, t.prototype.addIdentityListener = function(e) {
      this.listeners.add(e);
    }, t.prototype.removeIdentityListener = function(e) {
      this.listeners.delete(e);
    }, t;
  }()
), me = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : self, Yr = (
  /** @class */
  function() {
    function t() {
      this.identityStore = new Jr(), this.eventBridge = new qr(), this.applicationContextProvider = new Kr();
    }
    return t.getInstance = function(e) {
      return me.analyticsConnectorInstances || (me.analyticsConnectorInstances = {}), me.analyticsConnectorInstances[e] || (me.analyticsConnectorInstances[e] = new t()), me.analyticsConnectorInstances[e];
    }, t;
  }()
), _e = function(t) {
  return t === void 0 && (t = "$default_instance"), Yr.getInstance(t);
}, Xr = function(t, e) {
  _e(e).identityStore.editIdentity().setUserId(t).commit();
}, Zr = function(t, e) {
  _e(e).identityStore.editIdentity().setDeviceId(t).commit();
}, ei = (
  /** @class */
  function() {
    function t() {
      this.name = "identity", this.type = "before", this.identityStore = _e().identityStore;
    }
    return t.prototype.execute = function(e) {
      return k(this, void 0, void 0, function() {
        var n;
        return m(this, function(r) {
          return n = e.user_properties, n && this.identityStore.editIdentity().updateUserProperties(n).commit(), [2, e];
        });
      });
    }, t.prototype.setup = function(e) {
      return k(this, void 0, void 0, function() {
        return m(this, function(n) {
          return e.instanceName && (this.identityStore = _e(e.instanceName).identityStore), [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), ee = function() {
  var t = "ampIntegrationContext";
  if (typeof globalThis < "u" && typeof globalThis[t] < "u")
    return globalThis[t];
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global < "u")
    return global;
}, An = function(t, e) {
  e === void 0 && (e = Date.now());
  var n = Date.now(), r = n - e;
  return r > t;
}, In = function(t, e, n) {
  return e === void 0 && (e = ""), n === void 0 && (n = 10), [xe, e, t.substring(0, n)].filter(Boolean).join("_");
}, ti = function(t) {
  return "".concat(xe.toLowerCase(), "_").concat(t.substring(0, 6));
}, ni = function() {
  var t, e, n, r;
  if (typeof navigator > "u")
    return "";
  var s = navigator.userLanguage;
  return (r = (n = (e = (t = navigator.languages) === null || t === void 0 ? void 0 : t[0]) !== null && e !== void 0 ? e : navigator.language) !== null && n !== void 0 ? n : s) !== null && r !== void 0 ? r : "";
}, Le = function() {
  var t, e = ee();
  if (!(!((t = e == null ? void 0 : e.location) === null || t === void 0) && t.search))
    return {};
  var n = e.location.search.substring(1).split("&").filter(Boolean), r = n.reduce(function(s, o) {
    var a = o.split("=", 2), l = Ot(a[0]), u = Ot(a[1]);
    return u && (s[l] = u), s;
  }, {});
  return r;
}, Ot = function(t) {
  t === void 0 && (t = "");
  try {
    return decodeURIComponent(t);
  } catch {
    return "";
  }
}, ri = function(t) {
  var e = new Error().stack || "";
  return e.split(`
`).slice(2 + t).map(function(n) {
    return n.trim();
  });
}, F = function(t) {
  return function() {
    var e = b({}, t.config), n = e.loggerProvider, r = e.logLevel;
    return {
      logger: n,
      logLevel: r
    };
  };
}, ii = function(t, e) {
  var n, r;
  e = e.replace(/\[(\w+)\]/g, ".$1"), e = e.replace(/^\./, "");
  try {
    for (var s = H(e.split(".")), o = s.next(); !o.done; o = s.next()) {
      var a = o.value;
      if (a in t)
        t = t[a];
      else
        return;
    }
  } catch (l) {
    n = { error: l };
  } finally {
    try {
      o && !o.done && (r = s.return) && r.call(s);
    } finally {
      if (n) throw n.error;
    }
  }
  return t;
}, D = function(t, e) {
  return function() {
    var n, r, s = {};
    try {
      for (var o = H(e), a = o.next(); !a.done; a = o.next()) {
        var l = a.value;
        s[l] = ii(t, l);
      }
    } catch (u) {
      n = { error: u };
    } finally {
      try {
        a && !a.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
    return s;
  };
}, U = function(t, e, n, r, s) {
  return s === void 0 && (s = null), function() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    var l = n(), u = l.logger, c = l.logLevel;
    if (c && c < z.Debug || !c || !u)
      return t.apply(s, o);
    var d = {
      type: "invoke public method",
      name: e,
      args: o,
      stacktrace: ri(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    r && d.states && (d.states.before = r());
    var h = t.apply(s, o);
    return h && h.promise ? h.promise.then(function() {
      r && d.states && (d.states.after = r()), d.time && (d.time.end = (/* @__PURE__ */ new Date()).toISOString()), u.debug(JSON.stringify(d, null, 2));
    }) : (r && d.states && (d.states.after = r()), d.time && (d.time.end = (/* @__PURE__ */ new Date()).toISOString()), u.debug(JSON.stringify(d, null, 2))), h;
  };
}, yt = (
  /** @class */
  function() {
    function t() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    return t.prototype.isEnabled = function() {
      return k(this, void 0, void 0, function() {
        return m(this, function(e) {
          return [2, !0];
        });
      });
    }, t.prototype.get = function(e) {
      return k(this, void 0, void 0, function() {
        return m(this, function(n) {
          return [2, this.memoryStorage.get(e)];
        });
      });
    }, t.prototype.getRaw = function(e) {
      return k(this, void 0, void 0, function() {
        var n;
        return m(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.get(e)];
            case 1:
              return n = r.sent(), [2, n ? JSON.stringify(n) : void 0];
          }
        });
      });
    }, t.prototype.set = function(e, n) {
      return k(this, void 0, void 0, function() {
        return m(this, function(r) {
          return this.memoryStorage.set(e, n), [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.remove = function(e) {
      return k(this, void 0, void 0, function() {
        return m(this, function(n) {
          return this.memoryStorage.delete(e), [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.reset = function() {
      return k(this, void 0, void 0, function() {
        return m(this, function(e) {
          return this.memoryStorage.clear(), [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), vt = (
  /** @class */
  function() {
    function t(e) {
      this.options = b({}, e);
    }
    return t.prototype.isEnabled = function() {
      return k(this, void 0, void 0, function() {
        var e, n, r;
        return m(this, function(s) {
          switch (s.label) {
            case 0:
              if (!ee())
                return [2, !1];
              t.testValue = String(Date.now()), e = new t(this.options), n = "AMP_TEST", s.label = 1;
            case 1:
              return s.trys.push([1, 4, 5, 7]), [4, e.set(n, t.testValue)];
            case 2:
              return s.sent(), [4, e.get(n)];
            case 3:
              return r = s.sent(), [2, r === t.testValue];
            case 4:
              return s.sent(), [2, !1];
            case 5:
              return [4, e.remove(n)];
            case 6:
              return s.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.get = function(e) {
      var n;
      return k(this, void 0, void 0, function() {
        var r, s;
        return m(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.getRaw(e)];
            case 1:
              if (r = o.sent(), !r)
                return [2, void 0];
              try {
                return s = (n = si(r)) !== null && n !== void 0 ? n : oi(r), s === void 0 ? (console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(e, ", value: ").concat(r)), [2, void 0]) : [2, JSON.parse(s)];
              } catch {
                return console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(e, ", value: ").concat(r)), [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getRaw = function(e) {
      var n, r;
      return k(this, void 0, void 0, function() {
        var s, o, a;
        return m(this, function(l) {
          return s = ee(), o = (r = (n = s == null ? void 0 : s.document) === null || n === void 0 ? void 0 : n.cookie.split("; ")) !== null && r !== void 0 ? r : [], a = o.find(function(u) {
            return u.indexOf(e + "=") === 0;
          }), a ? [2, a.substring(e.length + 1)] : [2, void 0];
        });
      });
    }, t.prototype.set = function(e, n) {
      var r;
      return k(this, void 0, void 0, function() {
        var s, o, a, l, u, c, d;
        return m(this, function(h) {
          try {
            s = (r = this.options.expirationDays) !== null && r !== void 0 ? r : 0, o = n !== null ? s : -1, a = void 0, o && (l = /* @__PURE__ */ new Date(), l.setTime(l.getTime() + o * 24 * 60 * 60 * 1e3), a = l), u = "".concat(e, "=").concat(btoa(encodeURIComponent(JSON.stringify(n)))), a && (u += "; expires=".concat(a.toUTCString())), u += "; path=/", this.options.domain && (u += "; domain=".concat(this.options.domain)), this.options.secure && (u += "; Secure"), this.options.sameSite && (u += "; SameSite=".concat(this.options.sameSite)), c = ee(), c && (c.document.cookie = u);
          } catch (p) {
            d = p instanceof Error ? p.message : String(p), console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(e, ". Error: ").concat(d));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.remove = function(e) {
      return k(this, void 0, void 0, function() {
        return m(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.set(e, null)];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.reset = function() {
      return k(this, void 0, void 0, function() {
        return m(this, function(e) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), si = function(t) {
  try {
    return decodeURIComponent(atob(t));
  } catch {
    return;
  }
}, oi = function(t) {
  try {
    return decodeURIComponent(atob(decodeURIComponent(t)));
  } catch {
    return;
  }
}, ai = function(t, e, n) {
  return n === void 0 && (n = 10), [xe, e, t.substring(0, n)].filter(Boolean).join("_");
}, Qe = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.send = function(e, n) {
      return Promise.resolve(null);
    }, t.prototype.buildResponse = function(e) {
      var n, r, s, o, a, l, u, c, d, h, p, C, y, _, S, v, g, f, w, A, I, E;
      if (typeof e != "object")
        return null;
      var O = e.code || 0, P = this.buildStatus(O);
      switch (P) {
        case L.Success:
          return {
            status: P,
            statusCode: O,
            body: {
              eventsIngested: (n = e.events_ingested) !== null && n !== void 0 ? n : 0,
              payloadSizeBytes: (r = e.payload_size_bytes) !== null && r !== void 0 ? r : 0,
              serverUploadTime: (s = e.server_upload_time) !== null && s !== void 0 ? s : 0
            }
          };
        case L.Invalid:
          return {
            status: P,
            statusCode: O,
            body: {
              error: (o = e.error) !== null && o !== void 0 ? o : "",
              missingField: (a = e.missing_field) !== null && a !== void 0 ? a : "",
              eventsWithInvalidFields: (l = e.events_with_invalid_fields) !== null && l !== void 0 ? l : {},
              eventsWithMissingFields: (u = e.events_with_missing_fields) !== null && u !== void 0 ? u : {},
              eventsWithInvalidIdLengths: (c = e.events_with_invalid_id_lengths) !== null && c !== void 0 ? c : {},
              epsThreshold: (d = e.eps_threshold) !== null && d !== void 0 ? d : 0,
              exceededDailyQuotaDevices: (h = e.exceeded_daily_quota_devices) !== null && h !== void 0 ? h : {},
              silencedDevices: (p = e.silenced_devices) !== null && p !== void 0 ? p : [],
              silencedEvents: (C = e.silenced_events) !== null && C !== void 0 ? C : [],
              throttledDevices: (y = e.throttled_devices) !== null && y !== void 0 ? y : {},
              throttledEvents: (_ = e.throttled_events) !== null && _ !== void 0 ? _ : []
            }
          };
        case L.PayloadTooLarge:
          return {
            status: P,
            statusCode: O,
            body: {
              error: (S = e.error) !== null && S !== void 0 ? S : ""
            }
          };
        case L.RateLimit:
          return {
            status: P,
            statusCode: O,
            body: {
              error: (v = e.error) !== null && v !== void 0 ? v : "",
              epsThreshold: (g = e.eps_threshold) !== null && g !== void 0 ? g : 0,
              throttledDevices: (f = e.throttled_devices) !== null && f !== void 0 ? f : {},
              throttledUsers: (w = e.throttled_users) !== null && w !== void 0 ? w : {},
              exceededDailyQuotaDevices: (A = e.exceeded_daily_quota_devices) !== null && A !== void 0 ? A : {},
              exceededDailyQuotaUsers: (I = e.exceeded_daily_quota_users) !== null && I !== void 0 ? I : {},
              throttledEvents: (E = e.throttled_events) !== null && E !== void 0 ? E : []
            }
          };
        case L.Timeout:
        default:
          return {
            status: P,
            statusCode: O
          };
      }
    }, t.prototype.buildStatus = function(e) {
      return e >= 200 && e < 300 ? L.Success : e === 429 ? L.RateLimit : e === 413 ? L.PayloadTooLarge : e === 408 ? L.Timeout : e >= 400 && e < 500 ? L.Invalid : e >= 500 ? L.Failed : L.Unknown;
    }, t;
  }()
), ci = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.send = function(n, r) {
      return k(this, void 0, void 0, function() {
        var s, o, a;
        return m(this, function(l) {
          switch (l.label) {
            case 0:
              if (typeof fetch > "u")
                throw new Error("FetchTransport is not supported");
              return s = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify(r),
                method: "POST"
              }, [4, fetch(n, s)];
            case 1:
              return o = l.sent(), [4, o.text()];
            case 2:
              a = l.sent();
              try {
                return [2, this.buildResponse(JSON.parse(a))];
              } catch {
                return [2, this.buildResponse({ code: o.status })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }(Qe)
), Tn = null, En = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "video",
  "audio",
  '[contenteditable="true" i]',
  "[data-amp-default-track]",
  ".amp-default-track"
], On = "data-amp-track-", Pn = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"], be = function(t, e) {
  return typeof t == "boolean" ? t : (t == null ? void 0 : t[e]) !== !1;
}, Rn = function(t) {
  return be(t, "attribution");
}, ui = function(t) {
  return be(t, "fileDownloads");
}, li = function(t) {
  return be(t, "formInteractions");
}, Mn = function(t) {
  return be(t, "pageViews");
}, Pt = function(t) {
  return be(t, "sessions");
}, Fn = function(t) {
  return typeof t == "boolean" ? t : typeof t == "object" && (t.elementInteractions === !0 || typeof t.elementInteractions == "object");
}, di = function(t) {
  if (Fn(t.autocapture) && typeof t.autocapture == "object" && typeof t.autocapture.elementInteractions == "object")
    return t.autocapture.elementInteractions;
}, pi = function(t) {
  var e = function() {
    return !1;
  }, n = void 0, r, s = t.pageCounter, o = Mn(t.defaultTracking);
  return o && (e = void 0, r = void 0, t.defaultTracking && typeof t.defaultTracking == "object" && t.defaultTracking.pageViews && typeof t.defaultTracking.pageViews == "object" && ("trackOn" in t.defaultTracking.pageViews && (e = t.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in t.defaultTracking.pageViews && (n = t.defaultTracking.pageViews.trackHistoryChanges), "eventType" in t.defaultTracking.pageViews && t.defaultTracking.pageViews.eventType && (r = t.defaultTracking.pageViews.eventType))), {
    trackOn: e,
    trackHistoryChanges: n,
    eventType: r,
    pageCounter: s
  };
}, hi = function(t) {
  return Rn(t.defaultTracking) && t.defaultTracking && typeof t.defaultTracking == "object" && t.defaultTracking.attribution && typeof t.defaultTracking.attribution == "object" ? b({}, t.defaultTracking.attribution) : {};
}, tt = function(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n], s = r.name, o = r.args, a = r.resolve, l = t && t[s];
    if (typeof l == "function") {
      var u = l.apply(t, o);
      typeof a == "function" && a(u == null ? void 0 : u.promise);
    }
  }
  return t;
}, nt = function(t) {
  var e = t;
  return e && e._q !== void 0;
}, Dn = "2.12.2", vi = "amplitude-ts", gi = "Web", fi = "$remote", Ci = (
  /** @class */
  function() {
    function t() {
      this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = "".concat(vi, "/").concat(Dn), typeof navigator < "u" && (this.userAgent = navigator.userAgent);
    }
    return t.prototype.setup = function(e) {
      return this.config = e, Promise.resolve(void 0);
    }, t.prototype.execute = function(e) {
      var n, r;
      return k(this, void 0, void 0, function() {
        var s, o, a, l;
        return m(this, function(u) {
          return s = (/* @__PURE__ */ new Date()).getTime(), o = (n = this.config.lastEventId) !== null && n !== void 0 ? n : -1, a = (r = e.event_id) !== null && r !== void 0 ? r : o + 1, this.config.lastEventId = a, e.time || (this.config.lastEventTime = s), l = b(b(b(b(b(b(b(b({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: s }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: gi }), this.config.trackingOptions.language && { language: ni() }), this.config.trackingOptions.ipAddress && { ip: fi }), { insert_id: fe(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), e), { event_id: a, library: this.library, user_agent: this.userAgent }), [2, l];
        });
      });
    }, t;
  }()
), Un = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.isEnabled = function() {
      return k(this, void 0, void 0, function() {
        var e, n, r, s;
        return m(this, function(o) {
          switch (o.label) {
            case 0:
              if (!this.storage)
                return [2, !1];
              e = String(Date.now()), n = new t(this.storage), r = "AMP_TEST", o.label = 1;
            case 1:
              return o.trys.push([1, 4, 5, 7]), [4, n.set(r, e)];
            case 2:
              return o.sent(), [4, n.get(r)];
            case 3:
              return s = o.sent(), [2, s === e];
            case 4:
              return o.sent(), [2, !1];
            case 5:
              return [4, n.remove(r)];
            case 6:
              return o.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.get = function(e) {
      return k(this, void 0, void 0, function() {
        var n;
        return m(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.getRaw(e)];
            case 1:
              return n = r.sent(), n ? [2, JSON.parse(n)] : [2, void 0];
            case 2:
              return r.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getRaw = function(e) {
      var n;
      return k(this, void 0, void 0, function() {
        return m(this, function(r) {
          return [2, ((n = this.storage) === null || n === void 0 ? void 0 : n.getItem(e)) || void 0];
        });
      });
    }, t.prototype.set = function(e, n) {
      var r;
      return k(this, void 0, void 0, function() {
        return m(this, function(s) {
          try {
            (r = this.storage) === null || r === void 0 || r.setItem(e, JSON.stringify(n));
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.remove = function(e) {
      var n;
      return k(this, void 0, void 0, function() {
        return m(this, function(r) {
          try {
            (n = this.storage) === null || n === void 0 || n.removeItem(e);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.reset = function() {
      var e;
      return k(this, void 0, void 0, function() {
        return m(this, function(n) {
          try {
            (e = this.storage) === null || e === void 0 || e.clear();
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), Ee = 1e3, Ln = (
  /** @class */
  function(t) {
    K(e, t);
    function e(n) {
      var r = this, s;
      return r = t.call(this, (s = ee()) === null || s === void 0 ? void 0 : s.localStorage) || this, r.loggerProvider = n == null ? void 0 : n.loggerProvider, r;
    }
    return e.prototype.set = function(n, r) {
      var s;
      return k(this, void 0, void 0, function() {
        var o;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return Array.isArray(r) && r.length > Ee ? (o = r.length - Ee, [4, t.prototype.set.call(this, n, r.slice(0, Ee))]) : [3, 2];
            case 1:
              return a.sent(), (s = this.loggerProvider) === null || s === void 0 || s.error("Failed to save ".concat(o, " events because the queue length exceeded ").concat(Ee, ".")), [3, 4];
            case 2:
              return [4, t.prototype.set.call(this, n, r)];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }(Un)
), yi = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var n;
      return t.call(this, (n = ee()) === null || n === void 0 ? void 0 : n.sessionStorage) || this;
    }
    return e;
  }(Un)
), mi = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.state = {
        done: 4
      }, n;
    }
    return e.prototype.send = function(n, r) {
      return k(this, void 0, void 0, function() {
        var s = this;
        return m(this, function(o) {
          return [2, new Promise(function(a, l) {
            typeof XMLHttpRequest > "u" && l(new Error("XHRTransport is not supported."));
            var u = new XMLHttpRequest();
            u.open("POST", n, !0), u.onreadystatechange = function() {
              if (u.readyState === s.state.done) {
                var c = u.responseText;
                try {
                  a(s.buildResponse(JSON.parse(c)));
                } catch {
                  a(s.buildResponse({ code: u.status }));
                }
              }
            }, u.setRequestHeader("Content-Type", "application/json"), u.setRequestHeader("Accept", "*/*"), u.send(JSON.stringify(r));
          })];
        });
      });
    }, e;
  }(Qe)
), ki = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.send = function(n, r) {
      return k(this, void 0, void 0, function() {
        var s = this;
        return m(this, function(o) {
          return [2, new Promise(function(a, l) {
            var u = ee();
            if (!(u != null && u.navigator.sendBeacon))
              throw new Error("SendBeaconTransport is not supported");
            try {
              var c = JSON.stringify(r), d = u.navigator.sendBeacon(n, JSON.stringify(r));
              return a(d ? s.buildResponse({
                code: 200,
                events_ingested: r.events.length,
                payload_size_bytes: c.length,
                server_upload_time: Date.now()
              }) : s.buildResponse({ code: 500 }));
            } catch (h) {
              l(h);
            }
          })];
        });
      });
    }, e;
  }(Qe)
), wi = function(t, e, n) {
  return n === void 0 && (n = !0), k(void 0, void 0, void 0, function() {
    var r, s, o, a, l, u, c, d, h;
    return m(this, function(p) {
      switch (p.label) {
        case 0:
          return r = ti(t), [4, e.getRaw(r)];
        case 1:
          return s = p.sent(), s ? n ? [4, e.remove(r)] : [3, 3] : [2, {
            optOut: !1
          }];
        case 2:
          p.sent(), p.label = 3;
        case 3:
          return o = R(s.split("."), 6), a = o[0], l = o[1], u = o[2], c = o[3], d = o[4], h = o[5], [2, {
            deviceId: a,
            userId: _i(l),
            sessionId: rt(c),
            lastEventId: rt(h),
            lastEventTime: rt(d),
            optOut: !!u
          }];
      }
    });
  });
}, rt = function(t) {
  var e = parseInt(t, 32);
  if (!isNaN(e))
    return e;
}, _i = function(t) {
  if (!(!atob || !escape || !t))
    try {
      return decodeURIComponent(escape(atob(t)));
    } catch {
      return;
    }
}, X = "[Amplitude]", Rt = "".concat(X, " Form Started"), Si = "".concat(X, " Form Submitted"), bi = "".concat(X, " File Downloaded"), Mt = "session_start", Ft = "session_end", Ai = "".concat(X, " File Extension"), Ii = "".concat(X, " File Name"), Ti = "".concat(X, " Link ID"), Ei = "".concat(X, " Link Text"), Oi = "".concat(X, " Link URL"), it = "".concat(X, " Form ID"), st = "".concat(X, " Form Name"), ot = "".concat(X, " Form Destination"), Ne = "cookie", Pi = "US", Ri = (
  /** @class */
  function(t) {
    K(e, t);
    function e(n, r, s, o, a, l, u, c, d, h, p, C, y, _, S, v, g, f, w, A, I, E, O, P, W, V, G, te, ne, oe, ae, Ce, ye, le) {
      s === void 0 && (s = new yt()), o === void 0 && (o = {
        domain: "",
        expiration: 365,
        sameSite: "Lax",
        secure: !1,
        upgrade: !0
      }), c === void 0 && (c = 1e3), d === void 0 && (d = 5), h === void 0 && (h = 30), p === void 0 && (p = Ne), v === void 0 && (v = new _n()), g === void 0 && (g = z.Warn), w === void 0 && (w = !1), A === void 0 && (A = !1), O === void 0 && (O = ""), P === void 0 && (P = Pi), V === void 0 && (V = 30 * 60 * 1e3), G === void 0 && (G = new Ln({ loggerProvider: v })), te === void 0 && (te = {
        ipAddress: !0,
        language: !0,
        platform: !0
      }), ne === void 0 && (ne = "fetch"), oe === void 0 && (oe = !1), ae === void 0 && (ae = !1);
      var T = t.call(this, { apiKey: n, storageProvider: G, transportProvider: Nn(ne) }) || this;
      return T.apiKey = n, T.appVersion = r, T.cookieOptions = o, T.defaultTracking = a, T.autocapture = l, T.flushIntervalMillis = c, T.flushMaxRetries = d, T.flushQueueSize = h, T.identityStorage = p, T.ingestionMetadata = C, T.instanceName = y, T.loggerProvider = v, T.logLevel = g, T.minIdLength = f, T.offline = w, T.partnerId = I, T.plan = E, T.serverUrl = O, T.serverZone = P, T.sessionTimeout = V, T.storageProvider = G, T.trackingOptions = te, T.transport = ne, T.useBatch = oe, T.fetchRemoteConfig = ae, T.version = Dn, T._optOut = !1, T._cookieStorage = s, T.deviceId = u, T.lastEventId = _, T.lastEventTime = S, T.optOut = A, T.sessionId = W, T.pageCounter = ye, T.userId = Ce, T.debugLogsEnabled = le, T.loggerProvider.enable(le ? z.Debug : T.logLevel), T;
    }
    return Object.defineProperty(e.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(n) {
        this._cookieStorage !== n && (this._cookieStorage = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(n) {
        this._deviceId !== n && (this._deviceId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(n) {
        this._userId !== n && (this._userId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(n) {
        this._sessionId !== n && (this._sessionId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(n) {
        this._optOut !== n && (this._optOut = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(n) {
        this._lastEventTime !== n && (this._lastEventTime = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(n) {
        this._lastEventId !== n && (this._lastEventId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "pageCounter", {
      get: function() {
        return this._pageCounter;
      },
      set: function(n) {
        this._pageCounter !== n && (this._pageCounter = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "debugLogsEnabled", {
      set: function(n) {
        this._debugLogsEnabled !== n && (this._debugLogsEnabled = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateStorage = function() {
      var n = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId,
        pageCounter: this._pageCounter,
        debugLogsEnabled: this._debugLogsEnabled
      };
      this.cookieStorage.set(In(this.apiKey), n);
    }, e;
  }(Hr)
), Mi = function(t, e, n) {
  return e === void 0 && (e = {}), k(void 0, void 0, void 0, function() {
    var r, s, o, a, l, u, c, d, h, p, C, y, _, S, v, g, f, w, A, I, E, O, P, W, V, G, te, ne, oe, ae, Ce, ye, le, T, qe, ze, $e, je, Je, Ye, Xe, Ze, et;
    return m(this, function(ce) {
      switch (ce.label) {
        case 0:
          return r = e.identityStorage || Ne, A = {}, r === Ne ? [3, 1] : (o = "", [3, 5]);
        case 1:
          return (E = (I = e.cookieOptions) === null || I === void 0 ? void 0 : I.domain) !== null && E !== void 0 ? (a = E, [3, 4]) : [3, 2];
        case 2:
          return [4, Di()];
        case 3:
          a = ce.sent(), ce.label = 4;
        case 4:
          o = a, ce.label = 5;
        case 5:
          return s = b.apply(void 0, [(A.domain = o, A.expiration = 365, A.sameSite = "Lax", A.secure = !1, A.upgrade = !0, A), e.cookieOptions]), l = Fi(e.identityStorage, s), [4, wi(t, l, (P = (O = e.cookieOptions) === null || O === void 0 ? void 0 : O.upgrade) !== null && P !== void 0 ? P : !0)];
        case 6:
          return u = ce.sent(), [4, l.get(In(t))];
        case 7:
          return c = ce.sent(), d = Le(), h = (ne = (te = (G = (V = (W = e.deviceId) !== null && W !== void 0 ? W : d.ampDeviceId) !== null && V !== void 0 ? V : d.deviceId) !== null && G !== void 0 ? G : c == null ? void 0 : c.deviceId) !== null && te !== void 0 ? te : u.deviceId) !== null && ne !== void 0 ? ne : fe(), p = (oe = c == null ? void 0 : c.lastEventId) !== null && oe !== void 0 ? oe : u.lastEventId, C = (ae = c == null ? void 0 : c.lastEventTime) !== null && ae !== void 0 ? ae : u.lastEventTime, y = (ye = (Ce = e.optOut) !== null && Ce !== void 0 ? Ce : c == null ? void 0 : c.optOut) !== null && ye !== void 0 ? ye : u.optOut, _ = (le = c == null ? void 0 : c.sessionId) !== null && le !== void 0 ? le : u.sessionId, S = (qe = (T = e.userId) !== null && T !== void 0 ? T : c == null ? void 0 : c.userId) !== null && qe !== void 0 ? qe : u.userId, n.previousSessionDeviceId = (ze = c == null ? void 0 : c.deviceId) !== null && ze !== void 0 ? ze : u.deviceId, n.previousSessionUserId = ($e = c == null ? void 0 : c.userId) !== null && $e !== void 0 ? $e : u.userId, v = {
            ipAddress: (Je = (je = e.trackingOptions) === null || je === void 0 ? void 0 : je.ipAddress) !== null && Je !== void 0 ? Je : !0,
            language: (Xe = (Ye = e.trackingOptions) === null || Ye === void 0 ? void 0 : Ye.language) !== null && Xe !== void 0 ? Xe : !0,
            platform: (et = (Ze = e.trackingOptions) === null || Ze === void 0 ? void 0 : Ze.platform) !== null && et !== void 0 ? et : !0
          }, g = c == null ? void 0 : c.pageCounter, f = c == null ? void 0 : c.debugLogsEnabled, e.autocapture !== void 0 && (e.defaultTracking = e.autocapture), w = new Ri(t, e.appVersion, l, s, e.defaultTracking, e.autocapture, h, e.flushIntervalMillis, e.flushMaxRetries, e.flushQueueSize, r, e.ingestionMetadata, e.instanceName, p, C, e.loggerProvider, e.logLevel, e.minIdLength, e.offline, y, e.partnerId, e.plan, e.serverUrl, e.serverZone, _, e.sessionTimeout, e.storageProvider, v, e.transport, e.useBatch, e.fetchRemoteConfig, S, g, f), [4, w.storageProvider.isEnabled()];
        case 8:
          return ce.sent() || (w.loggerProvider.warn("Storage provider ".concat(w.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage.")), w.storageProvider = new yt()), [2, w];
      }
    });
  });
}, Fi = function(t, e) {
  switch (t === void 0 && (t = Ne), e === void 0 && (e = {}), t) {
    case "localStorage":
      return new Ln();
    case "sessionStorage":
      return new yi();
    case "none":
      return new yt();
    case "cookie":
    default:
      return new vt(b(b({}, e), { expirationDays: e.expiration }));
  }
}, Nn = function(t) {
  return t === "xhr" ? new mi() : t === "beacon" ? new ki() : new ci();
}, Di = function(t) {
  return k(void 0, void 0, void 0, function() {
    var e, n, r, s, o, o, a, l, u, c;
    return m(this, function(d) {
      switch (d.label) {
        case 0:
          return [4, new vt().isEnabled()];
        case 1:
          if (!d.sent() || typeof location > "u" || !location.hostname)
            return [2, ""];
          for (e = location.hostname, n = e.split("."), r = [], s = "AMP_TLDTEST", o = n.length - 2; o >= 0; --o)
            r.push(n.slice(o).join("."));
          o = 0, d.label = 2;
        case 2:
          return o < r.length ? (a = r[o], l = { domain: "." + a }, u = new vt(l), [4, u.set(s, 1)]) : [3, 7];
        case 3:
          return d.sent(), [4, u.get(s)];
        case 4:
          return c = d.sent(), c ? [4, u.remove(s)] : [3, 6];
        case 5:
          return d.sent(), [2, "." + a];
        case 6:
          return o++, [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
}, Vn = function() {
  var t = "ampIntegrationContext";
  if (typeof globalThis < "u" && typeof globalThis[t] < "u")
    return globalThis[t];
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global < "u")
    return global;
}, Dt = function() {
  var t, e = Vn();
  if (!(!((t = e == null ? void 0 : e.location) === null || t === void 0) && t.search))
    return {};
  var n = e.location.search.substring(1).split("&").filter(Boolean), r = n.reduce(function(s, o) {
    var a = o.split("=", 2), l = Ut(a[0]), u = Ut(a[1]);
    return u && (s[l] = u), s;
  }, {});
  return r;
}, Ut = function(t) {
  t === void 0 && (t = "");
  try {
    return decodeURIComponent(t);
  } catch {
    return "";
  }
}, Ui = "utm_campaign", Li = "utm_content", Ni = "utm_id", Vi = "utm_medium", Bi = "utm_source", Hi = "utm_term", Lt = "dclid", Nt = "fbclid", Vt = "gbraid", Bt = "gclid", Ht = "ko_click_id", Wt = "li_fat_id", xt = "msclkid", Qt = "rtd_cid", Kt = "ttclid", Gt = "twclid", qt = "wbraid", Bn = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, Wi = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.parse = function() {
      return k(this, void 0, void 0, function() {
        return m(this, function(e) {
          return [2, b(b(b(b({}, Bn), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, t.prototype.getUtmParam = function() {
      var e = Dt(), n = e[Ui], r = e[Li], s = e[Ni], o = e[Vi], a = e[Bi], l = e[Hi];
      return {
        utm_campaign: n,
        utm_content: r,
        utm_id: s,
        utm_medium: o,
        utm_source: a,
        utm_term: l
      };
    }, t.prototype.getReferrer = function() {
      var e, n, r = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        r.referrer = document.referrer || void 0, r.referring_domain = (n = (e = r.referrer) === null || e === void 0 ? void 0 : e.split("/")[2]) !== null && n !== void 0 ? n : void 0;
      } catch {
      }
      return r;
    }, t.prototype.getClickIds = function() {
      var e, n = Dt();
      return e = {}, e[Lt] = n[Lt], e[Nt] = n[Nt], e[Vt] = n[Vt], e[Bt] = n[Bt], e[Ht] = n[Ht], e[Wt] = n[Wt], e[xt] = n[xt], e[Qt] = n[Qt], e[Kt] = n[Kt], e[Gt] = n[Gt], e[qt] = n[qt], e;
    }, t;
  }()
), Ve;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.ADD = "$add", t.APPEND = "$append", t.PREPEND = "$prepend", t.REMOVE = "$remove", t.PREINSERT = "$preInsert", t.POSTINSERT = "$postInsert", t.UNSET = "$unset", t.CLEAR_ALL = "$clearAll";
})(Ve || (Ve = {}));
var zt;
(function(t) {
  t.REVENUE_PRODUCT_ID = "$productId", t.REVENUE_QUANTITY = "$quantity", t.REVENUE_PRICE = "$price", t.REVENUE_TYPE = "$revenueType", t.REVENUE_CURRENCY = "$currency", t.REVENUE = "$revenue";
})(zt || (zt = {}));
var $t;
(function(t) {
  t.IDENTIFY = "$identify", t.GROUP_IDENTIFY = "$groupidentify", t.REVENUE = "revenue_amount";
})($t || ($t = {}));
var Be;
(function(t) {
  t.US = "US", t.EU = "EU";
})(Be || (Be = {}));
var He;
(function(t) {
  t.Unknown = "unknown", t.Skipped = "skipped", t.Success = "success", t.RateLimit = "rate_limit", t.PayloadTooLarge = "payload_too_large", t.Invalid = "invalid", t.Failed = "failed", t.Timeout = "Timeout", t.SystemError = "SystemError";
})(He || (He = {}));
var xi = function(t) {
  var e = {};
  for (var n in t) {
    var r = t[n];
    r && (e[n] = r);
  }
  return e;
}, Qi = "[Amplitude] Page Viewed", Ki = function(t) {
  t === void 0 && (t = {});
  var e, n = Vn(), r = void 0, s, o, a = t.trackOn, l = t.trackHistoryChanges, u = t.eventType, c = u === void 0 ? Qi : u, d = function(v) {
    var g = v;
    try {
      g = decodeURI(v);
    } catch (f) {
      r == null || r.error("Malformed URI sequence: ", f);
    }
    return g;
  }, h = function() {
    return k(void 0, void 0, void 0, function() {
      var v, g, f;
      return m(this, function(w) {
        switch (w.label) {
          case 0:
            return v = d(typeof location < "u" && location.href || ""), f = {
              event_type: c
            }, g = [{}], [4, Gi()];
          case 1:
            return [2, (f.event_properties = b.apply(void 0, [b.apply(void 0, g.concat([w.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location < "u" && location.hostname || ""
            ), "[Amplitude] Page Location": v, "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location < "u" && d(location.pathname) || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document < "u" && document.title || ""
            ), "[Amplitude] Page URL": v.split("?")[0] }]), f)];
        }
      });
    });
  }, p = function() {
    return typeof a > "u" || typeof a == "function" && a();
  }, C = typeof location < "u" ? location.href : null, y = function() {
    return k(void 0, void 0, void 0, function() {
      var v, g, f, w;
      return m(this, function(A) {
        switch (A.label) {
          case 0:
            return v = location.href, g = zi(l, v, C || "") && p(), C = v, g ? (r == null || r.log("Tracking page view event"), e != null ? [3, 1] : [3, 3]) : [3, 4];
          case 1:
            return w = (f = e).track, [4, h()];
          case 2:
            w.apply(f, [A.sent()]), A.label = 3;
          case 3:
            A.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, _ = function() {
    y();
  }, S = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(v, g) {
      return k(void 0, void 0, void 0, function() {
        var f, w;
        return m(this, function(A) {
          switch (A.label) {
            case 0:
              return e = g, o = v, r = v.loggerProvider, r.log("Installing @amplitude/plugin-page-view-tracking-browser"), n && (n.addEventListener("popstate", _), s = n.history.pushState, n.history.pushState = new Proxy(n.history.pushState, {
                apply: function(I, E, O) {
                  var P = R(O, 3), W = P[0], V = P[1], G = P[2];
                  I.apply(E, [W, V, G]), y();
                }
              })), p() ? (r.log("Tracking page view event"), w = (f = e).track, [4, h()]) : [3, 2];
            case 1:
              w.apply(f, [A.sent()]), A.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(v) {
      return k(void 0, void 0, void 0, function() {
        var g;
        return m(this, function(f) {
          switch (f.label) {
            case 0:
              return a === "attribution" && qi(v) ? (r == null || r.log("Enriching campaign event to page view event with campaign parameters"), [4, h()]) : [3, 2];
            case 1:
              g = f.sent(), v.event_type = g.event_type, v.event_properties = b(b({}, v.event_properties), g.event_properties), f.label = 2;
            case 2:
              return o && v.event_type === c && (o.pageCounter = o.pageCounter ? o.pageCounter + 1 : 1, v.event_properties = b(b({}, v.event_properties), { "[Amplitude] Page Counter": o.pageCounter })), [2, v];
          }
        });
      });
    },
    teardown: function() {
      return k(void 0, void 0, void 0, function() {
        return m(this, function(v) {
          return n && (n.removeEventListener("popstate", _), s && (n.history.pushState = s)), [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return S;
}, Gi = function() {
  return k(void 0, void 0, void 0, function() {
    var t;
    return m(this, function(e) {
      switch (e.label) {
        case 0:
          return t = xi, [4, new Wi().parse()];
        case 1:
          return [2, t.apply(void 0, [e.sent()])];
      }
    });
  });
}, qi = function(t) {
  if (t.event_type === "$identify" && t.user_properties) {
    var e = t.user_properties, n = e[Ve.SET] || {}, r = e[Ve.UNSET] || {}, s = x(x([], R(Object.keys(n)), !1), R(Object.keys(r)), !1);
    return Object.keys(Bn).every(function(o) {
      return s.includes(o);
    });
  }
  return !1;
}, zi = function(t, e, n) {
  switch (t) {
    case "pathOnly": {
      if (n == "")
        return !0;
      var r = new URL(e), s = new URL(n), o = r.origin + r.pathname, a = s.origin + s.pathname;
      return o !== a;
    }
    default:
      return e !== n;
  }
}, $i = function() {
  var t, e = [], n = function(c, d, h) {
    c.addEventListener(d, h), e.push({
      element: c,
      type: d,
      handler: h
    });
  }, r = function() {
    e.forEach(function(c) {
      var d = c.element, h = c.type, p = c.handler;
      d == null || d.removeEventListener(h, p);
    }), e = [];
  }, s = "@amplitude/plugin-form-interaction-tracking-browser", o = "enrichment", a = function(c, d) {
    return k(void 0, void 0, void 0, function() {
      var h, p;
      return m(this, function(C) {
        return h = function() {
          if (!d) {
            c.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var y = function(S) {
              var v = !1;
              n(S, "change", function() {
                var g, f = jt(S);
                v || d.track(Rt, (g = {}, g[it] = de(S.id), g[st] = de(S.name), g[ot] = f, g)), v = !0;
              }), n(S, "submit", function() {
                var g, f, w = jt(S);
                v || d.track(Rt, (g = {}, g[it] = de(S.id), g[st] = de(S.name), g[ot] = w, g)), d.track(Si, (f = {}, f[it] = de(S.id), f[st] = de(S.name), f[ot] = w, f)), v = !1;
              });
            }, _ = Array.from(document.getElementsByTagName("form"));
            _.forEach(y), typeof MutationObserver < "u" && (t = new MutationObserver(function(S) {
              S.forEach(function(v) {
                v.addedNodes.forEach(function(g) {
                  g.nodeName === "FORM" && y(g), "querySelectorAll" in g && typeof g.querySelectorAll == "function" && Array.from(g.querySelectorAll("form")).map(y);
                });
              });
            }), t.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }, document.readyState === "complete" ? h() : (p = ee(), p ? p.addEventListener("load", h) : c.loggerProvider.debug("Form interaction tracking is not installed because global is undefined.")), [
          2
          /*return*/
        ];
      });
    });
  }, l = function(c) {
    return k(void 0, void 0, void 0, function() {
      return m(this, function(d) {
        return [2, c];
      });
    });
  }, u = function() {
    return k(void 0, void 0, void 0, function() {
      return m(this, function(c) {
        return t == null || t.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: s,
    type: o,
    setup: a,
    execute: l,
    teardown: u
  };
}, de = function(t) {
  if (typeof t == "string")
    return t;
}, jt = function(t) {
  var e = t.getAttribute("action");
  try {
    e = new URL(encodeURI(e ?? ""), window.location.href).href;
  } catch {
  }
  return e;
}, ji = function() {
  var t, e = [], n = function(c, d, h) {
    c.addEventListener(d, h), e.push({
      element: c,
      type: d,
      handler: h
    });
  }, r = function() {
    e.forEach(function(c) {
      var d = c.element, h = c.type, p = c.handler;
      d == null || d.removeEventListener(h, p);
    }), e = [];
  }, s = "@amplitude/plugin-file-download-tracking-browser", o = "enrichment", a = function(c, d) {
    return k(void 0, void 0, void 0, function() {
      var h, p;
      return m(this, function(C) {
        return h = function() {
          if (!d) {
            c.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var y = function(v) {
              var g;
              try {
                g = new URL(v.href, window.location.href);
              } catch {
                return;
              }
              var f = _.exec(g.href), w = f == null ? void 0 : f[1];
              w && n(v, "click", function() {
                var A;
                w && d.track(bi, (A = {}, A[Ai] = w, A[Ii] = g.pathname, A[Ti] = v.id, A[Ei] = v.text, A[Oi] = v.href, A));
              });
            }, _ = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/, S = Array.from(document.getElementsByTagName("a"));
            S.forEach(y), typeof MutationObserver < "u" && (t = new MutationObserver(function(v) {
              v.forEach(function(g) {
                g.addedNodes.forEach(function(f) {
                  f.nodeName === "A" && y(f), "querySelectorAll" in f && typeof f.querySelectorAll == "function" && Array.from(f.querySelectorAll("a")).map(y);
                });
              });
            }), t.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }, document.readyState === "complete" ? h() : (p = ee(), p ? p.addEventListener("load", h) : c.loggerProvider.debug("File download tracking is not installed because global is undefined.")), [
          2
          /*return*/
        ];
      });
    });
  }, l = function(c) {
    return k(void 0, void 0, void 0, function() {
      return m(this, function(d) {
        return [2, c];
      });
    });
  }, u = function() {
    return k(void 0, void 0, void 0, function() {
      return m(this, function(c) {
        return t == null || t.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: s,
    type: o,
    setup: a,
    execute: l,
    teardown: u
  };
}, Jt = !1, Ji = function(t) {
  if (!(Jt || t.defaultTracking !== void 0)) {
    var e = `\`options.defaultTracking\` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to \`options.defaultTracking\`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:

amplitude.init(<YOUR_API_KEY>, {
  defaultTracking: true,
});

Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.`;
    t.loggerProvider.warn(e), Jt = !0;
  }
}, Yi = function() {
  var t = "@amplitude/plugin-network-checker-browser", e = "before", n = ee(), r = [], s = function(u, c) {
    n && (n.addEventListener(u, c), r.push({
      type: u,
      handler: c
    }));
  }, o = function() {
    r.forEach(function(u) {
      var c = u.type, d = u.handler;
      n && n.removeEventListener(c, d);
    }), r = [];
  }, a = function(u, c) {
    return k(void 0, void 0, void 0, function() {
      return m(this, function(d) {
        return typeof navigator > "u" ? (u.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available."), u.offline = !1, [
          2
          /*return*/
        ]) : (u.offline = !navigator.onLine, s("online", function() {
          u.loggerProvider.debug("Network connectivity changed to online."), u.offline = !1, setTimeout(function() {
            c.flush();
          }, u.flushIntervalMillis);
        }), s("offline", function() {
          u.loggerProvider.debug("Network connectivity changed to offline."), u.offline = !0;
        }), [
          2
          /*return*/
        ]);
      });
    });
  }, l = function() {
    return k(void 0, void 0, void 0, function() {
      return m(this, function(u) {
        return o(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: t,
    type: e,
    setup: a,
    teardown: l
  };
}, Xi = "Network error occurred, remote config fetch failed", Zi = "Remote config successfully fetched", es = "Remote config fetch rejected due to exceeded retry count", Yt = "Remote config fetch rejected due to timeout after 5 seconds", Xt = "Unexpected error occurred", ts = "https://sr-client-cfg.amplitude.com/config", ns = "https://sr-client-cfg.stag2.amplitude.com/config", rs = "https://sr-client-cfg.eu.amplitude.com/config", is = (
  /** @class */
  function() {
    function t(e) {
      var n = e.localConfig, r = e.configKeys, s = this;
      this.retryTimeout = 1e3, this.attempts = 0, this.sessionTargetingMatch = !1, this.metrics = {}, this.getRemoteConfig = function(o, a, l) {
        return k(s, void 0, void 0, function() {
          var u, c, d;
          return m(this, function(h) {
            switch (h.label) {
              case 0:
                return u = Date.now(), [4, this.fetchWithTimeout(l)];
              case 1:
                return c = h.sent(), c && (d = c.configs && c.configs[o], d) ? (this.metrics.fetchTimeAPISuccess = Date.now() - u, [2, d[a]]) : (this.metrics.fetchTimeAPIFail = Date.now() - u, [2, void 0]);
            }
          });
        });
      }, this.fetchWithTimeout = function(o) {
        return k(s, void 0, void 0, function() {
          var a, l, u;
          return m(this, function(c) {
            switch (c.label) {
              case 0:
                return a = new AbortController(), l = setTimeout(function() {
                  return a.abort();
                }, 5e3), [4, this.fetchRemoteConfig(a.signal, o)];
              case 1:
                return u = c.sent(), clearTimeout(l), [2, u];
            }
          });
        });
      }, this.fetchRemoteConfig = function(o, a) {
        return k(s, void 0, void 0, function() {
          var l, u, c, d, h, p, C, y, _, S, v, g, f;
          return m(this, function(w) {
            switch (w.label) {
              case 0:
                if (a === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries)
                  return [2, this.completeRequest({ err: es })];
                if (o.aborted)
                  return [2, this.completeRequest({ err: Yt })];
                a !== this.lastFetchedSessionId && (this.lastFetchedSessionId = a, this.attempts = 0), w.label = 1;
              case 1:
                w.trys.push([1, 3, , 4]), l = new URLSearchParams({
                  api_key: this.localConfig.apiKey
                });
                try {
                  for (u = H(this.configKeys), c = u.next(); !c.done; c = u.next())
                    d = c.value, l.append("config_keys", d);
                } catch (A) {
                  v = { error: A };
                } finally {
                  try {
                    c && !c.done && (g = u.return) && g.call(u);
                  } finally {
                    if (v) throw v.error;
                  }
                }
                return a && l.set("session_id", String(a)), h = {
                  headers: {
                    Accept: "*/*"
                  },
                  method: "GET"
                }, p = "".concat(this.getServerUrl(), "?").concat(l.toString()), this.attempts += 1, [4, fetch(p, b(b({}, h), { signal: o }))];
              case 2:
                if (C = w.sent(), C === null)
                  return [2, this.completeRequest({ err: Xt })];
                switch (y = new Qe().buildStatus(C.status), y) {
                  case He.Success:
                    return this.attempts = 0, [2, this.parseAndStoreConfig(C)];
                  case He.Failed:
                    return [2, this.retryFetch(o, a)];
                  default:
                    return [2, this.completeRequest({ err: Xi })];
                }
              case 3:
                return _ = w.sent(), S = _, o.aborted ? [2, this.completeRequest({ err: Yt })] : [2, this.completeRequest({ err: (f = S.message) !== null && f !== void 0 ? f : Xt })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, this.retryFetch = function(o, a) {
        return k(s, void 0, void 0, function() {
          var l = this;
          return m(this, function(u) {
            switch (u.label) {
              case 0:
                return [4, new Promise(function(c) {
                  return setTimeout(c, l.attempts * l.retryTimeout);
                })];
              case 1:
                return u.sent(), [2, this.fetchRemoteConfig(o, a)];
            }
          });
        });
      }, this.parseAndStoreConfig = function(o) {
        return k(s, void 0, void 0, function() {
          var a;
          return m(this, function(l) {
            switch (l.label) {
              case 0:
                return [4, o.json()];
              case 1:
                return a = l.sent(), this.completeRequest({ success: Zi }), [2, a];
            }
          });
        });
      }, this.localConfig = n, this.configKeys = r;
    }
    return t.prototype.getServerUrl = function() {
      return this.localConfig.serverZone === Be.STAGING ? ns : this.localConfig.serverZone === Be.EU ? rs : ts;
    }, t.prototype.completeRequest = function(e) {
      var n = e.err, r = e.success;
      if (n)
        throw new Error(n);
      r && this.localConfig.loggerProvider.log(r);
    }, t;
  }()
), ss = function(t) {
  var e = t.localConfig, n = t.configKeys;
  return k(void 0, void 0, void 0, function() {
    return m(this, function(r) {
      return [2, new is({ localConfig: e, configKeys: n })];
    });
  });
}, os = ss, as = (
  /** @class */
  function() {
    function t(e) {
      this.config = e, this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
    }
    return t.prototype.initialize = function() {
      return k(this, void 0, void 0, function() {
        var e;
        return m(this, function(n) {
          switch (n.label) {
            case 0:
              return e = this, [4, os({
                localConfig: this.config,
                configKeys: ["analyticsSDK"]
              })];
            case 1:
              return e.remoteConfigFetch = n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.generateJoinedConfig = function() {
      var e, n, r, s;
      return k(this, void 0, void 0, function() {
        var o, a, l;
        return m(this, function(u) {
          switch (u.label) {
            case 0:
              return u.trys.push([0, 3, , 4]), a = this.remoteConfigFetch, a ? [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)] : [3, 2];
            case 1:
              a = u.sent(), u.label = 2;
            case 2:
              return o = a, this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(o, null, 2)), o && "autocapture" in o && (typeof o.autocapture == "boolean" && (this.config.autocapture = o.autocapture), typeof o.autocapture == "object" && (this.config.autocapture === void 0 && (this.config.autocapture = o.autocapture), typeof this.config.autocapture == "boolean" && (this.config.autocapture = b({ attribution: this.config.autocapture, fileDownloads: this.config.autocapture, formInteractions: this.config.autocapture, pageViews: this.config.autocapture, sessions: this.config.autocapture, elementInteractions: this.config.autocapture }, o.autocapture)), typeof this.config.autocapture == "object" && (this.config.autocapture = b(b({}, this.config.autocapture), o.autocapture))), this.config.defaultTracking = this.config.autocapture), this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2)), (e = (s = this.config).requestMetadata) !== null && e !== void 0 || (s.requestMetadata = new bn()), !((n = this.remoteConfigFetch) === null || n === void 0) && n.metrics.fetchTimeAPISuccess && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess), !((r = this.remoteConfigFetch) === null || r === void 0) && r.metrics.fetchTimeAPIFail && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail), [3, 4];
            case 3:
              return l = u.sent(), this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", l), [3, 4];
            case 4:
              return [2, this.config];
          }
        });
      });
    }, t;
  }()
), cs = function(t) {
  return k(void 0, void 0, void 0, function() {
    var e;
    return m(this, function(n) {
      switch (n.label) {
        case 0:
          return e = new as(t), [4, e.initialize()];
        case 1:
          return n.sent(), [2, e];
      }
    });
  });
}, us = "@amplitude/plugin-autocapture-browser", gt = "[Amplitude] Element Clicked", ls = "[Amplitude] Element Changed", ds = "[Amplitude] Element ID", ps = "[Amplitude] Element Class", Hn = "[Amplitude] Element Tag", Wn = "[Amplitude] Element Text", hs = "[Amplitude] Element Hierarchy", vs = "[Amplitude] Element Href", gs = "[Amplitude] Element Position Left", fs = "[Amplitude] Element Position Top", Cs = "[Amplitude] Element Aria Label", ys = "[Amplitude] Element Attributes", ms = "[Amplitude] Element Parent Label", xn = "[Amplitude] Page URL", ks = "[Amplitude] Page Title", ws = "[Amplitude] Viewport Height", _s = "[Amplitude] Viewport Width", Fe = "https://app.amplitude.com", Ss = "https://app.eu.amplitude.com", bs = "https://apps.stag2.amplitude.com", As = {
  US: Fe,
  EU: Ss,
  STAGING: bs
}, Is = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz", Ts = "amp-visual-tagging-selector-highlight";
function M(t) {
  return typeof t == "function";
}
function mt(t) {
  var e = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = t(e);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var at = mt(function(t) {
  return function(n) {
    t(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, s) {
      return s + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function We(t, e) {
  if (t) {
    var n = t.indexOf(e);
    0 <= n && t.splice(n, 1);
  }
}
var Ae = function() {
  function t(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var e, n, r, s, o;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var l = H(a), u = l.next(); !u.done; u = l.next()) {
              var c = u.value;
              c.remove(this);
            }
          } catch (_) {
            e = { error: _ };
          } finally {
            try {
              u && !u.done && (n = l.return) && n.call(l);
            } finally {
              if (e) throw e.error;
            }
          }
        else
          a.remove(this);
      var d = this.initialTeardown;
      if (M(d))
        try {
          d();
        } catch (_) {
          o = _ instanceof at ? _.errors : [_];
        }
      var h = this._finalizers;
      if (h) {
        this._finalizers = null;
        try {
          for (var p = H(h), C = p.next(); !C.done; C = p.next()) {
            var y = C.value;
            try {
              Zt(y);
            } catch (_) {
              o = o ?? [], _ instanceof at ? o = x(x([], R(o)), R(_.errors)) : o.push(_);
            }
          }
        } catch (_) {
          r = { error: _ };
        } finally {
          try {
            C && !C.done && (s = p.return) && s.call(p);
          } finally {
            if (r) throw r.error;
          }
        }
      }
      if (o)
        throw new at(o);
    }
  }, t.prototype.add = function(e) {
    var n;
    if (e && e !== this)
      if (this.closed)
        Zt(e);
      else {
        if (e instanceof t) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(e);
      }
  }, t.prototype._hasParent = function(e) {
    var n = this._parentage;
    return n === e || Array.isArray(n) && n.includes(e);
  }, t.prototype._addParent = function(e) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(e), n) : n ? [n, e] : e;
  }, t.prototype._removeParent = function(e) {
    var n = this._parentage;
    n === e ? this._parentage = null : Array.isArray(n) && We(n, e);
  }, t.prototype.remove = function(e) {
    var n = this._finalizers;
    n && We(n, e), e instanceof t && e._removeParent(this);
  }, t.EMPTY = function() {
    var e = new t();
    return e.closed = !0, e;
  }(), t;
}(), Qn = Ae.EMPTY;
function Kn(t) {
  return t instanceof Ae || t && "closed" in t && M(t.remove) && M(t.add) && M(t.unsubscribe);
}
function Zt(t) {
  M(t) ? t() : t.unsubscribe();
}
var Es = {
  Promise: void 0
}, Os = {
  setTimeout: function(t, e) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, x([t, e], R(n)));
  },
  clearTimeout: function(t) {
    return clearTimeout(t);
  },
  delegate: void 0
};
function Gn(t) {
  Os.setTimeout(function() {
    throw t;
  });
}
function ft() {
}
function De(t) {
  t();
}
var kt = function(t) {
  K(e, t);
  function e(n) {
    var r = t.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, Kn(n) && n.add(r)) : r.destination = Ms, r;
  }
  return e.create = function(n, r, s) {
    return new Se(n, r, s);
  }, e.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, e.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(n) {
    this.destination.next(n);
  }, e.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(Ae), Ps = function() {
  function t(e) {
    this.partialObserver = e;
  }
  return t.prototype.next = function(e) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(e);
      } catch (r) {
        Oe(r);
      }
  }, t.prototype.error = function(e) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(e);
      } catch (r) {
        Oe(r);
      }
    else
      Oe(e);
  }, t.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (n) {
        Oe(n);
      }
  }, t;
}(), Se = function(t) {
  K(e, t);
  function e(n, r, s) {
    var o = t.call(this) || this, a;
    return M(n) || !n ? a = {
      next: n ?? void 0,
      error: r ?? void 0,
      complete: s ?? void 0
    } : a = n, o.destination = new Ps(a), o;
  }
  return e;
}(kt);
function Oe(t) {
  Gn(t);
}
function Rs(t) {
  throw t;
}
var Ms = {
  closed: !0,
  next: ft,
  error: Rs,
  complete: ft
}, wt = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function qn(t) {
  return t;
}
function Fs(t) {
  return t.length === 0 ? qn : t.length === 1 ? t[0] : function(n) {
    return t.reduce(function(r, s) {
      return s(r);
    }, n);
  };
}
var Q = function() {
  function t(e) {
    e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var n = new t();
    return n.source = this, n.operator = e, n;
  }, t.prototype.subscribe = function(e, n, r) {
    var s = this, o = Us(e) ? e : new Se(e, n, r);
    return De(function() {
      var a = s, l = a.operator, u = a.source;
      o.add(l ? l.call(o, u) : u ? s._subscribe(o) : s._trySubscribe(o));
    }), o;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (n) {
      e.error(n);
    }
  }, t.prototype.forEach = function(e, n) {
    var r = this;
    return n = en(n), new n(function(s, o) {
      var a = new Se({
        next: function(l) {
          try {
            e(l);
          } catch (u) {
            o(u), a.unsubscribe();
          }
        },
        error: o,
        complete: s
      });
      r.subscribe(a);
    });
  }, t.prototype._subscribe = function(e) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e);
  }, t.prototype[wt] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], n = 0; n < arguments.length; n++)
      e[n] = arguments[n];
    return Fs(e)(this);
  }, t.prototype.toPromise = function(e) {
    var n = this;
    return e = en(e), new e(function(r, s) {
      var o;
      n.subscribe(function(a) {
        return o = a;
      }, function(a) {
        return s(a);
      }, function() {
        return r(o);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
}();
function en(t) {
  var e;
  return (e = t ?? Es.Promise) !== null && e !== void 0 ? e : Promise;
}
function Ds(t) {
  return t && M(t.next) && M(t.error) && M(t.complete);
}
function Us(t) {
  return t && t instanceof kt || Ds(t) && Kn(t);
}
function Ls(t) {
  return M(t == null ? void 0 : t.lift);
}
function J(t) {
  return function(e) {
    if (Ls(e))
      return e.lift(function(n) {
        try {
          return t(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function $(t, e, n, r, s) {
  return new Ns(t, e, n, r, s);
}
var Ns = function(t) {
  K(e, t);
  function e(n, r, s, o, a, l) {
    var u = t.call(this, n) || this;
    return u.onFinalize = a, u.shouldUnsubscribe = l, u._next = r ? function(c) {
      try {
        r(c);
      } catch (d) {
        n.error(d);
      }
    } : t.prototype._next, u._error = o ? function(c) {
      try {
        o(c);
      } catch (d) {
        n.error(d);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._error, u._complete = s ? function() {
      try {
        s();
      } catch (c) {
        n.error(c);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._complete, u;
  }
  return e.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      t.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, e;
}(kt), Vs = mt(function(t) {
  return function() {
    t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), zn = function(t) {
  K(e, t);
  function e() {
    var n = t.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return e.prototype.lift = function(n) {
    var r = new tn(this, this);
    return r.operator = n, r;
  }, e.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Vs();
  }, e.prototype.next = function(n) {
    var r = this;
    De(function() {
      var s, o;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var a = H(r.currentObservers), l = a.next(); !l.done; l = a.next()) {
            var u = l.value;
            u.next(n);
          }
        } catch (c) {
          s = { error: c };
        } finally {
          try {
            l && !l.done && (o = a.return) && o.call(a);
          } finally {
            if (s) throw s.error;
          }
        }
      }
    });
  }, e.prototype.error = function(n) {
    var r = this;
    De(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var s = r.observers; s.length; )
          s.shift().error(n);
      }
    });
  }, e.prototype.complete = function() {
    var n = this;
    De(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, e.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(e.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), t.prototype._trySubscribe.call(this, n);
  }, e.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, e.prototype._innerSubscribe = function(n) {
    var r = this, s = this, o = s.hasError, a = s.isStopped, l = s.observers;
    return o || a ? Qn : (this.currentObservers = null, l.push(n), new Ae(function() {
      r.currentObservers = null, We(l, n);
    }));
  }, e.prototype._checkFinalizedStatuses = function(n) {
    var r = this, s = r.hasError, o = r.thrownError, a = r.isStopped;
    s ? n.error(o) : a && n.complete();
  }, e.prototype.asObservable = function() {
    var n = new Q();
    return n.source = this, n;
  }, e.create = function(n, r) {
    return new tn(n, r);
  }, e;
}(Q), tn = function(t) {
  K(e, t);
  function e(n, r) {
    var s = t.call(this) || this;
    return s.destination = n, s.source = r, s;
  }
  return e.prototype.next = function(n) {
    var r, s;
    (s = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || s === void 0 || s.call(r, n);
  }, e.prototype.error = function(n) {
    var r, s;
    (s = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || s === void 0 || s.call(r, n);
  }, e.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, e.prototype._subscribe = function(n) {
    var r, s;
    return (s = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && s !== void 0 ? s : Qn;
  }, e;
}(zn), Bs = {
  now: function() {
    return Date.now();
  }
}, Hs = function(t) {
  K(e, t);
  function e(n, r) {
    return t.call(this) || this;
  }
  return e.prototype.schedule = function(n, r) {
    return this;
  }, e;
}(Ae), nn = {
  setInterval: function(t, e) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setInterval.apply(void 0, x([t, e], R(n)));
  },
  clearInterval: function(t) {
    return clearInterval(t);
  },
  delegate: void 0
}, Ws = function(t) {
  K(e, t);
  function e(n, r) {
    var s = t.call(this, n, r) || this;
    return s.scheduler = n, s.work = r, s.pending = !1, s;
  }
  return e.prototype.schedule = function(n, r) {
    var s;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var o = this.id, a = this.scheduler;
    return o != null && (this.id = this.recycleAsyncId(a, o, r)), this.pending = !0, this.delay = r, this.id = (s = this.id) !== null && s !== void 0 ? s : this.requestAsyncId(a, this.id, r), this;
  }, e.prototype.requestAsyncId = function(n, r, s) {
    return s === void 0 && (s = 0), nn.setInterval(n.flush.bind(n, this), s);
  }, e.prototype.recycleAsyncId = function(n, r, s) {
    if (s === void 0 && (s = 0), s != null && this.delay === s && this.pending === !1)
      return r;
    r != null && nn.clearInterval(r);
  }, e.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var s = this._execute(n, r);
    if (s)
      return s;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, e.prototype._execute = function(n, r) {
    var s = !1, o;
    try {
      this.work(n);
    } catch (a) {
      s = !0, o = a || new Error("Scheduled action threw falsy error");
    }
    if (s)
      return this.unsubscribe(), o;
  }, e.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, s = n.scheduler, o = s.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, We(o, this), r != null && (this.id = this.recycleAsyncId(s, r, null)), this.delay = null, t.prototype.unsubscribe.call(this);
    }
  }, e;
}(Hs), rn = function() {
  function t(e, n) {
    n === void 0 && (n = t.now), this.schedulerActionCtor = e, this.now = n;
  }
  return t.prototype.schedule = function(e, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, e).schedule(r, n);
  }, t.now = Bs.now, t;
}(), xs = function(t) {
  K(e, t);
  function e(n, r) {
    r === void 0 && (r = rn.now);
    var s = t.call(this, n, r) || this;
    return s.actions = [], s._active = !1, s;
  }
  return e.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var s;
    this._active = !0;
    do
      if (s = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, s) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw s;
    }
  }, e;
}(rn), Ke = new xs(Ws), Qs = Ke, _t = new Q(function(t) {
  return t.complete();
});
function $n(t) {
  return t && M(t.schedule);
}
function jn(t) {
  return t[t.length - 1];
}
function Ks(t) {
  return $n(jn(t)) ? t.pop() : void 0;
}
function Gs(t, e) {
  return typeof jn(t) == "number" ? t.pop() : e;
}
var St = function(t) {
  return t && typeof t.length == "number" && typeof t != "function";
};
function Jn(t) {
  return M(t == null ? void 0 : t.then);
}
function Yn(t) {
  return M(t[wt]);
}
function Xn(t) {
  return Symbol.asyncIterator && M(t == null ? void 0 : t[Symbol.asyncIterator]);
}
function Zn(t) {
  return new TypeError("You provided " + (t !== null && typeof t == "object" ? "an invalid object" : "'" + t + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function qs() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var er = qs();
function tr(t) {
  return M(t == null ? void 0 : t[er]);
}
function nr(t) {
  return yr(this, arguments, function() {
    var n, r, s, o;
    return m(this, function(a) {
      switch (a.label) {
        case 0:
          n = t.getReader(), a.label = 1;
        case 1:
          a.trys.push([1, , 9, 10]), a.label = 2;
        case 2:
          return [4, he(n.read())];
        case 3:
          return r = a.sent(), s = r.value, o = r.done, o ? [4, he(void 0)] : [3, 5];
        case 4:
          return [2, a.sent()];
        case 5:
          return [4, he(s)];
        case 6:
          return [4, a.sent()];
        case 7:
          return a.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function rr(t) {
  return M(t == null ? void 0 : t.getReader);
}
function j(t) {
  if (t instanceof Q)
    return t;
  if (t != null) {
    if (Yn(t))
      return zs(t);
    if (St(t))
      return $s(t);
    if (Jn(t))
      return js(t);
    if (Xn(t))
      return ir(t);
    if (tr(t))
      return Js(t);
    if (rr(t))
      return Ys(t);
  }
  throw Zn(t);
}
function zs(t) {
  return new Q(function(e) {
    var n = t[wt]();
    if (M(n.subscribe))
      return n.subscribe(e);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function $s(t) {
  return new Q(function(e) {
    for (var n = 0; n < t.length && !e.closed; n++)
      e.next(t[n]);
    e.complete();
  });
}
function js(t) {
  return new Q(function(e) {
    t.then(function(n) {
      e.closed || (e.next(n), e.complete());
    }, function(n) {
      return e.error(n);
    }).then(null, Gn);
  });
}
function Js(t) {
  return new Q(function(e) {
    var n, r;
    try {
      for (var s = H(t), o = s.next(); !o.done; o = s.next()) {
        var a = o.value;
        if (e.next(a), e.closed)
          return;
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        o && !o.done && (r = s.return) && r.call(s);
      } finally {
        if (n) throw n.error;
      }
    }
    e.complete();
  });
}
function ir(t) {
  return new Q(function(e) {
    Xs(t, e).catch(function(n) {
      return e.error(n);
    });
  });
}
function Ys(t) {
  return ir(nr(t));
}
function Xs(t, e) {
  var n, r, s, o;
  return k(this, void 0, void 0, function() {
    var a, l;
    return m(this, function(u) {
      switch (u.label) {
        case 0:
          u.trys.push([0, 5, 6, 11]), n = mr(t), u.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = u.sent(), !!r.done) return [3, 4];
          if (a = r.value, e.next(a), e.closed)
            return [2];
          u.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return l = u.sent(), s = { error: l }, [3, 11];
        case 6:
          return u.trys.push([6, , 9, 10]), r && !r.done && (o = n.return) ? [4, o.call(n)] : [3, 8];
        case 7:
          u.sent(), u.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (s) throw s.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return e.complete(), [2];
      }
    });
  });
}
function ie(t, e, n, r, s) {
  r === void 0 && (r = 0), s === void 0 && (s = !1);
  var o = e.schedule(function() {
    n(), s ? t.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (t.add(o), !s)
    return o;
}
function sr(t, e) {
  return e === void 0 && (e = 0), J(function(n, r) {
    n.subscribe($(r, function(s) {
      return ie(r, t, function() {
        return r.next(s);
      }, e);
    }, function() {
      return ie(r, t, function() {
        return r.complete();
      }, e);
    }, function(s) {
      return ie(r, t, function() {
        return r.error(s);
      }, e);
    }));
  });
}
function or(t, e) {
  return e === void 0 && (e = 0), J(function(n, r) {
    r.add(t.schedule(function() {
      return n.subscribe(r);
    }, e));
  });
}
function Zs(t, e) {
  return j(t).pipe(or(e), sr(e));
}
function eo(t, e) {
  return j(t).pipe(or(e), sr(e));
}
function to(t, e) {
  return new Q(function(n) {
    var r = 0;
    return e.schedule(function() {
      r === t.length ? n.complete() : (n.next(t[r++]), n.closed || this.schedule());
    });
  });
}
function no(t, e) {
  return new Q(function(n) {
    var r;
    return ie(n, e, function() {
      r = t[er](), ie(n, e, function() {
        var s, o, a;
        try {
          s = r.next(), o = s.value, a = s.done;
        } catch (l) {
          n.error(l);
          return;
        }
        a ? n.complete() : n.next(o);
      }, 0, !0);
    }), function() {
      return M(r == null ? void 0 : r.return) && r.return();
    };
  });
}
function ar(t, e) {
  if (!t)
    throw new Error("Iterable cannot be null");
  return new Q(function(n) {
    ie(n, e, function() {
      var r = t[Symbol.asyncIterator]();
      ie(n, e, function() {
        r.next().then(function(s) {
          s.done ? n.complete() : n.next(s.value);
        });
      }, 0, !0);
    });
  });
}
function ro(t, e) {
  return ar(nr(t), e);
}
function io(t, e) {
  if (t != null) {
    if (Yn(t))
      return Zs(t, e);
    if (St(t))
      return to(t, e);
    if (Jn(t))
      return eo(t, e);
    if (Xn(t))
      return ar(t, e);
    if (tr(t))
      return no(t, e);
    if (rr(t))
      return ro(t, e);
  }
  throw Zn(t);
}
function so(t, e) {
  return e ? io(t, e) : j(t);
}
function cr(t) {
  return t instanceof Date && !isNaN(t);
}
var oo = mt(function(t) {
  return function(n) {
    n === void 0 && (n = null), t(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = n;
  };
});
function ao(t, e) {
  var n = cr(t) ? { first: t } : typeof t == "number" ? { each: t } : t, r = n.first, s = n.each, o = n.with, a = o === void 0 ? co : o, l = n.scheduler, u = l === void 0 ? Ke : l, c = n.meta, d = c === void 0 ? null : c;
  if (r == null && s == null)
    throw new TypeError("No timeout provided.");
  return J(function(h, p) {
    var C, y, _ = null, S = 0, v = function(g) {
      y = ie(p, u, function() {
        try {
          C.unsubscribe(), j(a({
            meta: d,
            lastValue: _,
            seen: S
          })).subscribe(p);
        } catch (f) {
          p.error(f);
        }
      }, g);
    };
    C = h.subscribe($(p, function(g) {
      y == null || y.unsubscribe(), S++, p.next(_ = g), s > 0 && v(s);
    }, void 0, void 0, function() {
      y != null && y.closed || y == null || y.unsubscribe(), _ = null;
    })), !S && v(r != null ? typeof r == "number" ? r : +r - u.now() : s);
  });
}
function co(t) {
  throw new oo(t);
}
function Z(t, e) {
  return J(function(n, r) {
    var s = 0;
    n.subscribe($(r, function(o) {
      r.next(t.call(e, o, s++));
    }));
  });
}
var uo = Array.isArray;
function lo(t, e) {
  return uo(e) ? t.apply(void 0, x([], R(e))) : t(e);
}
function po(t) {
  return Z(function(e) {
    return lo(t, e);
  });
}
function ho(t, e, n, r, s, o, a, l) {
  var u = [], c = 0, d = 0, h = !1, p = function() {
    h && !u.length && !c && e.complete();
  }, C = function(_) {
    return c < r ? y(_) : u.push(_);
  }, y = function(_) {
    c++;
    var S = !1;
    j(n(_, d++)).subscribe($(e, function(v) {
      e.next(v);
    }, function() {
      S = !0;
    }, void 0, function() {
      if (S)
        try {
          c--;
          for (var v = function() {
            var g = u.shift();
            a || y(g);
          }; u.length && c < r; )
            v();
          p();
        } catch (g) {
          e.error(g);
        }
    }));
  };
  return t.subscribe($(e, C, function() {
    h = !0, p();
  })), function() {
  };
}
function Ge(t, e, n) {
  return n === void 0 && (n = 1 / 0), M(e) ? Ge(function(r, s) {
    return Z(function(o, a) {
      return e(r, o, s, a);
    })(j(t(r, s)));
  }, n) : (typeof e == "number" && (n = e), J(function(r, s) {
    return ho(r, s, t, n);
  }));
}
function vo(t) {
  return t === void 0 && (t = 1 / 0), Ge(qn, t);
}
var go = ["addListener", "removeListener"], fo = ["addEventListener", "removeEventListener"], Co = ["on", "off"];
function we(t, e, n, r) {
  if (M(n) && (r = n, n = void 0), r)
    return we(t, e, n).pipe(po(r));
  var s = R(ko(t) ? fo.map(function(l) {
    return function(u) {
      return t[l](e, u, n);
    };
  }) : yo(t) ? go.map(sn(t, e)) : mo(t) ? Co.map(sn(t, e)) : [], 2), o = s[0], a = s[1];
  if (!o && St(t))
    return Ge(function(l) {
      return we(l, e, n);
    })(j(t));
  if (!o)
    throw new TypeError("Invalid event target");
  return new Q(function(l) {
    var u = function() {
      for (var c = [], d = 0; d < arguments.length; d++)
        c[d] = arguments[d];
      return l.next(1 < c.length ? c : c[0]);
    };
    return o(u), function() {
      return a(u);
    };
  });
}
function sn(t, e) {
  return function(n) {
    return function(r) {
      return t[n](e, r);
    };
  };
}
function yo(t) {
  return M(t.addListener) && M(t.removeListener);
}
function mo(t) {
  return M(t.on) && M(t.off);
}
function ko(t) {
  return M(t.addEventListener) && M(t.removeEventListener);
}
function wo(t, e, n) {
  n === void 0 && (n = Qs);
  var r = -1;
  return e != null && ($n(e) ? n = e : r = e), new Q(function(s) {
    var o = cr(t) ? 0 - n.now() : t;
    o < 0 && (o = 0);
    var a = 0;
    return n.schedule(function() {
      s.closed || (s.next(a++), 0 <= r ? this.schedule(void 0, r) : s.complete());
    }, o);
  });
}
function ur() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = Ks(t), r = Gs(t, 1 / 0), s = t;
  return s.length ? s.length === 1 ? j(s[0]) : vo(r)(so(s, n)) : _t;
}
function se(t, e) {
  return J(function(n, r) {
    var s = 0;
    n.subscribe($(r, function(o) {
      return t.call(e, o, s++) && r.next(o);
    }));
  });
}
function _o(t) {
  return J(function(e, n) {
    var r = [];
    return e.subscribe($(n, function(s) {
      return r.push(s);
    }, function() {
      n.next(r), n.complete();
    })), j(t).subscribe($(n, function() {
      var s = r;
      r = [], n.next(s);
    }, ft)), function() {
      r = null;
    };
  });
}
function So(t, e) {
  return e === void 0 && (e = Ke), J(function(n, r) {
    var s = null, o = null, a = null, l = function() {
      if (s) {
        s.unsubscribe(), s = null;
        var c = o;
        o = null, r.next(c);
      }
    };
    function u() {
      var c = a + t, d = e.now();
      if (d < c) {
        s = this.schedule(void 0, c - d), r.add(s);
        return;
      }
      l();
    }
    n.subscribe($(r, function(c) {
      o = c, a = e.now(), s || (s = e.schedule(u, t), r.add(s));
    }, function() {
      l(), r.complete();
    }, void 0, function() {
      o = s = null;
    }));
  });
}
function lr(t) {
  return t <= 0 ? function() {
    return _t;
  } : J(function(e, n) {
    var r = 0;
    e.subscribe($(n, function(s) {
      ++r <= t && (n.next(s), t <= r && n.complete());
    }));
  });
}
function bo(t) {
  return Z(function() {
    return t;
  });
}
function Ao(t, e) {
  return Ge(function(n, r) {
    return j(t(n, r)).pipe(lr(1), bo(n));
  });
}
function Io(t, e) {
  e === void 0 && (e = Ke);
  var n = wo(t, e);
  return Ao(function() {
    return n;
  });
}
function To() {
  return J(function(t, e) {
    var n, r = !1;
    t.subscribe($(e, function(s) {
      var o = n;
      n = s, r && e.next([o, s]), r = !0;
    }));
  });
}
function Pe(t) {
  t === void 0 && (t = {});
  var e = t.connector, n = e === void 0 ? function() {
    return new zn();
  } : e, r = t.resetOnError, s = r === void 0 ? !0 : r, o = t.resetOnComplete, a = o === void 0 ? !0 : o, l = t.resetOnRefCountZero, u = l === void 0 ? !0 : l;
  return function(c) {
    var d, h, p, C = 0, y = !1, _ = !1, S = function() {
      h == null || h.unsubscribe(), h = void 0;
    }, v = function() {
      S(), d = p = void 0, y = _ = !1;
    }, g = function() {
      var f = d;
      v(), f == null || f.unsubscribe();
    };
    return J(function(f, w) {
      C++, !_ && !y && S();
      var A = p = p ?? n();
      w.add(function() {
        C--, C === 0 && !_ && !y && (h = ct(g, u));
      }), A.subscribe(w), !d && C > 0 && (d = new Se({
        next: function(I) {
          return A.next(I);
        },
        error: function(I) {
          _ = !0, S(), h = ct(v, s, I), A.error(I);
        },
        complete: function() {
          y = !0, S(), h = ct(v, a), A.complete();
        }
      }), j(f).subscribe(d));
    })(c);
  };
}
function ct(t, e) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  if (e === !0) {
    t();
    return;
  }
  if (e !== !1) {
    var s = new Se({
      next: function() {
        s.unsubscribe(), t();
      }
    });
    return j(e.apply(void 0, x([], R(n)))).subscribe(s);
  }
}
function Eo(t, e) {
  return J(function(n, r) {
    var s = null, o = 0, a = !1, l = function() {
      return a && !s && r.complete();
    };
    n.subscribe($(r, function(u) {
      s == null || s.unsubscribe();
      var c = 0, d = o++;
      j(t(u, d)).subscribe(s = $(r, function(h) {
        return r.next(e ? e(u, h, d, c++) : h);
      }, function() {
        s = null, l();
      }));
    }, function() {
      a = !0, l();
    }));
  });
}
var Oo = ["input", "select", "textarea"], ut = function(t, e) {
  return function(n, r) {
    var s, o, a, l = t.pageUrlAllowlist, u = t.shouldTrackEventResolver, c = (o = (s = r == null ? void 0 : r.tagName) === null || s === void 0 ? void 0 : s.toLowerCase) === null || o === void 0 ? void 0 : o.call(s);
    if (!c)
      return !1;
    if (u)
      return u(n, r);
    if (!Ro(window.location.href, l))
      return !1;
    var d = String(r == null ? void 0 : r.getAttribute("type")) || "";
    if (typeof d == "string")
      switch (d.toLowerCase()) {
        case "hidden":
          return !1;
        case "password":
          return !1;
      }
    if (e) {
      var h = e.some(function(C) {
        var y;
        return !!(!((y = r == null ? void 0 : r.matches) === null || y === void 0) && y.call(r, C));
      });
      if (!h)
        return !1;
    }
    switch (c) {
      case "input":
      case "select":
      case "textarea":
        return n === "change" || n === "click";
      default: {
        var p = (a = window == null ? void 0 : window.getComputedStyle) === null || a === void 0 ? void 0 : a.call(window, r);
        return p && p.getPropertyValue("cursor") === "pointer" && n === "click" ? !0 : n === "click";
      }
    }
  };
}, dr = function(t) {
  if (t == null)
    return !1;
  if (typeof t == "string") {
    var e = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (e.test((t || "").replace(/[- ]/g, "")))
      return !1;
    var n = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (n.test(t))
      return !1;
  }
  return !0;
}, Po = function(t) {
  return !!t && t.nodeType === 3;
}, pr = function(t) {
  var e, n, r, s = (n = (e = t == null ? void 0 : t.tagName) === null || e === void 0 ? void 0 : e.toLowerCase) === null || n === void 0 ? void 0 : n.call(e), o = t instanceof HTMLElement ? ((r = t.getAttribute("contenteditable")) === null || r === void 0 ? void 0 : r.toLowerCase()) === "true" : !1;
  return !Oo.includes(s) && !o;
}, bt = function(t) {
  var e = "";
  return pr(t) && t.childNodes && t.childNodes.length && t.childNodes.forEach(function(n) {
    var r = "";
    Po(n) ? n.textContent && (r = n.textContent) : r = bt(n), e += r.split(/(\s+)/).filter(dr).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
  }), e;
}, Ro = function(t, e) {
  return !e || !e.length ? !0 : e.some(function(n) {
    return typeof n == "string" ? t === n : t.match(n);
  });
}, Mo = function(t, e) {
  return t.getAttributeNames().reduce(function(n, r) {
    if (r.startsWith(e)) {
      var s = r.replace(e, ""), o = t.getAttribute(r);
      s && (n[s] = o || "");
    }
    return n;
  }, {});
}, Fo = function(t) {
  return t == null || typeof t == "object" && Object.keys(t).length === 0 || typeof t == "string" && t.trim().length === 0;
}, hr = function(t) {
  return Object.keys(t).reduce(function(e, n) {
    var r = t[n];
    return Fo(r) || (e[n] = r), e;
  }, {});
}, vr = function(t) {
  var e = t.parentElement;
  if (!e)
    return "";
  var n;
  try {
    n = e.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
  } catch {
    n = null;
  }
  if (n) {
    var r = n.textContent || "";
    return dr(r) ? r : "";
  }
  return vr(e);
}, At = function(t, e) {
  return t ? e.some(function(n) {
    var r;
    return (r = t == null ? void 0 : t.matches) === null || r === void 0 ? void 0 : r.call(t, n);
  }) ? t : At(t == null ? void 0 : t.parentElement, e) : null;
}, Do = function(t) {
  var e, n, r;
  if (!t)
    return {};
  var s = (r = (n = t == null ? void 0 : t.tagName) === null || n === void 0 ? void 0 : n.toLowerCase) === null || r === void 0 ? void 0 : r.call(n), o = (e = {}, e[Hn] = s, e[Wn] = bt(t), e[xn] = window.location.href.split("?")[0], e);
  return hr(o);
}, Uo = function(t) {
  return new Promise(function(e, n) {
    var r;
    try {
      var s = document.createElement("script");
      s.type = "text/javascript", s.async = !0, s.src = t, s.addEventListener("load", function() {
        e({ status: !0 });
      }, { once: !0 }), s.addEventListener("error", function() {
        n({
          status: !1,
          message: "Failed to load the script ".concat(t)
        });
      }), (r = document.head) === null || r === void 0 || r.appendChild(s);
    } catch (o) {
      n(o);
    }
  });
};
function Lo() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var It = function(t) {
  return !(t.event.target === null || !t.closestTrackedAncestor);
}, No = (
  /** @class */
  function() {
    function t(e) {
      var n = e === void 0 ? {} : e, r = n.origin, s = r === void 0 ? Fe : r, o = this;
      this.endpoint = Fe, this.requestCallbacks = {}, this.onSelect = function(a) {
        o.notify({ action: "element-selected", data: a });
      }, this.onTrack = function(a, l) {
        a === "selector-mode-changed" ? o.notify({ action: "track-selector-mode-changed", data: l }) : a === "selector-moved" && o.notify({ action: "track-selector-moved", data: l });
      }, this.endpoint = s;
    }
    return t.prototype.notify = function(e) {
      var n, r, s, o;
      (r = (n = this.logger) === null || n === void 0 ? void 0 : n.debug) === null || r === void 0 || r.call(n, "Message sent: ", JSON.stringify(e)), (o = (s = window.opener) === null || s === void 0 ? void 0 : s.postMessage) === null || o === void 0 || o.call(s, e, this.endpoint);
    }, t.prototype.sendRequest = function(e, n, r) {
      var s = this;
      r === void 0 && (r = { timeout: 15e3 });
      var o = Lo(), a = {
        id: o,
        action: e,
        args: n
      }, l = new Promise(function(u, c) {
        s.requestCallbacks[o] = { resolve: u, reject: c }, s.notify(a), (r == null ? void 0 : r.timeout) > 0 && setTimeout(function() {
          c(new Error("".concat(e, " timed out (id: ").concat(o, ")"))), delete s.requestCallbacks[o];
        }, r.timeout);
      });
      return l;
    }, t.prototype.handleResponse = function(e) {
      var n;
      if (!this.requestCallbacks[e.id]) {
        (n = this.logger) === null || n === void 0 || n.warn("No callback found for request id: ".concat(e.id));
        return;
      }
      this.requestCallbacks[e.id].resolve(e.responseData), delete this.requestCallbacks[e.id];
    }, t.prototype.setup = function(e) {
      var n = this, r = e === void 0 ? {} : e, s = r.logger, o = r.endpoint, a = r.isElementSelectable, l = r.cssSelectorAllowlist, u = r.actionClickAllowlist;
      this.logger = s, o && this.endpoint === Fe && (this.endpoint = o);
      var c = null;
      window.addEventListener("message", function(d) {
        var h, p, C, y, _;
        if ((p = (h = n.logger) === null || h === void 0 ? void 0 : h.debug) === null || p === void 0 || p.call(h, "Message received: ", JSON.stringify(d)), n.endpoint === d.origin) {
          var S = d == null ? void 0 : d.data, v = S == null ? void 0 : S.action;
          if (v)
            if ("id" in S)
              (y = (C = n.logger) === null || C === void 0 ? void 0 : C.debug) === null || y === void 0 || y.call(C, "Received Response to previous request: ", JSON.stringify(d)), n.handleResponse(S);
            else if (v === "ping")
              n.notify({ action: "pong" });
            else if (v === "initialize-visual-tagging-selector") {
              var g = S == null ? void 0 : S.data;
              Uo(Is).then(function() {
                var f;
                c = (f = window == null ? void 0 : window.amplitudeVisualTaggingSelector) === null || f === void 0 ? void 0 : f.call(window, {
                  getEventTagProps: Do,
                  isElementSelectable: function(w) {
                    return a ? a((g == null ? void 0 : g.actionType) || "click", w) : !0;
                  },
                  onTrack: n.onTrack,
                  onSelect: n.onSelect,
                  visualHighlightClass: Ts,
                  messenger: n,
                  cssSelectorAllowlist: l,
                  actionClickAllowlist: u
                }), n.notify({ action: "selector-loaded" });
              }).catch(function() {
                var f;
                (f = n.logger) === null || f === void 0 || f.warn("Failed to initialize visual tagging selector");
              });
            } else v === "close-visual-tagging-selector" && ((_ = c == null ? void 0 : c.close) === null || _ === void 0 || _.call(c));
        }
      }), this.notify({ action: "page-loaded" });
    }, t;
  }()
), Vo = [
  // Already captured elsewhere in the hierarchy object
  "id",
  "class",
  // non-useful and potentially large attribute
  "style",
  // sensitive as prefilled form data may populate this attribute
  "value",
  // DOM events
  "onclick",
  "onchange",
  "oninput",
  "onblur",
  "onsubmit",
  "onfocus",
  "onkeydown",
  "onkeyup",
  "onkeypress",
  // React specific
  "data-reactid",
  "data-react-checksum",
  "data-reactroot"
], Bo = ["type"], Ho = ["svg", "path", "g"], Wo = ["password", "hidden"], xo = 128, Qo = 1024;
function Ko(t) {
  var e, n, r, s, o, a;
  if (t === null)
    return null;
  var l = String(t.tagName).toLowerCase(), u = {
    tag: l
  }, c = Array.from((s = (r = t.parentElement) === null || r === void 0 ? void 0 : r.children) !== null && s !== void 0 ? s : []);
  c.length && (u.index = c.indexOf(t), u.indexOfType = c.filter(function(w) {
    return w.tagName === t.tagName;
  }).indexOf(t));
  var d = (a = (o = t.previousElementSibling) === null || o === void 0 ? void 0 : o.tagName) === null || a === void 0 ? void 0 : a.toLowerCase();
  d && (u.prevSib = String(d));
  var h = t.getAttribute("id");
  h && (u.id = String(h));
  var p = Array.from(t.classList);
  p.length && (u.classes = p);
  var C = {}, y = Array.from(t.attributes), _ = y.filter(function(w) {
    return !Vo.includes(w.name);
  }), S = !pr(t);
  if (!Wo.includes(String(t.getAttribute("type"))) && !Ho.includes(l))
    try {
      for (var v = H(_), g = v.next(); !g.done; g = v.next()) {
        var f = g.value;
        S && !Bo.includes(f.name) || (C[f.name] = String(f.value).substring(0, xo));
      }
    } catch (w) {
      e = { error: w };
    } finally {
      try {
        g && !g.done && (n = v.return) && n.call(v);
      } finally {
        if (e) throw e.error;
      }
    }
  return Object.keys(C).length && (u.attrs = C), u;
}
function Go(t) {
  var e = [];
  if (!t)
    return e;
  e.push(t);
  for (var n = t.parentElement; n && n.tagName !== "HTML"; )
    e.push(n), n = n.parentElement;
  return e;
}
var qo = function(t) {
  var e = [];
  if (!t)
    return [];
  var n = Go(t);
  return e = zo(n.map(function(r) {
    return Ko(r);
  }), Qo), e;
};
function zo(t, e) {
  for (var n = 0, r = 0; r < t.length; r++) {
    var s = t[r];
    if (s === null)
      n += 4;
    else {
      var o = Ue(s);
      n += o ? Array.from(o).length : 4;
    }
    if (n > e)
      return t.slice(0, r);
  }
  return t;
}
function Ue(t, e) {
  e === void 0 && (e = !1);
  try {
    if (t == null)
      return e ? "None" : null;
    if (typeof t == "string")
      return e ? (t = t.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r"), t.includes('"') ? "'".concat(t, "'") : t.includes("'") ? '"'.concat(t.replace(/'/g, "\\'"), '"') : "'".concat(t, "'")) : t;
    if (typeof t == "boolean")
      return t ? "True" : "False";
    if (Array.isArray(t)) {
      var n = t.map(function(o) {
        return Ue(o, !0);
      });
      return "[".concat(n.join(", "), "]");
    } else if (typeof t == "object") {
      var r = Object.entries(t).filter(function(o) {
        var a = R(o, 1), l = a[0];
        return l != null;
      }).map(function(o) {
        var a = R(o, 2), l = a[0], u = a[1];
        return "".concat(String(Ue(l, !0)), ": ").concat(String(Ue(u, !0)));
      }), s = "{".concat(r.join(", "), "}");
      return s.includes("\\'") && (s = s.replace(/'/g, "'").replace(/'/g, "\\'")), s;
    }
    return t.toString();
  } catch {
    return null;
  }
}
var $o = 5;
function jo(t) {
  var e = t.amplitude, n = t.allObservables, r = t.options, s = t.shouldTrackEvent, o = n.clickObservable, a = o.pipe(To(), se(function(d) {
    var h = R(d, 2), p = h[0], C = h[1], y = p.event.target !== C.event.target, _ = Math.abs(C.event.screenX - p.event.screenX) <= 20 && Math.abs(C.event.screenY - p.event.screenY) <= 20;
    return y && !_;
  })), l = o.pipe(So(r.debounceTime), Z(function() {
    return "timeout";
  })), u = ur(a, l), c = o.pipe(Io(0), se(It), se(function(d) {
    return s("click", d.closestTrackedAncestor);
  }), _o(u));
  return c.subscribe(function(d) {
    var h, p, C = (d.length >= $o, gt);
    try {
      for (var y = H(d), _ = y.next(); !_.done; _ = y.next()) {
        var S = _.value;
        e == null || e.track(C, S.targetElementProperties);
      }
    } catch (v) {
      h = { error: v };
    } finally {
      try {
        _ && !_.done && (p = y.return) && p.call(y);
      } finally {
        if (h) throw h.error;
      }
    }
  });
}
function Jo(t) {
  var e = t.amplitude, n = t.allObservables, r = t.getEventProperties, s = t.shouldTrackEvent, o = n.changeObservable, a = o.pipe(se(It), se(function(l) {
    return s("change", l.closestTrackedAncestor);
  }));
  return a.subscribe(function(l) {
    e == null || e.track(ls, r("change", l.closestTrackedAncestor));
  });
}
function Yo(t) {
  var e = t.amplitude, n = t.allObservables, r = t.options, s = t.getEventProperties, o = t.shouldTrackEvent, a = t.shouldTrackActionClick, l = n.clickObservable, u = n.mutationObservable, c = n.navigateObservable, d = l.pipe(se(function(y) {
    return !o("click", y.closestTrackedAncestor);
  }), Z(function(y) {
    var _ = At(y.event.target, r.actionClickAllowlist);
    return y.closestTrackedAncestor = _, y.closestTrackedAncestor !== null && (y.targetElementProperties = s(y.type, y.closestTrackedAncestor)), y;
  }), se(It), se(function(y) {
    return a("click", y.closestTrackedAncestor);
  })), h = [u];
  c && h.push(c);
  var p = ur.apply(void 0, x([], R(h), !1)), C = d.pipe(
    // If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    Eo(function(y) {
      return p.pipe(
        lr(1),
        ao({ first: 500, with: function() {
          return _t;
        } }),
        // in case of timeout, map to empty to prevent any click from being emitted
        Z(function() {
          return y;
        })
      );
    })
  );
  return C.subscribe(function(y) {
    e == null || e.track(gt, s("click", y.closestTrackedAncestor));
  });
}
var pe;
(function(t) {
  t.ClickObservable = "clickObservable", t.ChangeObservable = "changeObservable", t.NavigateObservable = "navigateObservable", t.MutationObservable = "mutationObservable";
})(pe || (pe = {}));
function Xo(t) {
  return t.type === "click" || t.type === "change";
}
var Zo = function(t) {
  var e, n, r;
  t === void 0 && (t = {});
  var s = t.dataAttributePrefix, o = s === void 0 ? On : s, a = t.visualTaggingOptions, l = a === void 0 ? {
    enabled: !0,
    messenger: new No()
  } : a;
  t.cssSelectorAllowlist = (e = t.cssSelectorAllowlist) !== null && e !== void 0 ? e : En, t.actionClickAllowlist = (n = t.actionClickAllowlist) !== null && n !== void 0 ? n : Pn, t.debounceTime = (r = t.debounceTime) !== null && r !== void 0 ? r : 0;
  var u = us, c = "enrichment", d = [], h = function() {
    var v, g = we(document, "click", { capture: !0 }).pipe(Z(function(I) {
      return C(I, "click");
    }), Pe()), f = we(document, "change", { capture: !0 }).pipe(Z(function(I) {
      return C(I, "change");
    }), Pe()), w;
    window.navigation && (w = we(window.navigation, "navigate").pipe(Z(function(I) {
      return C(I, "navigate");
    }), Pe()));
    var A = new Q(function(I) {
      var E = new MutationObserver(function(O) {
        I.next(O);
      });
      return E.observe(document.body, {
        childList: !0,
        attributes: !0,
        characterData: !0,
        subtree: !0
      }), function() {
        return E.disconnect();
      };
    }).pipe(Z(function(I) {
      return C(I, "mutation");
    }), Pe());
    return v = {}, v[pe.ClickObservable] = g, v[pe.ChangeObservable] = f, // [ObservablesEnum.ErrorObservable]: errorObservable,
    v[pe.NavigateObservable] = w, v[pe.MutationObservable] = A, v;
  }, p = function(v, g) {
    var f, w, A, I = (A = (w = g == null ? void 0 : g.tagName) === null || w === void 0 ? void 0 : w.toLowerCase) === null || A === void 0 ? void 0 : A.call(w), E = typeof g.getBoundingClientRect == "function" ? g.getBoundingClientRect() : { left: null, top: null }, O = g.getAttribute("aria-label"), P = Mo(g, o), W = vr(g), V = (f = {}, f[ds] = g.getAttribute("id") || "", f[ps] = g.getAttribute("class"), f[hs] = qo(g), f[Hn] = I, f[Wn] = bt(g), f[gs] = E.left == null ? null : Math.round(E.left), f[fs] = E.top == null ? null : Math.round(E.top), f[Cs] = O, f[ys] = P, f[ms] = W, f[xn] = window.location.href.split("?")[0], f[ks] = typeof document < "u" && document.title || "", f[ws] = window.innerHeight, f[_s] = window.innerWidth, f);
    return I === "a" && v === "click" && g instanceof HTMLAnchorElement && (V[vs] = g.href), hr(V);
  }, C = function(v, g) {
    var f = {
      event: v,
      timestamp: Date.now(),
      type: g
    };
    if (Xo(f) && f.event.target !== null) {
      var w = At(f.event.target, t.cssSelectorAllowlist);
      return w && (f.closestTrackedAncestor = w, f.targetElementProperties = p(f.type, w)), f;
    }
    return f;
  }, y = function(v, g) {
    return k(void 0, void 0, void 0, function() {
      var f, w, A, I, E, O, P, W, V, G;
      return m(this, function(te) {
        return typeof document > "u" ? [
          2
          /*return*/
        ] : (f = ut(t, t.cssSelectorAllowlist), w = ut(t, t.actionClickAllowlist), A = h(), I = jo({
          allObservables: A,
          options: t,
          amplitude: g,
          shouldTrackEvent: f
        }), d.push(I), E = Jo({
          allObservables: A,
          getEventProperties: p,
          amplitude: g,
          shouldTrackEvent: f
        }), d.push(E), O = Yo({
          allObservables: A,
          options: t,
          getEventProperties: p,
          amplitude: g,
          shouldTrackEvent: f,
          shouldTrackActionClick: w
        }), d.push(O), (V = v == null ? void 0 : v.loggerProvider) === null || V === void 0 || V.log("".concat(u, " has been successfully added.")), window.opener && l.enabled && (P = t.cssSelectorAllowlist, W = t.actionClickAllowlist, (G = l.messenger) === null || G === void 0 || G.setup(b(b({ logger: v == null ? void 0 : v.loggerProvider }, (v == null ? void 0 : v.serverZone) && { endpoint: As[v.serverZone] }), { isElementSelectable: ut(t, x(x([], R(P), !1), R(W), !1)), cssSelectorAllowlist: P, actionClickAllowlist: W }))), [
          2
          /*return*/
        ]);
      });
    });
  }, _ = function(v) {
    return k(void 0, void 0, void 0, function() {
      return m(this, function(g) {
        return [2, v];
      });
    });
  }, S = function() {
    return k(void 0, void 0, void 0, function() {
      var v, g, f, w, A;
      return m(this, function(I) {
        try {
          for (v = H(d), g = v.next(); !g.done; g = v.next())
            f = g.value, f.unsubscribe();
        } catch (E) {
          w = { error: E };
        } finally {
          try {
            g && !g.done && (A = v.return) && A.call(v);
          } finally {
            if (w) throw w.error;
          }
        }
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: u,
    type: c,
    setup: y,
    execute: _,
    teardown: S
  };
}, ea = "utm_campaign", ta = "utm_content", na = "utm_id", ra = "utm_medium", ia = "utm_source", sa = "utm_term", on = "dclid", an = "fbclid", cn = "gbraid", un = "gclid", ln = "ko_click_id", dn = "li_fat_id", pn = "msclkid", hn = "rtd_cid", vn = "ttclid", gn = "twclid", fn = "wbraid", Tt = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, Cn = function(t) {
  var e = t.split(".");
  return e.length <= 2 ? t : e.slice(e.length - 2, e.length).join(".");
}, oa = function(t) {
  return Object.values(t).every(function(e) {
    return !e;
  });
}, aa = function(t, e, n, r, s) {
  s === void 0 && (s = !0), t.referrer;
  var o = t.referring_domain, a = dt(t, ["referrer", "referring_domain"]), l = e || {};
  l.referrer;
  var u = l.referring_domain, c = dt(l, ["referrer", "referring_domain"]);
  if (ca(n.excludeReferrers, t.referring_domain))
    return r.debug("This is not a new campaign because ".concat(t.referring_domain, " is in the exclude referrer list.")), !1;
  if (!s && oa(t) && e)
    return r.debug("This is not a new campaign because this is a direct traffic in the same session."), !1;
  var d = JSON.stringify(a) !== JSON.stringify(c), h = Cn(o || "") !== Cn(u || ""), p = !e || d || h;
  return p ? r.debug("This is a new campaign. An $identify event will be sent.") : r.debug("This is not a new campaign because it's the same as the previous one."), p;
}, ca = function(t, e) {
  return t === void 0 && (t = []), e === void 0 && (e = ""), t.some(function(n) {
    return n instanceof RegExp ? n.test(e) : n === e;
  });
}, ua = function(t, e) {
  var n = b(b({}, Tt), t), r = Object.entries(n).reduce(function(s, o) {
    var a, l = R(o, 2), u = l[0], c = l[1];
    return s.setOnce("initial_".concat(u), (a = c ?? e.initialEmptyValue) !== null && a !== void 0 ? a : "EMPTY"), c ? s.set(u, c) : s.unset(u);
  }, new ge());
  return wn(r);
}, la = function(t) {
  var e = t;
  return e ? (e.startsWith(".") && (e = e.substring(1)), [new RegExp("".concat(e.replace(".", "\\."), "$"))]) : [];
}, da = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.parse = function() {
      return k(this, void 0, void 0, function() {
        return m(this, function(e) {
          return [2, b(b(b(b({}, Tt), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, t.prototype.getUtmParam = function() {
      var e = Le(), n = e[ea], r = e[ta], s = e[na], o = e[ra], a = e[ia], l = e[sa];
      return {
        utm_campaign: n,
        utm_content: r,
        utm_id: s,
        utm_medium: o,
        utm_source: a,
        utm_term: l
      };
    }, t.prototype.getReferrer = function() {
      var e, n, r = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        r.referrer = document.referrer || void 0, r.referring_domain = (n = (e = r.referrer) === null || e === void 0 ? void 0 : e.split("/")[2]) !== null && n !== void 0 ? n : void 0;
      } catch {
      }
      return r;
    }, t.prototype.getClickIds = function() {
      var e, n = Le();
      return e = {}, e[on] = n[on], e[an] = n[an], e[cn] = n[cn], e[un] = n[un], e[ln] = n[ln], e[dn] = n[dn], e[pn] = n[pn], e[hn] = n[hn], e[vn] = n[vn], e[gn] = n[gn], e[fn] = n[fn], e;
    }, t;
  }()
), pa = (
  /** @class */
  function() {
    function t(e, n) {
      var r;
      this.shouldTrackNewCampaign = !1, this.options = b({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: !1, excludeReferrers: la((r = n.cookieOptions) === null || r === void 0 ? void 0 : r.domain) }, e), this.storage = n.cookieStorage, this.storageKey = ai(n.apiKey, "MKTG"), this.currentCampaign = Tt, this.sessionTimeout = n.sessionTimeout, this.lastEventTime = n.lastEventTime, this.logger = n.loggerProvider, n.loggerProvider.log("Installing web attribution tracking.");
    }
    return t.prototype.init = function() {
      return k(this, void 0, void 0, function() {
        var e, n;
        return m(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.fetchCampaign()];
            case 1:
              return n = R.apply(void 0, [r.sent(), 2]), this.currentCampaign = n[0], this.previousCampaign = n[1], e = this.lastEventTime ? An(this.sessionTimeout, this.lastEventTime) : !0, aa(this.currentCampaign, this.previousCampaign, this.options, this.logger, e) ? (this.shouldTrackNewCampaign = !0, [4, this.storage.set(this.storageKey, this.currentCampaign)]) : [3, 3];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.fetchCampaign = function() {
      return k(this, void 0, void 0, function() {
        return m(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, Promise.all([new da().parse(), this.storage.get(this.storageKey)])];
            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, t.prototype.generateCampaignEvent = function(e) {
      this.shouldTrackNewCampaign = !1;
      var n = ua(this.currentCampaign, this.options);
      return e && (n.event_id = e), n;
    }, t.prototype.shouldSetSessionIdOnNewCampaign = function() {
      return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    }, t;
  }()
), ha = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.init = function(n, r, s) {
      n === void 0 && (n = "");
      var o, a;
      return arguments.length > 2 ? (o = r, a = s) : typeof r == "string" ? (o = r, a = void 0) : (o = r == null ? void 0 : r.userId, a = r), q(this._init(b(b({}, a), { userId: o, apiKey: n })));
    }, e.prototype._init = function(n) {
      var r, s, o;
      return k(this, void 0, void 0, function() {
        var a, l, u, c, d, h, p = this;
        return m(this, function(C) {
          switch (C.label) {
            case 0:
              return this.initializing ? [
                2
                /*return*/
              ] : (this.initializing = !0, [4, Mi(n.apiKey, n, this)]);
            case 1:
              return a = C.sent(), n.fetchRemoteConfig ? [4, cs(a)] : [3, 4];
            case 2:
              return l = C.sent(), [4, l.generateJoinedConfig()];
            case 3:
              a = C.sent(), C.label = 4;
            case 4:
              return [4, t.prototype._init.call(this, a)];
            case 5:
              return C.sent(), this.logBrowserOptions(a), Rn(this.config.defaultTracking) ? (u = hi(this.config), this.webAttribution = new pa(u, this.config), [4, this.webAttribution.init()]) : [3, 7];
            case 6:
              C.sent(), C.label = 7;
            case 7:
              return c = Le(), d = Number.isNaN(Number(c.ampSessionId)) ? void 0 : Number(c.ampSessionId), this.setSessionId((o = (s = (r = n.sessionId) !== null && r !== void 0 ? r : d) !== null && s !== void 0 ? s : this.config.sessionId) !== null && o !== void 0 ? o : Date.now()), h = _e(n.instanceName), h.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), this.config.offline === Tn ? [3, 9] : [4, this.add(Yi()).promise];
            case 8:
              C.sent(), C.label = 9;
            case 9:
              return [4, this.add(new Qr()).promise];
            case 10:
              return C.sent(), [4, this.add(new Ci()).promise];
            case 11:
              return C.sent(), [4, this.add(new ei()).promise];
            case 12:
              return C.sent(), Ji(this.config), ui(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding file download tracking plugin"), [4, this.add(ji()).promise]) : [3, 14];
            case 13:
              C.sent(), C.label = 14;
            case 14:
              return li(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding form interaction plugin"), [4, this.add($i()).promise]) : [3, 16];
            case 15:
              C.sent(), C.label = 16;
            case 16:
              return Mn(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding page view tracking plugin"), [4, this.add(Ki(pi(this.config))).promise]) : [3, 18];
            case 17:
              C.sent(), C.label = 18;
            case 18:
              return Fn(this.config.autocapture) ? (this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)"), [4, this.add(Zo(di(this.config))).promise]) : [3, 20];
            case 19:
              C.sent(), C.label = 20;
            case 20:
              return this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
            case 21:
              return C.sent(), h.eventBridge.setEventReceiver(function(y) {
                p.track(y.eventType, y.eventProperties);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getUserId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.userId;
    }, e.prototype.setUserId = function(n) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setUserId: ", n), (n !== this.config.userId || n === void 0) && (this.config.userId = n, Xr(n, this.config.instanceName));
    }, e.prototype.getDeviceId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.deviceId;
    }, e.prototype.setDeviceId = function(n) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setDeviceId: ", n), this.config.deviceId = n, Zr(n, this.config.instanceName);
    }, e.prototype.reset = function() {
      this.setDeviceId(fe()), this.setUserId(void 0);
    }, e.prototype.getSessionId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.sessionId;
    }, e.prototype.setSessionId = function(n) {
      var r, s = [];
      if (!this.config)
        return this.q.push(this.setSessionId.bind(this, n)), q(Promise.resolve());
      if (n === this.config.sessionId)
        return q(Promise.resolve());
      this.config.loggerProvider.debug("function setSessionId: ", n);
      var o = this.getSessionId(), a = this.config.lastEventTime, l = (r = this.config.lastEventId) !== null && r !== void 0 ? r : -1;
      this.config.sessionId = n, this.config.lastEventTime = void 0, this.config.pageCounter = 0, Pt(this.config.defaultTracking) && (o && a && s.push(this.track(Ft, void 0, {
        device_id: this.previousSessionDeviceId,
        event_id: ++l,
        session_id: o,
        time: a + 1,
        user_id: this.previousSessionUserId
      }).promise), this.config.lastEventTime = this.config.sessionId);
      var u = this.trackCampaignEventIfNeeded(++l, s);
      return Pt(this.config.defaultTracking) && s.push(this.track(Mt, void 0, {
        event_id: u ? ++l : l,
        session_id: this.config.sessionId,
        time: this.config.lastEventTime
      }).promise), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId, q(Promise.all(s));
    }, e.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    }, e.prototype.setTransport = function(n) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, n));
        return;
      }
      this.config.transportProvider = Nn(n);
    }, e.prototype.identify = function(n, r) {
      if (nt(n)) {
        var s = n._q;
        n._q = [], n = tt(new ge(), s);
      }
      return r != null && r.user_id && this.setUserId(r.user_id), r != null && r.device_id && this.setDeviceId(r.device_id), t.prototype.identify.call(this, n, r);
    }, e.prototype.groupIdentify = function(n, r, s, o) {
      if (nt(s)) {
        var a = s._q;
        s._q = [], s = tt(new ge(), a);
      }
      return t.prototype.groupIdentify.call(this, n, r, s, o);
    }, e.prototype.revenue = function(n, r) {
      if (nt(n)) {
        var s = n._q;
        n._q = [], n = tt(new Vr(), s);
      }
      return t.prototype.revenue.call(this, n, r);
    }, e.prototype.trackCampaignEventIfNeeded = function(n, r) {
      if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign)
        return !1;
      var s = this.webAttribution.generateCampaignEvent(n);
      return r ? r.push(this.track(s).promise) : this.track(s), this.config.loggerProvider.log("Tracking attribution."), !0;
    }, e.prototype.process = function(n) {
      return k(this, void 0, void 0, function() {
        var r, s, o;
        return m(this, function(a) {
          return r = Date.now(), s = An(this.config.sessionTimeout, this.config.lastEventTime), o = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign(), n.event_type !== Mt && n.event_type !== Ft && (!n.session_id || n.session_id === this.getSessionId()) && (s || o ? (this.setSessionId(r), o && this.config.loggerProvider.log("Created a new session for new campaign.")) : s || this.trackCampaignEventIfNeeded()), [2, t.prototype.process.call(this, n)];
        });
      });
    }, e.prototype.logBrowserOptions = function(n) {
      try {
        var r = b(b({}, n), { apiKey: n.apiKey.substring(0, 10) + "********" });
        this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify(r));
      } catch (s) {
        this.config.loggerProvider.error("Error logging browser config", s);
      }
    }, e;
  }(Nr)
), gr = function() {
  var t = new ha();
  return {
    init: U(t.init.bind(t), "init", F(t), D(t, ["config"])),
    add: U(t.add.bind(t), "add", F(t), D(t, ["config.apiKey", "timeline.plugins"])),
    remove: U(t.remove.bind(t), "remove", F(t), D(t, ["config.apiKey", "timeline.plugins"])),
    track: U(t.track.bind(t), "track", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    logEvent: U(t.logEvent.bind(t), "logEvent", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    identify: U(t.identify.bind(t), "identify", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: U(t.groupIdentify.bind(t), "groupIdentify", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    setGroup: U(t.setGroup.bind(t), "setGroup", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    revenue: U(t.revenue.bind(t), "revenue", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    flush: U(t.flush.bind(t), "flush", F(t), D(t, ["config.apiKey", "timeline.queue.length"])),
    getUserId: U(t.getUserId.bind(t), "getUserId", F(t), D(t, ["config", "config.userId"])),
    setUserId: U(t.setUserId.bind(t), "setUserId", F(t), D(t, ["config", "config.userId"])),
    getDeviceId: U(t.getDeviceId.bind(t), "getDeviceId", F(t), D(t, ["config", "config.deviceId"])),
    setDeviceId: U(t.setDeviceId.bind(t), "setDeviceId", F(t), D(t, ["config", "config.deviceId"])),
    reset: U(t.reset.bind(t), "reset", F(t), D(t, ["config", "config.userId", "config.deviceId"])),
    getSessionId: U(t.getSessionId.bind(t), "getSessionId", F(t), D(t, ["config"])),
    setSessionId: U(t.setSessionId.bind(t), "setSessionId", F(t), D(t, ["config"])),
    extendSession: U(t.extendSession.bind(t), "extendSession", F(t), D(t, ["config"])),
    setOptOut: U(t.setOptOut.bind(t), "setOptOut", F(t), D(t, ["config"])),
    setTransport: U(t.setTransport.bind(t), "setTransport", F(t), D(t, ["config"]))
  };
};
const N = gr();
N.add;
N.extendSession;
N.flush;
N.getDeviceId;
N.getSessionId;
N.getUserId;
N.groupIdentify;
N.identify;
N.init;
N.logEvent;
N.remove;
N.reset;
N.revenue;
N.setDeviceId;
N.setGroup;
N.setOptOut;
N.setSessionId;
N.setTransport;
N.setUserId;
N.track;
var Ct;
(function(t) {
  t.IdentifyOperation = ht, t.SpecialEventType = ue, t.RevenueProperty = Y, t.LogLevel = z, t.OfflineDisabled = Tn, t.DEFAULT_CSS_SELECTOR_ALLOWLIST = En, t.DEFAULT_DATA_ATTRIBUTE_PREFIX = On, t.DEFAULT_ACTION_CLICK_ALLOWLIST = Pn;
})(Ct || (Ct = {}));
const va = {
  prod: "9697cc8538da787c61338c2f38936f4e",
  stag: "44832403362971771e3b4df598b6c3f2"
}, ga = {
  plan: {
    version: "73",
    branch: "main",
    source: "agent-interface",
    versionId: "fa1a912c-3b22-4e76-9be3-3b9010a34115"
  },
  ingestionMetadata: {
    sourceName: "browser-typescript-ampli",
    sourceVersion: "2.0.0"
  }
};
class Jk {
  constructor(e) {
    i(this, "event_type", Ct.SpecialEventType.IDENTIFY);
    this.event_properties = e, this.event_properties = e;
  }
}
class fa {
  constructor(e) {
    i(this, "event_type", "Add Agents Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ca {
  constructor() {
    i(this, "event_type", "Agent Copilot Back Button Clicked");
  }
}
class ya {
  constructor(e) {
    i(this, "event_type", "Agent Copilot Dropdown Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ma {
  constructor(e) {
    i(this, "event_type", "Agent Copilot Improve Writing Improvement Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ka {
  constructor(e) {
    i(this, "event_type", "Agent Copilot Text Insert Below Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wa {
  constructor(e) {
    i(this, "event_type", "Agent Copilot Text Replace Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class _a {
  constructor(e) {
    i(this, "event_type", "Agent Copilot Translate Message Language Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sa {
  constructor(e) {
    i(this, "event_type", "Agent Copilot Trial Learn More Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ba {
  constructor() {
    i(this, "event_type", "Agent Copilot Trial Leftmenu CTA Clicked");
  }
}
class Aa {
  constructor() {
    i(this, "event_type", "Agent Copilot Trial Leftmenu CTA Dismissed");
  }
}
class Ia {
  constructor() {
    i(this, "event_type", "Agent Copilot Trial Request Contact Clicked");
  }
}
class Ta {
  constructor() {
    i(this, "event_type", "Agent Copilot Trial Started");
  }
}
class Ea {
  constructor() {
    i(this, "event_type", "Agent Copilot Trial Stopped");
  }
}
class Oa {
  constructor() {
    i(this, "event_type", "Agent Copilot Undo Clicked");
  }
}
class Pa {
  constructor(e) {
    i(this, "event_type", "Agent Custom Away Status Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ra {
  constructor(e) {
    i(this, "event_type", "Analytics Business Hours Schedule Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ma {
  constructor(e) {
    i(this, "event_type", "Analytics Business Hours Schedule Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fa {
  constructor(e) {
    i(this, "event_type", "Analytics Chart Granularity Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Da {
  constructor(e) {
    i(this, "event_type", "Analytics Chart Visualization Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ua {
  constructor(e) {
    i(this, "event_type", "Analytics Compare Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class La {
  constructor(e) {
    i(this, "event_type", "Analytics Compare Context Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Na {
  constructor(e) {
    i(this, "event_type", "Analytics Compare Period Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Va {
  constructor(e) {
    i(this, "event_type", "Analytics Context Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ba {
  constructor(e) {
    i(this, "event_type", "Analytics Conversation Link Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ha {
  constructor(e) {
    i(this, "event_type", "Analytics Conversation Preview Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wa {
  constructor(e) {
    i(this, "event_type", "Analytics Dashboard Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class xa {
  constructor(e) {
    i(this, "event_type", "Analytics Export Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qa {
  constructor(e) {
    i(this, "event_type", "Analytics Export Download Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ka {
  constructor(e) {
    i(this, "event_type", "Analytics Export My Data Button Pressed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ga {
  constructor(e) {
    i(this, "event_type", "Analytics Filter Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class qa {
  constructor(e) {
    i(this, "event_type", "Analytics Filter Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class za {
  constructor(e) {
    i(this, "event_type", "Analytics Filter Operator Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class $a {
  constructor(e) {
    i(this, "event_type", "Analytics Filter Value Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class ja {
  constructor(e) {
    i(this, "event_type", "Analytics Filters Applied");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ja {
  constructor(e) {
    i(this, "event_type", "Analytics Filters Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ya {
  constructor(e) {
    i(this, "event_type", "Analytics Helper Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xa {
  constructor(e) {
    i(this, "event_type", "Analytics In Depth Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Za {
  constructor(e) {
    i(this, "event_type", "Analytics Insights Copy Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ec {
  constructor(e) {
    i(this, "event_type", "Analytics Insights Feedback Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class tc {
  constructor(e) {
    i(this, "event_type", "Analytics Insights Prompt Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class nc {
  constructor(e) {
    i(this, "event_type", "Analytics Insights Regenerate Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class rc {
  constructor(e) {
    i(this, "event_type", "Analytics Panel Controls Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class ic {
  constructor(e) {
    i(this, "event_type", "Analytics Period Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class sc {
  constructor(e) {
    i(this, "event_type", "Analytics Pin Panel Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class oc {
  constructor(e) {
    i(this, "event_type", "Analytics Pin Panel Quick View Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class ac {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Auto Refresh Disabled");
    this.event_properties = e, this.event_properties = e;
  }
}
class cc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Auto Refresh Enabled");
    this.event_properties = e, this.event_properties = e;
  }
}
class uc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Auto Refresh Triggered");
    this.event_properties = e, this.event_properties = e;
  }
}
class lc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class dc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class pc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Duplicated");
    this.event_properties = e, this.event_properties = e;
  }
}
class hc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Favorite Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class vc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Landing Page Set");
    this.event_properties = e, this.event_properties = e;
  }
}
class gc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Landing Page Unset");
    this.event_properties = e, this.event_properties = e;
  }
}
class fc {
  constructor() {
    i(this, "event_type", "Analytics Quick View Ownership Transferred");
  }
}
class Cc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Panel Controls Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class yc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Panel Description Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class mc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Panel Pinned");
    this.event_properties = e, this.event_properties = e;
  }
}
class kc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Panel Unpinned");
    this.event_properties = e, this.event_properties = e;
  }
}
class wc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Panels Layout Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class _c {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Panels Reset");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Panels Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class bc {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Sharing Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ac {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ic {
  constructor(e) {
    i(this, "event_type", "Analytics Quick View Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tc {
  constructor(e) {
    i(this, "event_type", "Analytics Refresh Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ec {
  constructor(e) {
    i(this, "event_type", "Analytics Table Load All Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Oc {
  constructor(e) {
    i(this, "event_type", "Analytics Table Sort Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pc {
  constructor(e) {
    i(this, "event_type", "Analytics Timezone Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rc {
  constructor(e) {
    i(this, "event_type", "Analytics View Conversations Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mc {
  constructor(e) {
    i(this, "event_type", "Auth Failed Init");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fc {
  constructor() {
    i(this, "event_type", "Automations Flow Options Menu Option Audit Log Clicked");
  }
}
class Dc {
  constructor(e) {
    i(this, "event_type", "Automations Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Uc {
  constructor(e) {
    i(this, "event_type", "Automations Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lc {
  constructor(e) {
    i(this, "event_type", "Automations Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nc {
  constructor() {
    i(this, "event_type", "Automations Options Menu Opened");
  }
}
class Vc {
  constructor() {
    i(this, "event_type", "Automations Options Menu Option Delete Clicked");
  }
}
class Bc {
  constructor() {
    i(this, "event_type", "Automations Options Menu Option Duplicate Clicked");
  }
}
class Hc {
  constructor() {
    i(this, "event_type", "Automations Options Menu Option Flow Clicked");
  }
}
class Wc {
  constructor() {
    i(this, "event_type", "Automations Options Menu Option Settings Clicked");
  }
}
class xc {
  constructor() {
    i(this, "event_type", "Automations Pagination Next Clicked");
  }
}
class Qc {
  constructor() {
    i(this, "event_type", "Automations Pagination Previous Clicked");
  }
}
class Kc {
  constructor() {
    i(this, "event_type", "Automations Search Applied");
  }
}
class Gc {
  constructor() {
    i(this, "event_type", "Automations Search Closed");
  }
}
class qc {
  constructor() {
    i(this, "event_type", "Automations Search Opened");
  }
}
class zc {
  constructor() {
    i(this, "event_type", "Automations Toggled Off");
  }
}
class $c {
  constructor() {
    i(this, "event_type", "Automations Toggled On");
  }
}
class jc {
  constructor(e) {
    i(this, "event_type", "Bans Ban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jc {
  constructor() {
    i(this, "event_type", "Bans Unban Ip Clicked");
  }
}
class Yc {
  constructor(e) {
    i(this, "event_type", "Bans Unban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xc {
  constructor(e) {
    i(this, "event_type", "Bulk Actions Update Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zc {
  constructor(e) {
    i(this, "event_type", "Business Hours Add Schedule Audio Message Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class eu {
  constructor() {
    i(this, "event_type", "Business Hours Add Schedule Button Clicked");
  }
}
class tu {
  constructor(e) {
    i(this, "event_type", "Business Hours Add Schedule Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class nu {
  constructor(e) {
    i(this, "event_type", "Business Hours Add Schedule Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ru {
  constructor() {
    i(this, "event_type", "Business Hours Conflict Notification Button Clicked");
  }
}
class iu {
  constructor() {
    i(this, "event_type", "Business Hours Conflict Notification Closed");
  }
}
class su {
  constructor() {
    i(this, "event_type", "Business Hours Delete Schedule Form Cancelled");
  }
}
class ou {
  constructor() {
    i(this, "event_type", "Business Hours Delete Schedule Form Submitted");
  }
}
class au {
  constructor() {
    i(this, "event_type", "Business Hours Duplicate Schedule Form Cancelled");
  }
}
class cu {
  constructor() {
    i(this, "event_type", "Business Hours Duplicate Schedule Form Submitted");
  }
}
class uu {
  constructor(e) {
    i(this, "event_type", "Business Hours First Schedule Modal Question Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class lu {
  constructor() {
    i(this, "event_type", "Business Hours First Schedule Support Article Clicked");
  }
}
class du {
  constructor() {
    i(this, "event_type", "Business Hours Go To Flow Clicked");
  }
}
class pu {
  constructor(e) {
    i(this, "event_type", "Business Hours Migration Wizard Audio Message Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class hu {
  constructor() {
    i(this, "event_type", "Business Hours Migration Wizard Create New Schedule Button Clicked");
  }
}
class vu {
  constructor() {
    i(this, "event_type", "Business Hours Migration Wizard Edit Hours Button Clicked");
  }
}
class gu {
  constructor(e) {
    i(this, "event_type", "Business Hours Migration Wizard Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class fu {
  constructor(e) {
    i(this, "event_type", "Business Hours Migration Wizard Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cu {
  constructor() {
    i(this, "event_type", "Business Hours Migration Wizard Opening Hours Form Cancelled");
  }
}
class yu {
  constructor() {
    i(this, "event_type", "Business Hours Migration Wizard Opening Hours Form Submitted");
  }
}
class mu {
  constructor() {
    i(this, "event_type", "Business Hours Migration Wizard Start Update Button Clicked");
  }
}
class ku {
  constructor() {
    i(this, "event_type", "Business Hours Options Menu Opened");
  }
}
class wu {
  constructor() {
    i(this, "event_type", "Business Hours Options Menu Option Delete Clicked");
  }
}
class _u {
  constructor() {
    i(this, "event_type", "Business Hours Options Menu Option Duplicate Clicked");
  }
}
class Su {
  constructor() {
    i(this, "event_type", "Business Hours Options Menu Option Edit Clicked");
  }
}
class bu {
  constructor() {
    i(this, "event_type", "Business Hours Options Menu Option Rename Clicked");
  }
}
class Au {
  constructor() {
    i(this, "event_type", "Business Hours Rename Schedule Form Cancelled");
  }
}
class Iu {
  constructor(e) {
    i(this, "event_type", "Business Hours Rename Schedule Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Add Exception Button Clicked");
  }
}
class Eu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Add Exception Form Cancelled");
  }
}
class Ou {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Add Exception Form Submitted");
  }
}
class Pu {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Audio Message Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ru {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Audio Message Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mu {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Audio Message Options Menu Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fu {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Audio Message Options Menu Option Clear Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Du {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Audio Message Options Menu Option Record Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Uu {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Audio Message Options Menu Option Upload Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lu {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Auto Reply Options Menu Option Clear Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Conflict Change Button Clicked");
  }
}
class Vu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Conflict Review Button Clicked");
  }
}
class Bu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Delete Exception Form Cancelled");
  }
}
class Hu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Delete Exception Form Submitted");
  }
}
class Wu {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Exception Options Menu Option Delete Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class xu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Import Holiday Form Cancelled");
  }
}
class Qu {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Import Holiday Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ku {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Options Menu Import Holidays Clicked");
  }
}
class Gu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Options Menu Opened");
  }
}
class qu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Options Menu Recover Holidays Clicked");
  }
}
class zu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Options Menu Rename Clicked");
  }
}
class $u {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Options Menu Timezone Clicked");
  }
}
class ju {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Preview Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ju {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Recover Holidays Form Cancelled");
  }
}
class Yu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Recover Holidays Form Submitted");
  }
}
class Xu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Review Form Cancelled");
  }
}
class Zu {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Review Form Submitted");
  }
}
class el {
  constructor() {
    i(this, "event_type", "Business Hours Schedule Save Schedule Button Clicked");
  }
}
class tl {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule Tab Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class nl {
  constructor(e) {
    i(this, "event_type", "Business Hours Schedule View Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class rl {
  constructor() {
    i(this, "event_type", "Chat Flow Options Menu Option Audit Log Clicked");
  }
}
class il {
  constructor(e) {
    i(this, "event_type", "Chat Form Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class sl {
  constructor(e) {
    i(this, "event_type", "Chat Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class ol {
  constructor(e) {
    i(this, "event_type", "Chat Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class al {
  constructor() {
    i(this, "event_type", "Chat Options Menu Opened");
  }
}
class cl {
  constructor() {
    i(this, "event_type", "Chat Options Menu Option Delete Clicked");
  }
}
class ul {
  constructor() {
    i(this, "event_type", "Chat Options Menu Option Duplicate Clicked");
  }
}
class ll {
  constructor() {
    i(this, "event_type", "Chat Options Menu Option Flow Clicked");
  }
}
class dl {
  constructor() {
    i(this, "event_type", "Chat Options Menu Option Rename Clicked");
  }
}
class pl {
  constructor() {
    i(this, "event_type", "Chat Options Menu Option Setup Clicked");
  }
}
class hl {
  constructor() {
    i(this, "event_type", "Chat Pagination Next Clicked");
  }
}
class vl {
  constructor() {
    i(this, "event_type", "Chat Pagination Previous Clicked");
  }
}
class gl {
  constructor() {
    i(this, "event_type", "Chat Search Applied");
  }
}
class fl {
  constructor() {
    i(this, "event_type", "Chat Search Closed");
  }
}
class Cl {
  constructor() {
    i(this, "event_type", "Chat Search Opened");
  }
}
class yl {
  constructor() {
    i(this, "event_type", "Chatbot Create Modal Opened");
  }
}
class ml {
  constructor(e) {
    i(this, "event_type", "Chatbot Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class kl {
  constructor() {
    i(this, "event_type", "Chatbot Delete Modal Opened");
  }
}
class wl {
  constructor(e) {
    i(this, "event_type", "Chatbot Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class _l {
  constructor() {
    i(this, "event_type", "Chatbot Edit Identity Modal Opened");
  }
}
class Sl {
  constructor() {
    i(this, "event_type", "Chatbot Identity Edited");
  }
}
class bl {
  constructor(e) {
    i(this, "event_type", "Color Mode Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Al {
  constructor(e) {
    i(this, "event_type", "Command Executed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Il {
  constructor(e) {
    i(this, "event_type", "Company Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tl {
  constructor() {
    i(this, "event_type", "Contacts Add New Company Clicked");
  }
}
class El {
  constructor() {
    i(this, "event_type", "Contacts Add New Contact Clicked");
  }
}
class Ol {
  constructor(e) {
    i(this, "event_type", "Contacts Ban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pl {
  constructor() {
    i(this, "event_type", "Contacts Card Actions Menu Opened");
  }
}
class Rl {
  constructor() {
    i(this, "event_type", "Contacts Card Compose New Email Clicked");
  }
}
class Ml {
  constructor() {
    i(this, "event_type", "Contacts Card Edit Company Clicked");
  }
}
class Fl {
  constructor() {
    i(this, "event_type", "Contacts Card Edit Contact Clicked");
  }
}
class Dl {
  constructor() {
    i(this, "event_type", "Contacts Card Make Call Clicked");
  }
}
class Ul {
  constructor() {
    i(this, "event_type", "Contacts Card See All Assigned Conversations Clicked");
  }
}
class Ll {
  constructor() {
    i(this, "event_type", "Contacts Card See All Conversations Clicked");
  }
}
class Nl {
  constructor() {
    i(this, "event_type", "Contacts Card View Company Clicked");
  }
}
class Vl {
  constructor() {
    i(this, "event_type", "Contacts Card View User Clicked");
  }
}
class Bl {
  constructor() {
    i(this, "event_type", "Contacts Search Blurred");
  }
}
class Hl {
  constructor() {
    i(this, "event_type", "Contacts Search Focused");
  }
}
class Wl {
  constructor(e) {
    i(this, "event_type", "Contacts Unban User Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class xl {
  constructor() {
    i(this, "event_type", "Contacts View Companies");
  }
}
class Ql {
  constructor() {
    i(this, "event_type", "Contacts View End Users");
  }
}
class Kl {
  constructor() {
    i(this, "event_type", "Conversation Actions Menu Opened");
  }
}
class Gl {
  constructor(e) {
    i(this, "event_type", "Conversation Actions Menu Option Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ql {
  constructor() {
    i(this, "event_type", "Conversation Activity Log Closed");
  }
}
class zl {
  constructor() {
    i(this, "event_type", "Conversation Activity Log Flooter Expanded");
  }
}
class $l {
  constructor(e) {
    i(this, "event_type", "Conversation Activity Log Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class jl {
  constructor(e) {
    i(this, "event_type", "Conversation Article Draft Improvement Requested");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jl {
  constructor(e) {
    i(this, "event_type", "Conversation Article Draft Improvement Response Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yl {
  constructor(e) {
    i(this, "event_type", "Conversation Article Draft Preview Requested");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xl {
  constructor(e) {
    i(this, "event_type", "Conversation Article Draft Preview Response Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zl {
  constructor(e) {
    i(this, "event_type", "Conversation Article Draft Save Requested");
    this.event_properties = e, this.event_properties = e;
  }
}
class ed {
  constructor(e) {
    i(this, "event_type", "Conversation Article Draft Save Response Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class td {
  constructor() {
    i(this, "event_type", "Conversation Attached Image Is Downloaded");
  }
}
class nd {
  constructor() {
    i(this, "event_type", "Conversation Attached Image Is Viewed");
  }
}
class rd {
  constructor(e) {
    i(this, "event_type", "Conversation Claimed");
    this.event_properties = e, this.event_properties = e;
  }
}
class id {
  constructor(e) {
    i(this, "event_type", "Conversation Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class sd {
  constructor() {
    i(this, "event_type", "Conversation Csat Cancelled");
  }
}
class od {
  constructor() {
    i(this, "event_type", "Conversation Csat Menu Cancel Option Clicked");
  }
}
class ad {
  constructor(e) {
    i(this, "event_type", "Conversation Csat Menu Language Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class cd {
  constructor() {
    i(this, "event_type", "Conversation Csat Menu Opened");
  }
}
class ud {
  constructor(e) {
    i(this, "event_type", "Conversation Focus Mode Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class ld {
  constructor(e) {
    i(this, "event_type", "Conversation Follow Up");
    this.event_properties = e, this.event_properties = e;
  }
}
class dd {
  constructor() {
    i(this, "event_type", "Conversation Follow Up Menu Opened");
  }
}
class pd {
  constructor(e) {
    i(this, "event_type", "Conversation Follow Up Menu Option Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class hd {
  constructor() {
    i(this, "event_type", "Conversation Header Conversation Details Menu Opened");
  }
}
class vd {
  constructor(e) {
    i(this, "event_type", "Conversation Header Tag Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class gd {
  constructor(e) {
    i(this, "event_type", "Conversation Header Tag Include Deactivated Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class fd {
  constructor() {
    i(this, "event_type", "Conversation Header Tag Menu Opened");
  }
}
class Cd {
  constructor(e) {
    i(this, "event_type", "Conversation Header Tag Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class yd {
  constructor() {
    i(this, "event_type", "Conversation Header Transfer To Agent Item Selected");
  }
}
class md {
  constructor() {
    i(this, "event_type", "Conversation Header Transfer To Agent Menu Opened");
  }
}
class kd {
  constructor() {
    i(this, "event_type", "Conversation Header Transfer To Number Button Clicked");
  }
}
class wd {
  constructor(e) {
    i(this, "event_type", "Conversation Header Transfer To Queue Item Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class _d {
  constructor() {
    i(this, "event_type", "Conversation Header Transfer To Queue Menu Opened");
  }
}
class Sd {
  constructor() {
    i(this, "event_type", "Conversation Internal Note Editor Opened");
  }
}
class bd {
  constructor(e) {
    i(this, "event_type", "Conversation Offered");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ad {
  constructor(e) {
    i(this, "event_type", "Conversation Replied");
    this.event_properties = e, this.event_properties = e;
  }
}
class Id {
  constructor(e) {
    i(this, "event_type", "Conversation Resolved As A Knowledge Article Draft");
    this.event_properties = e, this.event_properties = e;
  }
}
class Td {
  constructor(e) {
    i(this, "event_type", "Conversation Resolved As A Knowledge Gap");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ed {
  constructor(e) {
    i(this, "event_type", "Conversation Resolved By Knowledge");
    this.event_properties = e, this.event_properties = e;
  }
}
class Od {
  constructor(e) {
    i(this, "event_type", "Conversation Resolved With No Knowledge Article");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pd {
  constructor() {
    i(this, "event_type", "Conversation Sidebar Closed");
  }
}
class Rd {
  constructor() {
    i(this, "event_type", "Conversation Sidebar Conversation History Closed");
  }
}
class Md {
  constructor() {
    i(this, "event_type", "Conversation Sidebar Conversation History Navigated To Conversation");
  }
}
class Fd {
  constructor() {
    i(this, "event_type", "Conversation Sidebar Conversation History Opened");
  }
}
class Dd {
  constructor() {
    i(this, "event_type", "Conversation Sidebar Customer Info Email Clicked");
  }
}
class Ud {
  constructor() {
    i(this, "event_type", "Conversation Sidebar Customer Info Phone Number Clicked");
  }
}
class Ld {
  constructor() {
    i(this, "event_type", "Conversation Sidebar Opened");
  }
}
class Nd {
  constructor() {
    i(this, "event_type", "Conversation Timeline Item Opened");
  }
}
class Vd {
  constructor() {
    i(this, "event_type", "Conversation Timeline Navigated To Conversation");
  }
}
class Bd {
  constructor(e) {
    i(this, "event_type", "Conversation Transferred");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hd {
  constructor(e) {
    i(this, "event_type", "Conversations Bulk Actions Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wd {
  constructor() {
    i(this, "event_type", "Conversations Clear All Clicked");
  }
}
class xd {
  constructor(e) {
    i(this, "event_type", "Conversations Filter Agent Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qd {
  constructor() {
    i(this, "event_type", "Conversations Filter Clear All Clicked");
  }
}
class Kd {
  constructor(e) {
    i(this, "event_type", "Conversations Filter Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gd {
  constructor(e) {
    i(this, "event_type", "Conversations Filter Contact Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class qd {
  constructor(e) {
    i(this, "event_type", "Conversations Filter Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class zd {
  constructor(e) {
    i(this, "event_type", "Conversations Go To Conversation Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class $d {
  constructor() {
    i(this, "event_type", "Conversations Item Preview Clicked");
  }
}
class jd {
  constructor() {
    i(this, "event_type", "Conversations Next Page Clicked");
  }
}
class Jd {
  constructor() {
    i(this, "event_type", "Conversations Previous Page Clicked");
  }
}
class Yd {
  constructor() {
    i(this, "event_type", "Conversations Select All Clicked");
  }
}
class Xd {
  constructor(e) {
    i(this, "event_type", "Conversations Select Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zd {
  constructor(e) {
    i(this, "event_type", "Conversations Timestamp Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ep {
  constructor() {
    i(this, "event_type", "Conversations Transfer To Queue Clicked");
  }
}
class tp {
  constructor() {
    i(this, "event_type", "Conversations View Agent Clicked");
  }
}
class np {
  constructor() {
    i(this, "event_type", "Conversations View Contact Clicked");
  }
}
class rp {
  constructor(e) {
    i(this, "event_type", "ConversationSummaryFeedbackNotUseful");
    this.event_properties = e, this.event_properties = e;
  }
}
class ip {
  constructor(e) {
    i(this, "event_type", "ConversationSummaryFeedbackUseful");
    this.event_properties = e, this.event_properties = e;
  }
}
class sp {
  constructor(e) {
    i(this, "event_type", "ConversationSummaryRegenerateSummary");
    this.event_properties = e, this.event_properties = e;
  }
}
class op {
  constructor() {
    i(this, "event_type", "Copy Script");
  }
}
class ap {
  constructor() {
    i(this, "event_type", "Country Code Selected");
  }
}
class cp {
  constructor(e) {
    i(this, "event_type", "Custom Attribute Value Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class up {
  constructor() {
    i(this, "event_type", "Dashboard Channel All Conversations Clicked");
  }
}
class lp {
  constructor() {
    i(this, "event_type", "Dashboard Channel Go To Analytics Clicked");
  }
}
class dp {
  constructor() {
    i(this, "event_type", "Dashboard Channel Longest Queued Time Metric Clicked");
  }
}
class pp {
  constructor() {
    i(this, "event_type", "Dashboard Channel Name Clicked");
  }
}
class hp {
  constructor(e) {
    i(this, "event_type", "Dashboard Channel Pending Conversations Metric Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class vp {
  constructor() {
    i(this, "event_type", "Dashboard Channel Tv Dashboard Clicked");
  }
}
class gp {
  constructor() {
    i(this, "event_type", "Dashboard Global Tv Dashboard Clicked");
  }
}
class fp {
  constructor(e) {
    i(this, "event_type", "Dashboard Layout Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cp {
  constructor(e) {
    i(this, "event_type", "Dashboard Longest Queued Time Metric Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class yp {
  constructor(e) {
    i(this, "event_type", "Dashboard Metric Helper Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class mp {
  constructor() {
    i(this, "event_type", "Dashboard Next Page Clicked");
  }
}
class kp {
  constructor() {
    i(this, "event_type", "Dashboard Organization Timezone Settings Clicked");
  }
}
class wp {
  constructor() {
    i(this, "event_type", "Dashboard Previous Page Clicked");
  }
}
class _p {
  constructor() {
    i(this, "event_type", "Dashboard Queue All Conversations Clicked");
  }
}
class Sp {
  constructor() {
    i(this, "event_type", "Dashboard Queue Go To Analytics Clicked");
  }
}
class bp {
  constructor(e) {
    i(this, "event_type", "Dashboard Queue Item Favorite Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ap {
  constructor() {
    i(this, "event_type", "Dashboard Queue Name Clicked");
  }
}
class Ip {
  constructor(e) {
    i(this, "event_type", "Dashboard Queue Pending Conversations Metric Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tp {
  constructor() {
    i(this, "event_type", "Dashboard Queue Settings Clicked");
  }
}
class Ep {
  constructor() {
    i(this, "event_type", "Dashboard Queue Tv Dashboard Clicked");
  }
}
class Op {
  constructor(e) {
    i(this, "event_type", "Dashboard Queues Manually Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pp {
  constructor(e) {
    i(this, "event_type", "Dashboard Queues Search Field Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rp {
  constructor(e) {
    i(this, "event_type", "Dashboard Queues Search Field Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mp {
  constructor(e) {
    i(this, "event_type", "Dashboard Queues Sorting Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fp {
  constructor(e) {
    i(this, "event_type", "Dashboard Queues Type Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dp {
  constructor() {
    i(this, "event_type", "Dashboard Refresh Data Clicked");
  }
}
class Up {
  constructor() {
    i(this, "event_type", "Dashboard Tv Reloaded");
  }
}
class Lp {
  constructor(e) {
    i(this, "event_type", "Dashboard Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Np {
  constructor() {
    i(this, "event_type", "Email Flow Options Menu Option Audit Log Clicked");
  }
}
class Vp {
  constructor(e) {
    i(this, "event_type", "Email Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bp {
  constructor() {
    i(this, "event_type", "Email Options Menu Opened");
  }
}
class Hp {
  constructor() {
    i(this, "event_type", "Email Options Menu Option Delete Clicked");
  }
}
class Wp {
  constructor() {
    i(this, "event_type", "Email Options Menu Option Duplicate Clicked");
  }
}
class xp {
  constructor() {
    i(this, "event_type", "Email Options Menu Option Email Clicked");
  }
}
class Qp {
  constructor() {
    i(this, "event_type", "Email Options Menu Option Flow Clicked");
  }
}
class Kp {
  constructor() {
    i(this, "event_type", "Email Options Menu Option Rename Clicked");
  }
}
class Gp {
  constructor() {
    i(this, "event_type", "Email Search Applied");
  }
}
class qp {
  constructor() {
    i(this, "event_type", "Email Search Closed");
  }
}
class zp {
  constructor() {
    i(this, "event_type", "Email Search Opened");
  }
}
class $p {
  constructor(e) {
    i(this, "event_type", "Flow Action Add Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class jp {
  constructor(e) {
    i(this, "event_type", "Flow Action Condition Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jp {
  constructor(e) {
    i(this, "event_type", "Flow Action Condition Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yp {
  constructor(e) {
    i(this, "event_type", "Flow Action Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xp {
  constructor(e) {
    i(this, "event_type", "Flow Action Edit Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zp {
  constructor(e) {
    i(this, "event_type", "Flow Action Edit Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class eh {
  constructor(e) {
    i(this, "event_type", "Flow Activate Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class th {
  constructor(e) {
    i(this, "event_type", "Flow Add Action Action Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class nh {
  constructor(e) {
    i(this, "event_type", "Flow Add Action Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class rh {
  constructor(e) {
    i(this, "event_type", "Flow Add Action Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class ih {
  constructor(e) {
    i(this, "event_type", "Flow Back To Settings Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class sh {
  constructor(e) {
    i(this, "event_type", "Flow Context Align Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class oh {
  constructor(e) {
    i(this, "event_type", "Flow Context Delete Cancel Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ah {
  constructor(e) {
    i(this, "event_type", "Flow Context Delete Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ch {
  constructor(e) {
    i(this, "event_type", "Flow Context Delete Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class uh {
  constructor(e) {
    i(this, "event_type", "Flow Context Node Arrange Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class lh {
  constructor() {
    i(this, "event_type", "Flow Phone Number Changed");
  }
}
class dh {
  constructor(e) {
    i(this, "event_type", "Flow Save Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ph {
  constructor(e) {
    i(this, "event_type", "Flow Title Edit Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class hh {
  constructor(e) {
    i(this, "event_type", "Flow Zoom In Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class vh {
  constructor(e) {
    i(this, "event_type", "Flow Zoom Out Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class gh {
  constructor(e) {
    i(this, "event_type", "Flow Zoom Reset Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class fh {
  constructor() {
    i(this, "event_type", "Follow Up Conversation Modal Internal Note Added");
  }
}
class Ch {
  constructor() {
    i(this, "event_type", "Follow Up Conversation Modal Offer In Queue Added");
  }
}
class yh {
  constructor(e) {
    i(this, "event_type", "Intelligence Distribution Chart Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class mh {
  constructor(e) {
    i(this, "event_type", "Intelligence Evolution Chart Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class kh {
  constructor(e) {
    i(this, "event_type", "Intelligence Filter Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class wh {
  constructor(e) {
    i(this, "event_type", "Intelligence Filter Period Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class _h {
  constructor(e) {
    i(this, "event_type", "Intelligence Group By Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sh {
  constructor(e) {
    i(this, "event_type", "Intelligence Preset Comparison Started");
    this.event_properties = e, this.event_properties = e;
  }
}
class bh {
  constructor(e) {
    i(this, "event_type", "Intelligence Table Customized");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ah {
  constructor() {
    i(this, "event_type", "Intent Detection Created");
  }
}
class Ih {
  constructor() {
    i(this, "event_type", "Intent Detection Deleted");
  }
}
class Th {
  constructor(e) {
    i(this, "event_type", "Intent Detection Flow Node Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class Eh {
  constructor() {
    i(this, "event_type", "Intent Detection Updated");
  }
}
class Oh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Archived");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ph {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Changes Discarded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Destroyed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Feedback Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Marked As Helpful");
    this.event_properties = e, this.event_properties = e;
  }
}
class Uh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Moved");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Published");
    this.event_properties = e, this.event_properties = e;
  }
}
class Nh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Reordered");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Tag Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Tag Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Unpublished");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class xh {
  constructor(e) {
    i(this, "event_type", "Knowledge Article Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qh {
  constructor(e) {
    i(this, "event_type", "Knowledge Articles Search By Term Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kh {
  constructor(e) {
    i(this, "event_type", "Knowledge Category Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gh {
  constructor(e) {
    i(this, "event_type", "Knowledge Category Destroyed");
    this.event_properties = e, this.event_properties = e;
  }
}
class qh {
  constructor(e) {
    i(this, "event_type", "Knowledge Category Reordered");
    this.event_properties = e, this.event_properties = e;
  }
}
class zh {
  constructor(e) {
    i(this, "event_type", "Knowledge Category Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class $h {
  constructor(e) {
    i(this, "event_type", "Knowledge Collection Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class jh {
  constructor(e) {
    i(this, "event_type", "Knowledge Collection Destroyed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jh {
  constructor(e) {
    i(this, "event_type", "Knowledge Collection Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yh {
  constructor(e) {
    i(this, "event_type", "Knowledge Collection Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xh {
  constructor(e) {
    i(this, "event_type", "Knowledge Help Center Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zh {
  constructor(e) {
    i(this, "event_type", "Knowledge Help Center Deleted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ev {
  constructor(e) {
    i(this, "event_type", "Knowledge Help Center Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class tv {
  constructor() {
    i(this, "event_type", "Knowledge Internal Kb Dashboard Viewed");
  }
}
class nv {
  constructor(e) {
    i(this, "event_type", "Knowledge Internal Kb Search Result Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class rv {
  constructor(e) {
    i(this, "event_type", "Knowledge Resolution Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class iv {
  constructor(e) {
    i(this, "event_type", "Knowledge Resolution Initialised");
    this.event_properties = e, this.event_properties = e;
  }
}
class sv {
  constructor() {
    i(this, "event_type", "Link Conversations Modal Opened");
  }
}
class ov {
  constructor() {
    i(this, "event_type", "Link Conversations Submitted");
  }
}
class av {
  constructor() {
    i(this, "event_type", "Mention User Notification Clicked");
  }
}
class cv {
  constructor() {
    i(this, "event_type", "Mention User Selected");
  }
}
class uv {
  constructor() {
    i(this, "event_type", "Merge Contacts Merge Cancelled");
  }
}
class lv {
  constructor() {
    i(this, "event_type", "Merge Contacts Merge Failed");
  }
}
class dv {
  constructor(e) {
    i(this, "event_type", "Merge Contacts Merge Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class pv {
  constructor() {
    i(this, "event_type", "Merge Contacts Modal Closed");
  }
}
class hv {
  constructor() {
    i(this, "event_type", "Merge Contacts Modal Opened");
  }
}
class vv {
  constructor() {
    i(this, "event_type", "Merge Contacts Source Contact Selected");
  }
}
class gv {
  constructor() {
    i(this, "event_type", "Messenger Flow Options Menu Option Audit Log Clicked");
  }
}
class fv {
  constructor(e) {
    i(this, "event_type", "Messenger Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cv {
  constructor(e) {
    i(this, "event_type", "Messenger Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class yv {
  constructor(e) {
    i(this, "event_type", "Messenger Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class mv {
  constructor() {
    i(this, "event_type", "Messenger Options Menu Opened");
  }
}
class kv {
  constructor(e) {
    i(this, "event_type", "Messenger Options Menu Option Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wv {
  constructor() {
    i(this, "event_type", "Modal Conversation Close Cancel Clicked");
  }
}
class _v {
  constructor(e) {
    i(this, "event_type", "Modal Conversation Close Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sv {
  constructor() {
    i(this, "event_type", "Modal Transfer To Queue Cancel Clicked");
  }
}
class bv {
  constructor(e) {
    i(this, "event_type", "Modal Transfer To Queue Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Av {
  constructor(e) {
    i(this, "event_type", "Network Connection Status Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Iv {
  constructor(e) {
    i(this, "event_type", "Notification Offer Accepted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Tv {
  constructor(e) {
    i(this, "event_type", "Notification Offer Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ev {
  constructor(e) {
    i(this, "event_type", "Notification Offer Rejected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ov {
  constructor() {
    i(this, "event_type", "Notification Offer Timeout");
  }
}
class Pv {
  constructor(e) {
    i(this, "event_type", "Notification Transfer Offer Accepted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rv {
  constructor(e) {
    i(this, "event_type", "Notification Transfer Offer Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mv {
  constructor(e) {
    i(this, "event_type", "Notification Transfer Offer Rejected");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fv {
  constructor() {
    i(this, "event_type", "Notification Transfer Offer Timeout");
  }
}
class Dv {
  constructor(e) {
    i(this, "event_type", "Organizations Navigation Organization Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Uv {
  constructor() {
    i(this, "event_type", "Partner Integrations Braze Profile Received");
  }
}
class Lv {
  constructor() {
    i(this, "event_type", "Partner Integrations Braze Subscription Email Opt in Succeeded");
  }
}
class Nv {
  constructor() {
    i(this, "event_type", "Partner Integrations Braze Subscription Email Unsubscribed Succeeded");
  }
}
class Vv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Create New Issue Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Create New Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Create New Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Link Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class xv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Unlink All Issues Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Unlink All Issues Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Unlink All Issues Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Unlink Issue Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class qv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Unlink Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class zv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github Unlink Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class $v {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Github View Link Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class jv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Comments Collapsed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Comments Expanded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Create Issue Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Create Issue Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zv {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Link Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class eg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Open Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class tg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Open Jira Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ng {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Remove All Dangling Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class rg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Remove Dangling Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ig {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Unlink All Issues Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class sg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Unlink All Issues Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class og {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Unlink All Issues Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class ag {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Unlink Issue Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class cg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Unlink Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ug {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Jira Unlink Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class lg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Messages Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class dg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class pg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class hg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Subscription To Channel Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class vg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Subscription To Channel Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class gg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Subscription To Channel Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class fg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Unsubscribe Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Unsubscribe Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class yg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Klaviyo Profile Unsubscribe Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class mg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Linear Create New Issue Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class kg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Linear Create New Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Linear Create New Issue Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class _g {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Linear Link Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Sg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Linear Open Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class bg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Linear Open Linear Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ag {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Linear Unlink Issue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ig {
  constructor() {
    i(this, "event_type", "Partner Integrations Recharge Widget Customer Overview Opened");
  }
}
class Tg {
  constructor() {
    i(this, "event_type", "Partner Integrations Recharge Widget Order Opened");
  }
}
class Eg {
  constructor() {
    i(this, "event_type", "Partner Integrations Recharge Widget Orders List Opened");
  }
}
class Og {
  constructor() {
    i(this, "event_type", "Partner Integrations Recharge Widget Profile Received");
  }
}
class Pg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings Create Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings Overview Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Mg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings Overview Viewed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings View Delete Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings View Delete Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ug {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings View Delete Requested");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings View OAuth Started");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ng {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings View OAuth Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Settings View Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bg {
  constructor() {
    i(this, "event_type", "Partner Integrations Shopify Widget Discount Code Created");
  }
}
class Hg {
  constructor() {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Cancelled");
  }
}
class Wg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Collapse Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class xg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Collapse Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Edit Shipping Address Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class qg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Refund Canceled");
    this.event_properties = e, this.event_properties = e;
  }
}
class zg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Refund Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class $g {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Refund Requested");
    this.event_properties = e, this.event_properties = e;
  }
}
class jg {
  constructor() {
    i(this, "event_type", "Partner Integrations Shopify Widget Order Tags Updated");
  }
}
class Jg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Order View Order In Shopify Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xg {
  constructor() {
    i(this, "event_type", "Partner Integrations Shopify Widget Profile Created");
  }
}
class Zg {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget Refreshed");
    this.event_properties = e, this.event_properties = e;
  }
}
class ef {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Shopify Widget View Customer In Shopify Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class tf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Channel Subscription Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class nf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Channel Subscription Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class rf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Channel Subscription Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class sf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Channel Unsubscription Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class of {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Channel Unsubscription Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class af {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Channel Unsubscription Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class cf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Message External Link Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class uf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Messages Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class lf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Orders Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class df {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Profile Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class pf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Voyado Widget Transactions Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class hf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Widget Collapse Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class vf {
  constructor(e) {
    i(this, "event_type", "Partner Integrations Widget Collapse Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class gf {
  constructor() {
    i(this, "event_type", "Partner Integrations Widget LoyaltyLion Add Points Failed");
  }
}
class ff {
  constructor() {
    i(this, "event_type", "Partner Integrations Widget LoyaltyLion Add Points Succeeded");
  }
}
class Cf {
  constructor() {
    i(this, "event_type", "Partner Integrations Widget LoyaltyLion Customer Received");
  }
}
class yf {
  constructor() {
    i(this, "event_type", "Partner Integrations Widget LoyaltyLion Remove Points Failed");
  }
}
class mf {
  constructor() {
    i(this, "event_type", "Partner Integrations Widget LoyaltyLion Remove Points Succeeded");
  }
}
class kf {
  constructor() {
    i(this, "event_type", "Partner Integrations Widget Voyado Update Points Failed");
  }
}
class wf {
  constructor() {
    i(this, "event_type", "Partner Integrations Widget Voyado Update Points Succeeded");
  }
}
class _f {
  constructor() {
    i(this, "event_type", "Phone Actions Menu Action Add Outbound Caller ID Clicked");
  }
}
class Sf {
  constructor() {
    i(this, "event_type", "Phone Actions Menu Action Change Hold Music Clicked");
  }
}
class bf {
  constructor() {
    i(this, "event_type", "Phone Actions Menu Opened");
  }
}
class Af {
  constructor() {
    i(this, "event_type", "Phone Add Outbound Caller ID Form Cancelled");
  }
}
class If {
  constructor() {
    i(this, "event_type", "Phone Add Outbound Caller ID Form Submitted");
  }
}
class Tf {
  constructor() {
    i(this, "event_type", "Phone Change Hold Music Form Cancelled");
  }
}
class Ef {
  constructor() {
    i(this, "event_type", "Phone Change Hold Music Form Submitted");
  }
}
class Of {
  constructor() {
    i(this, "event_type", "Phone Create Flow Form Cancelled");
  }
}
class Pf {
  constructor() {
    i(this, "event_type", "Phone Create Flow Form Submitted");
  }
}
class Rf {
  constructor() {
    i(this, "event_type", "Phone Flow Options Menu Option Audit Log Clicked");
  }
}
class Mf {
  constructor() {
    i(this, "event_type", "Phone Flow Options Menu Option Delete Clicked");
  }
}
class Ff {
  constructor() {
    i(this, "event_type", "Phone Flow Options Menu Option Duplicate Clicked");
  }
}
class Df {
  constructor() {
    i(this, "event_type", "Phone Flow Options Menu Option Edit Clicked");
  }
}
class Uf {
  constructor() {
    i(this, "event_type", "Phone Flow Options Menu Option Move To Another Number Clicked");
  }
}
class Lf {
  constructor() {
    i(this, "event_type", "Phone Flow Options Menu Option Opened");
  }
}
class Nf {
  constructor() {
    i(this, "event_type", "Phone Flow Options Menu Option Rename Clicked");
  }
}
class Vf {
  constructor() {
    i(this, "event_type", "Phone Form Cancelled");
  }
}
class Bf {
  constructor() {
    i(this, "event_type", "Phone Form Opened");
  }
}
class Hf {
  constructor() {
    i(this, "event_type", "Phone Form Submitted");
  }
}
class Wf {
  constructor() {
    i(this, "event_type", "Phone Options Menu Opened");
  }
}
class xf {
  constructor() {
    i(this, "event_type", "Phone Options Menu Option Create Flow Clicked");
  }
}
class Qf {
  constructor() {
    i(this, "event_type", "Phone Options Menu Option Edit Clicked");
  }
}
class Kf {
  constructor() {
    i(this, "event_type", "Phone Options Menu Option Remove Number Clicked");
  }
}
class Gf {
  constructor() {
    i(this, "event_type", "Phone Options Menu Option Set Default Caller ID Clicked");
  }
}
class qf {
  constructor() {
    i(this, "event_type", "Phone Options Menu Option Setup Clicked");
  }
}
class zf {
  constructor(e) {
    i(this, "event_type", "Phone Recording Downloaded");
    this.event_properties = e, this.event_properties = e;
  }
}
class $f {
  constructor(e) {
    i(this, "event_type", "Phone Recording Pause Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class jf {
  constructor(e) {
    i(this, "event_type", "Phone Recording Play Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jf {
  constructor(e) {
    i(this, "event_type", "Phone Recording Playback Abandoned");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yf {
  constructor(e) {
    i(this, "event_type", "Phone Recording Playback Ended");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xf {
  constructor() {
    i(this, "event_type", "Phone Search Applied");
  }
}
class Zf {
  constructor() {
    i(this, "event_type", "Presence List Item Clicked");
  }
}
class eC {
  constructor(e) {
    i(this, "event_type", "Presence Media Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class tC {
  constructor(e) {
    i(this, "event_type", "Presence Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class nC {
  constructor(e) {
    i(this, "event_type", "Push Notification Platform Form Cancelled");
    this.event_properties = e, this.event_properties = e;
  }
}
class rC {
  constructor(e) {
    i(this, "event_type", "Push Notification Platform Form Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class iC {
  constructor(e) {
    i(this, "event_type", "Push Notification Platform Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class sC {
  constructor(e) {
    i(this, "event_type", "Quick Replies Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class oC {
  constructor(e) {
    i(this, "event_type", "Quick Reply Chosen");
    this.event_properties = e, this.event_properties = e;
  }
}
class aC {
  constructor(e) {
    i(this, "event_type", "Quick Reply Feedback for Recommended Replies Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class cC {
  constructor(e) {
    i(this, "event_type", "Quick Reply Filter Chosen");
    this.event_properties = e, this.event_properties = e;
  }
}
class uC {
  constructor(e) {
    i(this, "event_type", "Quick Reply Language Selected");
    this.event_properties = e, this.event_properties = e;
  }
}
class lC {
  constructor(e) {
    i(this, "event_type", "Quick Reply Template Favorite Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class dC {
  constructor() {
    i(this, "event_type", "Saved Search Applied");
  }
}
class pC {
  constructor() {
    i(this, "event_type", "Saved Search Closed");
  }
}
class hC {
  constructor(e) {
    i(this, "event_type", "Saved Search Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class vC {
  constructor() {
    i(this, "event_type", "Saved Search Deleted");
  }
}
class gC {
  constructor() {
    i(this, "event_type", "Saved Search Updated");
  }
}
class fC {
  constructor() {
    i(this, "event_type", "Scheduled Conversations Csv Import Clicked");
  }
}
class CC {
  constructor() {
    i(this, "event_type", "Scheduled Conversations Csv Imported");
  }
}
class yC {
  constructor(e) {
    i(this, "event_type", "Search Contact Preview Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class mC {
  constructor(e) {
    i(this, "event_type", "Search Contact Preview Go To Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class kC {
  constructor(e) {
    i(this, "event_type", "Search Contact Preview Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class wC {
  constructor(e) {
    i(this, "event_type", "Search Contact Type Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class _C {
  constructor() {
    i(this, "event_type", "Search Conversation Preview Closed");
  }
}
class SC {
  constructor(e) {
    i(this, "event_type", "Search Conversation Preview Go To Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class bC {
  constructor(e) {
    i(this, "event_type", "Search Conversation Preview Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class AC {
  constructor(e) {
    i(this, "event_type", "Search Field Blurred");
    this.event_properties = e, this.event_properties = e;
  }
}
class IC {
  constructor(e) {
    i(this, "event_type", "Search Field Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class TC {
  constructor(e) {
    i(this, "event_type", "Search Field Focused");
    this.event_properties = e, this.event_properties = e;
  }
}
class EC {
  constructor(e) {
    i(this, "event_type", "Search Field Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class OC {
  constructor(e) {
    i(this, "event_type", "Search Filter Condition Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class PC {
  constructor(e) {
    i(this, "event_type", "Search Filter Condition Removed");
    this.event_properties = e, this.event_properties = e;
  }
}
class RC {
  constructor(e) {
    i(this, "event_type", "Search Filter Operator Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class MC {
  constructor(e) {
    i(this, "event_type", "Search Filter Strategy Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class FC {
  constructor(e) {
    i(this, "event_type", "Search Filter Value Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class DC {
  constructor(e) {
    i(this, "event_type", "Search Filter Value Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class UC {
  constructor(e) {
    i(this, "event_type", "Search Filters Applied");
    this.event_properties = e, this.event_properties = e;
  }
}
class LC {
  constructor(e) {
    i(this, "event_type", "Search Filters Cleared");
    this.event_properties = e, this.event_properties = e;
  }
}
class NC {
  constructor(e) {
    i(this, "event_type", "Search Filters Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class VC {
  constructor(e) {
    i(this, "event_type", "Search Filters Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class BC {
  constructor(e) {
    i(this, "event_type", "Search Filters Validation Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class HC {
  constructor() {
    i(this, "event_type", "Search Note Preview Closed");
  }
}
class WC {
  constructor() {
    i(this, "event_type", "Search Note Preview Go To Clicked");
  }
}
class xC {
  constructor() {
    i(this, "event_type", "Search Note Preview Opened");
  }
}
class QC {
  constructor(e) {
    i(this, "event_type", "Search Sorting Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class KC {
  constructor(e) {
    i(this, "event_type", "Search Strict Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class GC {
  constructor(e) {
    i(this, "event_type", "Search Tab Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class qC {
  constructor() {
    i(this, "event_type", "Settings Agents Add Agent Button Clicked");
  }
}
class zC {
  constructor(e) {
    i(this, "event_type", "Settings Agents Custom Workload Assigned");
    this.event_properties = e, this.event_properties = e;
  }
}
class $C {
  constructor() {
    i(this, "event_type", "Settings Agents Custom Workload Created");
  }
}
class jC {
  constructor() {
    i(this, "event_type", "Settings Agents Custom Workload Deleted");
  }
}
class JC {
  constructor() {
    i(this, "event_type", "Settings Agents Edit Button Clicked");
  }
}
class YC {
  constructor(e) {
    i(this, "event_type", "Settings Agents Tab Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class XC {
  constructor(e) {
    i(this, "event_type", "Settings Agents Workloads Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class ZC {
  constructor(e) {
    i(this, "event_type", "Settings Audio Delete Cancel Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ey {
  constructor(e) {
    i(this, "event_type", "Settings Audio Delete Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ty {
  constructor(e) {
    i(this, "event_type", "Settings Audio Delete Confirm Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ny {
  constructor(e) {
    i(this, "event_type", "Settings Audio Usage Flow Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ry {
  constructor(e) {
    i(this, "event_type", "Settings Audio Usage Link Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class iy {
  constructor(e) {
    i(this, "event_type", "Settings Commands Assign Keybindings");
    this.event_properties = e, this.event_properties = e;
  }
}
class sy {
  constructor() {
    i(this, "event_type", "Settings Commands Reset All Keybindings");
  }
}
class oy {
  constructor(e) {
    i(this, "event_type", "Settings Commands Reset Keybindings");
    this.event_properties = e, this.event_properties = e;
  }
}
class ay {
  constructor() {
    i(this, "event_type", "Settings Commands Unassign All Keybindings");
  }
}
class cy {
  constructor(e) {
    i(this, "event_type", "Settings Commands Unassign Keybindings");
    this.event_properties = e, this.event_properties = e;
  }
}
class uy {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Activated");
    this.event_properties = e, this.event_properties = e;
  }
}
class ly {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Add New Attribute Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class dy {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Archived");
    this.event_properties = e, this.event_properties = e;
  }
}
class py {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class hy {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Deactivated");
    this.event_properties = e, this.event_properties = e;
  }
}
class vy {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Reordered");
    this.event_properties = e, this.event_properties = e;
  }
}
class gy {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Unarchived");
    this.event_properties = e, this.event_properties = e;
  }
}
class fy {
  constructor(e) {
    i(this, "event_type", "Settings Custom Attribute Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cy {
  constructor() {
    i(this, "event_type", "Settings Custom Away Status Add New Clicked");
  }
}
class yy {
  constructor() {
    i(this, "event_type", "Settings Custom Away Status Archived");
  }
}
class my {
  constructor() {
    i(this, "event_type", "Settings Custom Away Status Created");
  }
}
class ky {
  constructor() {
    i(this, "event_type", "Settings Custom Away Status Unarchived");
  }
}
class wy {
  constructor() {
    i(this, "event_type", "Settings Custom Away Status Updated");
  }
}
class _y {
  constructor() {
    i(this, "event_type", "Settings Forms Embed Url Copied");
  }
}
class Sy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Api Tokens Add Confirm");
    this.event_properties = e, this.event_properties = e;
  }
}
class by {
  constructor() {
    i(this, "event_type", "Settings Integrations Api Tokens Copy");
  }
}
class Ay {
  constructor() {
    i(this, "event_type", "Settings Integrations Api Tokens Documentation Link Integrations Api");
  }
}
class Iy {
  constructor() {
    i(this, "event_type", "Settings Integrations Api Tokens Remove");
  }
}
class Ty {
  constructor() {
    i(this, "event_type", "Settings Integrations Api Tokens Remove Cancel");
  }
}
class Ey {
  constructor() {
    i(this, "event_type", "Settings Integrations Api Tokens Remove Confirm");
  }
}
class Oy {
  constructor() {
    i(this, "event_type", "Settings Integrations Api Tokens View");
  }
}
class Py {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Edit Save");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ry {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Edit Test");
    this.event_properties = e, this.event_properties = e;
  }
}
class My {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Listing Add Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class Fy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Listing Edit Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Listing Remove Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class Uy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Listing Remove Card Cancel");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ly {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Listing Remove Card Confirm");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ny {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Listing Test Card");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Read Documentation");
    this.event_properties = e, this.event_properties = e;
  }
}
class By {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Test");
    this.event_properties = e, this.event_properties = e;
  }
}
class Hy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Test Add Parameter");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Card Test Remove Parameter");
    this.event_properties = e, this.event_properties = e;
  }
}
class xy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Custom Card Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Custom Card Edited");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ky {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Custom Card Oauth Provider Authentication Failed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Custom Card Oauth Provider Authentication Succeeded");
    this.event_properties = e, this.event_properties = e;
  }
}
class qy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Custom Card Oauth Provider Authentication Timed Out");
    this.event_properties = e, this.event_properties = e;
  }
}
class zy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Custom Card Oauth Provider Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class $y {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Custom Card Oauth Provider Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class jy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Webform Endpoints Add Save");
    this.event_properties = e, this.event_properties = e;
  }
}
class Yy {
  constructor() {
    i(this, "event_type", "Settings Integrations Webform Endpoints Copy");
  }
}
class Xy {
  constructor() {
    i(this, "event_type", "Settings Integrations Webform Endpoints Read Documentation Link");
  }
}
class Zy {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Webform Endpoints Remove");
    this.event_properties = e, this.event_properties = e;
  }
}
class em {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Webform Endpoints Remove Cancel");
    this.event_properties = e, this.event_properties = e;
  }
}
class tm {
  constructor(e) {
    i(this, "event_type", "Settings Integrations Webform Endpoints Remove Confirm");
    this.event_properties = e, this.event_properties = e;
  }
}
class nm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Add");
  }
}
class rm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Add Confirm");
  }
}
class im {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Documentation Link Clicked");
  }
}
class sm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Edit");
  }
}
class om {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Edit Save");
  }
}
class am {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Enabled Off");
  }
}
class cm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Enabled On");
  }
}
class um {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Remove");
  }
}
class lm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Remove Cancel");
  }
}
class dm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks Remove Confirm");
  }
}
class pm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks View");
  }
}
class hm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks View Copy Secret");
  }
}
class vm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks View Copy Url");
  }
}
class gm {
  constructor() {
    i(this, "event_type", "Settings Integrations Webhooks View Edit");
  }
}
class fm {
  constructor(e) {
    i(this, "event_type", "Settings Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Cm {
  constructor() {
    i(this, "event_type", "Settings Organization Form Submitted");
  }
}
class ym {
  constructor() {
    i(this, "event_type", "Settings Organization Logo Changed");
  }
}
class mm {
  constructor(e) {
    i(this, "event_type", "Settings Profile Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class km {
  constructor(e) {
    i(this, "event_type", "Settings Queue Added");
    this.event_properties = e, this.event_properties = e;
  }
}
class wm {
  constructor() {
    i(this, "event_type", "Settings Queue Agent Deleted");
  }
}
class _m {
  constructor() {
    i(this, "event_type", "Settings Queue Agent Search Submitted");
  }
}
class Sm {
  constructor(e) {
    i(this, "event_type", "Settings Queue Agent Sorted");
    this.event_properties = e, this.event_properties = e;
  }
}
class bm {
  constructor(e) {
    i(this, "event_type", "Settings Queue Alerts Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class Am {
  constructor(e) {
    i(this, "event_type", "Settings Queue Saved");
    this.event_properties = e, this.event_properties = e;
  }
}
class Im {
  constructor() {
    i(this, "event_type", "Settings Queue Teams Add Team Button Clicked");
  }
}
class Tm {
  constructor() {
    i(this, "event_type", "Settings Queue Teams Add Team Form Submitted");
  }
}
class Em {
  constructor() {
    i(this, "event_type", "Settings Queue Teams Delete Team Button Clicked");
  }
}
class Om {
  constructor() {
    i(this, "event_type", "Settings Queues Add Queue Clicked");
  }
}
class Pm {
  constructor(e) {
    i(this, "event_type", "Settings Queues Archive Queue Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rm {
  constructor() {
    i(this, "event_type", "Settings Queues Edit Queue Clicked");
  }
}
class Mm {
  constructor() {
    i(this, "event_type", "Settings Queues Unarchive Queue Clicked");
  }
}
class Fm {
  constructor(e) {
    i(this, "event_type", "Settings Roles Custom Role Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class Dm {
  constructor() {
    i(this, "event_type", "Settings Roles Custom Role Deleted");
  }
}
class Um {
  constructor(e) {
    i(this, "event_type", "Settings Roles Custom Role Edited");
    this.event_properties = e, this.event_properties = e;
  }
}
class Lm {
  constructor() {
    i(this, "event_type", "Settings Summarization Save Changes Clicked");
  }
}
class Nm {
  constructor(e) {
    i(this, "event_type", "Settings Summarization Show Automatically Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Vm {
  constructor(e) {
    i(this, "event_type", "Settings Summarization Show On Demand Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bm {
  constructor() {
    i(this, "event_type", "Settings Tags Add Tag Button Clicked");
  }
}
class Hm {
  constructor(e) {
    i(this, "event_type", "Settings Tags Tag Activated");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wm {
  constructor(e) {
    i(this, "event_type", "Settings Tags Tag Deactivated");
    this.event_properties = e, this.event_properties = e;
  }
}
class xm {
  constructor() {
    i(this, "event_type", "Settings Team Add Team Button Clicked");
  }
}
class Qm {
  constructor() {
    i(this, "event_type", "Settings Team Details Add Agents Button Clicked");
  }
}
class Km {
  constructor() {
    i(this, "event_type", "Settings Team Edit Team Button Clicked");
  }
}
class Gm {
  constructor(e) {
    i(this, "event_type", "Settings Team Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class qm {
  constructor() {
    i(this, "event_type", "Settings Team Remove Team Button Clicked");
  }
}
class zm {
  constructor() {
    i(this, "event_type", "Settings Team Remove Team Confirmed");
  }
}
class $m {
  constructor(e) {
    i(this, "event_type", "Settings Templates Add Template Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class jm {
  constructor(e) {
    i(this, "event_type", "Settings Templates Edit Template Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Jm {
  constructor(e) {
    i(this, "event_type", "Settings Templates Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ym {
  constructor(e) {
    i(this, "event_type", "Settings Templates Remove Template Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Xm {
  constructor(e) {
    i(this, "event_type", "Settings Templates Remove Template Confirmed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Zm {
  constructor(e) {
    i(this, "event_type", "Settings Templates Tab Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ek {
  constructor() {
    i(this, "event_type", "Shared Worker Tab Or Window Changed");
  }
}
class tk {
  constructor(e) {
    i(this, "event_type", "Shared Worker Tab Or Window Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class nk {
  constructor(e) {
    i(this, "event_type", "Shared Worker Tab Or Window Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class rk {
  constructor() {
    i(this, "event_type", "Sidebar Add Agent Button Clicked");
  }
}
class ik {
  constructor() {
    i(this, "event_type", "Sidebar Collapsed");
  }
}
class sk {
  constructor() {
    i(this, "event_type", "Sidebar Expanded");
  }
}
class ok {
  constructor(e) {
    i(this, "event_type", "Sidebar Nav Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class ak {
  constructor() {
    i(this, "event_type", "Sign Out Aborted");
  }
}
class ck {
  constructor() {
    i(this, "event_type", "Sign Out Confirmed");
  }
}
class uk {
  constructor(e) {
    i(this, "event_type", "Simultaneous Ring Updated");
    this.event_properties = e, this.event_properties = e;
  }
}
class lk {
  constructor(e) {
    i(this, "event_type", "Smart Conversation Reply Button Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class dk {
  constructor() {
    i(this, "event_type", "Subflow Back To Main Flow Node Reused");
  }
}
class pk {
  constructor() {
    i(this, "event_type", "Subflow Back To Main Flow Node Used");
  }
}
class hk {
  constructor() {
    i(this, "event_type", "Subflow Created From Highlighted Nodes");
  }
}
class vk {
  constructor() {
    i(this, "event_type", "Subflow Created From Scratch");
  }
}
class gk {
  constructor() {
    i(this, "event_type", "Subflow Reused");
  }
}
class fk {
  constructor(e) {
    i(this, "event_type", "Tag Select Create New Tag Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ck {
  constructor(e) {
    i(this, "event_type", "Tags Create Modal Color Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class yk {
  constructor(e) {
    i(this, "event_type", "Tags Create Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class mk {
  constructor(e) {
    i(this, "event_type", "Tags Create Modal Opened");
    this.event_properties = e, this.event_properties = e;
  }
}
class kk {
  constructor(e) {
    i(this, "event_type", "Team Agent Actions Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class wk {
  constructor() {
    i(this, "event_type", "Team Agent Actions Menu Opened");
  }
}
class _k {
  constructor() {
    i(this, "event_type", "Team Agent Collapsed");
  }
}
class Sk {
  constructor() {
    i(this, "event_type", "Team Agent Expanded");
  }
}
class bk {
  constructor() {
    i(this, "event_type", "Team Assigned Agents Only Clicked");
  }
}
class Ak {
  constructor(e) {
    i(this, "event_type", "Team Conversation Actions Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Ik {
  constructor() {
    i(this, "event_type", "Team Conversation Actions Menu Opened");
  }
}
class Tk {
  constructor() {
    i(this, "event_type", "Team Conversation Status Link Clicked");
  }
}
class Ek {
  constructor() {
    i(this, "event_type", "Team Conversation Title Link Clicked");
  }
}
class Ok {
  constructor(e) {
    i(this, "event_type", "Team Favorite Toggled");
    this.event_properties = e, this.event_properties = e;
  }
}
class Pk {
  constructor(e) {
    i(this, "event_type", "Team Filter Menu Item Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Rk {
  constructor() {
    i(this, "event_type", "Team Filter Menu Opened");
  }
}
class Mk {
  constructor() {
    i(this, "event_type", "Team Next Page Clicked");
  }
}
class Fk {
  constructor() {
    i(this, "event_type", "Team Previous Page Clicked");
  }
}
class Dk {
  constructor() {
    i(this, "event_type", "Topbar Beamer Opened");
  }
}
class Uk {
  constructor() {
    i(this, "event_type", "Topbar Email Opened");
  }
}
class Lk {
  constructor() {
    i(this, "event_type", "Topbar Notifications Opened");
  }
}
class Nk {
  constructor() {
    i(this, "event_type", "Topbar Phones Opened");
  }
}
class Vk {
  constructor(e) {
    i(this, "event_type", "Topbar Search Quick Action Clicked");
    this.event_properties = e, this.event_properties = e;
  }
}
class Bk {
  constructor() {
    i(this, "event_type", "Topbar Support Opened");
  }
}
class Hk {
  constructor(e) {
    i(this, "event_type", "User Modal Form Submitted");
    this.event_properties = e, this.event_properties = e;
  }
}
class Wk {
  constructor(e) {
    i(this, "event_type", "User Modal Role Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class xk {
  constructor(e) {
    i(this, "event_type", "User Modal User Type Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Qk {
  constructor(e) {
    i(this, "event_type", "Websocket Active Connection Changed");
    this.event_properties = e, this.event_properties = e;
  }
}
class Kk {
  constructor(e) {
    i(this, "event_type", "Websocket Close Event Received");
    this.event_properties = e, this.event_properties = e;
  }
}
class Gk {
  constructor(e) {
    i(this, "event_type", "Websocket Connection Closed");
    this.event_properties = e, this.event_properties = e;
  }
}
class qk {
  constructor(e) {
    i(this, "event_type", "Websocket Connection Created");
    this.event_properties = e, this.event_properties = e;
  }
}
class zk {
  constructor(e) {
    i(this, "event_type", "Websocket Reconnect Attempt Started");
    this.event_properties = e, this.event_properties = e;
  }
}
const ke = () => ({ promise: Promise.resolve() });
class $k {
  constructor() {
    i(this, "disabled", !1);
    i(this, "amplitude");
  }
  get client() {
    return this.isInitializedAndEnabled(), this.amplitude;
  }
  get isLoaded() {
    return this.amplitude != null;
  }
  isInitializedAndEnabled() {
    return this.amplitude ? !this.disabled : (console.error("ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?"), !1);
  }
  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(e) {
    if (this.disabled = e.disabled ?? !1, this.amplitude)
      return console.warn("WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup."), ke();
    let n = null;
    if (e.client && "apiKey" in e.client ? n = e.client.apiKey : "environment" in e && (n = va[e.environment]), e.client && "instance" in e.client)
      this.amplitude = e.client.instance;
    else if (n) {
      this.amplitude = gr();
      const r = e.client && "configuration" in e.client ? e.client.configuration : {};
      return this.amplitude.init(n, void 0, { ...ga, ...r });
    } else
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    return ke();
  }
  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(e, n, r) {
    if (!this.isInitializedAndEnabled())
      return ke();
    e && (r = { ...r, user_id: e });
    const s = new ge(), o = n;
    if (o != null)
      for (const [a, l] of Object.entries(o))
        s.set(a, l);
    return this.amplitude.identify(
      s,
      r
    );
  }
  /**
   * Flush the event.
   */
  flush() {
    return this.isInitializedAndEnabled() ? this.amplitude.flush() : ke();
  }
  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(e, n) {
    return this.isInitializedAndEnabled() ? this.amplitude.track(e, void 0, n) : ke();
  }
  /**
   * Add Agents Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Add%20Agents%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on Add agents modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. addTo)
   * @param options Amplitude event options.
   */
  addAgentsModalFormSubmitted(e, n) {
    return this.track(new fa(e), n);
  }
  /**
   * Agent Copilot Back Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Back%20Button%20Clicked)
   *
   * When the user clicks the back button in Agent Copilot
   *
   * @param options Amplitude event options.
   */
  agentCopilotBackButtonClicked(e) {
    return this.track(new Ca(), e);
  }
  /**
   * Agent Copilot Dropdown Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Dropdown%20Item%20Clicked)
   *
   * When the user clicks an items from the Agent Copilot dropdown in the reply area.
   *
   * @param properties The event's properties (e.g. key)
   * @param options Amplitude event options.
   */
  agentCopilotDropdownItemClicked(e, n) {
    return this.track(new ya(e), n);
  }
  /**
   * Agent Copilot Improve Writing Improvement Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Improve%20Writing%20Improvement%20Clicked)
   *
   * When the user selects a writing improvement option
   *
   * @param properties The event's properties (e.g. improvement)
   * @param options Amplitude event options.
   */
  agentCopilotImproveWritingImprovementClicked(e, n) {
    return this.track(new ma(e), n);
  }
  /**
   * Agent Copilot Text Insert Below Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Text%20Insert%20Below%20Clicked)
   *
   * When the user clicks the Replace Text action in a copilot action.
   *
   * @param properties The event's properties (e.g. key)
   * @param options Amplitude event options.
   */
  agentCopilotTextInsertBelowClicked(e, n) {
    return this.track(new ka(e), n);
  }
  /**
   * Agent Copilot Text Replace Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Text%20Replace%20Clicked)
   *
   * When the user clicks the Insert Below action in a copilot action.
   *
   * @param properties The event's properties (e.g. key)
   * @param options Amplitude event options.
   */
  agentCopilotTextReplaceClicked(e, n) {
    return this.track(new wa(e), n);
  }
  /**
   * Agent Copilot Translate Message Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Translate%20Message%20Language%20Selected)
   *
   * When the user selects a language to translate a message to.
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  agentCopilotTranslateMessageLanguageSelected(e, n) {
    return this.track(new _a(e), n);
  }
  /**
   * Agent Copilot Trial Learn More Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Learn%20More%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. url)
   * @param options Amplitude event options.
   */
  agentCopilotTrialLearnMoreClicked(e, n) {
    return this.track(new Sa(e), n);
  }
  /**
   * Agent Copilot Trial Leftmenu CTA Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Leftmenu%20CTA%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialLeftmenuCtaClicked(e) {
    return this.track(new ba(), e);
  }
  /**
   * Agent Copilot Trial Leftmenu CTA Dismissed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Leftmenu%20CTA%20Dismissed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialLeftmenuCtaDismissed(e) {
    return this.track(new Aa(), e);
  }
  /**
   * Agent Copilot Trial Request Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Request%20Contact%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialRequestContactClicked(e) {
    return this.track(new Ia(), e);
  }
  /**
   * Agent Copilot Trial Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Started)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialStarted(e) {
    return this.track(new Ta(), e);
  }
  /**
   * Agent Copilot Trial Stopped
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Trial%20Stopped)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  agentCopilotTrialStopped(e) {
    return this.track(new Ea(), e);
  }
  /**
   * Agent Copilot Undo Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Copilot%20Undo%20Clicked)
   *
   * When the user clicks the undo button in Agent Copilot
   *
   * @param options Amplitude event options.
   */
  agentCopilotUndoClicked(e) {
    return this.track(new Oa(), e);
  }
  /**
   * Agent Custom Away Status Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Agent%20Custom%20Away%20Status%20Updated)
   *
   * Event to track when the custom away status of an agent is changed by an agent in the Dixa Agent-Interface
   *
   * @param properties The event's properties (e.g. statusEmoji)
   * @param options Amplitude event options.
   */
  agentCustomAwayStatusUpdated(e, n) {
    return this.track(new Pa(e), n);
  }
  /**
   * Analytics Business Hours Schedule Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Business%20Hours%20Schedule%20Removed)
   *
   * When the user remoes a global business hours schedule filter on a dashboard or contextually on a panel
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsBusinessHoursScheduleRemoved(e, n) {
    return this.track(new Ra(e), n);
  }
  /**
   * Analytics Business Hours Schedule Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Business%20Hours%20Schedule%20Updated)
   *
   * When the user selects a global business hours schedule filter on a dashboard or contextually on a panel
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsBusinessHoursScheduleUpdated(e, n) {
    return this.track(new Ma(e), n);
  }
  /**
   * Analytics Chart Granularity Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Chart%20Granularity%20Changed)
   *
   * When the user changes the granularity of a chart
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsChartGranularityChanged(e, n) {
    return this.track(new Fa(e), n);
  }
  /**
   * Analytics Chart Visualization Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Chart%20Visualization%20Changed)
   *
   * When the user changes the visualization of a chart
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsChartVisualizationChanged(e, n) {
    return this.track(new Da(e), n);
  }
  /**
   * Analytics Compare Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Clicked)
   *
   * When the user clicks the compare button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsCompareClicked(e, n) {
    return this.track(new Ua(e), n);
  }
  /**
   * Analytics Compare Context Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Context%20Updated)
   *
   * When the user updates the context in a comparison
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsCompareContextUpdated(e, n) {
    return this.track(new La(e), n);
  }
  /**
   * Analytics Compare Period Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Compare%20Period%20Updated)
   *
   * When the user updates the context in a comparison
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsComparePeriodUpdated(e, n) {
    return this.track(new Na(e), n);
  }
  /**
   * Analytics Context Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Context%20Updated)
   *
   * When the user updates the global context on a dashboard or contextually on a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsContextUpdated(e, n) {
    return this.track(new Va(e), n);
  }
  /**
   * Analytics Conversation Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Conversation%20Link%20Clicked)
   *
   * When the user clicks on a conversation link in supported instruments
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  analyticsConversationLinkClicked(e, n) {
    return this.track(new Ba(e), n);
  }
  /**
   * Analytics Conversation Preview Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Conversation%20Preview%20Clicked)
   *
   * When the user clicks on the button to preview a conversation in supported instruments
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  analyticsConversationPreviewClicked(e, n) {
    return this.track(new Ha(e), n);
  }
  /**
   * Analytics Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Dashboard%20Viewed)
   *
   * When the user views a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  analyticsDashboardViewed(e, n) {
    return this.track(new Wa(e), n);
  }
  /**
   * Analytics Export Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20Clicked)
   *
   * When the user clicks the export button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsExportClicked(e, n) {
    return this.track(new xa(e), n);
  }
  /**
   * Analytics Export Download Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20Download%20Clicked)
   *
   * When the user clicks the export download button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsExportDownloadClicked(e, n) {
    return this.track(new Qa(e), n);
  }
  /**
   * Analytics Export My Data Button Pressed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Export%20My%20Data%20Button%20Pressed)
   *
   * When the user clicks Export my data button on Analytics Export Dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfDays)
   * @param options Amplitude event options.
   */
  analyticsExportMyDataButtonPressed(e, n) {
    return this.track(new Ka(e), n);
  }
  /**
   * Analytics Filter Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Cleared)
   *
   * When the user clears a filter in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterCleared(e, n) {
    return this.track(new Ga(e), n);
  }
  /**
   * Analytics Filter Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Opened)
   *
   * When the user opens a filter in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterOpened(e, n) {
    return this.track(new qa(e), n);
  }
  /**
   * Analytics Filter Operator Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Operator%20Updated)
   *
   * When the updates the operator of filter in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFilterOperatorUpdated(e, n) {
    return this.track(new za(e), n);
  }
  /**
   * Analytics Filter Value Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filter%20Value%20Added)
   *
   * When the user adds a filter value in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. all)
   * @param options Amplitude event options.
   */
  analyticsFilterValueAdded(e, n) {
    return this.track(new $a(e), n);
  }
  /**
   * Analytics Filters Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filters%20Applied)
   *
   * When the user applies some global filters in a dashboard or contextually on a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFiltersApplied(e, n) {
    return this.track(new ja(e), n);
  }
  /**
   * Analytics Filters Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Filters%20Cleared)
   *
   * When the user clears all global filters in a dashboard or contextually in a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsFiltersCleared(e, n) {
    return this.track(new Ja(e), n);
  }
  /**
   * Analytics Helper Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Helper%20Clicked)
   *
   * When the user clicks a helper in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsHelperClicked(e, n) {
    return this.track(new Ya(e), n);
  }
  /**
   * Analytics In Depth Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20In%20Depth%20Clicked)
   *
   * When the user clicks an in-depth button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInDepthClicked(e, n) {
    return this.track(new Xa(e), n);
  }
  /**
   * Analytics Insights Copy Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Copy%20Clicked)
   *
   * When the user clicks copy to clipboard on an AI insight in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsCopyClicked(e, n) {
    return this.track(new Za(e), n);
  }
  /**
   * Analytics Insights Feedback Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Feedback%20Clicked)
   *
   * When the user clicks a feedback button on an AI insight in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsFeedbackClicked(e, n) {
    return this.track(new ec(e), n);
  }
  /**
   * Analytics Insights Prompt Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Prompt%20Clicked)
   *
   * When the user clicks on an AI insight prompt in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsPromptClicked(e, n) {
    return this.track(new tc(e), n);
  }
  /**
   * Analytics Insights Regenerate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Insights%20Regenerate%20Clicked)
   *
   * When the user clicks regenerate on an AI insight prompt in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsInsightsRegenerateClicked(e, n) {
    return this.track(new nc(e), n);
  }
  /**
   * Analytics Panel Controls Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Panel%20Controls%20Opened)
   *
   * When the user opens the panel controls modal
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPanelControlsOpened(e, n) {
    return this.track(new rc(e), n);
  }
  /**
   * Analytics Period Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Period%20Updated)
   *
   * When the user updates the global period on a dashboard or contextually in a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPeriodUpdated(e, n) {
    return this.track(new ic(e), n);
  }
  /**
   * Analytics Pin Panel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Pin%20Panel%20Clicked)
   *
   * When the user clicks the pin panel button in a dashboard
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPinPanelClicked(e, n) {
    return this.track(new sc(e), n);
  }
  /**
   * Analytics Pin Panel Quick View Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Pin%20Panel%20Quick%20View%20Created)
   *
   * When the user creates a quick view from the pin panel modal
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsPinPanelQuickViewCreated(e, n) {
    return this.track(new oc(e), n);
  }
  /**
   * Analytics Quick View Auto Refresh Disabled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Auto%20Refresh%20Disabled)
   *
   * When the user disables auto-refresh on a quick view
   *
   * @param properties The event's properties (e.g. interval)
   * @param options Amplitude event options.
   */
  analyticsQuickViewAutoRefreshDisabled(e, n) {
    return this.track(new ac(e), n);
  }
  /**
   * Analytics Quick View Auto Refresh Enabled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Auto%20Refresh%20Enabled)
   *
   * When the user enables auto-refresh on a quick view
   *
   * @param properties The event's properties (e.g. interval)
   * @param options Amplitude event options.
   */
  analyticsQuickViewAutoRefreshEnabled(e, n) {
    return this.track(new cc(e), n);
  }
  /**
   * Analytics Quick View Auto Refresh Triggered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Auto%20Refresh%20Triggered)
   *
   * When the quick view auto-refresh is triggered
   *
   * @param properties The event's properties (e.g. interval)
   * @param options Amplitude event options.
   */
  analyticsQuickViewAutoRefreshTriggered(e, n) {
    return this.track(new uc(e), n);
  }
  /**
   * Analytics Quick View Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Created)
   *
   * When the user creates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewCreated(e, n) {
    return this.track(new lc(e), n);
  }
  /**
   * Analytics Quick View Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Deleted)
   *
   * When the user deletes a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  analyticsQuickViewDeleted(e, n) {
    return this.track(new dc(e), n);
  }
  /**
   * Analytics Quick View Duplicated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Duplicated)
   *
   * When the user duplicates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewDuplicated(e, n) {
    return this.track(new pc(e), n);
  }
  /**
   * Analytics Quick View Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Favorite%20Toggled)
   *
   * When the user favorites or unfavorites a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. favorited)
   * @param options Amplitude event options.
   */
  analyticsQuickViewFavoriteToggled(e, n) {
    return this.track(new hc(e), n);
  }
  /**
   * Analytics Quick View Landing Page Set
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Landing%20Page%20Set)
   *
   * When the user sets a quick view as the Analytics landing page
   *
   * @param properties The event's properties (e.g. isOwner)
   * @param options Amplitude event options.
   */
  analyticsQuickViewLandingPageSet(e, n) {
    return this.track(new vc(e), n);
  }
  /**
   * Analytics Quick View Landing Page Unset
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Landing%20Page%20Unset)
   *
   * When the user sets a quick view as the Analytics landing page
   *
   * @param properties The event's properties (e.g. isOwner)
   * @param options Amplitude event options.
   */
  analyticsQuickViewLandingPageUnset(e, n) {
    return this.track(new gc(e), n);
  }
  /**
   * Analytics Quick View Ownership Transferred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Ownership%20Transferred)
   *
   * When the user transfers ownership of a quick view
   *
   * @param options Amplitude event options.
   */
  analyticsQuickViewOwnershipTransferred(e) {
    return this.track(new fc(), e);
  }
  /**
   * Analytics Quick View Panel Controls Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Controls%20Updated)
   *
   * When the user updates the controls of a panel in a quick view
   *
   * @param properties The event's properties (e.g. applyToAll)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelControlsUpdated(e, n) {
    return this.track(new Cc(e), n);
  }
  /**
   * Analytics Quick View Panel Description Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Description%20Updated)
   *
   * When the user updates the description of a panel in a quick view
   *
   * @param properties The event's properties (e.g. panel)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelDescriptionUpdated(e, n) {
    return this.track(new yc(e), n);
  }
  /**
   * Analytics Quick View Panel Pinned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Pinned)
   *
   * When the user pins a panel to a quick view
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelPinned(e, n) {
    return this.track(new mc(e), n);
  }
  /**
   * Analytics Quick View Panel Unpinned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panel%20Unpinned)
   *
   * When the user unpins a panel from a quick view
   *
   * @param properties The event's properties (e.g. panel)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelUnpinned(e, n) {
    return this.track(new kc(e), n);
  }
  /**
   * Analytics Quick View Panels Layout Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panels%20Layout%20Changed)
   *
   * When the user changes the layout of panels in a quick view by dragging or resizing
   *
   * @param properties The event's properties (e.g. event)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelsLayoutChanged(e, n) {
    return this.track(new wc(e), n);
  }
  /**
   * Analytics Quick View Panels Reset
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panels%20Reset)
   *
   * When the user resets the panels in a quick view
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelsReset(e, n) {
    return this.track(new _c(e), n);
  }
  /**
   * Analytics Quick View Panels Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Panels%20Updated)
   *
   * When the user updates the panels in a quick view
   *
   * @param properties The event's properties (e.g. shared)
   * @param options Amplitude event options.
   */
  analyticsQuickViewPanelsUpdated(e, n) {
    return this.track(new Sc(e), n);
  }
  /**
   * Analytics Quick View Sharing Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Sharing%20Toggled)
   *
   * When the user shares or unshares a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewSharingToggled(e, n) {
    return this.track(new bc(e), n);
  }
  /**
   * Analytics Quick View Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Updated)
   *
   * When the user updates a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewUpdated(e, n) {
    return this.track(new Ac(e), n);
  }
  /**
   * Analytics Quick View Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Quick%20View%20Viewed)
   *
   * When the user views a quick view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsQuickViewViewed(e, n) {
    return this.track(new Ic(e), n);
  }
  /**
   * Analytics Refresh Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Refresh%20Clicked)
   *
   * When the user clicks a refresh button in a dashboard
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsRefreshClicked(e, n) {
    return this.track(new Tc(e), n);
  }
  /**
   * Analytics Table Load All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Table%20Load%20All%20Clicked)
   *
   * When the user clicks the load all results button on a table
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsTableLoadAllClicked(e, n) {
    return this.track(new Ec(e), n);
  }
  /**
   * Analytics Table Sort Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Table%20Sort%20Updated)
   *
   * When the user updates the sorting on a table
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. column)
   * @param options Amplitude event options.
   */
  analyticsTableSortUpdated(e, n) {
    return this.track(new Oc(e), n);
  }
  /**
   * Analytics Timezone Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20Timezone%20Updated)
   *
   * When the user updates the global timezone on a dashboard or contextually on a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsTimezoneUpdated(e, n) {
    return this.track(new Pc(e), n);
  }
  /**
   * Analytics View Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Analytics%20View%20Conversations%20Clicked)
   *
   * When the user clicks the view conversations button in a panel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  analyticsViewConversationsClicked(e, n) {
    return this.track(new Rc(e), n);
  }
  /**
   * Auth Failed Init
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Auth%20Failed%20Init)
   *
   * When the application fails to initialize authentication
   *
   * @param properties The event's properties (e.g. failureReason)
   * @param options Amplitude event options.
   */
  authFailedInit(e, n) {
    return this.track(new Mc(e), n);
  }
  /**
   * Automations Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in automations settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new Fc(), e);
  }
  /**
   * Automations Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Cancelled)
   *
   * When the user cancels the Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormCancelled(e, n) {
    return this.track(new Dc(e), n);
  }
  /**
   * Automations Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Opened)
   *
   * When the user opens the create/update Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormOpened(e, n) {
    return this.track(new Uc(e), n);
  }
  /**
   * Automations Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Form%20Submitted)
   *
   * When the user proceeds on the Automation form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  automationsFormSubmitted(e, n) {
    return this.track(new Lc(e), n);
  }
  /**
   * Automations Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOpened(e) {
    return this.track(new Nc(), e);
  }
  /**
   * Automations Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionDeleteClicked(e) {
    return this.track(new Vc(), e);
  }
  /**
   * Automations Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new Bc(), e);
  }
  /**
   * Automations Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit Flow in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionFlowClicked(e) {
    return this.track(new Hc(), e);
  }
  /**
   * Automations Options Menu Option Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Options%20Menu%20Option%20Settings%20Clicked)
   *
   * When the user selects Settings in the Automation options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsOptionsMenuOptionSettingsClicked(e) {
    return this.track(new Wc(), e);
  }
  /**
   * Automations Pagination Next Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Pagination%20Next%20Clicked)
   *
   * When the user clicks the next page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsPaginationNextClicked(e) {
    return this.track(new xc(), e);
  }
  /**
   * Automations Pagination Previous Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Pagination%20Previous%20Clicked)
   *
   * When the user clicks the previous page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsPaginationPreviousClicked(e) {
    return this.track(new Qc(), e);
  }
  /**
   * Automations Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchApplied(e) {
    return this.track(new Kc(), e);
  }
  /**
   * Automations Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchClosed(e) {
    return this.track(new Gc(), e);
  }
  /**
   * Automations Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsSearchOpened(e) {
    return this.track(new qc(), e);
  }
  /**
   * Automations Toggled Off
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Toggled%20Off)
   *
   * When the user toggles an automation off
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsToggledOff(e) {
    return this.track(new zc(), e);
  }
  /**
   * Automations Toggled On
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Automations%20Toggled%20On)
   *
   * When the user toggles an automation on
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  automationsToggledOn(e) {
    return this.track(new $c(), e);
  }
  /**
   * Bans Ban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Ban%20User%20Clicked)
   *
   * When the user clicks the Ban User button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  bansBanUserClicked(e, n) {
    return this.track(new jc(e), n);
  }
  /**
   * Bans Unban Ip Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Unban%20Ip%20Clicked)
   *
   * When the user clicks the Unban IP button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  bansUnbanIpClicked(e) {
    return this.track(new Jc(), e);
  }
  /**
   * Bans Unban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bans%20Unban%20User%20Clicked)
   *
   * When the user clicks the Unban User button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  bansUnbanUserClicked(e, n) {
    return this.track(new Yc(e), n);
  }
  /**
   * Bulk Actions Update Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Bulk%20Actions%20Update%20Clicked)
   *
   * When the user clicks the Update button in the Bulk Actions
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationsCount)
   * @param options Amplitude event options.
   */
  bulkActionsUpdateClicked(e, n) {
    return this.track(new Xc(e), n);
  }
  /**
   * Business Hours Add Schedule Audio Message Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Audio%20Message%20Added)
   *
   * When the user added an Audio message.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleAudioMessageAdded(e, n) {
    return this.track(new Zc(e), n);
  }
  /**
   * Business Hours Add Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Button%20Clicked)
   *
   * When the user clicked the Add new schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleButtonClicked(e) {
    return this.track(new eu(), e);
  }
  /**
   * Business Hours Add Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Add new schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleFormCancelled(e, n) {
    return this.track(new tu(e), n);
  }
  /**
   * Business Hours Add Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Add%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Add new schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursAddScheduleFormSubmitted(e, n) {
    return this.track(new nu(e), n);
  }
  /**
   * Business Hours Conflict Notification Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Conflict%20Notification%20Button%20Clicked)
   *
   * When the user clicked the Go to Business Hours button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursConflictNotificationButtonClicked(e) {
    return this.track(new ru(), e);
  }
  /**
   * Business Hours Conflict Notification Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Conflict%20Notification%20Closed)
   *
   * When the user clicked the close button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursConflictNotificationClosed(e) {
    return this.track(new iu(), e);
  }
  /**
   * Business Hours Delete Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Delete%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Delete schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDeleteScheduleFormCancelled(e) {
    return this.track(new su(), e);
  }
  /**
   * Business Hours Delete Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Delete%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Delete schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDeleteScheduleFormSubmitted(e) {
    return this.track(new ou(), e);
  }
  /**
   * Business Hours Duplicate Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Duplicate%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Duplicate schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDuplicateScheduleFormCancelled(e) {
    return this.track(new au(), e);
  }
  /**
   * Business Hours Duplicate Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Duplicate%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Duplicate schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursDuplicateScheduleFormSubmitted(e) {
    return this.track(new cu(), e);
  }
  /**
   * Business Hours First Schedule Modal Question Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20First%20Schedule%20Modal%20Question%20Clicked)
   *
   * When the user clicked the one of the question toggle.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. question)
   * @param options Amplitude event options.
   */
  businessHoursFirstScheduleModalQuestionClicked(e, n) {
    return this.track(new uu(e), n);
  }
  /**
   * Business Hours First Schedule Support Article Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20First%20Schedule%20Support%20Article%20Clicked)
   *
   * When the user clicked the Support article link.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursFirstScheduleSupportArticleClicked(e) {
    return this.track(new lu(), e);
  }
  /**
   * Business Hours Go To Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Go%20To%20Flow%20Clicked)
   *
   * When the user clicked the Go to flow on the Schedules listing page.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursGoToFlowClicked(e) {
    return this.track(new du(), e);
  }
  /**
   * Business Hours Migration Wizard Audio Message Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Audio%20Message%20Added)
   *
   * When the user added an Audio message.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardAudioMessageAdded(e, n) {
    return this.track(new pu(e), n);
  }
  /**
   * Business Hours Migration Wizard Create New Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Create%20New%20Schedule%20Button%20Clicked)
   *
   * When the clicked the Create new schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardCreateNewScheduleButtonClicked(e) {
    return this.track(new hu(), e);
  }
  /**
   * Business Hours Migration Wizard Edit Hours Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Edit%20Hours%20Button%20Clicked)
   *
   * When the user clicked the Edit hours button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardEditHoursButtonClicked(e) {
    return this.track(new vu(), e);
  }
  /**
   * Business Hours Migration Wizard Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Form%20Cancelled)
   *
   * When the user cancelled the Migration wizard modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. step)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardFormCancelled(e, n) {
    return this.track(new gu(e), n);
  }
  /**
   * Business Hours Migration Wizard Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Form%20Submitted)
   *
   * When the user submitted the Migration wizard modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardFormSubmitted(e, n) {
    return this.track(new fu(e), n);
  }
  /**
   * Business Hours Migration Wizard Opening Hours Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Opening%20Hours%20Form%20Cancelled)
   *
   * When the user cancelled the Migration wizard Opening hours form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardOpeningHoursFormCancelled(e) {
    return this.track(new Cu(), e);
  }
  /**
   * Business Hours Migration Wizard Opening Hours Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Opening%20Hours%20Form%20Submitted)
   *
   * When the user submitted the Migration wizard Opening hours form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardOpeningHoursFormSubmitted(e) {
    return this.track(new yu(), e);
  }
  /**
   * Business Hours Migration Wizard Start Update Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Migration%20Wizard%20Start%20Update%20Button%20Clicked)
   *
   * When the user clicked the Start update button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursMigrationWizardStartUpdateButtonClicked(e) {
    return this.track(new mu(), e);
  }
  /**
   * Business Hours Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Opened)
   *
   * When the user opened the Options Menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOpened(e) {
    return this.track(new ku(), e);
  }
  /**
   * Business Hours Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selected Delete in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionDeleteClicked(e) {
    return this.track(new wu(), e);
  }
  /**
   * Business Hours Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selected Duplicate in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new _u(), e);
  }
  /**
   * Business Hours Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selected Edit schedule in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionEditClicked(e) {
    return this.track(new Su(), e);
  }
  /**
   * Business Hours Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selected Rename in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursOptionsMenuOptionRenameClicked(e) {
    return this.track(new bu(), e);
  }
  /**
   * Business Hours Rename Schedule Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Rename%20Schedule%20Form%20Cancelled)
   *
   * When the user cancelled the Rename schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursRenameScheduleFormCancelled(e) {
    return this.track(new Au(), e);
  }
  /**
   * Business Hours Rename Schedule Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Rename%20Schedule%20Form%20Submitted)
   *
   * When the user submitted the Rename schedule form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursRenameScheduleFormSubmitted(e, n) {
    return this.track(new Iu(e), n);
  }
  /**
   * Business Hours Schedule Add Exception Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Button%20Clicked)
   *
   * When user clicked on the Add exception button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionButtonClicked(e) {
    return this.track(new Tu(), e);
  }
  /**
   * Business Hours Schedule Add Exception Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Form%20Cancelled)
   *
   * When the user cancelled the Add exception form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionFormCancelled(e) {
    return this.track(new Eu(), e);
  }
  /**
   * Business Hours Schedule Add Exception Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Add%20Exception%20Form%20Submitted)
   *
   * When the user submitted Add exception form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleAddExceptionFormSubmitted(e) {
    return this.track(new Ou(), e);
  }
  /**
   * Business Hours Schedule Audio Message Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Form%20Cancelled)
   *
   * When the user cancelled the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageFormCancelled(e, n) {
    return this.track(new Pu(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Form%20Submitted)
   *
   * When the user submitted the Audio message modal.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageFormSubmitted(e, n) {
    return this.track(new Ru(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Opened)
   *
   * When the user opened the Audio message options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOpened(e, n) {
    return this.track(new Mu(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Clear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Clear%20Clicked)
   *
   * When the user selected Clear from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionClearClicked(e, n) {
    return this.track(new Fu(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Record Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Record%20Clicked)
   *
   * When the user selected Record audio message from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked(e, n) {
    return this.track(new Du(e), n);
  }
  /**
   * Business Hours Schedule Audio Message Options Menu Option Upload Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Audio%20Message%20Options%20Menu%20Option%20Upload%20Clicked)
   *
   * When the user selected Upload audio message from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked(e, n) {
    return this.track(new Uu(e), n);
  }
  /**
   * Business Hours Schedule Auto Reply Options Menu Option Clear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Auto%20Reply%20Options%20Menu%20Option%20Clear%20Clicked)
   *
   * When the user selected Clear from the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleAutoReplyOptionsMenuOptionClearClicked(e, n) {
    return this.track(new Lu(e), n);
  }
  /**
   * Business Hours Schedule Conflict Change Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Conflict%20Change%20Button%20Clicked)
   *
   * When the user clicked the Change button on the overridden item.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleConflictChangeButtonClicked(e) {
    return this.track(new Nu(), e);
  }
  /**
   * Business Hours Schedule Conflict Review Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Conflict%20Review%20Button%20Clicked)
   *
   * When the user clicked the Review conflicts button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleConflictReviewButtonClicked(e) {
    return this.track(new Vu(), e);
  }
  /**
   * Business Hours Schedule Delete Exception Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Delete%20Exception%20Form%20Cancelled)
   *
   * When the user cancelled the Delete exception modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleDeleteExceptionFormCancelled(e) {
    return this.track(new Bu(), e);
  }
  /**
   * Business Hours Schedule Delete Exception Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Delete%20Exception%20Form%20Submitted)
   *
   * When the user submitted the Delete exception modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleDeleteExceptionFormSubmitted(e) {
    return this.track(new Hu(), e);
  }
  /**
   * Business Hours Schedule Exception Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Exception%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selected Delete in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. openingHourType)
   * @param options Amplitude event options.
   */
  businessHoursScheduleExceptionOptionsMenuOptionDeleteClicked(e, n) {
    return this.track(new Wu(e), n);
  }
  /**
   * Business Hours Schedule Import Holiday Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Import%20Holiday%20Form%20Cancelled)
   *
   * When the user cancelled the Import holiday form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleImportHolidayFormCancelled(e) {
    return this.track(new xu(), e);
  }
  /**
   * Business Hours Schedule Import Holiday Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Import%20Holiday%20Form%20Submitted)
   *
   * When the user submitted the Import holiday form.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. countryCode)
   * @param options Amplitude event options.
   */
  businessHoursScheduleImportHolidayFormSubmitted(e, n) {
    return this.track(new Qu(e), n);
  }
  /**
   * Business Hours Schedule Options Menu Import Holidays Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Import%20Holidays%20Clicked)
   *
   * When the user selected Import holidays in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuImportHolidaysClicked(e) {
    return this.track(new Ku(), e);
  }
  /**
   * Business Hours Schedule Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Opened)
   *
   * When the user opened the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuOpened(e) {
    return this.track(new Gu(), e);
  }
  /**
   * Business Hours Schedule Options Menu Recover Holidays Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Recover%20Holidays%20Clicked)
   *
   * When the user selected Recover deleted holidays in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuRecoverHolidaysClicked(e) {
    return this.track(new qu(), e);
  }
  /**
   * Business Hours Schedule Options Menu Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Rename%20Clicked)
   *
   * When the user selected Rename in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuRenameClicked(e) {
    return this.track(new zu(), e);
  }
  /**
   * Business Hours Schedule Options Menu Timezone Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Options%20Menu%20Timezone%20Clicked)
   *
   * When the user selected Edit timezone in the options menu.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleOptionsMenuTimezoneClicked(e) {
    return this.track(new $u(), e);
  }
  /**
   * Business Hours Schedule Preview Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Preview%20Button%20Clicked)
   *
   * When the user clicked the Preview button.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursSchedulePreviewButtonClicked(e, n) {
    return this.track(new ju(e), n);
  }
  /**
   * Business Hours Schedule Recover Holidays Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Recover%20Holidays%20Form%20Cancelled)
   *
   * When the user cancelled the Recover holidays modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleRecoverHolidaysFormCancelled(e) {
    return this.track(new Ju(), e);
  }
  /**
   * Business Hours Schedule Recover Holidays Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Recover%20Holidays%20Form%20Submitted)
   *
   * When the user submitted the Recover holidays modal.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleRecoverHolidaysFormSubmitted(e) {
    return this.track(new Yu(), e);
  }
  /**
   * Business Hours Schedule Review Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Review%20Form%20Cancelled)
   *
   * When the user cancelled the Review conflicts form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleReviewFormCancelled(e) {
    return this.track(new Xu(), e);
  }
  /**
   * Business Hours Schedule Review Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Review%20Form%20Submitted)
   *
   * When the user submitted the Review conflicts form.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleReviewFormSubmitted(e) {
    return this.track(new Zu(), e);
  }
  /**
   * Business Hours Schedule Save Schedule Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Save%20Schedule%20Button%20Clicked)
   *
   * When the user clicked the Save schedule button.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  businessHoursScheduleSaveScheduleButtonClicked(e) {
    return this.track(new el(), e);
  }
  /**
   * Business Hours Schedule Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20Tab%20Clicked)
   *
   * When user clicked one of the view tabs.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. view)
   * @param options Amplitude event options.
   */
  businessHoursScheduleTabClicked(e, n) {
    return this.track(new tl(e), n);
  }
  /**
   * Business Hours Schedule View Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Business%20Hours%20Schedule%20View%20Clicked)
   *
   * When the user clicked one of the view buttons.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  businessHoursScheduleViewClicked(e, n) {
    return this.track(new nl(e), n);
  }
  /**
   * Chat Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in chat settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new rl(), e);
  }
  /**
   * Chat Form Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Canceled)
   *
   * When the user cancels the Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormCanceled(e, n) {
    return this.track(new il(e), n);
  }
  /**
   * Chat Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Opened)
   *
   * When the user opens the create/rename Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormOpened(e, n) {
    return this.track(new sl(e), n);
  }
  /**
   * Chat Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Form%20Submitted)
   *
   * When the user proceed on the Widget form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  chatFormSubmitted(e, n) {
    return this.track(new ol(e), n);
  }
  /**
   * Chat Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Opened)
   *
   * Whether the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOpened(e) {
    return this.track(new al(), e);
  }
  /**
   * Chat Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionDeleteClicked(e) {
    return this.track(new cl(), e);
  }
  /**
   * Chat Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new ul(), e);
  }
  /**
   * Chat Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit flow in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionFlowClicked(e) {
    return this.track(new ll(), e);
  }
  /**
   * Chat Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionRenameClicked(e) {
    return this.track(new dl(), e);
  }
  /**
   * Chat Options Menu Option Setup Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Options%20Menu%20Option%20Setup%20Clicked)
   *
   * When the user selects Setup in the Widget options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatOptionsMenuOptionSetupClicked(e) {
    return this.track(new pl(), e);
  }
  /**
   * Chat Pagination Next Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Pagination%20Next%20Clicked)
   *
   * When the user clicks the next page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatPaginationNextClicked(e) {
    return this.track(new hl(), e);
  }
  /**
   * Chat Pagination Previous Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Pagination%20Previous%20Clicked)
   *
   * When the user clicks the previous page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatPaginationPreviousClicked(e) {
    return this.track(new vl(), e);
  }
  /**
   * Chat Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchApplied(e) {
    return this.track(new gl(), e);
  }
  /**
   * Chat Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchClosed(e) {
    return this.track(new fl(), e);
  }
  /**
   * Chat Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chat%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  chatSearchOpened(e) {
    return this.track(new Cl(), e);
  }
  /**
   * Chatbot Create Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Create%20Modal%20Opened)
   *
   * When the user opens the Create new chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotCreateModalOpened(e) {
    return this.track(new yl(), e);
  }
  /**
   * Chatbot Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Created)
   *
   * When the user creates a new chatbot
   *
   * @param properties The event's properties (e.g. chatbotType)
   * @param options Amplitude event options.
   */
  chatbotCreated(e, n) {
    return this.track(new ml(e), n);
  }
  /**
   * Chatbot Delete Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Delete%20Modal%20Opened)
   *
   * When the user opens the Delete chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotDeleteModalOpened(e) {
    return this.track(new kl(), e);
  }
  /**
   * Chatbot Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Deleted)
   *
   * When the user deletes a chatbot
   *
   * @param properties The event's properties (e.g. chatbotType)
   * @param options Amplitude event options.
   */
  chatbotDeleted(e, n) {
    return this.track(new wl(e), n);
  }
  /**
   * Chatbot Edit Identity Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Edit%20Identity%20Modal%20Opened)
   *
   * When the user opens the Identity chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotEditIdentityModalOpened(e) {
    return this.track(new _l(), e);
  }
  /**
   * Chatbot Identity Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Chatbot%20Identity%20Edited)
   *
   * When the user edits the Identity chatbot modal
   *
   * @param options Amplitude event options.
   */
  chatbotIdentityEdited(e) {
    return this.track(new Sl(), e);
  }
  /**
   * Color Mode Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Color%20Mode%20Updated)
   *
   * When the user updates their preferred color mode.
   *
   * @param properties The event's properties (e.g. colorMode)
   * @param options Amplitude event options.
   */
  colorModeUpdated(e, n) {
    return this.track(new bl(e), n);
  }
  /**
   * Command Executed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Command%20Executed)
   *
   * When the user executes a command.
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  commandExecuted(e, n) {
    return this.track(new Al(e), n);
  }
  /**
   * Company Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Company%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on company modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  companyModalFormSubmitted(e, n) {
    return this.track(new Il(e), n);
  }
  /**
   * Contacts Add New Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Add%20New%20Company%20Clicked)
   *
   * When the user clicks the Add New Company button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsAddNewCompanyClicked(e) {
    return this.track(new Tl(), e);
  }
  /**
   * Contacts Add New Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Add%20New%20Contact%20Clicked)
   *
   * When the user clicks the Add New Contact button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsAddNewContactClicked(e) {
    return this.track(new El(), e);
  }
  /**
   * Contacts Ban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Ban%20User%20Clicked)
   *
   * When the user clicks the Ban User button on the Contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  contactsBanUserClicked(e, n) {
    return this.track(new Ol(e), n);
  }
  /**
   * Contacts Card Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Actions%20Menu%20Opened)
   *
   * When the user opens the Actions Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardActionsMenuOpened(e) {
    return this.track(new Pl(), e);
  }
  /**
   * Contacts Card Compose New Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Compose%20New%20Email%20Clicked)
   *
   * When the user clicks the Compose New Email button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardComposeNewEmailClicked(e) {
    return this.track(new Rl(), e);
  }
  /**
   * Contacts Card Edit Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Edit%20Company%20Clicked)
   *
   * When the user clicks the to edit a company
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardEditCompanyClicked(e) {
    return this.track(new Ml(), e);
  }
  /**
   * Contacts Card Edit Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Edit%20Contact%20Clicked)
   *
   * When the user clicks the to edit a contact
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardEditContactClicked(e) {
    return this.track(new Fl(), e);
  }
  /**
   * Contacts Card Make Call Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20Make%20Call%20Clicked)
   *
   * When the user clicks to make a call in the contact card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardMakeCallClicked(e) {
    return this.track(new Dl(), e);
  }
  /**
   * Contacts Card See All Assigned Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20See%20All%20Assigned%20Conversations%20Clicked)
   *
   * When the user clicks the button to see all assigned conversations
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardSeeAllAssignedConversationsClicked(e) {
    return this.track(new Ul(), e);
  }
  /**
   * Contacts Card See All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20See%20All%20Conversations%20Clicked)
   *
   * When the user clicks the button to see all conversations
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardSeeAllConversationsClicked(e) {
    return this.track(new Ll(), e);
  }
  /**
   * Contacts Card View Company Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20View%20Company%20Clicked)
   *
   * When the user clicks to view the company in the contacts card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardViewCompanyClicked(e) {
    return this.track(new Nl(), e);
  }
  /**
   * Contacts Card View User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Card%20View%20User%20Clicked)
   *
   * When the user clicks to view the user in the contacts card
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsCardViewUserClicked(e) {
    return this.track(new Vl(), e);
  }
  /**
   * Contacts Search Blurred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Search%20Blurred)
   *
   * When the search input is blurred
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsSearchBlurred(e) {
    return this.track(new Bl(), e);
  }
  /**
   * Contacts Search Focused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Search%20Focused)
   *
   * When the search input is focused
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsSearchFocused(e) {
    return this.track(new Hl(), e);
  }
  /**
   * Contacts Unban User Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20Unban%20User%20Clicked)
   *
   * When the user clicks the Unban User button on the Contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  contactsUnbanUserClicked(e, n) {
    return this.track(new Wl(e), n);
  }
  /**
   * Contacts View Companies
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20View%20Companies)
   *
   * When the user selects Companies in the dropdown in the contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsViewCompanies(e) {
    return this.track(new xl(), e);
  }
  /**
   * Contacts View End Users
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Contacts%20View%20End%20Users)
   *
   * When the user selects Contacts from the dropdown in the contacts page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  contactsViewEndUsers(e) {
    return this.track(new Ql(), e);
  }
  /**
   * Conversation Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Actions%20Menu%20Opened)
   *
   * When the user opens the Actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActionsMenuOpened(e) {
    return this.track(new Kl(), e);
  }
  /**
   * Conversation Actions Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Actions%20Menu%20Option%20Clicked)
   *
   * When the user selects an option from the Actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  conversationActionsMenuOptionClicked(e, n) {
    return this.track(new Gl(e), n);
  }
  /**
   * Conversation Activity Log Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Closed)
   *
   * When the user closed the Activity Log
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActivityLogClosed(e) {
    return this.track(new ql(), e);
  }
  /**
   * Conversation Activity Log Flooter Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Flooter%20Expanded)
   *
   * When the agent has expanded the Flooter.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationActivityLogFlooterExpanded(e) {
    return this.track(new zl(), e);
  }
  /**
   * Conversation Activity Log Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Activity%20Log%20Opened)
   *
   * When the user opens the Activity Log
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationActivityLogOpened(e, n) {
    return this.track(new $l(e), n);
  }
  /**
   * Conversation Article Draft Improvement Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Improvement%20Requested)
   *
   * Event triggered when an agent requests improvements to a drafted article for a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftImprovementRequested(e, n) {
    return this.track(new jl(e), n);
  }
  /**
   * Conversation Article Draft Improvement Response Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Improvement%20Response%20Received)
   *
   * Event indicating that a response has been received for improving a draft article within a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftImprovementResponseReceived(e, n) {
    return this.track(new Jl(e), n);
  }
  /**
   * Conversation Article Draft Preview Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Preview%20Requested)
   *
   * Event indicating that a user has requested a preview of a draft article within a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftPreviewRequested(e, n) {
    return this.track(new Yl(e), n);
  }
  /**
   * Conversation Article Draft Preview Response Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Preview%20Response%20Received)
   *
   * Event indicating that a draft article preview was received for a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftPreviewResponseReceived(e, n) {
    return this.track(new Xl(e), n);
  }
  /**
   * Conversation Article Draft Save Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Save%20Requested)
   *
   * Event indicating that a user has requested to save a draft of an article within a conversation.
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftSaveRequested(e, n) {
    return this.track(new Zl(e), n);
  }
  /**
   * Conversation Article Draft Save Response Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Article%20Draft%20Save%20Response%20Received)
   *
   * Event indicating that saving a draft of an article in a conversation has succeeded.
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  conversationArticleDraftSaveResponseReceived(e, n) {
    return this.track(new ed(e), n);
  }
  /**
   * Conversation Attached Image Is Downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Attached%20Image%20Is%20Downloaded)
   *
   * When the user downloads an image attachment from the preview modal
   *
   * @param options Amplitude event options.
   */
  conversationAttachedImageIsDownloaded(e) {
    return this.track(new td(), e);
  }
  /**
   * Conversation Attached Image Is Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Attached%20Image%20Is%20Viewed)
   *
   * When the user clicks on an image attachment that opens the preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationAttachedImageIsViewed(e) {
    return this.track(new nd(), e);
  }
  /**
   * Conversation Claimed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Claimed)
   *
   * When the user claims the conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationClaimed(e, n) {
    return this.track(new rd(e), n);
  }
  /**
   * Conversation Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Closed)
   *
   * When the user closes the conversatio
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationClosed(e, n) {
    return this.track(new id(e), n);
  }
  /**
   * Conversation Csat Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Cancelled)
   *
   * When the user cancels the CSAT
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatCancelled(e) {
    return this.track(new sd(), e);
  }
  /**
   * Conversation Csat Menu Cancel Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Cancel%20Option%20Clicked)
   *
   * When the user clicks the Cancel CSAT menu option
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatMenuCancelOptionClicked(e) {
    return this.track(new od(), e);
  }
  /**
   * Conversation Csat Menu Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Language%20Selected)
   *
   * When the user changes the language from the CSAT menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. languageCode)
   * @param options Amplitude event options.
   */
  conversationCsatMenuLanguageSelected(e, n) {
    return this.track(new ad(e), n);
  }
  /**
   * Conversation Csat Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Csat%20Menu%20Opened)
   *
   * When the user opens the CSAT menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationCsatMenuOpened(e) {
    return this.track(new cd(), e);
  }
  /**
   * Conversation Focus Mode Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Focus%20Mode%20Toggled)
   *
   * When user decides to turn on or off Focus mode (which makes the area for writing messages bigger)
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationFocusModeToggled(e, n) {
    return this.track(new ud(e), n);
  }
  /**
   * Conversation Follow Up
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up)
   *
   * When a conversation was followed up.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationFollowUp(e, n) {
    return this.track(new ld(e), n);
  }
  /**
   * Conversation Follow Up Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up%20Menu%20Opened)
   *
   * When the user opens the Follow Up menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationFollowUpMenuOpened(e) {
    return this.track(new dd(), e);
  }
  /**
   * Conversation Follow Up Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Follow%20Up%20Menu%20Option%20Clicked)
   *
   * When the user selects an option from the Follow Up menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  conversationFollowUpMenuOptionClicked(e, n) {
    return this.track(new pd(e), n);
  }
  /**
   * Conversation Header Conversation Details Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Conversation%20Details%20Menu%20Opened)
   *
   * When the user opens conversation details dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderConversationDetailsMenuOpened(e) {
    return this.track(new hd(), e);
  }
  /**
   * Conversation Header Tag Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Added)
   *
   * When the user adds a tag from tag dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationHeaderTagAdded(e, n) {
    return this.track(new vd(e), n);
  }
  /**
   * Conversation Header Tag Include Deactivated Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Include%20Deactivated%20Toggled)
   *
   * When the user toggles Include deactivated tags in tag select dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. include)
   * @param options Amplitude event options.
   */
  conversationHeaderTagIncludeDeactivatedToggled(e, n) {
    return this.track(new gd(e), n);
  }
  /**
   * Conversation Header Tag Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Menu%20Opened)
   *
   * When the user opens tags select dropdown from conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTagMenuOpened(e) {
    return this.track(new fd(), e);
  }
  /**
   * Conversation Header Tag Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Tag%20Removed)
   *
   * When the user removes a tag from conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationHeaderTagRemoved(e, n) {
    return this.track(new Cd(e), n);
  }
  /**
   * Conversation Header Transfer To Agent Item Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Agent%20Item%20Selected)
   *
   * When the user selects an agent from transfer to agent dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToAgentItemSelected(e) {
    return this.track(new yd(), e);
  }
  /**
   * Conversation Header Transfer To Agent Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Agent%20Menu%20Opened)
   *
   * When the user opens the transfer to agent dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToAgentMenuOpened(e) {
    return this.track(new md(), e);
  }
  /**
   * Conversation Header Transfer To Number Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Number%20Button%20Clicked)
   *
   * When the user clicks on transfer to number button in the conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToNumberButtonClicked(e) {
    return this.track(new kd(), e);
  }
  /**
   * Conversation Header Transfer To Queue Item Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Queue%20Item%20Selected)
   *
   * When the user selects a queue from transfer to queue dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. queue)
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToQueueItemSelected(e, n) {
    return this.track(new wd(e), n);
  }
  /**
   * Conversation Header Transfer To Queue Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Header%20Transfer%20To%20Queue%20Menu%20Opened)
   *
   * When the user opens the transfer to queue dropdown in conversation header
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationHeaderTransferToQueueMenuOpened(e) {
    return this.track(new _d(), e);
  }
  /**
   * Conversation Internal Note Editor Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Internal%20Note%20Editor%20Opened)
   *
   * When the user opens the internal note tab
   *
   * @param options Amplitude event options.
   */
  conversationInternalNoteEditorOpened(e) {
    return this.track(new Sd(), e);
  }
  /**
   * Conversation Offered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Offered)
   *
   * When a conversation was offered to an agent
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationOffered(e, n) {
    return this.track(new bd(e), n);
  }
  /**
   * Conversation Replied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Replied)
   *
   * When the user replies a conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  conversationReplied(e, n) {
    return this.track(new Ad(e), n);
  }
  /**
   * Conversation Resolved As A Knowledge Article Draft
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20As%20A%20Knowledge%20Article%20Draft)
   *
   * When a user chooses to create a draft when they resolve a conversation
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedAsAKnowledgeArticleDraft(e, n) {
    return this.track(new Id(e), n);
  }
  /**
   * Conversation Resolved As A Knowledge Gap
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20As%20A%20Knowledge%20Gap)
   *
   * When a user chooses to register a knowledge gap when they resolve a conversation
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedAsAKnowledgeGap(e, n) {
    return this.track(new Td(e), n);
  }
  /**
   * Conversation Resolved By Knowledge
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20By%20Knowledge)
   *
   * When a user resolves a conversation using the knowledge flow
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedByKnowledge(e, n) {
    return this.track(new Ed(e), n);
  }
  /**
   * Conversation Resolved With No Knowledge Article
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Resolved%20With%20No%20Knowledge%20Article)
   *
   * When a user chooses to resolve a conversation without marking any knowledge article as having helped
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationResolvedWithNoKnowledgeArticle(e, n) {
    return this.track(new Od(e), n);
  }
  /**
   * Conversation Sidebar Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Closed)
   *
   * When the user closes the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarClosed(e) {
    return this.track(new Pd(), e);
  }
  /**
   * Conversation Sidebar Conversation History Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Closed)
   *
   * When the user closes the accordion item conversation history
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryClosed(e) {
    return this.track(new Rd(), e);
  }
  /**
   * Conversation Sidebar Conversation History Navigated To Conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Navigated%20To%20Conversation)
   *
   * When the user navigates to a conversation listed in the conversation history accordion item in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryNavigatedToConversation(e) {
    return this.track(new Md(), e);
  }
  /**
   * Conversation Sidebar Conversation History Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Conversation%20History%20Opened)
   *
   * When the user opens the accordion item conversation history
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarConversationHistoryOpened(e) {
    return this.track(new Fd(), e);
  }
  /**
   * Conversation Sidebar Customer Info Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Customer%20Info%20Email%20Clicked)
   *
   * When the user opens compose email from clicking the customers email in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarCustomerInfoEmailClicked(e) {
    return this.track(new Dd(), e);
  }
  /**
   * Conversation Sidebar Customer Info Phone Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Customer%20Info%20Phone%20Number%20Clicked)
   *
   * When the user starts phone call from clicking the customers phone number in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarCustomerInfoPhoneNumberClicked(e) {
    return this.track(new Ud(), e);
  }
  /**
   * Conversation Sidebar Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Sidebar%20Opened)
   *
   * When the user opens the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationSidebarOpened(e) {
    return this.track(new Ld(), e);
  }
  /**
   * Conversation Timeline Item Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Timeline%20Item%20Opened)
   *
   * When the user clicks an item in the conversation timeline
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationTimelineItemOpened(e) {
    return this.track(new Nd(), e);
  }
  /**
   * Conversation Timeline Navigated To Conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Timeline%20Navigated%20To%20Conversation)
   *
   * When the user clicks a conversation listed in a timeline item
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationTimelineNavigatedToConversation(e) {
    return this.track(new Vd(), e);
  }
  /**
   * Conversation Transferred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversation%20Transferred)
   *
   * When a conversation was transferred.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  conversationTransferred(e, n) {
    return this.track(new Bd(e), n);
  }
  /**
   * Conversations Bulk Actions Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Bulk%20Actions%20Clicked)
   *
   * When the user clicks the Bulk Actions button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  conversationsBulkActionsClicked(e, n) {
    return this.track(new Hd(e), n);
  }
  /**
   * Conversations Clear All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Clear%20All%20Clicked)
   *
   * When the user clicks the clear all checkbox
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsClearAllClicked(e) {
    return this.track(new Wd(), e);
  }
  /**
   * Conversations Filter Agent Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Agent%20Clicked)
   *
   * When the user clicks the Filter Conversations" button for the agent"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  conversationsFilterAgentClicked(e, n) {
    return this.track(new xd(e), n);
  }
  /**
   * Conversations Filter Clear All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Clear%20All%20Clicked)
   *
   * When the user clicks the Clear all button in the Conversations filters
   *
   * @param options Amplitude event options.
   */
  conversationsFilterClearAllClicked(e) {
    return this.track(new Qd(), e);
  }
  /**
   * Conversations Filter Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Cleared)
   *
   * When the user clears a conversations filter
   *
   * @param properties The event's properties (e.g. filter)
   * @param options Amplitude event options.
   */
  conversationsFilterCleared(e, n) {
    return this.track(new Kd(e), n);
  }
  /**
   * Conversations Filter Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Contact%20Clicked)
   *
   * When the user clicks the Filter Conversations" button for the contact"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  conversationsFilterContactClicked(e, n) {
    return this.track(new Gd(e), n);
  }
  /**
   * Conversations Filter Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Filter%20Toggled)
   *
   * When the user toggles a conversations filter
   *
   * @param properties The event's properties (e.g. checked)
   * @param options Amplitude event options.
   */
  conversationsFilterToggled(e, n) {
    return this.track(new qd(e), n);
  }
  /**
   * Conversations Go To Conversation Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Go%20To%20Conversation%20Clicked)
   *
   * When the user clicks the Go To Conversations button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationsGoToConversationClicked(e, n) {
    return this.track(new zd(e), n);
  }
  /**
   * Conversations Item Preview Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Item%20Preview%20Clicked)
   *
   * When the user clicks the preview conversation button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsItemPreviewClicked(e) {
    return this.track(new $d(), e);
  }
  /**
   * Conversations Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Next%20Page%20Clicked)
   *
   * When the user clicks the Next Page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsNextPageClicked(e) {
    return this.track(new jd(), e);
  }
  /**
   * Conversations Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Previous%20Page%20Clicked)
   *
   * When the user clicks the Previous Page button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsPreviousPageClicked(e) {
    return this.track(new Jd(), e);
  }
  /**
   * Conversations Select All Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Select%20All%20Clicked)
   *
   * When the user clicks the select all checkbox
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsSelectAllClicked(e) {
    return this.track(new Yd(), e);
  }
  /**
   * Conversations Select Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Select%20Clicked)
   *
   * When the user clicks the select checkbox for a single conversation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  conversationsSelectClicked(e, n) {
    return this.track(new Xd(e), n);
  }
  /**
   * Conversations Timestamp Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Timestamp%20Clicked)
   *
   * When the user clicks a timestamp
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  conversationsTimestampClicked(e, n) {
    return this.track(new Zd(e), n);
  }
  /**
   * Conversations Transfer To Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20Transfer%20To%20Queue%20Clicked)
   *
   * When the user clicks the Transfer To Queue button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsTransferToQueueClicked(e) {
    return this.track(new ep(), e);
  }
  /**
   * Conversations View Agent Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20View%20Agent%20Clicked)
   *
   * When the user clicks the View Agent button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsViewAgentClicked(e) {
    return this.track(new tp(), e);
  }
  /**
   * Conversations View Contact Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Conversations%20View%20Contact%20Clicked)
   *
   * When the user clicks the View Contact button in the actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  conversationsViewContactClicked(e) {
    return this.track(new np(), e);
  }
  /**
   * ConversationSummaryFeedbackNotUseful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryFeedbackNotUseful)
   *
   * When an agent doesn't find the summary of conversation useful and clicks on thumbs down button.
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryFeedbackNotUseful(e, n) {
    return this.track(new rp(e), n);
  }
  /**
   * ConversationSummaryFeedbackUseful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryFeedbackUseful)
   *
   * When an agent finds the summary of conversation useful and clicks on thumbs up button.
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryFeedbackUseful(e, n) {
    return this.track(new ip(e), n);
  }
  /**
   * ConversationSummaryRegenerateSummary
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/ConversationSummaryRegenerateSummary)
   *
   * When an agent requests for a new conversation summary
   *
   * @param properties The event's properties (e.g. summaryId)
   * @param options Amplitude event options.
   */
  conversationSummaryRegenerateSummary(e, n) {
    return this.track(new sp(e), n);
  }
  /**
   * Copy Script
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Copy%20Script)
   *
   * When the user copy the Dixa Widget script
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  copyScript(e) {
    return this.track(new op(), e);
  }
  /**
   * Country Code Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Country%20Code%20Selected)
   *
   * When the user selects a country from the Country Code Dropdown in Telephony Search User field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  countryCodeSelected(e) {
    return this.track(new ap(), e);
  }
  /**
   * Custom Attribute Value Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Custom%20Attribute%20Value%20Updated)
   *
   * Whenever the user updates value of a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  customAttributeValueUpdated(e, n) {
    return this.track(new cp(e), n);
  }
  /**
   * Dashboard Channel All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20All%20Conversations%20Clicked)
   *
   * When the user clicks the link to see all the channel conversations in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelAllConversationsClicked(e) {
    return this.track(new up(), e);
  }
  /**
   * Dashboard Channel Go To Analytics Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Go%20To%20Analytics%20Clicked)
   *
   * When the user clicks the link to go to the channel Analytics
   *
   * @param options Amplitude event options.
   */
  dashboardChannelGoToAnalyticsClicked(e) {
    return this.track(new lp(), e);
  }
  /**
   * Dashboard Channel Longest Queued Time Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Longest%20Queued%20Time%20Metric%20Clicked)
   *
   * When the user clicks the longest queued time metric in the channel dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelLongestQueuedTimeMetricClicked(e) {
    return this.track(new dp(), e);
  }
  /**
   * Dashboard Channel Name Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Name%20Clicked)
   *
   * When the user clicks the channel name link in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelNameClicked(e) {
    return this.track(new pp(), e);
  }
  /**
   * Dashboard Channel Pending Conversations Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Pending%20Conversations%20Metric%20Clicked)
   *
   * When the user clicks the pending conversations metric in the channel dashboard
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  dashboardChannelPendingConversationsMetricClicked(e, n) {
    return this.track(new hp(e), n);
  }
  /**
   * Dashboard Channel Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Channel%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the link to see the channel tv dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardChannelTvDashboardClicked(e) {
    return this.track(new vp(), e);
  }
  /**
   * Dashboard Global Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Global%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the global tv dashboard button
   *
   * @param options Amplitude event options.
   */
  dashboardGlobalTvDashboardClicked(e) {
    return this.track(new gp(), e);
  }
  /**
   * Dashboard Layout Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Layout%20Changed)
   *
   * When the user changes the dashboard layout
   *
   * @param properties The event's properties (e.g. layout)
   * @param options Amplitude event options.
   */
  dashboardLayoutChanged(e, n) {
    return this.track(new fp(e), n);
  }
  /**
   * Dashboard Longest Queued Time Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Longest%20Queued%20Time%20Metric%20Clicked)
   *
   * When the user clicks the longest queued time metric in the queue dashboard
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  dashboardLongestQueuedTimeMetricClicked(e, n) {
    return this.track(new Cp(e), n);
  }
  /**
   * Dashboard Metric Helper Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Metric%20Helper%20Clicked)
   *
   * When the user clicks on the helper button on a metric
   *
   * @param properties The event's properties (e.g. dashboard)
   * @param options Amplitude event options.
   */
  dashboardMetricHelperClicked(e, n) {
    return this.track(new yp(e), n);
  }
  /**
   * Dashboard Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Next%20Page%20Clicked)
   *
   * When the user clicks the next page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  dashboardNextPageClicked(e) {
    return this.track(new mp(), e);
  }
  /**
   * Dashboard Organization Timezone Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Organization%20Timezone%20Settings%20Clicked)
   *
   * When the user clicks on the link to go to organization settings from the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardOrganizationTimezoneSettingsClicked(e) {
    return this.track(new kp(), e);
  }
  /**
   * Dashboard Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Previous%20Page%20Clicked)
   *
   * When the user clicks the previous page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  dashboardPreviousPageClicked(e) {
    return this.track(new wp(), e);
  }
  /**
   * Dashboard Queue All Conversations Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20All%20Conversations%20Clicked)
   *
   * When the user clicks the link to see all the queue conversations in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueAllConversationsClicked(e) {
    return this.track(new _p(), e);
  }
  /**
   * Dashboard Queue Go To Analytics Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Go%20To%20Analytics%20Clicked)
   *
   * When the user clicks the link to go to the queue Analytics
   *
   * @param options Amplitude event options.
   */
  dashboardQueueGoToAnalyticsClicked(e) {
    return this.track(new Sp(), e);
  }
  /**
   * Dashboard Queue Item Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Item%20Favorite%20Toggled)
   *
   * When the user toggles the favorite queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  dashboardQueueItemFavoriteToggled(e, n) {
    return this.track(new bp(e), n);
  }
  /**
   * Dashboard Queue Name Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Name%20Clicked)
   *
   * When the user clicks the queue name link in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueNameClicked(e) {
    return this.track(new Ap(), e);
  }
  /**
   * Dashboard Queue Pending Conversations Metric Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Pending%20Conversations%20Metric%20Clicked)
   *
   * When the user clicks the pending conversations metric in the queue dashboard
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  dashboardQueuePendingConversationsMetricClicked(e, n) {
    return this.track(new Ip(e), n);
  }
  /**
   * Dashboard Queue Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Settings%20Clicked)
   *
   * When the user clicks the link to go to the queue settings
   *
   * @param options Amplitude event options.
   */
  dashboardQueueSettingsClicked(e) {
    return this.track(new Tp(), e);
  }
  /**
   * Dashboard Queue Tv Dashboard Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queue%20Tv%20Dashboard%20Clicked)
   *
   * When the user clicks the link to see the queue tv dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardQueueTvDashboardClicked(e) {
    return this.track(new Ep(), e);
  }
  /**
   * Dashboard Queues Manually Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Manually%20Selected)
   *
   * When the user manually selects which queues to show in the dashboard
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  dashboardQueuesManuallySelected(e, n) {
    return this.track(new Op(e), n);
  }
  /**
   * Dashboard Queues Search Field Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Search%20Field%20Cleared)
   *
   * When the user clears the query in the queues search field
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesSearchFieldCleared(e, n) {
    return this.track(new Pp(e), n);
  }
  /**
   * Dashboard Queues Search Field Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Search%20Field%20Submitted)
   *
   * When the user submits the query in the queues search field
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesSearchFieldSubmitted(e, n) {
    return this.track(new Rp(e), n);
  }
  /**
   * Dashboard Queues Sorting Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Sorting%20Updated)
   *
   * When the user updates the queues sorting on the dashboard
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  dashboardQueuesSortingUpdated(e, n) {
    return this.track(new Mp(e), n);
  }
  /**
   * Dashboard Queues Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Queues%20Type%20Changed)
   *
   * When the user changes the queues type
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  dashboardQueuesTypeChanged(e, n) {
    return this.track(new Fp(e), n);
  }
  /**
   * Dashboard Refresh Data Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Refresh%20Data%20Clicked)
   *
   * When the user clicks the refresh data button in the dashboard
   *
   * @param options Amplitude event options.
   */
  dashboardRefreshDataClicked(e) {
    return this.track(new Dp(), e);
  }
  /**
   * Dashboard Tv Reloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Tv%20Reloaded)
   *
   * When the TV dashboard is automatically reloaded
   *
   * @param options Amplitude event options.
   */
  dashboardTvReloaded(e) {
    return this.track(new Up(), e);
  }
  /**
   * Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Dashboard%20Viewed)
   *
   * When the user views the dashboard
   *
   * @param properties The event's properties (e.g. layout)
   * @param options Amplitude event options.
   */
  dashboardViewed(e, n) {
    return this.track(new Lp(e), n);
  }
  /**
   * Email Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in email settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new Np(), e);
  }
  /**
   * Email Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Form%20Submitted)
   *
   * When the user proceeds on the Email form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  emailFormSubmitted(e, n) {
    return this.track(new Vp(e), n);
  }
  /**
   * Email Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOpened(e) {
    return this.track(new Bp(), e);
  }
  /**
   * Email Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionDeleteClicked(e) {
    return this.track(new Hp(), e);
  }
  /**
   * Email Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new Wp(), e);
  }
  /**
   * Email Options Menu Option Email Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Email%20Clicked)
   *
   * When the user selects Edit Email in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionEmailClicked(e) {
    return this.track(new xp(), e);
  }
  /**
   * Email Options Menu Option Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Flow%20Clicked)
   *
   * When the user selects Edit Flow in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionFlowClicked(e) {
    return this.track(new Qp(), e);
  }
  /**
   * Email Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename in the Email options menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailOptionsMenuOptionRenameClicked(e) {
    return this.track(new Kp(), e);
  }
  /**
   * Email Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Applied)
   *
   * When the user performs a search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchApplied(e) {
    return this.track(new Gp(), e);
  }
  /**
   * Email Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Closed)
   *
   * When the user closes the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchClosed(e) {
    return this.track(new qp(), e);
  }
  /**
   * Email Search Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Email%20Search%20Opened)
   *
   * When the user opens the search field
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  emailSearchOpened(e) {
    return this.track(new zp(), e);
  }
  /**
   * Flow Action Add Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Add%20Saved)
   *
   * When the user added an action and saved it.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionAddSaved(e, n) {
    return this.track(new $p(e), n);
  }
  /**
   * Flow Action Condition Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Condition%20Added)
   *
   * When the user adds a condition to a branch/condition-action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionConditionAdded(e, n) {
    return this.track(new jp(e), n);
  }
  /**
   * Flow Action Condition Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Condition%20Removed)
   *
   * When the user adds a condition to a branch/condition-action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionConditionRemoved(e, n) {
    return this.track(new Jp(e), n);
  }
  /**
   * Flow Action Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Deleted)
   *
   * When the user deletes a node in a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionDeleted(e, n) {
    return this.track(new Yp(e), n);
  }
  /**
   * Flow Action Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Edit%20Clicked)
   *
   * When the user clicks the edit button on an action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionEditClicked(e, n) {
    return this.track(new Xp(e), n);
  }
  /**
   * Flow Action Edit Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Action%20Edit%20Saved)
   *
   * When the user saves an action
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActionEditSaved(e, n) {
    return this.track(new Zp(e), n);
  }
  /**
   * Flow Activate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Activate%20Clicked)
   *
   * When the user saves a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowActivateClicked(e, n) {
    return this.track(new eh(e), n);
  }
  /**
   * Flow Add Action Action Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Action%20Selected)
   *
   * When the user selects a specific action to add
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionActionSelected(e, n) {
    return this.track(new th(e), n);
  }
  /**
   * Flow Add Action Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Cancelled)
   *
   * When the user closes the add action modal without making a selection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionCancelled(e, n) {
    return this.track(new nh(e), n);
  }
  /**
   * Flow Add Action Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Add%20Action%20Opened)
   *
   * When the user opens the add action modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowAddActionOpened(e, n) {
    return this.track(new rh(e), n);
  }
  /**
   * Flow Back To Settings Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Back%20To%20Settings%20Clicked)
   *
   * When the user clicks the go back to settings button in a Flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowBackToSettingsClicked(e, n) {
    return this.track(new ih(e), n);
  }
  /**
   * Flow Context Align Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Align%20Clicked)
   *
   * When the user clicks Align" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextAlignClicked(e, n) {
    return this.track(new sh(e), n);
  }
  /**
   * Flow Context Delete Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Cancel%20Clicked)
   *
   * When the user clicks Cancel" in the confirm modal after clicking the "Delete" option in context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteCancelClicked(e, n) {
    return this.track(new oh(e), n);
  }
  /**
   * Flow Context Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Clicked)
   *
   * When the user clicks Delete" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteClicked(e, n) {
    return this.track(new ah(e), n);
  }
  /**
   * Flow Context Delete Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Delete%20Confirm%20Clicked)
   *
   * When the user clicks Confirm" in the confirm modal after clicking the "Delete" option in context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextDeleteConfirmClicked(e, n) {
    return this.track(new ch(e), n);
  }
  /**
   * Flow Context Node Arrange Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Context%20Node%20Arrange%20Clicked)
   *
   * When the user clicks Arrange nodes" in the context menu"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowContextNodeArrangeClicked(e, n) {
    return this.track(new uh(e), n);
  }
  /**
   * Flow Phone Number Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Phone%20Number%20Changed)
   *
   * When the user changed the phone number in the phone flow.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  flowPhoneNumberChanged(e) {
    return this.track(new lh(), e);
  }
  /**
   * Flow Save Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Save%20Clicked)
   *
   * When the user saves a flow
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowSaveClicked(e, n) {
    return this.track(new dh(e), n);
  }
  /**
   * Flow Title Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Title%20Edit%20Clicked)
   *
   * When the user clicks the Flow Title to Edit
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowTitleEditClicked(e, n) {
    return this.track(new ph(e), n);
  }
  /**
   * Flow Zoom In Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20In%20Clicked)
   *
   * When the user uses zooms in using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomInClicked(e, n) {
    return this.track(new hh(e), n);
  }
  /**
   * Flow Zoom Out Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20Out%20Clicked)
   *
   * When the user uses zooms out using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomOutClicked(e, n) {
    return this.track(new vh(e), n);
  }
  /**
   * Flow Zoom Reset Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Flow%20Zoom%20Reset%20Clicked)
   *
   * When the user reset the zoom level using the zoom control
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. flowType)
   * @param options Amplitude event options.
   */
  flowZoomResetClicked(e, n) {
    return this.track(new gh(e), n);
  }
  /**
   * Follow Up Conversation Modal Internal Note Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Follow%20Up%20Conversation%20Modal%20Internal%20Note%20Added)
   *
   * When the user selects the option to include an internal note
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  followUpConversationModalInternalNoteAdded(e) {
    return this.track(new fh(), e);
  }
  /**
   * Follow Up Conversation Modal Offer In Queue Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Follow%20Up%20Conversation%20Modal%20Offer%20In%20Queue%20Added)
   *
   * When the user selects the option to offer the conversation in the queue
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  followUpConversationModalOfferInQueueAdded(e) {
    return this.track(new Ch(), e);
  }
  /**
   * Intelligence Distribution Chart Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Distribution%20Chart%20Opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  intelligenceDistributionChartOpened(e, n) {
    return this.track(new yh(e), n);
  }
  /**
   * Intelligence Evolution Chart Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Evolution%20Chart%20Opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  intelligenceEvolutionChartOpened(e, n) {
    return this.track(new mh(e), n);
  }
  /**
   * Intelligence Filter Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Filter%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. changeType)
   * @param options Amplitude event options.
   */
  intelligenceFilterChanged(e, n) {
    return this.track(new kh(e), n);
  }
  /**
   * Intelligence Filter Period Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Filter%20Period%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. dayCount)
   * @param options Amplitude event options.
   */
  intelligenceFilterPeriodChanged(e, n) {
    return this.track(new wh(e), n);
  }
  /**
   * Intelligence Group By Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Group%20By%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. changeType)
   * @param options Amplitude event options.
   */
  intelligenceGroupByChanged(e, n) {
    return this.track(new _h(e), n);
  }
  /**
   * Intelligence Preset Comparison Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Preset%20Comparison%20Started)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. presetCount)
   * @param options Amplitude event options.
   */
  intelligencePresetComparisonStarted(e, n) {
    return this.track(new Sh(e), n);
  }
  /**
   * Intelligence Table Customized
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intelligence%20Table%20Customized)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. tableName)
   * @param options Amplitude event options.
   */
  intelligenceTableCustomized(e, n) {
    return this.track(new bh(e), n);
  }
  /**
   * Intent Detection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Created)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  intentDetectionCreated(e) {
    return this.track(new Ah(), e);
  }
  /**
   * Intent Detection Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  intentDetectionDeleted(e) {
    return this.track(new Ih(), e);
  }
  /**
   * Intent Detection Flow Node Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Flow%20Node%20Saved)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  intentDetectionFlowNodeSaved(e, n) {
    return this.track(new Th(e), n);
  }
  /**
   * Intent Detection Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Intent%20Detection%20Updated)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  intentDetectionUpdated(e) {
    return this.track(new Eh(), e);
  }
  /**
   * Knowledge Article Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Archived)
   *
   * When a user archives an article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleArchived(e, n) {
    return this.track(new Oh(e), n);
  }
  /**
   * Knowledge Article Changes Discarded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Changes%20Discarded)
   *
   * When a user discards changes made to a work in progress article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleChangesDiscarded(e, n) {
    return this.track(new Ph(e), n);
  }
  /**
   * Knowledge Article Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Created)
   *
   * When an article is created in knowledge, either from content management or other sources (like conversation sidebar)
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleCreated(e, n) {
    return this.track(new Rh(e), n);
  }
  /**
   * Knowledge Article Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Destroyed)
   *
   * When the user deletes an article
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleDestroyed(e, n) {
    return this.track(new Mh(e), n);
  }
  /**
   * Knowledge Article Feedback Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Feedback%20Submitted)
   *
   * When a user submits feedback on an article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleFeedbackSubmitted(e, n) {
    return this.track(new Fh(e), n);
  }
  /**
   * Knowledge Article Marked As Helpful
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Marked%20As%20Helpful)
   *
   * When a user indicates that an article was helpful
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. assistType)
   * @param options Amplitude event options.
   */
  knowledgeArticleMarkedAsHelpful(e, n) {
    return this.track(new Dh(e), n);
  }
  /**
   * Knowledge Article Moved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Moved)
   *
   * When the user moves an article to a new collection
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleMoved(e, n) {
    return this.track(new Uh(e), n);
  }
  /**
   * Knowledge Article Published
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Published)
   *
   * When a user publishes an article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticlePublished(e, n) {
    return this.track(new Lh(e), n);
  }
  /**
   * Knowledge Article Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Reordered)
   *
   * When an article is re-ordered in the knowledge management screen
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleReordered(e, n) {
    return this.track(new Nh(e), n);
  }
  /**
   * Knowledge Article Tag Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Tag%20Added)
   *
   * When a user adds a tag to a knowledge article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleTagAdded(e, n) {
    return this.track(new Vh(e), n);
  }
  /**
   * Knowledge Article Tag Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Tag%20Removed)
   *
   * When a user removes a tag from a knowledge article
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleTagRemoved(e, n) {
    return this.track(new Bh(e), n);
  }
  /**
   * Knowledge Article Unpublished
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Unpublished)
   *
   * When a user unpublishes a knowledge article
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleUnpublished(e, n) {
    return this.track(new Hh(e), n);
  }
  /**
   * Knowledge Article Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Updated)
   *
   * When the user updates an article, either the content or meta
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleUpdated(e, n) {
    return this.track(new Wh(e), n);
  }
  /**
   * Knowledge Article Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Article%20Viewed)
   *
   * When a user views a knowledge article
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeArticleViewed(e, n) {
    return this.track(new xh(e), n);
  }
  /**
   * Knowledge Articles Search By Term Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Articles%20Search%20By%20Term%20Submitted)
   *
   * When a user searches for knowledge articles
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeArticlesSearchByTermSubmitted(e, n) {
    return this.track(new Qh(e), n);
  }
  /**
   * Knowledge Category Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Created)
   *
   * When a user creates a knowledge category
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryCreated(e, n) {
    return this.track(new Kh(e), n);
  }
  /**
   * Knowledge Category Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Destroyed)
   *
   * When a user deletes a knowledge category
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryDestroyed(e, n) {
    return this.track(new Gh(e), n);
  }
  /**
   * Knowledge Category Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Reordered)
   *
   * When a category is re-ordered in the knowledge management screen
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryReordered(e, n) {
    return this.track(new qh(e), n);
  }
  /**
   * Knowledge Category Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Category%20Updated)
   *
   * When a user makes a change to a knowledge category
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. categoryId)
   * @param options Amplitude event options.
   */
  knowledgeCategoryUpdated(e, n) {
    return this.track(new zh(e), n);
  }
  /**
   * Knowledge Collection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Created)
   *
   * When a user creates a knowledge collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionCreated(e, n) {
    return this.track(new $h(e), n);
  }
  /**
   * Knowledge Collection Destroyed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Destroyed)
   *
   * When a user deletes a knowledge collection
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionDestroyed(e, n) {
    return this.track(new jh(e), n);
  }
  /**
   * Knowledge Collection Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Updated)
   *
   * When a user makes a change to a collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  knowledgeCollectionUpdated(e, n) {
    return this.track(new Jh(e), n);
  }
  /**
   * Knowledge Collection Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Collection%20Viewed)
   *
   * When a user views the knowledge collection
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. collectionId)
   * @param options Amplitude event options.
   */
  knowledgeCollectionViewed(e, n) {
    return this.track(new Yh(e), n);
  }
  /**
   * Knowledge Help Center Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Created)
   *
   * When the user creates a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterCreated(e, n) {
    return this.track(new Xh(e), n);
  }
  /**
   * Knowledge Help Center Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Deleted)
   *
   * When the user updates a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterDeleted(e, n) {
    return this.track(new Zh(e), n);
  }
  /**
   * Knowledge Help Center Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Help%20Center%20Updated)
   *
   * When the user deletes a Knowledge Help Center
   *
   * @param properties The event's properties (e.g. helpCenterId)
   * @param options Amplitude event options.
   */
  knowledgeHelpCenterUpdated(e, n) {
    return this.track(new ev(e), n);
  }
  /**
   * Knowledge Internal Kb Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Internal%20Kb%20Dashboard%20Viewed)
   *
   * When a knowledge user views the dashboard in an Internal KB
   *
   * @param options Amplitude event options.
   */
  knowledgeInternalKbDashboardViewed(e) {
    return this.track(new tv(), e);
  }
  /**
   * Knowledge Internal Kb Search Result Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Internal%20Kb%20Search%20Result%20Clicked)
   *
   * Knowledge Internal Kb Search Result Clicked
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  knowledgeInternalKbSearchResultClicked(e, n) {
    return this.track(new nv(e), n);
  }
  /**
   * Knowledge Resolution Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Resolution%20Cancelled)
   *
   * When a knowledge resolution is cancelled
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  knowledgeResolutionCancelled(e, n) {
    return this.track(new rv(e), n);
  }
  /**
   * Knowledge Resolution Initialised
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Knowledge%20Resolution%20Initialised)
   *
   * When a initialises a knowledge conversation resolution flow
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. conversationId)
   * @param options Amplitude event options.
   */
  knowledgeResolutionInitialised(e, n) {
    return this.track(new iv(e), n);
  }
  /**
   * Link Conversations Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Link%20Conversations%20Modal%20Opened)
   *
   * When the user opens the modal to link selected conversations
   *
   * @param options Amplitude event options.
   */
  linkConversationsModalOpened(e) {
    return this.track(new sv(), e);
  }
  /**
   * Link Conversations Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Link%20Conversations%20Submitted)
   *
   * When user submits the conversations link
   *
   * @param options Amplitude event options.
   */
  linkConversationsSubmitted(e) {
    return this.track(new ov(), e);
  }
  /**
   * Mention User Notification Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Mention%20User%20Notification%20Clicked)
   *
   * When the user follows the received mention notification.
   *
   * @param options Amplitude event options.
   */
  mentionUserNotificationClicked(e) {
    return this.track(new av(), e);
  }
  /**
   * Mention User Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Mention%20User%20Selected)
   *
   * When the user selects an agent to mention.
   *
   * @param options Amplitude event options.
   */
  mentionUserSelected(e) {
    return this.track(new cv(), e);
  }
  /**
   * Merge Contacts Merge Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Cancelled)
   *
   * When a user has been selected and the modal is closed afterwards
   *
   * @param options Amplitude event options.
   */
  mergeContactsMergeCancelled(e) {
    return this.track(new uv(), e);
  }
  /**
   * Merge Contacts Merge Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Failed)
   *
   * When a merge is failing for some reason
   *
   * @param options Amplitude event options.
   */
  mergeContactsMergeFailed(e) {
    return this.track(new lv(), e);
  }
  /**
   * Merge Contacts Merge Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Merge%20Succeeded)
   *
   * When a contact has successfully been merged
   *
   * @param properties The event's properties (e.g. numberOfEmails)
   * @param options Amplitude event options.
   */
  mergeContactsMergeSucceeded(e, n) {
    return this.track(new dv(e), n);
  }
  /**
   * Merge Contacts Modal Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Modal%20Closed)
   *
   * When the merge contacts modal is closed
   *
   * @param options Amplitude event options.
   */
  mergeContactsModalClosed(e) {
    return this.track(new pv(), e);
  }
  /**
   * Merge Contacts Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Modal%20Opened)
   *
   * When the merge contacts modal is opened
   *
   * @param options Amplitude event options.
   */
  mergeContactsModalOpened(e) {
    return this.track(new hv(), e);
  }
  /**
   * Merge Contacts Source Contact Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Merge%20Contacts%20Source%20Contact%20Selected)
   *
   * When a contact is selected in the merge contacts modal
   *
   * @param options Amplitude event options.
   */
  mergeContactsSourceContactSelected(e) {
    return this.track(new vv(), e);
  }
  /**
   * Messenger Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in messenger settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  messengerFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new gv(), e);
  }
  /**
   * Messenger Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Cancelled)
   *
   * When the user cancels the Messenger modal/form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormCancelled(e, n) {
    return this.track(new fv(e), n);
  }
  /**
   * Messenger Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Opened)
   *
   * When the user opens one of the Messenger listing modals/forms
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormOpened(e, n) {
    return this.track(new Cv(e), n);
  }
  /**
   * Messenger Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Form%20Submitted)
   *
   * When the user proceeds on a messenger form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  messengerFormSubmitted(e, n) {
    return this.track(new yv(e), n);
  }
  /**
   * Messenger Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Options%20Menu%20Opened)
   *
   * When the user opens the Options Menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  messengerOptionsMenuOpened(e) {
    return this.track(new mv(), e);
  }
  /**
   * Messenger Options Menu Option Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Messenger%20Options%20Menu%20Option%20Clicked)
   *
   * When the user selects an option in the Messenger options menu
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. option)
   * @param options Amplitude event options.
   */
  messengerOptionsMenuOptionClicked(e, n) {
    return this.track(new kv(e), n);
  }
  /**
   * Modal Conversation Close Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Conversation%20Close%20Cancel%20Clicked)
   *
   * When the user clicks cancel in the confirm close conversation modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  modalConversationCloseCancelClicked(e) {
    return this.track(new wv(), e);
  }
  /**
   * Modal Conversation Close Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Conversation%20Close%20Confirm%20Clicked)
   *
   * When the user clicks confirm in the confirm close conversation modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  modalConversationCloseConfirmClicked(e, n) {
    return this.track(new _v(e), n);
  }
  /**
   * Modal Transfer To Queue Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Transfer%20To%20Queue%20Cancel%20Clicked)
   *
   * When the user clicks cancel in the transfer to queue modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  modalTransferToQueueCancelClicked(e) {
    return this.track(new Sv(), e);
  }
  /**
   * Modal Transfer To Queue Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Modal%20Transfer%20To%20Queue%20Confirm%20Clicked)
   *
   * When the user clicks confirm in the transfer to queue modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  modalTransferToQueueConfirmClicked(e, n) {
    return this.track(new bv(e), n);
  }
  /**
   * Network Connection Status Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Network%20Connection%20Status%20Changed)
   *
   * When the user network connection changes
   *
   * @param properties The event's properties (e.g. status)
   * @param options Amplitude event options.
   */
  networkConnectionStatusChanged(e, n) {
    return this.track(new Av(e), n);
  }
  /**
   * Notification Offer Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Accepted)
   *
   * When the user accepts an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferAccepted(e, n) {
    return this.track(new Iv(e), n);
  }
  /**
   * Notification Offer Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Closed)
   *
   * When the user closes an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferClosed(e, n) {
    return this.track(new Tv(e), n);
  }
  /**
   * Notification Offer Rejected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Rejected)
   *
   * When the user rejects an offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationOfferRejected(e, n) {
    return this.track(new Ev(e), n);
  }
  /**
   * Notification Offer Timeout
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Offer%20Timeout)
   *
   * When the offer notification times out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  notificationOfferTimeout(e) {
    return this.track(new Ov(), e);
  }
  /**
   * Notification Transfer Offer Accepted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Accepted)
   *
   * When the user accepts a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferAccepted(e, n) {
    return this.track(new Pv(e), n);
  }
  /**
   * Notification Transfer Offer Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Closed)
   *
   * When the user closes a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferClosed(e, n) {
    return this.track(new Rv(e), n);
  }
  /**
   * Notification Transfer Offer Rejected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Rejected)
   *
   * When the user rejects a transfer offer notification
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  notificationTransferOfferRejected(e, n) {
    return this.track(new Mv(e), n);
  }
  /**
   * Notification Transfer Offer Timeout
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Notification%20Transfer%20Offer%20Timeout)
   *
   * When the transfer offer notification times out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  notificationTransferOfferTimeout(e) {
    return this.track(new Fv(), e);
  }
  /**
   * Organizations Navigation Organization Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Organizations%20Navigation%20Organization%20Clicked)
   *
   * When the user clicks an organization in the organizations navigation
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  organizationsNavigationOrganizationClicked(e, n) {
    return this.track(new Dv(e), n);
  }
  /**
   * Partner Integrations Braze Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Braze%20Profile%20Received)
   *
   * When the integration received data to be displayed in the conversation sidebar.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsBrazeProfileReceived(e) {
    return this.track(new Uv(), e);
  }
  /**
   * Partner Integrations Braze Subscription Email Opt in Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Braze%20Subscription%20Email%20Opt%20in%20Succeeded)
   *
   * When the email subscription status got updated to opt-in.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsBrazeSubscriptionEmailOptInSucceeded(e) {
    return this.track(new Lv(), e);
  }
  /**
   * Partner Integrations Braze Subscription Email Unsubscribed Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Braze%20Subscription%20Email%20Unsubscribed%20Succeeded)
   *
   * When the email subscription status got updated to unsubscribed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsBrazeSubscriptionEmailUnsubscribedSucceeded(e) {
    return this.track(new Nv(), e);
  }
  /**
   * Partner Integrations Github Create New Issue Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Canceled)
   *
   * When the user closes the create new modal without confirming/saving.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueCanceled(e, n) {
    return this.track(new Vv(e), n);
  }
  /**
   * Partner Integrations Github Create New Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Clicked)
   *
   * When the user clicked on the create new button.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueClicked(e, n) {
    return this.track(new Bv(e), n);
  }
  /**
   * Partner Integrations Github Create New Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Create%20New%20Issue%20Confirmed)
   *
   * When the user confirmed to create a new issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubCreateNewIssueConfirmed(e, n) {
    return this.track(new Hv(e), n);
  }
  /**
   * Partner Integrations Github Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Link%20Issue%20Clicked)
   *
   * When the user clicked on an issue in the search results to link it to the conversation.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubLinkIssueClicked(e, n) {
    return this.track(new Wv(e), n);
  }
  /**
   * Partner Integrations Github Unlink All Issues Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Canceled)
   *
   * when the user canceled to unlink all issues.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesCanceled(e, n) {
    return this.track(new xv(e), n);
  }
  /**
   * Partner Integrations Github Unlink All Issues Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Clicked)
   *
   * When the user clicked on the unlink all button.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesClicked(e, n) {
    return this.track(new Qv(e), n);
  }
  /**
   * Partner Integrations Github Unlink All Issues Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20All%20Issues%20Confirmed)
   *
   * When the user confirmed to unlink all issues.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkAllIssuesConfirmed(e, n) {
    return this.track(new Kv(e), n);
  }
  /**
   * Partner Integrations Github Unlink Issue Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Canceled)
   *
   * When the user canceled to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueCanceled(e, n) {
    return this.track(new Gv(e), n);
  }
  /**
   * Partner Integrations Github Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Clicked)
   *
   * When the user clicked on the button to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueClicked(e, n) {
    return this.track(new qv(e), n);
  }
  /**
   * Partner Integrations Github Unlink Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20Unlink%20Issue%20Confirmed)
   *
   * When the user confirmed to unlink an issue.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubUnlinkIssueConfirmed(e, n) {
    return this.track(new zv(e), n);
  }
  /**
   * Partner Integrations Github View Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Github%20View%20Link%20Clicked)
   *
   * When the user clicked on a linked issue to open it in Github.
   *
   * @param properties The event's properties (e.g. githubOrganization)
   * @param options Amplitude event options.
   */
  partnerIntegrationsGithubViewLinkClicked(e, n) {
    return this.track(new $v(e), n);
  }
  /**
   * Partner Integrations Jira Comments Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Comments%20Collapsed)
   *
   * When the user collapses an issue's comments
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCommentsCollapsed(e, n) {
    return this.track(new jv(e), n);
  }
  /**
   * Partner Integrations Jira Comments Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Comments%20Expanded)
   *
   * When the user expands an issue's comments
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCommentsExpanded(e, n) {
    return this.track(new Jv(e), n);
  }
  /**
   * Partner Integrations Jira Create Issue Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Create%20Issue%20Failed)
   *
   * When the user failed to create a Jira issue from the Jira integration.
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCreateIssueFailed(e, n) {
    return this.track(new Yv(e), n);
  }
  /**
   * Partner Integrations Jira Create Issue Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Create%20Issue%20Succeeded)
   *
   * When the user successfully create a Jira issue from the Jira integration.
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraCreateIssueSucceeded(e, n) {
    return this.track(new Xv(e), n);
  }
  /**
   * Partner Integrations Jira Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Link%20Issue%20Clicked)
   *
   * When the user creates a link to a Jira issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraLinkIssueClicked(e, n) {
    return this.track(new Zv(e), n);
  }
  /**
   * Partner Integrations Jira Open Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Open%20Issue%20Clicked)
   *
   * When the user opens a Jira issue's details
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraOpenIssueClicked(e, n) {
    return this.track(new eg(e), n);
  }
  /**
   * Partner Integrations Jira Open Jira Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Open%20Jira%20Clicked)
   *
   * When the user opens Jira from the widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraOpenJiraClicked(e, n) {
    return this.track(new tg(e), n);
  }
  /**
   * Partner Integrations Jira Remove All Dangling Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Remove%20All%20Dangling%20Clicked)
   *
   * When the user clicks remove all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraRemoveAllDanglingClicked(e, n) {
    return this.track(new ng(e), n);
  }
  /**
   * Partner Integrations Jira Remove Dangling Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Remove%20Dangling%20Issue%20Clicked)
   *
   * When the user clicks remove on a dangling link
   *
   * @param properties The event's properties (e.g. jiraDanglingIssueKey)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraRemoveDanglingIssueClicked(e, n) {
    return this.track(new rg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Cancelled)
   *
   * When the user cancels removing all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesCancelled(e, n) {
    return this.track(new ig(e), n);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Clicked)
   *
   * When the user clicks unlink all links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesClicked(e, n) {
    return this.track(new sg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink All Issues Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20All%20Issues%20Confirmed)
   *
   * When the user confirms removing all dangling links
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkAllIssuesConfirmed(e, n) {
    return this.track(new og(e), n);
  }
  /**
   * Partner Integrations Jira Unlink Issue Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Cancelled)
   *
   * When the user cancels unlinking an issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueCancelled(e, n) {
    return this.track(new ag(e), n);
  }
  /**
   * Partner Integrations Jira Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Clicked)
   *
   * When the user clicks unlink issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueClicked(e, n) {
    return this.track(new cg(e), n);
  }
  /**
   * Partner Integrations Jira Unlink Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Jira%20Unlink%20Issue%20Confirmed)
   *
   * When the user confirms unlinking an issue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. jiraInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsJiraUnlinkIssueConfirmed(e, n) {
    return this.track(new ug(e), n);
  }
  /**
   * Partner Integrations Klaviyo Messages Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Messages%20Received)
   *
   * When the widget received messages
   *
   * @param properties The event's properties (e.g. emailsBounced)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoMessagesReceived(e, n) {
    return this.track(new lg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Failed)
   *
   * When the widget failed to receive profile information
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileFailed(e, n) {
    return this.track(new dg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Received)
   *
   * When the widget received profile information
   *
   * @param properties The event's properties (e.g. hasProfile)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileReceived(e, n) {
    return this.track(new pg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Clicked)
   *
   * When the user clicked to subscribe to a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked(e, n) {
    return this.track(new hg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Failed)
   *
   * When the subscription to a channel failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed(e, n) {
    return this.track(new vg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Subscription To Channel Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Subscription%20To%20Channel%20Succeeded)
   *
   * When the user successfully subscribed to a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded(e, n) {
    return this.track(new gg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Clicked)
   *
   * When the user unsubscribed a given channel
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeClicked(e, n) {
    return this.track(new fg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Failed)
   *
   * When the user unsubscription attempt failed
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeFailed(e, n) {
    return this.track(new Cg(e), n);
  }
  /**
   * Partner Integrations Klaviyo Profile Unsubscribe Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Klaviyo%20Profile%20Unsubscribe%20Succeeded)
   *
   * When the user successfully unsubscribed from a channel.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsKlaviyoProfileUnsubscribeSucceeded(e, n) {
    return this.track(new yg(e), n);
  }
  /**
   * Partner Integrations Linear Create New Issue Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Cancelled)
   *
   * When the user cancels to create a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueCancelled(e, n) {
    return this.track(new mg(e), n);
  }
  /**
   * Partner Integrations Linear Create New Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Clicked)
   *
   * When the user clicks to open a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueClicked(e, n) {
    return this.track(new kg(e), n);
  }
  /**
   * Partner Integrations Linear Create New Issue Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Create%20New%20Issue%20Confirmed)
   *
   * When the user confirms to create a new Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearCreateNewIssueConfirmed(e, n) {
    return this.track(new wg(e), n);
  }
  /**
   * Partner Integrations Linear Link Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Link%20Issue%20Clicked)
   *
   * When the user creates a link to a Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearLinkIssueClicked(e, n) {
    return this.track(new _g(e), n);
  }
  /**
   * Partner Integrations Linear Open Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Open%20Issue%20Clicked)
   *
   * When the user opens the details of a Linear issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearOpenIssueClicked(e, n) {
    return this.track(new Sg(e), n);
  }
  /**
   * Partner Integrations Linear Open Linear Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Open%20Linear%20Clicked)
   *
   * When the user opens Linear from the widget
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearOpenLinearClicked(e, n) {
    return this.track(new bg(e), n);
  }
  /**
   * Partner Integrations Linear Unlink Issue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Linear%20Unlink%20Issue%20Clicked)
   *
   * When the user clicks unlink issue
   *
   * @param properties The event's properties (e.g. linearInstanceUrl)
   * @param options Amplitude event options.
   */
  partnerIntegrationsLinearUnlinkIssueClicked(e, n) {
    return this.track(new Ag(e), n);
  }
  /**
   * Partner Integrations Recharge Widget Customer Overview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Customer%20Overview%20Opened)
   *
   * When the agent opens the link to see the customers overview in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetCustomerOverviewOpened(e) {
    return this.track(new Ig(), e);
  }
  /**
   * Partner Integrations Recharge Widget Order Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Order%20Opened)
   *
   * When the agent opens the link to see the order in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetOrderOpened(e) {
    return this.track(new Tg(), e);
  }
  /**
   * Partner Integrations Recharge Widget Orders List Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Orders%20List%20Opened)
   *
   * When the agent opens the link to see a list of orders in Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetOrdersListOpened(e) {
    return this.track(new Eg(), e);
  }
  /**
   * Partner Integrations Recharge Widget Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Recharge%20Widget%20Profile%20Received)
   *
   * When the integration received a customer profile from Recharge.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsRechargeWidgetProfileReceived(e) {
    return this.track(new Og(), e);
  }
  /**
   * Partner Integrations Settings Create Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Create%20Submitted)
   *
   * When the user submitted the creation of a partner integration configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsCreateSubmitted(e, n) {
    return this.track(new Pg(e), n);
  }
  /**
   * Partner Integrations Settings Overview Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Overview%20Created)
   *
   * When the user created a partner integration settings page from the integration settings overview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetType)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsOverviewCreated(e, n) {
    return this.track(new Rg(e), n);
  }
  /**
   * Partner Integrations Settings Overview Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20Overview%20Viewed)
   *
   * When the user viewed a partner integration settings page from the integration settings overview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsOverviewViewed(e, n) {
    return this.track(new Mg(e), n);
  }
  /**
   * Partner Integrations Settings View Delete Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Canceled)
   *
   * When the user canceled the deletion request
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteCanceled(e, n) {
    return this.track(new Fg(e), n);
  }
  /**
   * Partner Integrations Settings View Delete Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Confirmed)
   *
   * When the user confirmed the deletion of a partner integrations configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteConfirmed(e, n) {
    return this.track(new Dg(e), n);
  }
  /**
   * Partner Integrations Settings View Delete Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Delete%20Requested)
   *
   * Then the user requested the deletion of a partner integrations configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewDeleteRequested(e, n) {
    return this.track(new Ug(e), n);
  }
  /**
   * Partner Integrations Settings View OAuth Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20OAuth%20Started)
   *
   * When the user clicked the OAuth button in the widget settings view
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewOAuthStarted(e, n) {
    return this.track(new Lg(e), n);
  }
  /**
   * Partner Integrations Settings View OAuth Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20OAuth%20Succeeded)
   *
   * When the user clicked the OAuth button in the widget settings view and the connection was successful
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewOAuthSucceeded(e, n) {
    return this.track(new Ng(e), n);
  }
  /**
   * Partner Integrations Settings View Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Settings%20View%20Submitted)
   *
   * When the user submitted changes to a partner integration configuration
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsSettingsViewSubmitted(e, n) {
    return this.track(new Vg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Discount Code Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Discount%20Code%20Created)
   *
   * When the user created a new discount code from the Shopify integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetDiscountCodeCreated(e) {
    return this.track(new Bg(), e);
  }
  /**
   * Partner Integrations Shopify Widget Order Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Cancelled)
   *
   * When the user cancels an order from the Shopify integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCancelled(e) {
    return this.track(new Hg(), e);
  }
  /**
   * Partner Integrations Shopify Widget Order Collapse Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Collapse%20Closed)
   *
   * When the user closed an order collapse inside the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCollapseClosed(e, n) {
    return this.track(new Wg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Collapse Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Collapse%20Opened)
   *
   * When the user opened an order collapse inside the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderCollapseOpened(e, n) {
    return this.track(new xg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Modal%20Canceled)
   *
   * When the user canceled the change of the shipping address of an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled(e, n) {
    return this.track(new Qg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Modal%20Opened)
   *
   * When the user opened the change shipping address modal for an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened(e, n) {
    return this.track(new Kg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Edit Shipping Address Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Edit%20Shipping%20Address%20Submitted)
   *
   * When the user submitted a change of the shipping address for an order
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted(e, n) {
    return this.track(new Gg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Canceled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Canceled)
   *
   * When the user canceled the refund order option request
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundCanceled(e, n) {
    return this.track(new qg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Confirmed)
   *
   * When the user confirmed the refund order option
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundConfirmed(e, n) {
    return this.track(new zg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Refund Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Refund%20Requested)
   *
   * When the user requested the refund order option
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderRefundRequested(e, n) {
    return this.track(new $g(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order Tags Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20Tags%20Updated)
   *
   * When the user updated the tags on an order from the Shopify integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderTagsUpdated(e) {
    return this.track(new jg(), e);
  }
  /**
   * Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20View%20All%20Orders%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view all orders in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked(e, n) {
    return this.track(new Jg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Order View Order In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Order%20View%20Order%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view order in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. orderId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked(e, n) {
    return this.track(new Yg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget Profile Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Profile%20Created)
   *
   * When the user created a new shopify profile for the customer from the Shopfiy integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetProfileCreated(e) {
    return this.track(new Xg(), e);
  }
  /**
   * Partner Integrations Shopify Widget Refreshed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20Refreshed)
   *
   * When the user refreshed the partner integration widget
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetRefreshed(e, n) {
    return this.track(new Zg(e), n);
  }
  /**
   * Partner Integrations Shopify Widget View Customer In Shopify Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Shopify%20Widget%20View%20Customer%20In%20Shopify%20Clicked)
   *
   * When the user clicked on the view customer in Shopify" deeplink"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. shopifyId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked(e, n) {
    return this.track(new ef(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Clicked)
   *
   * If the icon to subscribe to a channel got clicked.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionClicked(e, n) {
    return this.track(new tf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Failed)
   *
   * If a channel subscription failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionFailed(e, n) {
    return this.track(new nf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Subscription Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Subscription%20Succeeded)
   *
   * If a channel subscription succeeded.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded(e, n) {
    return this.track(new rf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Clicked)
   *
   * If the icon to unsubscribe to a channel got clicked.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked(e, n) {
    return this.track(new sf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Failed)
   *
   * If a channel unsubscription failed.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed(e, n) {
    return this.track(new of(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Channel Unsubscription Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Channel%20Unsubscription%20Succeeded)
   *
   * If a channel unsubscription succeeded.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded(e, n) {
    return this.track(new af(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Message External Link Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Message%20External%20Link%20Opened)
   *
   * A link to an external message got opened.
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetMessageExternalLinkOpened(e, n) {
    return this.track(new cf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Messages Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Messages%20Received)
   *
   * Describes if the widget received messages.
   *
   * @param properties The event's properties (e.g. emailsReceived)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetMessagesReceived(e, n) {
    return this.track(new uf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Orders Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Orders%20Received)
   *
   * Describes if the widget received transactions.
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetOrdersReceived(e, n) {
    return this.track(new lf(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Profile Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Profile%20Received)
   *
   * Describes if the widget received profile informations.
   *
   * @param properties The event's properties (e.g. hasProfile)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetProfileReceived(e, n) {
    return this.track(new df(e), n);
  }
  /**
   * Partner Integrations Voyado Widget Transactions Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Voyado%20Widget%20Transactions%20Received)
   *
   * Describes if the widget received transactions.
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  partnerIntegrationsVoyadoWidgetTransactionsReceived(e, n) {
    return this.track(new pf(e), n);
  }
  /**
   * Partner Integrations Widget Collapse Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Collapse%20Closed)
   *
   * When the user closed the partner integration widget in the conversation sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetCollapseClosed(e, n) {
    return this.track(new hf(e), n);
  }
  /**
   * Partner Integrations Widget Collapse Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Collapse%20Opened)
   *
   * When the user opened the partner integration widget in the conversation sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. widgetId)
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetCollapseOpened(e, n) {
    return this.track(new vf(e), n);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Add Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Add%20Points%20Failed)
   *
   * When adding points to the customers points balance failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionAddPointsFailed(e) {
    return this.track(new gf(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Add Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Add%20Points%20Succeeded)
   *
   * When the agent successfuly added points to the customers point balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded(e) {
    return this.track(new ff(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Customer Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Customer%20Received)
   *
   * When the user received customer data to be displayed in the integration.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionCustomerReceived(e) {
    return this.track(new Cf(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Remove Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Remove%20Points%20Failed)
   *
   * When removing points from the customers point balance failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionRemovePointsFailed(e) {
    return this.track(new yf(), e);
  }
  /**
   * Partner Integrations Widget LoyaltyLion Remove Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20LoyaltyLion%20Remove%20Points%20Succeeded)
   *
   * When the agent successfuly removed points from the customers points balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded(e) {
    return this.track(new mf(), e);
  }
  /**
   * Partner Integrations Widget Voyado Update Points Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Voyado%20Update%20Points%20Failed)
   *
   * When the points balance update failed.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetVoyadoUpdatePointsFailed(e) {
    return this.track(new kf(), e);
  }
  /**
   * Partner Integrations Widget Voyado Update Points Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Partner%20Integrations%20Widget%20Voyado%20Update%20Points%20Succeeded)
   *
   * When the agent successfuly updated the points balance.
   *
   * @param options Amplitude event options.
   */
  partnerIntegrationsWidgetVoyadoUpdatePointsSucceeded(e) {
    return this.track(new wf(), e);
  }
  /**
   * Phone Actions Menu Action Add Outbound Caller ID Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Action%20Add%20Outbound%20Caller%20ID%20Clicked)
   *
   * When the user selects Add outbound caller ID from the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuActionAddOutboundCallerIdClicked(e) {
    return this.track(new _f(), e);
  }
  /**
   * Phone Actions Menu Action Change Hold Music Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Action%20Change%20Hold%20Music%20Clicked)
   *
   * When the user selects Change hold music from the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuActionChangeHoldMusicClicked(e) {
    return this.track(new Sf(), e);
  }
  /**
   * Phone Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Actions%20Menu%20Opened)
   *
   * When the users opens the Actions drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneActionsMenuOpened(e) {
    return this.track(new bf(), e);
  }
  /**
   * Phone Add Outbound Caller ID Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Add%20Outbound%20Caller%20ID%20Form%20Cancelled)
   *
   * When the user cancels to verify a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneAddOutboundCallerIdFormCancelled(e) {
    return this.track(new Af(), e);
  }
  /**
   * Phone Add Outbound Caller ID Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Add%20Outbound%20Caller%20ID%20Form%20Submitted)
   *
   * When the user verifies a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneAddOutboundCallerIdFormSubmitted(e) {
    return this.track(new If(), e);
  }
  /**
   * Phone Change Hold Music Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Change%20Hold%20Music%20Form%20Cancelled)
   *
   * When the user cancels the change the hold music form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneChangeHoldMusicFormCancelled(e) {
    return this.track(new Tf(), e);
  }
  /**
   * Phone Change Hold Music Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Change%20Hold%20Music%20Form%20Submitted)
   *
   * When the user changes the hold music
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneChangeHoldMusicFormSubmitted(e) {
    return this.track(new Ef(), e);
  }
  /**
   * Phone Create Flow Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Create%20Flow%20Form%20Cancelled)
   *
   * When the user cancels the Create flow form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneCreateFlowFormCancelled(e) {
    return this.track(new Of(), e);
  }
  /**
   * Phone Create Flow Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Create%20Flow%20Form%20Submitted)
   *
   * When the user submit the Create flow form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneCreateFlowFormSubmitted(e) {
    return this.track(new Pf(), e);
  }
  /**
   * Phone Flow Options Menu Option Audit Log Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Audit%20Log%20Clicked)
   *
   * When the user clicks the See Audit Log button in phone settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionAuditLogClicked(e) {
    return this.track(new Rf(), e);
  }
  /**
   * Phone Flow Options Menu Option Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Delete%20Clicked)
   *
   * When the user selects Delete from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionDeleteClicked(e) {
    return this.track(new Mf(), e);
  }
  /**
   * Phone Flow Options Menu Option Duplicate Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Duplicate%20Clicked)
   *
   * When the user selects Duplicate from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionDuplicateClicked(e) {
    return this.track(new Ff(), e);
  }
  /**
   * Phone Flow Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selects Edit from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionEditClicked(e) {
    return this.track(new Df(), e);
  }
  /**
   * Phone Flow Options Menu Option Move To Another Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Move%20To%20Another%20Number%20Clicked)
   *
   * When the user selects Move to another number from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionMoveToAnotherNumberClicked(e) {
    return this.track(new Uf(), e);
  }
  /**
   * Phone Flow Options Menu Option Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Opened)
   *
   * When the user opens the flow ellipsis menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionOpened(e) {
    return this.track(new Lf(), e);
  }
  /**
   * Phone Flow Options Menu Option Rename Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Flow%20Options%20Menu%20Option%20Rename%20Clicked)
   *
   * When the user selects Rename from the flow options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFlowOptionsMenuOptionRenameClicked(e) {
    return this.track(new Nf(), e);
  }
  /**
   * Phone Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Cancelled)
   *
   * When the user cancels the buy number form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormCancelled(e) {
    return this.track(new Vf(), e);
  }
  /**
   * Phone Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Opened)
   *
   * When the user opens the buy number form
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormOpened(e) {
    return this.track(new Bf(), e);
  }
  /**
   * Phone Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Form%20Submitted)
   *
   * When the user buys a phone number
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneFormSubmitted(e) {
    return this.track(new Hf(), e);
  }
  /**
   * Phone Options Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Opened)
   *
   * When the user opens the ellipsis menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOpened(e) {
    return this.track(new Wf(), e);
  }
  /**
   * Phone Options Menu Option Create Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Create%20Flow%20Clicked)
   *
   * When the user selects Create flow from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionCreateFlowClicked(e) {
    return this.track(new xf(), e);
  }
  /**
   * Phone Options Menu Option Edit Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Edit%20Clicked)
   *
   * When the user selects Edit from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionEditClicked(e) {
    return this.track(new Qf(), e);
  }
  /**
   * Phone Options Menu Option Remove Number Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Remove%20Number%20Clicked)
   *
   * When the user selects Remove number from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionRemoveNumberClicked(e) {
    return this.track(new Kf(), e);
  }
  /**
   * Phone Options Menu Option Set Default Caller ID Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Set%20Default%20Caller%20ID%20Clicked)
   *
   * When the user selects Set default caller ID from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionSetDefaultCallerIdClicked(e) {
    return this.track(new Gf(), e);
  }
  /**
   * Phone Options Menu Option Setup Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Options%20Menu%20Option%20Setup%20Clicked)
   *
   * When the user selects Setup from the options drop down menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneOptionsMenuOptionSetupClicked(e) {
    return this.track(new qf(), e);
  }
  /**
   * Phone Recording Downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Downloaded)
   *
   * When a user downloads the voice conversation recording
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingDownloaded(e, n) {
    return this.track(new zf(e), n);
  }
  /**
   * Phone Recording Pause Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Pause%20Clicked)
   *
   * When a user clicks pause" on the voice conversation recording"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPauseClicked(e, n) {
    return this.track(new $f(e), n);
  }
  /**
   * Phone Recording Play Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Play%20Clicked)
   *
   * When a user clicks play" on the voice conversation recording"
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlayClicked(e, n) {
    return this.track(new jf(e), n);
  }
  /**
   * Phone Recording Playback Abandoned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Playback%20Abandoned)
   *
   * When a user navigates away from a conversation while the voice conversation recording is playing
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlaybackAbandoned(e, n) {
    return this.track(new Jf(e), n);
  }
  /**
   * Phone Recording Playback Ended
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Recording%20Playback%20Ended)
   *
   * When the voice conversation recording plays through to the end
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  phoneRecordingPlaybackEnded(e, n) {
    return this.track(new Yf(e), n);
  }
  /**
   * Phone Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Phone%20Search%20Applied)
   *
   * When the user searches for a flow
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  phoneSearchApplied(e) {
    return this.track(new Xf(), e);
  }
  /**
   * Presence List Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20List%20Item%20Clicked)
   *
   * Event to track when an agent clicks on a presence list item in the sidebar.
   *
   * @param options Amplitude event options.
   */
  presenceListItemClicked(e) {
    return this.track(new Zf(), e);
  }
  /**
   * Presence Media Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Media%20Updated)
   *
   * When the user updates their availability for a channel
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  presenceMediaUpdated(e, n) {
    return this.track(new eC(e), n);
  }
  /**
   * Presence Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Presence%20Updated)
   *
   * When the user updates their status to Away or Working
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  presenceUpdated(e, n) {
    return this.track(new tC(e), n);
  }
  /**
   * Push Notification Platform Form Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Cancelled)
   *
   * When the user cancels the push notification platform modal/form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormCancelled(e, n) {
    return this.track(new nC(e), n);
  }
  /**
   * Push Notification Platform Form Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Opened)
   *
   * When the user opens one of the push notification platform listing modals/forms
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormOpened(e, n) {
    return this.track(new rC(e), n);
  }
  /**
   * Push Notification Platform Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Push%20Notification%20Platform%20Form%20Submitted)
   *
   * When the user submits push notification platform form
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  pushNotificationPlatformFormSubmitted(e, n) {
    return this.track(new iC(e), n);
  }
  /**
   * Quick Replies Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Replies%20Opened)
   *
   * Event to track when user opens the Quick replies. Two ways to do it: conversation -> lightning icon/ triggering through editor with '='
   *
   * @param properties The event's properties (e.g. openedBy)
   * @param options Amplitude event options.
   */
  quickRepliesOpened(e, n) {
    return this.track(new sC(e), n);
  }
  /**
   * Quick Reply Chosen
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Chosen)
   *
   * Event to track some data related to chosen by user Quick Reply template
   *
   * @param properties The event's properties (e.g. score)
   * @param options Amplitude event options.
   */
  quickReplyChosen(e, n) {
    return this.track(new oC(e), n);
  }
  /**
   * Quick Reply Feedback for Recommended Replies Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Feedback%20for%20Recommended%20Replies%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. feedback)
   * @param options Amplitude event options.
   */
  quickReplyFeedbackForRecommendedRepliesClicked(e, n) {
    return this.track(new aC(e), n);
  }
  /**
   * Quick Reply Filter Chosen
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Filter%20Chosen)
   *
   * Event triggered when user applies filter in the Quick Replies
   *
   * @param properties The event's properties (e.g. filterUsed)
   * @param options Amplitude event options.
   */
  quickReplyFilterChosen(e, n) {
    return this.track(new cC(e), n);
  }
  /**
   * Quick Reply Language Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Language%20Selected)
   *
   * When the user selects a language in the quick replies dropdown
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  quickReplyLanguageSelected(e, n) {
    return this.track(new uC(e), n);
  }
  /**
   * Quick Reply Template Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Quick%20Reply%20Template%20Favorite%20Toggled)
   *
   * Event to track when a quick reply is favorited/unfavorited by user
   *
   * @param properties The event's properties (e.g. favorited)
   * @param options Amplitude event options.
   */
  quickReplyTemplateFavoriteToggled(e, n) {
    return this.track(new lC(e), n);
  }
  /**
   * Saved Search Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Applied)
   *
   * When the user applies a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchApplied(e) {
    return this.track(new dC(), e);
  }
  /**
   * Saved Search Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Closed)
   *
   * When the user closes a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchClosed(e) {
    return this.track(new pC(), e);
  }
  /**
   * Saved Search Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Created)
   *
   * When the user creates a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. saveAsNew)
   * @param options Amplitude event options.
   */
  savedSearchCreated(e, n) {
    return this.track(new hC(e), n);
  }
  /**
   * Saved Search Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Deleted)
   *
   * When the user deletes a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchDeleted(e) {
    return this.track(new vC(), e);
  }
  /**
   * Saved Search Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Saved%20Search%20Updated)
   *
   * When the user updates a saved search
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  savedSearchUpdated(e) {
    return this.track(new gC(), e);
  }
  /**
   * Scheduled Conversations Csv Import Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Scheduled%20Conversations%20Csv%20Import%20Clicked)
   *
   * When the user clicks the import csv button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  scheduledConversationsCsvImportClicked(e) {
    return this.track(new fC(), e);
  }
  /**
   * Scheduled Conversations Csv Imported
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Scheduled%20Conversations%20Csv%20Imported)
   *
   * When the user submits a csv file
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  scheduledConversationsCsvImported(e) {
    return this.track(new CC(), e);
  }
  /**
   * Search Contact Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Closed)
   *
   * When the users closes the contact preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewClosed(e, n) {
    return this.track(new yC(e), n);
  }
  /**
   * Search Contact Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full contact view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewGoToClicked(e, n) {
    return this.track(new mC(e), n);
  }
  /**
   * Search Contact Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Preview%20Opened)
   *
   * When the users clicks on a contact in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactPreviewOpened(e, n) {
    return this.track(new kC(e), n);
  }
  /**
   * Search Contact Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Contact%20Type%20Changed)
   *
   * When the users changes the contact type in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchContactTypeChanged(e, n) {
    return this.track(new wC(e), n);
  }
  /**
   * Search Conversation Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Closed)
   *
   * When the user closes the conversation preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchConversationPreviewClosed(e) {
    return this.track(new _C(), e);
  }
  /**
   * Search Conversation Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full conversation view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  searchConversationPreviewGoToClicked(e, n) {
    return this.track(new SC(e), n);
  }
  /**
   * Search Conversation Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Conversation%20Preview%20Opened)
   *
   * When the user clicks on a conversation in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. csid)
   * @param options Amplitude event options.
   */
  searchConversationPreviewOpened(e, n) {
    return this.track(new bC(e), n);
  }
  /**
   * Search Field Blurred
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Blurred)
   *
   * When the user clicks outside of the search field and it loses focus
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldBlurred(e, n) {
    return this.track(new AC(e), n);
  }
  /**
   * Search Field Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Cleared)
   *
   * When the user clicks the button to clear the search field
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldCleared(e, n) {
    return this.track(new IC(e), n);
  }
  /**
   * Search Field Focused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Focused)
   *
   * When the user clicks on the search field and it becomes focused
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFieldFocused(e, n) {
    return this.track(new TC(e), n);
  }
  /**
   * Search Field Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Field%20Submitted)
   *
   * When the user submits the value in the search field
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isEmpty)
   * @param options Amplitude event options.
   */
  searchFieldSubmitted(e, n) {
    return this.track(new EC(e), n);
  }
  /**
   * Search Filter Condition Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Condition%20Added)
   *
   * When the user adds a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  searchFilterConditionAdded(e, n) {
    return this.track(new OC(e), n);
  }
  /**
   * Search Filter Condition Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Condition%20Removed)
   *
   * When the user removes a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  searchFilterConditionRemoved(e, n) {
    return this.track(new PC(e), n);
  }
  /**
   * Search Filter Operator Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Operator%20Updated)
   *
   * When the user updates the operator of a search filter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. operator)
   * @param options Amplitude event options.
   */
  searchFilterOperatorUpdated(e, n) {
    return this.track(new RC(e), n);
  }
  /**
   * Search Filter Strategy Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Strategy%20Updated)
   *
   * When the user updates the search filtering strategy
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. strategy)
   * @param options Amplitude event options.
   */
  searchFilterStrategyUpdated(e, n) {
    return this.track(new MC(e), n);
  }
  /**
   * Search Filter Value Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Value%20Added)
   *
   * When the user adds a value to a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. operator)
   * @param options Amplitude event options.
   */
  searchFilterValueAdded(e, n) {
    return this.track(new FC(e), n);
  }
  /**
   * Search Filter Value Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filter%20Value%20Cleared)
   *
   * When the user clears the value of a search filter condition
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFilterValueCleared(e, n) {
    return this.track(new DC(e), n);
  }
  /**
   * Search Filters Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Applied)
   *
   * When the user applies the search filters
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersApplied(e, n) {
    return this.track(new UC(e), n);
  }
  /**
   * Search Filters Cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Cleared)
   *
   * When the user clears the search filters
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersCleared(e, n) {
    return this.track(new LC(e), n);
  }
  /**
   * Search Filters Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Closed)
   *
   * When the user closes the search filters sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersClosed(e, n) {
    return this.track(new NC(e), n);
  }
  /**
   * Search Filters Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Opened)
   *
   * When the user opens the search filters sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  searchFiltersOpened(e, n) {
    return this.track(new VC(e), n);
  }
  /**
   * Search Filters Validation Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Filters%20Validation%20Failed)
   *
   * When the validation of the search filters fails
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. errors)
   * @param options Amplitude event options.
   */
  searchFiltersValidationFailed(e, n) {
    return this.track(new BC(e), n);
  }
  /**
   * Search Note Preview Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Note%20Preview%20Closed)
   *
   * When the user closes the note preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchNotePreviewClosed(e) {
    return this.track(new HC(), e);
  }
  /**
   * Search Note Preview Go To Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Note%20Preview%20Go%20To%20Clicked)
   *
   * When the user navigates to the full conversation view from the search preview
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchNotePreviewGoToClicked(e) {
    return this.track(new WC(), e);
  }
  /**
   * Search Note Preview Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Note%20Preview%20Opened)
   *
   * When the user clicks on a note in the search results
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  searchNotePreviewOpened(e) {
    return this.track(new xC(), e);
  }
  /**
   * Search Sorting Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Sorting%20Updated)
   *
   * When the user changes the search results sorting
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  searchSortingUpdated(e, n) {
    return this.track(new QC(e), n);
  }
  /**
   * Search Strict Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Strict%20Toggled)
   *
   * When the user toggles strict search
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  searchStrictToggled(e, n) {
    return this.track(new KC(e), n);
  }
  /**
   * Search Tab Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Search%20Tab%20Opened)
   *
   * When the user opens a different search tab
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  searchTabOpened(e, n) {
    return this.track(new GC(e), n);
  }
  /**
   * Settings Agents Add Agent Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Add%20Agent%20Button%20Clicked)
   *
   * When the user clicks on Add agent" button on agents settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsAgentsAddAgentButtonClicked(e) {
    return this.track(new qC(), e);
  }
  /**
   * Settings Agents Custom Workload Assigned
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Custom%20Workload%20Assigned)
   *
   * When the user assigns a custom workload to 1 or more agents
   *
   * @param properties The event's properties (e.g. numberOfAgents)
   * @param options Amplitude event options.
   */
  settingsAgentsCustomWorkloadAssigned(e, n) {
    return this.track(new zC(e), n);
  }
  /**
   * Settings Agents Custom Workload Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Custom%20Workload%20Created)
   *
   * When the user creates a new custom workload on agents settings page - Workloads tab
   *
   * @param options Amplitude event options.
   */
  settingsAgentsCustomWorkloadCreated(e) {
    return this.track(new $C(), e);
  }
  /**
   * Settings Agents Custom Workload Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Custom%20Workload%20Deleted)
   *
   * When the user deletes a custom workload on agents settings page - Workloads tab
   *
   * @param options Amplitude event options.
   */
  settingsAgentsCustomWorkloadDeleted(e) {
    return this.track(new jC(), e);
  }
  /**
   * Settings Agents Edit Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Edit%20Button%20Clicked)
   *
   * When the user clicks on the edit icon in the agents table on settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsAgentsEditButtonClicked(e) {
    return this.track(new JC(), e);
  }
  /**
   * Settings Agents Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Tab%20Clicked)
   *
   * When the user switches between tabs on agents settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsAgentsTabClicked(e, n) {
    return this.track(new YC(e), n);
  }
  /**
   * Settings Agents Workloads Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Agents%20Workloads%20Form%20Submitted)
   *
   * When the user submits the form on workloads tab on agents settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. payload)
   * @param options Amplitude event options.
   */
  settingsAgentsWorkloadsFormSubmitted(e, n) {
    return this.track(new XC(e), n);
  }
  /**
   * Settings Audio Delete Cancel Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Cancel%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteCancelClicked(e, n) {
    return this.track(new ZC(e), n);
  }
  /**
   * Settings Audio Delete Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteClicked(e, n) {
    return this.track(new ey(e), n);
  }
  /**
   * Settings Audio Delete Confirm Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Delete%20Confirm%20Clicked)
   *
   * When the user opens the confirm delete modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioDeleteConfirmClicked(e, n) {
    return this.track(new ty(e), n);
  }
  /**
   * Settings Audio Usage Flow Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Usage%20Flow%20Clicked)
   *
   * When the user interacts with audio usage
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioUsageFlowClicked(e, n) {
    return this.track(new ny(e), n);
  }
  /**
   * Settings Audio Usage Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Audio%20Usage%20Link%20Clicked)
   *
   * When the user interacts with audio usage
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. filename)
   * @param options Amplitude event options.
   */
  settingsAudioUsageLinkClicked(e, n) {
    return this.track(new ry(e), n);
  }
  /**
   * Settings Commands Assign Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Assign%20Keybindings)
   *
   * When the user assigns keybindings to a command
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsAssignKeybindings(e, n) {
    return this.track(new iy(e), n);
  }
  /**
   * Settings Commands Reset All Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Reset%20All%20Keybindings)
   *
   * When the user resets all commands to their default keybindings
   *
   * @param options Amplitude event options.
   */
  settingsCommandsResetAllKeybindings(e) {
    return this.track(new sy(), e);
  }
  /**
   * Settings Commands Reset Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Reset%20Keybindings)
   *
   * When the user resets a command's keybindings
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsResetKeybindings(e, n) {
    return this.track(new oy(e), n);
  }
  /**
   * Settings Commands Unassign All Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Unassign%20All%20Keybindings)
   *
   * When the user unassigns all commands' keybindings
   *
   * @param options Amplitude event options.
   */
  settingsCommandsUnassignAllKeybindings(e) {
    return this.track(new ay(), e);
  }
  /**
   * Settings Commands Unassign Keybindings
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Commands%20Unassign%20Keybindings)
   *
   * When the user unassigns a command's keybindings
   *
   * @param properties The event's properties (e.g. commandName)
   * @param options Amplitude event options.
   */
  settingsCommandsUnassignKeybindings(e, n) {
    return this.track(new cy(e), n);
  }
  /**
   * Settings Custom Attribute Activated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Activated)
   *
   * When the user activated a custom attribute
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeActivated(e, n) {
    return this.track(new uy(e), n);
  }
  /**
   * Settings Custom Attribute Add New Attribute Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Add%20New%20Attribute%20Clicked)
   *
   * When the user clicks the Add new attribute button
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. entityId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeAddNewAttributeClicked(e, n) {
    return this.track(new ly(e), n);
  }
  /**
   * Settings Custom Attribute Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Archived)
   *
   * When the user archives a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeArchived(e, n) {
    return this.track(new dy(e), n);
  }
  /**
   * Settings Custom Attribute Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Created)
   *
   * When the user create a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. entityId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeCreated(e, n) {
    return this.track(new py(e), n);
  }
  /**
   * Settings Custom Attribute Deactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Deactivated)
   *
   * When the user deactivates a custom attribute
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeDeactivated(e, n) {
    return this.track(new hy(e), n);
  }
  /**
   * Settings Custom Attribute Reordered
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Reordered)
   *
   * When the user reorders a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeReordered(e, n) {
    return this.track(new vy(e), n);
  }
  /**
   * Settings Custom Attribute Unarchived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Unarchived)
   *
   * When the user unarchives a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeUnarchived(e, n) {
    return this.track(new gy(e), n);
  }
  /**
   * Settings Custom Attribute Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Attribute%20Updated)
   *
   * When the user updates a custom attribute
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. attributeId)
   * @param options Amplitude event options.
   */
  settingsCustomAttributeUpdated(e, n) {
    return this.track(new fy(e), n);
  }
  /**
   * Settings Custom Away Status Add New Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Add%20New%20Clicked)
   *
   * When the user clicks Create new status button
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusAddNewClicked(e) {
    return this.track(new Cy(), e);
  }
  /**
   * Settings Custom Away Status Archived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Archived)
   *
   * When the user archives a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusArchived(e) {
    return this.track(new yy(), e);
  }
  /**
   * Settings Custom Away Status Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Created)
   *
   * When the user creates a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusCreated(e) {
    return this.track(new my(), e);
  }
  /**
   * Settings Custom Away Status Unarchived
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Unarchived)
   *
   * When the user unarchives a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusUnarchived(e) {
    return this.track(new ky(), e);
  }
  /**
   * Settings Custom Away Status Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Custom%20Away%20Status%20Updated)
   *
   * When the user updates a custom away status
   *
   * @param options Amplitude event options.
   */
  settingsCustomAwayStatusUpdated(e) {
    return this.track(new wy(), e);
  }
  /**
   * Settings Forms Embed Url Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Forms%20Embed%20Url%20Copied)
   *
   * When the user copies form embed url.
   *
   * @param options Amplitude event options.
   */
  settingsFormsEmbedUrlCopied(e) {
    return this.track(new _y(), e);
  }
  /**
   * Settings Integrations Api Tokens Add Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Add%20Confirm)
   *
   * When the user creates a new API token
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. apiTokenVersion)
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensAddConfirm(e, n) {
    return this.track(new Sy(e), n);
  }
  /**
   * Settings Integrations Api Tokens Copy
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Copy)
   *
   * When the user clicks on the button to copy an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensCopy(e) {
    return this.track(new by(), e);
  }
  /**
   * Settings Integrations Api Tokens Documentation Link Integrations Api
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Documentation%20Link%20Integrations%20Api)
   *
   * When the user clicks on the link to open the documentation for the Integrations API
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensDocumentationLinkIntegrationsApi(e) {
    return this.track(new Ay(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove)
   *
   * When the user clicks on the button to remove an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemove(e) {
    return this.track(new Iy(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove%20Cancel)
   *
   * When the user cancels removing an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemoveCancel(e) {
    return this.track(new Ty(), e);
  }
  /**
   * Settings Integrations Api Tokens Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20Remove%20Confirm)
   *
   * When the user confirms removing an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensRemoveConfirm(e) {
    return this.track(new Ey(), e);
  }
  /**
   * Settings Integrations Api Tokens View
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Api%20Tokens%20View)
   *
   * When the user clicks on the button to view an API token
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsApiTokensView(e) {
    return this.track(new Oy(), e);
  }
  /**
   * Settings Integrations Card Edit Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Edit%20Save)
   *
   * When the user is on the card edit page and saves changes to an existing card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardEditSave(e, n) {
    return this.track(new Py(e), n);
  }
  /**
   * Settings Integrations Card Edit Test
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Edit%20Test)
   *
   * When the user is on the card edit page and clicks on Test
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardEditTest(e, n) {
    return this.track(new Ry(e), n);
  }
  /**
   * Settings Integrations Card Listing Add Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Add%20Card)
   *
   * When the user clicks on Add card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardType)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingAddCard(e, n) {
    return this.track(new My(e), n);
  }
  /**
   * Settings Integrations Card Listing Edit Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Edit%20Card)
   *
   * When the user clicks on Edit card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingEditCard(e, n) {
    return this.track(new Fy(e), n);
  }
  /**
   * Settings Integrations Card Listing Remove Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Remove%20Card)
   *
   * When the user clicks on Remove Card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingRemoveCard(e, n) {
    return this.track(new Dy(e), n);
  }
  /**
   * Settings Integrations Card Listing Remove Card Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Remove%20Card%20Cancel)
   *
   * When the user clicks on Remove Card but cancels the dialog
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingRemoveCardCancel(e, n) {
    return this.track(new Uy(e), n);
  }
  /**
   * Settings Integrations Card Listing Remove Card Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Remove%20Card%20Confirm)
   *
   * When the user clicks on Remove Card and confirms the dialog
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingRemoveCardConfirm(e, n) {
    return this.track(new Ly(e), n);
  }
  /**
   * Settings Integrations Card Listing Test Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Listing%20Test%20Card)
   *
   * When the user clicks on Test card
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardListingTestCard(e, n) {
    return this.track(new Ny(e), n);
  }
  /**
   * Settings Integrations Card Read Documentation
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Read%20Documentation)
   *
   * When the user clicks on the documentation link in the header
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardRoute)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardReadDocumentation(e, n) {
    return this.track(new Vy(e), n);
  }
  /**
   * Settings Integrations Card Test
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test)
   *
   * When the user is on the test card page and clicks on Test
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTest(e, n) {
    return this.track(new By(e), n);
  }
  /**
   * Settings Integrations Card Test Add Parameter
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test%20Add%20Parameter)
   *
   * When the user is on the test card page and adds a parameter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTestAddParameter(e, n) {
    return this.track(new Hy(e), n);
  }
  /**
   * Settings Integrations Card Test Remove Parameter
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Card%20Test%20Remove%20Parameter)
   *
   * When the user is on the test card page and removes a parameter
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. cardId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCardTestRemoveParameter(e, n) {
    return this.track(new Wy(e), n);
  }
  /**
   * Settings Integrations Custom Card Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Created)
   *
   * When the user created a custom card.
   *
   * @param properties The event's properties (e.g. authorizationHeader)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardCreated(e, n) {
    return this.track(new xy(e), n);
  }
  /**
   * Settings Integrations Custom Card Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Edited)
   *
   * When the user edited a custom card.
   *
   * @param properties The event's properties (e.g. authorizationHeader)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardEdited(e, n) {
    return this.track(new Qy(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Failed)
   *
   * When the authentication of the OAuth provider failed.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationFailed(e, n) {
    return this.track(new Ky(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Succeeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Succeeded)
   *
   * When the authentication of the OAuth provider succeeded.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded(e, n) {
    return this.track(new Gy(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Authentication Timed Out
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Authentication%20Timed%20Out)
   *
   * When the authentication of the OAuth provider timed out.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut(e, n) {
    return this.track(new qy(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Created)
   *
   * When the user created a new OAuth provider.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderCreated(e, n) {
    return this.track(new zy(e), n);
  }
  /**
   * Settings Integrations Custom Card Oauth Provider Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Custom%20Card%20Oauth%20Provider%20Updated)
   *
   * When the user updated an existing OAuth provider.
   *
   * @param properties The event's properties (e.g. oAuthProviderId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsCustomCardOauthProviderUpdated(e, n) {
    return this.track(new $y(e), n);
  }
  /**
   * Settings Integrations Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Item%20Clicked)
   *
   * When the user clicks on one of the integrations
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. integrationsId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsItemClicked(e, n) {
    return this.track(new jy(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Add Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Add%20Save)
   *
   * When the user adds a new webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. hasRedirectUrl)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsAddSave(e, n) {
    return this.track(new Jy(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Copy
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Copy)
   *
   * When the user copies a webform endpoint
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsCopy(e) {
    return this.track(new Yy(), e);
  }
  /**
   * Settings Integrations Webform Endpoints Read Documentation Link
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Read%20Documentation%20Link)
   *
   * When the user clicks on the documentation link in the header of the webforms endpoint page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsReadDocumentationLink(e) {
    return this.track(new Xy(), e);
  }
  /**
   * Settings Integrations Webform Endpoints Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove)
   *
   * When the user clicks the delete button on a webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemove(e, n) {
    return this.track(new Zy(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove%20Cancel)
   *
   * When the user cancels deleting a webform endpoint
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemoveCancel(e, n) {
    return this.track(new em(e), n);
  }
  /**
   * Settings Integrations Webform Endpoints Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webform%20Endpoints%20Remove%20Confirm)
   *
   * When the user confirms deleting a webform endpoint
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. webformId)
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebformEndpointsRemoveConfirm(e, n) {
    return this.track(new tm(e), n);
  }
  /**
   * Settings Integrations Webhooks Add
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Add)
   *
   * When the user confirms adding a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksAdd(e) {
    return this.track(new nm(), e);
  }
  /**
   * Settings Integrations Webhooks Add Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Add%20Confirm)
   *
   * When the user adds a new webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksAddConfirm(e) {
    return this.track(new rm(), e);
  }
  /**
   * Settings Integrations Webhooks Documentation Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Documentation%20Link%20Clicked)
   *
   * When the user clicks on the webhooks documentation link
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksDocumentationLinkClicked(e) {
    return this.track(new im(), e);
  }
  /**
   * Settings Integrations Webhooks Edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Edit)
   *
   * When the user clicks on the button to edit a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEdit(e) {
    return this.track(new sm(), e);
  }
  /**
   * Settings Integrations Webhooks Edit Save
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Edit%20Save)
   *
   * When the user clicks on the button to save changes to a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEditSave(e) {
    return this.track(new om(), e);
  }
  /**
   * Settings Integrations Webhooks Enabled Off
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Enabled%20Off)
   *
   * When the user disables a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEnabledOff(e) {
    return this.track(new am(), e);
  }
  /**
   * Settings Integrations Webhooks Enabled On
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Enabled%20On)
   *
   * When the user enables a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksEnabledOn(e) {
    return this.track(new cm(), e);
  }
  /**
   * Settings Integrations Webhooks Remove
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove)
   *
   * When the user clicks on the button to remove a webhook
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemove(e) {
    return this.track(new um(), e);
  }
  /**
   * Settings Integrations Webhooks Remove Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove%20Cancel)
   *
   * When the user cancels removing a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemoveCancel(e) {
    return this.track(new lm(), e);
  }
  /**
   * Settings Integrations Webhooks Remove Confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20Remove%20Confirm)
   *
   * When the user confirms removing a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksRemoveConfirm(e) {
    return this.track(new dm(), e);
  }
  /**
   * Settings Integrations Webhooks View
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View)
   *
   * When the user clicks on the button to view a webhook
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksView(e) {
    return this.track(new pm(), e);
  }
  /**
   * Settings Integrations Webhooks View Copy Secret
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Copy%20Secret)
   *
   * When the user clicks on the copy webhook URL button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewCopySecret(e) {
    return this.track(new hm(), e);
  }
  /**
   * Settings Integrations Webhooks View Copy Url
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Copy%20Url)
   *
   * When the user is on the Settings/Webhooks page and views a webhook and clicks on the copy URL button
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewCopyUrl(e) {
    return this.track(new vm(), e);
  }
  /**
   * Settings Integrations Webhooks View Edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Integrations%20Webhooks%20View%20Edit)
   *
   * When the user clicks on the button to edit a webhook from the webhook view
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsIntegrationsWebhooksViewEdit(e) {
    return this.track(new gm(), e);
  }
  /**
   * Settings Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Menu%20Item%20Clicked)
   *
   * When the user clicks the settings menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  settingsMenuItemClicked(e, n) {
    return this.track(new fm(e), n);
  }
  /**
   * Settings Organization Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Organization%20Form%20Submitted)
   *
   * When the user submits the form on organization settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsOrganizationFormSubmitted(e) {
    return this.track(new Cm(), e);
  }
  /**
   * Settings Organization Logo Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Organization%20Logo%20Changed)
   *
   * When the user changes organization logo
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsOrganizationLogoChanged(e) {
    return this.track(new ym(), e);
  }
  /**
   * Settings Profile Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Profile%20Form%20Submitted)
   *
   * When the user submits the form on profile settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. payload)
   * @param options Amplitude event options.
   */
  settingsProfileFormSubmitted(e, n) {
    return this.track(new mm(e), n);
  }
  /**
   * Settings Queue Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Added)
   *
   * When the user added a queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isDefault)
   * @param options Amplitude event options.
   */
  settingsQueueAdded(e, n) {
    return this.track(new km(e), n);
  }
  /**
   * Settings Queue Agent Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Deleted)
   *
   * When the user performed a search.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueAgentDeleted(e) {
    return this.track(new wm(), e);
  }
  /**
   * Settings Queue Agent Search Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Search%20Submitted)
   *
   * When an agent was deleted.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueAgentSearchSubmitted(e) {
    return this.track(new _m(), e);
  }
  /**
   * Settings Queue Agent Sorted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Agent%20Sorted)
   *
   * When sorting was applied.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  settingsQueueAgentSorted(e, n) {
    return this.track(new Sm(e), n);
  }
  /**
   * Settings Queue Alerts Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Alerts%20Saved)
   *
   * When the queue settings alerts form was saved.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. availableAgentsEnabled)
   * @param options Amplitude event options.
   */
  settingsQueueAlertsSaved(e, n) {
    return this.track(new bm(e), n);
  }
  /**
   * Settings Queue Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Saved)
   *
   * When the user saved a queue
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. isDefault)
   * @param options Amplitude event options.
   */
  settingsQueueSaved(e, n) {
    return this.track(new Am(e), n);
  }
  /**
   * Settings Queue Teams Add Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Add%20Team%20Button%20Clicked)
   *
   * When the Add team button was clicked.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsAddTeamButtonClicked(e) {
    return this.track(new Im(), e);
  }
  /**
   * Settings Queue Teams Add Team Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Add%20Team%20Form%20Submitted)
   *
   * When the Add team form was submitted.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsAddTeamFormSubmitted(e) {
    return this.track(new Tm(), e);
  }
  /**
   * Settings Queue Teams Delete Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queue%20Teams%20Delete%20Team%20Button%20Clicked)
   *
   * When the Delete team button was clicked.
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueueTeamsDeleteTeamButtonClicked(e) {
    return this.track(new Em(), e);
  }
  /**
   * Settings Queues Add Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Add%20Queue%20Clicked)
   *
   * When the user clicks the Add Queue button in the queue settings
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueuesAddQueueClicked(e) {
    return this.track(new Om(), e);
  }
  /**
   * Settings Queues Archive Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Archive%20Queue%20Clicked)
   *
   * When the users clicks the archive queue button in the queue settings
   *
   * @param properties The event's properties (e.g. openConversationsCount)
   * @param options Amplitude event options.
   */
  settingsQueuesArchiveQueueClicked(e, n) {
    return this.track(new Pm(e), n);
  }
  /**
   * Settings Queues Edit Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Edit%20Queue%20Clicked)
   *
   * When the user clicks the edit button in the queue settings
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsQueuesEditQueueClicked(e) {
    return this.track(new Rm(), e);
  }
  /**
   * Settings Queues Unarchive Queue Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Queues%20Unarchive%20Queue%20Clicked)
   *
   * When the users clicks the unarchive queue button in the queue settings
   *
   * @param options Amplitude event options.
   */
  settingsQueuesUnarchiveQueueClicked(e) {
    return this.track(new Mm(), e);
  }
  /**
   * Settings Roles Custom Role Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Created)
   *
   * When a user creates a custom role
   *
   * @param properties The event's properties (e.g. hasDescription)
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleCreated(e, n) {
    return this.track(new Fm(e), n);
  }
  /**
   * Settings Roles Custom Role Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Deleted)
   *
   * When a user deletes a custom role
   *
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleDeleted(e) {
    return this.track(new Dm(), e);
  }
  /**
   * Settings Roles Custom Role Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Roles%20Custom%20Role%20Edited)
   *
   * When a user edits a custom role
   *
   * @param properties The event's properties (e.g. hasDescription)
   * @param options Amplitude event options.
   */
  settingsRolesCustomRoleEdited(e, n) {
    return this.track(new Um(e), n);
  }
  /**
   * Settings Summarization Save Changes Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Save%20Changes%20Clicked)
   *
   * The Settings Summarization Save Changes Clicked" is triggered when user have saved changes to their summarization settings. In this instance
   *
   * @param options Amplitude event options.
   */
  settingsSummarizationSaveChangesClicked(e) {
    return this.track(new Lm(), e);
  }
  /**
   * Settings Summarization Show Automatically Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Show%20Automatically%20Clicked)
   *
   * The Settings summarization show automatically clicked" is triggered when user chooses to show automatic summaries for said channel"
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSummarizationShowAutomaticallyClicked(e, n) {
    return this.track(new Nm(e), n);
  }
  /**
   * Settings Summarization Show On Demand Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Summarization%20Show%20On%20Demand%20Clicked)
   *
   * The Settings summarization show on demand clicked" is triggered when user chooses to show summaries on demand for said channel"
   *
   * @param properties The event's properties (e.g. channel)
   * @param options Amplitude event options.
   */
  settingsSummarizationShowOnDemandClicked(e, n) {
    return this.track(new Vm(e), n);
  }
  /**
   * Settings Tags Add Tag Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Add%20Tag%20Button%20Clicked)
   *
   * When the user clicks on Add Tag button on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTagsAddTagButtonClicked(e) {
    return this.track(new Bm(), e);
  }
  /**
   * Settings Tags Tag Activated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Tag%20Activated)
   *
   * When the user activates a tag on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tagName)
   * @param options Amplitude event options.
   */
  settingsTagsTagActivated(e, n) {
    return this.track(new Hm(e), n);
  }
  /**
   * Settings Tags Tag Deactivated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Tags%20Tag%20Deactivated)
   *
   * When the user deactivates a tag on tags settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tagName)
   * @param options Amplitude event options.
   */
  settingsTagsTagDeactivated(e, n) {
    return this.track(new Wm(e), n);
  }
  /**
   * Settings Team Add Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Add%20Team%20Button%20Clicked)
   *
   * When the user clicks on Add team" button on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamAddTeamButtonClicked(e) {
    return this.track(new xm(), e);
  }
  /**
   * Settings Team Details Add Agents Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Details%20Add%20Agents%20Button%20Clicked)
   *
   * When the user clicks on Add agents" button on team details settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamDetailsAddAgentsButtonClicked(e) {
    return this.track(new Qm(), e);
  }
  /**
   * Settings Team Edit Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Edit%20Team%20Button%20Clicked)
   *
   * When the user clicks on Edit" icon in the table on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamEditTeamButtonClicked(e) {
    return this.track(new Km(), e);
  }
  /**
   * Settings Team Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on team modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. teamName)
   * @param options Amplitude event options.
   */
  settingsTeamModalFormSubmitted(e, n) {
    return this.track(new Gm(e), n);
  }
  /**
   * Settings Team Remove Team Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Remove%20Team%20Button%20Clicked)
   *
   * When the user clicks on Remove" icon in the table on team settings page"
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamRemoveTeamButtonClicked(e) {
    return this.track(new qm(), e);
  }
  /**
   * Settings Team Remove Team Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Team%20Remove%20Team%20Confirmed)
   *
   * When the user presses confirm button on delete team modal
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  settingsTeamRemoveTeamConfirmed(e) {
    return this.track(new zm(), e);
  }
  /**
   * Settings Templates Add Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Add%20Template%20Button%20Clicked)
   *
   * When the user clicks on the add button in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateType)
   * @param options Amplitude event options.
   */
  settingsTemplatesAddTemplateButtonClicked(e, n) {
    return this.track(new $m(e), n);
  }
  /**
   * Settings Templates Edit Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Edit%20Template%20Button%20Clicked)
   *
   * When the user clicks on the edit icon in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesEditTemplateButtonClicked(e, n) {
    return this.track(new jm(e), n);
  }
  /**
   * Settings Templates Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on template modal on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  settingsTemplatesModalFormSubmitted(e, n) {
    return this.track(new Jm(e), n);
  }
  /**
   * Settings Templates Remove Template Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Remove%20Template%20Button%20Clicked)
   *
   * When the user clicks on the delete icon in one of the tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesRemoveTemplateButtonClicked(e, n) {
    return this.track(new Ym(e), n);
  }
  /**
   * Settings Templates Remove Template Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Remove%20Template%20Confirmed)
   *
   * When the user clicks on confirm button on remove template confirm modal on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. templateName)
   * @param options Amplitude event options.
   */
  settingsTemplatesRemoveTemplateConfirmed(e, n) {
    return this.track(new Xm(e), n);
  }
  /**
   * Settings Templates Tab Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Settings%20Templates%20Tab%20Clicked)
   *
   * When the user switches between tabs on templates settings page
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsTemplatesTabClicked(e, n) {
    return this.track(new Zm(e), n);
  }
  /**
   * Shared Worker Tab Or Window Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Changed)
   *
   * When the user opens and closes a tab or window if there are any instances left and when the focus changes between different instances
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowChanged(e) {
    return this.track(new ek(), e);
  }
  /**
   * Shared Worker Tab Or Window Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Closed)
   *
   * When the user closes the agent interface. Including every tab and window.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfInstances)
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowClosed(e, n) {
    return this.track(new tk(e), n);
  }
  /**
   * Shared Worker Tab Or Window Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Shared%20Worker%20Tab%20Or%20Window%20Opened)
   *
   * When the user opens the agent interface. Including every tab and window.
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. numberOfInstances)
   * @param options Amplitude event options.
   */
  sharedWorkerTabOrWindowOpened(e, n) {
    return this.track(new nk(e), n);
  }
  /**
   * Sidebar Add Agent Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Add%20Agent%20Button%20Clicked)
   *
   * When the user clicks on add agent icon on sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarAddAgentButtonClicked(e) {
    return this.track(new rk(), e);
  }
  /**
   * Sidebar Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Collapsed)
   *
   * When the sidebar is collapsed
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarCollapsed(e) {
    return this.track(new ik(), e);
  }
  /**
   * Sidebar Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Expanded)
   *
   * When the sidebar is expanded
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  sidebarExpanded(e) {
    return this.track(new sk(), e);
  }
  /**
   * Sidebar Nav Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sidebar%20Nav%20Clicked)
   *
   * When the user clicks on a navigation link in the sidebar
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. item)
   * @param options Amplitude event options.
   */
  sidebarNavClicked(e, n) {
    return this.track(new ok(e), n);
  }
  /**
   * Sign Out Aborted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sign%20Out%20Aborted)
   *
   * When the user aborts signing out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  signOutAborted(e) {
    return this.track(new ak(), e);
  }
  /**
   * Sign Out Confirmed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Sign%20Out%20Confirmed)
   *
   * When the user confirms signing out
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  signOutConfirmed(e) {
    return this.track(new ck(), e);
  }
  /**
   * Simultaneous Ring Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Simultaneous%20Ring%20Updated)
   *
   * When the user updates their simultaneous ring status
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  simultaneousRingUpdated(e, n) {
    return this.track(new uk(e), n);
  }
  /**
   * Smart Conversation Reply Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Smart%20Conversation%20Reply%20Button%20Clicked)
   *
   * When the user clicks the Smart Conversation Reply" button from the Elevio or Dixa knowledge sidebar card"
   *
   * Owner: Chris Duell
   *
   * @param properties The event's properties (e.g. articleId)
   * @param options Amplitude event options.
   */
  smartConversationReplyButtonClicked(e, n) {
    return this.track(new lk(e), n);
  }
  /**
   * Subflow Back To Main Flow Node Reused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Back%20To%20Main%20Flow%20Node%20Reused)
   *
   * This happens when in the subflow editor, a user decides to instead of creating a new exit path, reuse an existing one by selecting it in the "return to main flow" node modal
   *
   * @param options Amplitude event options.
   */
  subflowBackToMainFlowNodeReused(e) {
    return this.track(new dk(), e);
  }
  /**
   * Subflow Back To Main Flow Node Used
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Back%20To%20Main%20Flow%20Node%20Used)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  subflowBackToMainFlowNodeUsed(e) {
    return this.track(new pk(), e);
  }
  /**
   * Subflow Created From Highlighted Nodes
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Created%20From%20Highlighted%20Nodes)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  subflowCreatedFromHighlightedNodes(e) {
    return this.track(new hk(), e);
  }
  /**
   * Subflow Created From Scratch
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Created%20From%20Scratch)
   *
   * When a subflow is created from scratch.
   *
   * @param options Amplitude event options.
   */
  subflowCreatedFromScratch(e) {
    return this.track(new vk(), e);
  }
  /**
   * Subflow Reused
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Subflow%20Reused)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  subflowReused(e) {
    return this.track(new gk(), e);
  }
  /**
   * Tag Select Create New Tag Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tag%20Select%20Create%20New%20Tag%20Clicked)
   *
   * When the user clicks on the inline tag creation item on the list to create a tag with the searched value
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. component)
   * @param options Amplitude event options.
   */
  tagSelectCreateNewTagClicked(e, n) {
    return this.track(new fk(e), n);
  }
  /**
   * Tags Create Modal Color Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Color%20Changed)
   *
   * When the user changes the tag color on Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. color)
   * @param options Amplitude event options.
   */
  tagsCreateModalColorChanged(e, n) {
    return this.track(new Ck(e), n);
  }
  /**
   * Tags Create Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. path)
   * @param options Amplitude event options.
   */
  tagsCreateModalFormSubmitted(e, n) {
    return this.track(new yk(e), n);
  }
  /**
   * Tags Create Modal Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Tags%20Create%20Modal%20Opened)
   *
   * When the user opens the Create new tag modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. path)
   * @param options Amplitude event options.
   */
  tagsCreateModalOpened(e, n) {
    return this.track(new mk(e), n);
  }
  /**
   * Team Agent Actions Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Actions%20Menu%20Item%20Clicked)
   *
   * When the user clicks the agent actions menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  teamAgentActionsMenuItemClicked(e, n) {
    return this.track(new kk(e), n);
  }
  /**
   * Team Agent Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Actions%20Menu%20Opened)
   *
   * When the user opens the agent actions menu
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamAgentActionsMenuOpened(e) {
    return this.track(new wk(), e);
  }
  /**
   * Team Agent Collapsed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Collapsed)
   *
   * When the user collapsed the agent item
   *
   * @param options Amplitude event options.
   */
  teamAgentCollapsed(e) {
    return this.track(new _k(), e);
  }
  /**
   * Team Agent Expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Agent%20Expanded)
   *
   * When the user expands the agent item
   *
   * @param options Amplitude event options.
   */
  teamAgentExpanded(e) {
    return this.track(new Sk(), e);
  }
  /**
   * Team Assigned Agents Only Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Assigned%20Agents%20Only%20Clicked)
   *
   * When the user clicks the Assigned Agents Only button
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamAssignedAgentsOnlyClicked(e) {
    return this.track(new bk(), e);
  }
  /**
   * Team Conversation Actions Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Actions%20Menu%20Item%20Clicked)
   *
   * When the user clicks the conversation actions menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  teamConversationActionsMenuItemClicked(e, n) {
    return this.track(new Ak(e), n);
  }
  /**
   * Team Conversation Actions Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Actions%20Menu%20Opened)
   *
   * When the user opens the conversation actions menu
   *
   * @param options Amplitude event options.
   */
  teamConversationActionsMenuOpened(e) {
    return this.track(new Ik(), e);
  }
  /**
   * Team Conversation Status Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Status%20Link%20Clicked)
   *
   * When the user clicks the status link in the conversation
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamConversationStatusLinkClicked(e) {
    return this.track(new Tk(), e);
  }
  /**
   * Team Conversation Title Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Conversation%20Title%20Link%20Clicked)
   *
   * When the user clicks the title link in the conversation
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamConversationTitleLinkClicked(e) {
    return this.track(new Ek(), e);
  }
  /**
   * Team Favorite Toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Favorite%20Toggled)
   *
   * When the user toggles the favorite agent
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  teamFavoriteToggled(e, n) {
    return this.track(new Ok(e), n);
  }
  /**
   * Team Filter Menu Item Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Filter%20Menu%20Item%20Clicked)
   *
   * When the user clicks the filter menu item
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  teamFilterMenuItemClicked(e, n) {
    return this.track(new Pk(e), n);
  }
  /**
   * Team Filter Menu Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Filter%20Menu%20Opened)
   *
   * When the user opens the filter agents menu
   *
   * @param options Amplitude event options.
   */
  teamFilterMenuOpened(e) {
    return this.track(new Rk(), e);
  }
  /**
   * Team Next Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Next%20Page%20Clicked)
   *
   * When the user clicks the next page on the Team page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamNextPageClicked(e) {
    return this.track(new Mk(), e);
  }
  /**
   * Team Previous Page Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Team%20Previous%20Page%20Clicked)
   *
   * When the user clicks the previous page on the Team page
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  teamPreviousPageClicked(e) {
    return this.track(new Fk(), e);
  }
  /**
   * Topbar Beamer Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Beamer%20Opened)
   *
   * When Beamer is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarBeamerOpened(e) {
    return this.track(new Dk(), e);
  }
  /**
   * Topbar Email Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Email%20Opened)
   *
   * When the email dropdown in the topbar is opened
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarEmailOpened(e) {
    return this.track(new Uk(), e);
  }
  /**
   * Topbar Notifications Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Notifications%20Opened)
   *
   * When the notifications dropdown is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarNotificationsOpened(e) {
    return this.track(new Lk(), e);
  }
  /**
   * Topbar Phones Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Phones%20Opened)
   *
   * When the phones dropdown in the topbar is opened
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarPhonesOpened(e) {
    return this.track(new Nk(), e);
  }
  /**
   * Topbar Search Quick Action Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Search%20Quick%20Action%20Clicked)
   *
   * When the user clicks on a quick action in the topbar search field
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  topbarSearchQuickActionClicked(e, n) {
    return this.track(new Vk(e), n);
  }
  /**
   * Topbar Support Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Topbar%20Support%20Opened)
   *
   * When the support menu is opened from the topbar
   *
   * Owner: hac@dixa.com
   *
   * @param options Amplitude event options.
   */
  topbarSupportOpened(e) {
    return this.track(new Bk(), e);
  }
  /**
   * User Modal Form Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/User%20Modal%20Form%20Submitted)
   *
   * When the user submits the form on user modal
   *
   * Owner: hac@dixa.com
   *
   * @param properties The event's properties (e.g. company)
   * @param options Amplitude event options.
   */
  userModalFormSubmitted(e, n) {
    return this.track(new Hk(e), n);
  }
  /**
   * User Modal Role Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/User%20Modal%20Role%20Changed)
   *
   * When the user changes the role of a user in the user modal
   *
   * @param properties The event's properties (e.g. after)
   * @param options Amplitude event options.
   */
  userModalRoleChanged(e, n) {
    return this.track(new Wk(e), n);
  }
  /**
   * User Modal User Type Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/User%20Modal%20User%20Type%20Changed)
   *
   * When the user changes the type of a user in the user modal
   *
   * @param properties The event's properties (e.g. after)
   * @param options Amplitude event options.
   */
  userModalUserTypeChanged(e, n) {
    return this.track(new xk(e), n);
  }
  /**
   * Websocket Active Connection Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Active%20Connection%20Changed)
   *
   * When the active websocket connection changes
   *
   * @param properties The event's properties (e.g. newConnectionId)
   * @param options Amplitude event options.
   */
  websocketActiveConnectionChanged(e, n) {
    return this.track(new Qk(e), n);
  }
  /**
   * Websocket Close Event Received
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Close%20Event%20Received)
   *
   * When the websocket receives a close event
   *
   * @param properties The event's properties (e.g. code)
   * @param options Amplitude event options.
   */
  websocketCloseEventReceived(e, n) {
    return this.track(new Kk(e), n);
  }
  /**
   * Websocket Connection Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Connection%20Closed)
   *
   * When the websocket connection is created
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  websocketConnectionClosed(e, n) {
    return this.track(new Gk(e), n);
  }
  /**
   * Websocket Connection Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Connection%20Created)
   *
   * When the websocket connection is closed
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  websocketConnectionCreated(e, n) {
    return this.track(new qk(e), n);
  }
  /**
   * Websocket Reconnect Attempt Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/dixa/Dixa%20Agent-Interface/events/main/latest/Websocket%20Reconnect%20Attempt%20Started)
   *
   * When the websocket reconnect attempt starts
   *
   * @param properties The event's properties (e.g. count)
   * @param options Amplitude event options.
   */
  websocketReconnectAttemptStarted(e, n) {
    return this.track(new zk(e), n);
  }
}
const yn = new $k();
function Yk(t, e, n) {
  if (!yn.isLoaded)
    return { promise: Promise.resolve() };
  const r = new ge();
  if (n)
    for (const [s, o] of Object.entries(n))
      o != null && r.set(s, o);
  return yn.client.groupIdentify(t, e, r);
}
export {
  fa as AddAgentsModalFormSubmitted,
  Ca as AgentCopilotBackButtonClicked,
  ya as AgentCopilotDropdownItemClicked,
  ma as AgentCopilotImproveWritingImprovementClicked,
  ka as AgentCopilotTextInsertBelowClicked,
  wa as AgentCopilotTextReplaceClicked,
  _a as AgentCopilotTranslateMessageLanguageSelected,
  Sa as AgentCopilotTrialLearnMoreClicked,
  ba as AgentCopilotTrialLeftmenuCtaClicked,
  Aa as AgentCopilotTrialLeftmenuCtaDismissed,
  Ia as AgentCopilotTrialRequestContactClicked,
  Ta as AgentCopilotTrialStarted,
  Ea as AgentCopilotTrialStopped,
  Oa as AgentCopilotUndoClicked,
  Pa as AgentCustomAwayStatusUpdated,
  $k as Ampli,
  Ra as AnalyticsBusinessHoursScheduleRemoved,
  Ma as AnalyticsBusinessHoursScheduleUpdated,
  Fa as AnalyticsChartGranularityChanged,
  Da as AnalyticsChartVisualizationChanged,
  Ua as AnalyticsCompareClicked,
  La as AnalyticsCompareContextUpdated,
  Na as AnalyticsComparePeriodUpdated,
  Va as AnalyticsContextUpdated,
  Ba as AnalyticsConversationLinkClicked,
  Ha as AnalyticsConversationPreviewClicked,
  Wa as AnalyticsDashboardViewed,
  xa as AnalyticsExportClicked,
  Qa as AnalyticsExportDownloadClicked,
  Ka as AnalyticsExportMyDataButtonPressed,
  Ga as AnalyticsFilterCleared,
  qa as AnalyticsFilterOpened,
  za as AnalyticsFilterOperatorUpdated,
  $a as AnalyticsFilterValueAdded,
  ja as AnalyticsFiltersApplied,
  Ja as AnalyticsFiltersCleared,
  Ya as AnalyticsHelperClicked,
  Xa as AnalyticsInDepthClicked,
  Za as AnalyticsInsightsCopyClicked,
  ec as AnalyticsInsightsFeedbackClicked,
  tc as AnalyticsInsightsPromptClicked,
  nc as AnalyticsInsightsRegenerateClicked,
  rc as AnalyticsPanelControlsOpened,
  ic as AnalyticsPeriodUpdated,
  sc as AnalyticsPinPanelClicked,
  oc as AnalyticsPinPanelQuickViewCreated,
  ac as AnalyticsQuickViewAutoRefreshDisabled,
  cc as AnalyticsQuickViewAutoRefreshEnabled,
  uc as AnalyticsQuickViewAutoRefreshTriggered,
  lc as AnalyticsQuickViewCreated,
  dc as AnalyticsQuickViewDeleted,
  pc as AnalyticsQuickViewDuplicated,
  hc as AnalyticsQuickViewFavoriteToggled,
  vc as AnalyticsQuickViewLandingPageSet,
  gc as AnalyticsQuickViewLandingPageUnset,
  fc as AnalyticsQuickViewOwnershipTransferred,
  Cc as AnalyticsQuickViewPanelControlsUpdated,
  yc as AnalyticsQuickViewPanelDescriptionUpdated,
  mc as AnalyticsQuickViewPanelPinned,
  kc as AnalyticsQuickViewPanelUnpinned,
  wc as AnalyticsQuickViewPanelsLayoutChanged,
  _c as AnalyticsQuickViewPanelsReset,
  Sc as AnalyticsQuickViewPanelsUpdated,
  bc as AnalyticsQuickViewSharingToggled,
  Ac as AnalyticsQuickViewUpdated,
  Ic as AnalyticsQuickViewViewed,
  Tc as AnalyticsRefreshClicked,
  Ec as AnalyticsTableLoadAllClicked,
  Oc as AnalyticsTableSortUpdated,
  Pc as AnalyticsTimezoneUpdated,
  Rc as AnalyticsViewConversationsClicked,
  va as ApiKey,
  Mc as AuthFailedInit,
  Fc as AutomationsFlowOptionsMenuOptionAuditLogClicked,
  Dc as AutomationsFormCancelled,
  Uc as AutomationsFormOpened,
  Lc as AutomationsFormSubmitted,
  Nc as AutomationsOptionsMenuOpened,
  Vc as AutomationsOptionsMenuOptionDeleteClicked,
  Bc as AutomationsOptionsMenuOptionDuplicateClicked,
  Hc as AutomationsOptionsMenuOptionFlowClicked,
  Wc as AutomationsOptionsMenuOptionSettingsClicked,
  xc as AutomationsPaginationNextClicked,
  Qc as AutomationsPaginationPreviousClicked,
  Kc as AutomationsSearchApplied,
  Gc as AutomationsSearchClosed,
  qc as AutomationsSearchOpened,
  zc as AutomationsToggledOff,
  $c as AutomationsToggledOn,
  jc as BansBanUserClicked,
  Jc as BansUnbanIpClicked,
  Yc as BansUnbanUserClicked,
  Xc as BulkActionsUpdateClicked,
  Zc as BusinessHoursAddScheduleAudioMessageAdded,
  eu as BusinessHoursAddScheduleButtonClicked,
  tu as BusinessHoursAddScheduleFormCancelled,
  nu as BusinessHoursAddScheduleFormSubmitted,
  ru as BusinessHoursConflictNotificationButtonClicked,
  iu as BusinessHoursConflictNotificationClosed,
  su as BusinessHoursDeleteScheduleFormCancelled,
  ou as BusinessHoursDeleteScheduleFormSubmitted,
  au as BusinessHoursDuplicateScheduleFormCancelled,
  cu as BusinessHoursDuplicateScheduleFormSubmitted,
  uu as BusinessHoursFirstScheduleModalQuestionClicked,
  lu as BusinessHoursFirstScheduleSupportArticleClicked,
  du as BusinessHoursGoToFlowClicked,
  pu as BusinessHoursMigrationWizardAudioMessageAdded,
  hu as BusinessHoursMigrationWizardCreateNewScheduleButtonClicked,
  vu as BusinessHoursMigrationWizardEditHoursButtonClicked,
  gu as BusinessHoursMigrationWizardFormCancelled,
  fu as BusinessHoursMigrationWizardFormSubmitted,
  Cu as BusinessHoursMigrationWizardOpeningHoursFormCancelled,
  yu as BusinessHoursMigrationWizardOpeningHoursFormSubmitted,
  mu as BusinessHoursMigrationWizardStartUpdateButtonClicked,
  ku as BusinessHoursOptionsMenuOpened,
  wu as BusinessHoursOptionsMenuOptionDeleteClicked,
  _u as BusinessHoursOptionsMenuOptionDuplicateClicked,
  Su as BusinessHoursOptionsMenuOptionEditClicked,
  bu as BusinessHoursOptionsMenuOptionRenameClicked,
  Au as BusinessHoursRenameScheduleFormCancelled,
  Iu as BusinessHoursRenameScheduleFormSubmitted,
  Tu as BusinessHoursScheduleAddExceptionButtonClicked,
  Eu as BusinessHoursScheduleAddExceptionFormCancelled,
  Ou as BusinessHoursScheduleAddExceptionFormSubmitted,
  Pu as BusinessHoursScheduleAudioMessageFormCancelled,
  Ru as BusinessHoursScheduleAudioMessageFormSubmitted,
  Mu as BusinessHoursScheduleAudioMessageOptionsMenuOpened,
  Fu as BusinessHoursScheduleAudioMessageOptionsMenuOptionClearClicked,
  Du as BusinessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked,
  Uu as BusinessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked,
  Lu as BusinessHoursScheduleAutoReplyOptionsMenuOptionClearClicked,
  Nu as BusinessHoursScheduleConflictChangeButtonClicked,
  Vu as BusinessHoursScheduleConflictReviewButtonClicked,
  Bu as BusinessHoursScheduleDeleteExceptionFormCancelled,
  Hu as BusinessHoursScheduleDeleteExceptionFormSubmitted,
  Wu as BusinessHoursScheduleExceptionOptionsMenuOptionDeleteClicked,
  xu as BusinessHoursScheduleImportHolidayFormCancelled,
  Qu as BusinessHoursScheduleImportHolidayFormSubmitted,
  Ku as BusinessHoursScheduleOptionsMenuImportHolidaysClicked,
  Gu as BusinessHoursScheduleOptionsMenuOpened,
  qu as BusinessHoursScheduleOptionsMenuRecoverHolidaysClicked,
  zu as BusinessHoursScheduleOptionsMenuRenameClicked,
  $u as BusinessHoursScheduleOptionsMenuTimezoneClicked,
  ju as BusinessHoursSchedulePreviewButtonClicked,
  Ju as BusinessHoursScheduleRecoverHolidaysFormCancelled,
  Yu as BusinessHoursScheduleRecoverHolidaysFormSubmitted,
  Xu as BusinessHoursScheduleReviewFormCancelled,
  Zu as BusinessHoursScheduleReviewFormSubmitted,
  el as BusinessHoursScheduleSaveScheduleButtonClicked,
  tl as BusinessHoursScheduleTabClicked,
  nl as BusinessHoursScheduleViewClicked,
  rl as ChatFlowOptionsMenuOptionAuditLogClicked,
  il as ChatFormCanceled,
  sl as ChatFormOpened,
  ol as ChatFormSubmitted,
  al as ChatOptionsMenuOpened,
  cl as ChatOptionsMenuOptionDeleteClicked,
  ul as ChatOptionsMenuOptionDuplicateClicked,
  ll as ChatOptionsMenuOptionFlowClicked,
  dl as ChatOptionsMenuOptionRenameClicked,
  pl as ChatOptionsMenuOptionSetupClicked,
  hl as ChatPaginationNextClicked,
  vl as ChatPaginationPreviousClicked,
  gl as ChatSearchApplied,
  fl as ChatSearchClosed,
  Cl as ChatSearchOpened,
  yl as ChatbotCreateModalOpened,
  ml as ChatbotCreated,
  kl as ChatbotDeleteModalOpened,
  wl as ChatbotDeleted,
  _l as ChatbotEditIdentityModalOpened,
  Sl as ChatbotIdentityEdited,
  bl as ColorModeUpdated,
  Al as CommandExecuted,
  Il as CompanyModalFormSubmitted,
  Tl as ContactsAddNewCompanyClicked,
  El as ContactsAddNewContactClicked,
  Ol as ContactsBanUserClicked,
  Pl as ContactsCardActionsMenuOpened,
  Rl as ContactsCardComposeNewEmailClicked,
  Ml as ContactsCardEditCompanyClicked,
  Fl as ContactsCardEditContactClicked,
  Dl as ContactsCardMakeCallClicked,
  Ul as ContactsCardSeeAllAssignedConversationsClicked,
  Ll as ContactsCardSeeAllConversationsClicked,
  Nl as ContactsCardViewCompanyClicked,
  Vl as ContactsCardViewUserClicked,
  Bl as ContactsSearchBlurred,
  Hl as ContactsSearchFocused,
  Wl as ContactsUnbanUserClicked,
  xl as ContactsViewCompanies,
  Ql as ContactsViewEndUsers,
  Kl as ConversationActionsMenuOpened,
  Gl as ConversationActionsMenuOptionClicked,
  ql as ConversationActivityLogClosed,
  zl as ConversationActivityLogFlooterExpanded,
  $l as ConversationActivityLogOpened,
  jl as ConversationArticleDraftImprovementRequested,
  Jl as ConversationArticleDraftImprovementResponseReceived,
  Yl as ConversationArticleDraftPreviewRequested,
  Xl as ConversationArticleDraftPreviewResponseReceived,
  Zl as ConversationArticleDraftSaveRequested,
  ed as ConversationArticleDraftSaveResponseReceived,
  td as ConversationAttachedImageIsDownloaded,
  nd as ConversationAttachedImageIsViewed,
  rd as ConversationClaimed,
  id as ConversationClosed,
  sd as ConversationCsatCancelled,
  od as ConversationCsatMenuCancelOptionClicked,
  ad as ConversationCsatMenuLanguageSelected,
  cd as ConversationCsatMenuOpened,
  ud as ConversationFocusModeToggled,
  ld as ConversationFollowUp,
  dd as ConversationFollowUpMenuOpened,
  pd as ConversationFollowUpMenuOptionClicked,
  hd as ConversationHeaderConversationDetailsMenuOpened,
  vd as ConversationHeaderTagAdded,
  gd as ConversationHeaderTagIncludeDeactivatedToggled,
  fd as ConversationHeaderTagMenuOpened,
  Cd as ConversationHeaderTagRemoved,
  yd as ConversationHeaderTransferToAgentItemSelected,
  md as ConversationHeaderTransferToAgentMenuOpened,
  kd as ConversationHeaderTransferToNumberButtonClicked,
  wd as ConversationHeaderTransferToQueueItemSelected,
  _d as ConversationHeaderTransferToQueueMenuOpened,
  Sd as ConversationInternalNoteEditorOpened,
  bd as ConversationOffered,
  Ad as ConversationReplied,
  Id as ConversationResolvedAsAKnowledgeArticleDraft,
  Td as ConversationResolvedAsAKnowledgeGap,
  Ed as ConversationResolvedByKnowledge,
  Od as ConversationResolvedWithNoKnowledgeArticle,
  Pd as ConversationSidebarClosed,
  Rd as ConversationSidebarConversationHistoryClosed,
  Md as ConversationSidebarConversationHistoryNavigatedToConversation,
  Fd as ConversationSidebarConversationHistoryOpened,
  Dd as ConversationSidebarCustomerInfoEmailClicked,
  Ud as ConversationSidebarCustomerInfoPhoneNumberClicked,
  Ld as ConversationSidebarOpened,
  rp as ConversationSummaryFeedbackNotUseful,
  ip as ConversationSummaryFeedbackUseful,
  sp as ConversationSummaryRegenerateSummary,
  Nd as ConversationTimelineItemOpened,
  Vd as ConversationTimelineNavigatedToConversation,
  Bd as ConversationTransferred,
  Hd as ConversationsBulkActionsClicked,
  Wd as ConversationsClearAllClicked,
  xd as ConversationsFilterAgentClicked,
  Qd as ConversationsFilterClearAllClicked,
  Kd as ConversationsFilterCleared,
  Gd as ConversationsFilterContactClicked,
  qd as ConversationsFilterToggled,
  zd as ConversationsGoToConversationClicked,
  $d as ConversationsItemPreviewClicked,
  jd as ConversationsNextPageClicked,
  Jd as ConversationsPreviousPageClicked,
  Yd as ConversationsSelectAllClicked,
  Xd as ConversationsSelectClicked,
  Zd as ConversationsTimestampClicked,
  ep as ConversationsTransferToQueueClicked,
  tp as ConversationsViewAgentClicked,
  np as ConversationsViewContactClicked,
  op as CopyScript,
  ap as CountryCodeSelected,
  cp as CustomAttributeValueUpdated,
  up as DashboardChannelAllConversationsClicked,
  lp as DashboardChannelGoToAnalyticsClicked,
  dp as DashboardChannelLongestQueuedTimeMetricClicked,
  pp as DashboardChannelNameClicked,
  hp as DashboardChannelPendingConversationsMetricClicked,
  vp as DashboardChannelTvDashboardClicked,
  gp as DashboardGlobalTvDashboardClicked,
  fp as DashboardLayoutChanged,
  Cp as DashboardLongestQueuedTimeMetricClicked,
  yp as DashboardMetricHelperClicked,
  mp as DashboardNextPageClicked,
  kp as DashboardOrganizationTimezoneSettingsClicked,
  wp as DashboardPreviousPageClicked,
  _p as DashboardQueueAllConversationsClicked,
  Sp as DashboardQueueGoToAnalyticsClicked,
  bp as DashboardQueueItemFavoriteToggled,
  Ap as DashboardQueueNameClicked,
  Ip as DashboardQueuePendingConversationsMetricClicked,
  Tp as DashboardQueueSettingsClicked,
  Ep as DashboardQueueTvDashboardClicked,
  Op as DashboardQueuesManuallySelected,
  Pp as DashboardQueuesSearchFieldCleared,
  Rp as DashboardQueuesSearchFieldSubmitted,
  Mp as DashboardQueuesSortingUpdated,
  Fp as DashboardQueuesTypeChanged,
  Dp as DashboardRefreshDataClicked,
  Up as DashboardTvReloaded,
  Lp as DashboardViewed,
  ga as DefaultConfiguration,
  Np as EmailFlowOptionsMenuOptionAuditLogClicked,
  Vp as EmailFormSubmitted,
  Bp as EmailOptionsMenuOpened,
  Hp as EmailOptionsMenuOptionDeleteClicked,
  Wp as EmailOptionsMenuOptionDuplicateClicked,
  xp as EmailOptionsMenuOptionEmailClicked,
  Qp as EmailOptionsMenuOptionFlowClicked,
  Kp as EmailOptionsMenuOptionRenameClicked,
  Gp as EmailSearchApplied,
  qp as EmailSearchClosed,
  zp as EmailSearchOpened,
  $p as FlowActionAddSaved,
  jp as FlowActionConditionAdded,
  Jp as FlowActionConditionRemoved,
  Yp as FlowActionDeleted,
  Xp as FlowActionEditClicked,
  Zp as FlowActionEditSaved,
  eh as FlowActivateClicked,
  th as FlowAddActionActionSelected,
  nh as FlowAddActionCancelled,
  rh as FlowAddActionOpened,
  ih as FlowBackToSettingsClicked,
  sh as FlowContextAlignClicked,
  oh as FlowContextDeleteCancelClicked,
  ah as FlowContextDeleteClicked,
  ch as FlowContextDeleteConfirmClicked,
  uh as FlowContextNodeArrangeClicked,
  lh as FlowPhoneNumberChanged,
  dh as FlowSaveClicked,
  ph as FlowTitleEditClicked,
  hh as FlowZoomInClicked,
  vh as FlowZoomOutClicked,
  gh as FlowZoomResetClicked,
  fh as FollowUpConversationModalInternalNoteAdded,
  Ch as FollowUpConversationModalOfferInQueueAdded,
  Jk as Identify,
  yh as IntelligenceDistributionChartOpened,
  mh as IntelligenceEvolutionChartOpened,
  kh as IntelligenceFilterChanged,
  wh as IntelligenceFilterPeriodChanged,
  _h as IntelligenceGroupByChanged,
  Sh as IntelligencePresetComparisonStarted,
  bh as IntelligenceTableCustomized,
  Ah as IntentDetectionCreated,
  Ih as IntentDetectionDeleted,
  Th as IntentDetectionFlowNodeSaved,
  Eh as IntentDetectionUpdated,
  Oh as KnowledgeArticleArchived,
  Ph as KnowledgeArticleChangesDiscarded,
  Rh as KnowledgeArticleCreated,
  Mh as KnowledgeArticleDestroyed,
  Fh as KnowledgeArticleFeedbackSubmitted,
  Dh as KnowledgeArticleMarkedAsHelpful,
  Uh as KnowledgeArticleMoved,
  Lh as KnowledgeArticlePublished,
  Nh as KnowledgeArticleReordered,
  Vh as KnowledgeArticleTagAdded,
  Bh as KnowledgeArticleTagRemoved,
  Hh as KnowledgeArticleUnpublished,
  Wh as KnowledgeArticleUpdated,
  xh as KnowledgeArticleViewed,
  Qh as KnowledgeArticlesSearchByTermSubmitted,
  Kh as KnowledgeCategoryCreated,
  Gh as KnowledgeCategoryDestroyed,
  qh as KnowledgeCategoryReordered,
  zh as KnowledgeCategoryUpdated,
  $h as KnowledgeCollectionCreated,
  jh as KnowledgeCollectionDestroyed,
  Jh as KnowledgeCollectionUpdated,
  Yh as KnowledgeCollectionViewed,
  Xh as KnowledgeHelpCenterCreated,
  Zh as KnowledgeHelpCenterDeleted,
  ev as KnowledgeHelpCenterUpdated,
  tv as KnowledgeInternalKbDashboardViewed,
  nv as KnowledgeInternalKbSearchResultClicked,
  rv as KnowledgeResolutionCancelled,
  iv as KnowledgeResolutionInitialised,
  sv as LinkConversationsModalOpened,
  ov as LinkConversationsSubmitted,
  av as MentionUserNotificationClicked,
  cv as MentionUserSelected,
  uv as MergeContactsMergeCancelled,
  lv as MergeContactsMergeFailed,
  dv as MergeContactsMergeSucceeded,
  pv as MergeContactsModalClosed,
  hv as MergeContactsModalOpened,
  vv as MergeContactsSourceContactSelected,
  gv as MessengerFlowOptionsMenuOptionAuditLogClicked,
  fv as MessengerFormCancelled,
  Cv as MessengerFormOpened,
  yv as MessengerFormSubmitted,
  mv as MessengerOptionsMenuOpened,
  kv as MessengerOptionsMenuOptionClicked,
  wv as ModalConversationCloseCancelClicked,
  _v as ModalConversationCloseConfirmClicked,
  Sv as ModalTransferToQueueCancelClicked,
  bv as ModalTransferToQueueConfirmClicked,
  Av as NetworkConnectionStatusChanged,
  Iv as NotificationOfferAccepted,
  Tv as NotificationOfferClosed,
  Ev as NotificationOfferRejected,
  Ov as NotificationOfferTimeout,
  Pv as NotificationTransferOfferAccepted,
  Rv as NotificationTransferOfferClosed,
  Mv as NotificationTransferOfferRejected,
  Fv as NotificationTransferOfferTimeout,
  Dv as OrganizationsNavigationOrganizationClicked,
  Uv as PartnerIntegrationsBrazeProfileReceived,
  Lv as PartnerIntegrationsBrazeSubscriptionEmailOptInSucceeded,
  Nv as PartnerIntegrationsBrazeSubscriptionEmailUnsubscribedSucceeded,
  Vv as PartnerIntegrationsGithubCreateNewIssueCanceled,
  Bv as PartnerIntegrationsGithubCreateNewIssueClicked,
  Hv as PartnerIntegrationsGithubCreateNewIssueConfirmed,
  Wv as PartnerIntegrationsGithubLinkIssueClicked,
  xv as PartnerIntegrationsGithubUnlinkAllIssuesCanceled,
  Qv as PartnerIntegrationsGithubUnlinkAllIssuesClicked,
  Kv as PartnerIntegrationsGithubUnlinkAllIssuesConfirmed,
  Gv as PartnerIntegrationsGithubUnlinkIssueCanceled,
  qv as PartnerIntegrationsGithubUnlinkIssueClicked,
  zv as PartnerIntegrationsGithubUnlinkIssueConfirmed,
  $v as PartnerIntegrationsGithubViewLinkClicked,
  jv as PartnerIntegrationsJiraCommentsCollapsed,
  Jv as PartnerIntegrationsJiraCommentsExpanded,
  Yv as PartnerIntegrationsJiraCreateIssueFailed,
  Xv as PartnerIntegrationsJiraCreateIssueSucceeded,
  Zv as PartnerIntegrationsJiraLinkIssueClicked,
  eg as PartnerIntegrationsJiraOpenIssueClicked,
  tg as PartnerIntegrationsJiraOpenJiraClicked,
  ng as PartnerIntegrationsJiraRemoveAllDanglingClicked,
  rg as PartnerIntegrationsJiraRemoveDanglingIssueClicked,
  ig as PartnerIntegrationsJiraUnlinkAllIssuesCancelled,
  sg as PartnerIntegrationsJiraUnlinkAllIssuesClicked,
  og as PartnerIntegrationsJiraUnlinkAllIssuesConfirmed,
  ag as PartnerIntegrationsJiraUnlinkIssueCancelled,
  cg as PartnerIntegrationsJiraUnlinkIssueClicked,
  ug as PartnerIntegrationsJiraUnlinkIssueConfirmed,
  lg as PartnerIntegrationsKlaviyoMessagesReceived,
  dg as PartnerIntegrationsKlaviyoProfileFailed,
  pg as PartnerIntegrationsKlaviyoProfileReceived,
  hg as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked,
  vg as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed,
  gg as PartnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded,
  fg as PartnerIntegrationsKlaviyoProfileUnsubscribeClicked,
  Cg as PartnerIntegrationsKlaviyoProfileUnsubscribeFailed,
  yg as PartnerIntegrationsKlaviyoProfileUnsubscribeSucceeded,
  mg as PartnerIntegrationsLinearCreateNewIssueCancelled,
  kg as PartnerIntegrationsLinearCreateNewIssueClicked,
  wg as PartnerIntegrationsLinearCreateNewIssueConfirmed,
  _g as PartnerIntegrationsLinearLinkIssueClicked,
  Sg as PartnerIntegrationsLinearOpenIssueClicked,
  bg as PartnerIntegrationsLinearOpenLinearClicked,
  Ag as PartnerIntegrationsLinearUnlinkIssueClicked,
  Ig as PartnerIntegrationsRechargeWidgetCustomerOverviewOpened,
  Tg as PartnerIntegrationsRechargeWidgetOrderOpened,
  Eg as PartnerIntegrationsRechargeWidgetOrdersListOpened,
  Og as PartnerIntegrationsRechargeWidgetProfileReceived,
  Pg as PartnerIntegrationsSettingsCreateSubmitted,
  Rg as PartnerIntegrationsSettingsOverviewCreated,
  Mg as PartnerIntegrationsSettingsOverviewViewed,
  Fg as PartnerIntegrationsSettingsViewDeleteCanceled,
  Dg as PartnerIntegrationsSettingsViewDeleteConfirmed,
  Ug as PartnerIntegrationsSettingsViewDeleteRequested,
  Lg as PartnerIntegrationsSettingsViewOAuthStarted,
  Ng as PartnerIntegrationsSettingsViewOAuthSucceeded,
  Vg as PartnerIntegrationsSettingsViewSubmitted,
  Bg as PartnerIntegrationsShopifyWidgetDiscountCodeCreated,
  Hg as PartnerIntegrationsShopifyWidgetOrderCancelled,
  Wg as PartnerIntegrationsShopifyWidgetOrderCollapseClosed,
  xg as PartnerIntegrationsShopifyWidgetOrderCollapseOpened,
  Qg as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled,
  Kg as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened,
  Gg as PartnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted,
  qg as PartnerIntegrationsShopifyWidgetOrderRefundCanceled,
  zg as PartnerIntegrationsShopifyWidgetOrderRefundConfirmed,
  $g as PartnerIntegrationsShopifyWidgetOrderRefundRequested,
  jg as PartnerIntegrationsShopifyWidgetOrderTagsUpdated,
  Jg as PartnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked,
  Yg as PartnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked,
  Xg as PartnerIntegrationsShopifyWidgetProfileCreated,
  Zg as PartnerIntegrationsShopifyWidgetRefreshed,
  ef as PartnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked,
  tf as PartnerIntegrationsVoyadoWidgetChannelSubscriptionClicked,
  nf as PartnerIntegrationsVoyadoWidgetChannelSubscriptionFailed,
  rf as PartnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded,
  sf as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked,
  of as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed,
  af as PartnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded,
  cf as PartnerIntegrationsVoyadoWidgetMessageExternalLinkOpened,
  uf as PartnerIntegrationsVoyadoWidgetMessagesReceived,
  lf as PartnerIntegrationsVoyadoWidgetOrdersReceived,
  df as PartnerIntegrationsVoyadoWidgetProfileReceived,
  pf as PartnerIntegrationsVoyadoWidgetTransactionsReceived,
  hf as PartnerIntegrationsWidgetCollapseClosed,
  vf as PartnerIntegrationsWidgetCollapseOpened,
  gf as PartnerIntegrationsWidgetLoyaltyLionAddPointsFailed,
  ff as PartnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded,
  Cf as PartnerIntegrationsWidgetLoyaltyLionCustomerReceived,
  yf as PartnerIntegrationsWidgetLoyaltyLionRemovePointsFailed,
  mf as PartnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded,
  kf as PartnerIntegrationsWidgetVoyadoUpdatePointsFailed,
  wf as PartnerIntegrationsWidgetVoyadoUpdatePointsSucceeded,
  _f as PhoneActionsMenuActionAddOutboundCallerIdClicked,
  Sf as PhoneActionsMenuActionChangeHoldMusicClicked,
  bf as PhoneActionsMenuOpened,
  Af as PhoneAddOutboundCallerIdFormCancelled,
  If as PhoneAddOutboundCallerIdFormSubmitted,
  Tf as PhoneChangeHoldMusicFormCancelled,
  Ef as PhoneChangeHoldMusicFormSubmitted,
  Of as PhoneCreateFlowFormCancelled,
  Pf as PhoneCreateFlowFormSubmitted,
  Rf as PhoneFlowOptionsMenuOptionAuditLogClicked,
  Mf as PhoneFlowOptionsMenuOptionDeleteClicked,
  Ff as PhoneFlowOptionsMenuOptionDuplicateClicked,
  Df as PhoneFlowOptionsMenuOptionEditClicked,
  Uf as PhoneFlowOptionsMenuOptionMoveToAnotherNumberClicked,
  Lf as PhoneFlowOptionsMenuOptionOpened,
  Nf as PhoneFlowOptionsMenuOptionRenameClicked,
  Vf as PhoneFormCancelled,
  Bf as PhoneFormOpened,
  Hf as PhoneFormSubmitted,
  Wf as PhoneOptionsMenuOpened,
  xf as PhoneOptionsMenuOptionCreateFlowClicked,
  Qf as PhoneOptionsMenuOptionEditClicked,
  Kf as PhoneOptionsMenuOptionRemoveNumberClicked,
  Gf as PhoneOptionsMenuOptionSetDefaultCallerIdClicked,
  qf as PhoneOptionsMenuOptionSetupClicked,
  zf as PhoneRecordingDownloaded,
  $f as PhoneRecordingPauseClicked,
  jf as PhoneRecordingPlayClicked,
  Jf as PhoneRecordingPlaybackAbandoned,
  Yf as PhoneRecordingPlaybackEnded,
  Xf as PhoneSearchApplied,
  Zf as PresenceListItemClicked,
  eC as PresenceMediaUpdated,
  tC as PresenceUpdated,
  nC as PushNotificationPlatformFormCancelled,
  rC as PushNotificationPlatformFormOpened,
  iC as PushNotificationPlatformFormSubmitted,
  sC as QuickRepliesOpened,
  oC as QuickReplyChosen,
  aC as QuickReplyFeedbackForRecommendedRepliesClicked,
  cC as QuickReplyFilterChosen,
  uC as QuickReplyLanguageSelected,
  lC as QuickReplyTemplateFavoriteToggled,
  dC as SavedSearchApplied,
  pC as SavedSearchClosed,
  hC as SavedSearchCreated,
  vC as SavedSearchDeleted,
  gC as SavedSearchUpdated,
  fC as ScheduledConversationsCsvImportClicked,
  CC as ScheduledConversationsCsvImported,
  yC as SearchContactPreviewClosed,
  mC as SearchContactPreviewGoToClicked,
  kC as SearchContactPreviewOpened,
  wC as SearchContactTypeChanged,
  _C as SearchConversationPreviewClosed,
  SC as SearchConversationPreviewGoToClicked,
  bC as SearchConversationPreviewOpened,
  AC as SearchFieldBlurred,
  IC as SearchFieldCleared,
  TC as SearchFieldFocused,
  EC as SearchFieldSubmitted,
  OC as SearchFilterConditionAdded,
  PC as SearchFilterConditionRemoved,
  RC as SearchFilterOperatorUpdated,
  MC as SearchFilterStrategyUpdated,
  FC as SearchFilterValueAdded,
  DC as SearchFilterValueCleared,
  UC as SearchFiltersApplied,
  LC as SearchFiltersCleared,
  NC as SearchFiltersClosed,
  VC as SearchFiltersOpened,
  BC as SearchFiltersValidationFailed,
  HC as SearchNotePreviewClosed,
  WC as SearchNotePreviewGoToClicked,
  xC as SearchNotePreviewOpened,
  QC as SearchSortingUpdated,
  KC as SearchStrictToggled,
  GC as SearchTabOpened,
  qC as SettingsAgentsAddAgentButtonClicked,
  zC as SettingsAgentsCustomWorkloadAssigned,
  $C as SettingsAgentsCustomWorkloadCreated,
  jC as SettingsAgentsCustomWorkloadDeleted,
  JC as SettingsAgentsEditButtonClicked,
  YC as SettingsAgentsTabClicked,
  XC as SettingsAgentsWorkloadsFormSubmitted,
  ZC as SettingsAudioDeleteCancelClicked,
  ey as SettingsAudioDeleteClicked,
  ty as SettingsAudioDeleteConfirmClicked,
  ny as SettingsAudioUsageFlowClicked,
  ry as SettingsAudioUsageLinkClicked,
  iy as SettingsCommandsAssignKeybindings,
  sy as SettingsCommandsResetAllKeybindings,
  oy as SettingsCommandsResetKeybindings,
  ay as SettingsCommandsUnassignAllKeybindings,
  cy as SettingsCommandsUnassignKeybindings,
  uy as SettingsCustomAttributeActivated,
  ly as SettingsCustomAttributeAddNewAttributeClicked,
  dy as SettingsCustomAttributeArchived,
  py as SettingsCustomAttributeCreated,
  hy as SettingsCustomAttributeDeactivated,
  vy as SettingsCustomAttributeReordered,
  gy as SettingsCustomAttributeUnarchived,
  fy as SettingsCustomAttributeUpdated,
  Cy as SettingsCustomAwayStatusAddNewClicked,
  yy as SettingsCustomAwayStatusArchived,
  my as SettingsCustomAwayStatusCreated,
  ky as SettingsCustomAwayStatusUnarchived,
  wy as SettingsCustomAwayStatusUpdated,
  _y as SettingsFormsEmbedUrlCopied,
  Sy as SettingsIntegrationsApiTokensAddConfirm,
  by as SettingsIntegrationsApiTokensCopy,
  Ay as SettingsIntegrationsApiTokensDocumentationLinkIntegrationsApi,
  Iy as SettingsIntegrationsApiTokensRemove,
  Ty as SettingsIntegrationsApiTokensRemoveCancel,
  Ey as SettingsIntegrationsApiTokensRemoveConfirm,
  Oy as SettingsIntegrationsApiTokensView,
  Py as SettingsIntegrationsCardEditSave,
  Ry as SettingsIntegrationsCardEditTest,
  My as SettingsIntegrationsCardListingAddCard,
  Fy as SettingsIntegrationsCardListingEditCard,
  Dy as SettingsIntegrationsCardListingRemoveCard,
  Uy as SettingsIntegrationsCardListingRemoveCardCancel,
  Ly as SettingsIntegrationsCardListingRemoveCardConfirm,
  Ny as SettingsIntegrationsCardListingTestCard,
  Vy as SettingsIntegrationsCardReadDocumentation,
  By as SettingsIntegrationsCardTest,
  Hy as SettingsIntegrationsCardTestAddParameter,
  Wy as SettingsIntegrationsCardTestRemoveParameter,
  xy as SettingsIntegrationsCustomCardCreated,
  Qy as SettingsIntegrationsCustomCardEdited,
  Ky as SettingsIntegrationsCustomCardOauthProviderAuthenticationFailed,
  Gy as SettingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded,
  qy as SettingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut,
  zy as SettingsIntegrationsCustomCardOauthProviderCreated,
  $y as SettingsIntegrationsCustomCardOauthProviderUpdated,
  jy as SettingsIntegrationsItemClicked,
  Jy as SettingsIntegrationsWebformEndpointsAddSave,
  Yy as SettingsIntegrationsWebformEndpointsCopy,
  Xy as SettingsIntegrationsWebformEndpointsReadDocumentationLink,
  Zy as SettingsIntegrationsWebformEndpointsRemove,
  em as SettingsIntegrationsWebformEndpointsRemoveCancel,
  tm as SettingsIntegrationsWebformEndpointsRemoveConfirm,
  nm as SettingsIntegrationsWebhooksAdd,
  rm as SettingsIntegrationsWebhooksAddConfirm,
  im as SettingsIntegrationsWebhooksDocumentationLinkClicked,
  sm as SettingsIntegrationsWebhooksEdit,
  om as SettingsIntegrationsWebhooksEditSave,
  am as SettingsIntegrationsWebhooksEnabledOff,
  cm as SettingsIntegrationsWebhooksEnabledOn,
  um as SettingsIntegrationsWebhooksRemove,
  lm as SettingsIntegrationsWebhooksRemoveCancel,
  dm as SettingsIntegrationsWebhooksRemoveConfirm,
  pm as SettingsIntegrationsWebhooksView,
  hm as SettingsIntegrationsWebhooksViewCopySecret,
  vm as SettingsIntegrationsWebhooksViewCopyUrl,
  gm as SettingsIntegrationsWebhooksViewEdit,
  fm as SettingsMenuItemClicked,
  Cm as SettingsOrganizationFormSubmitted,
  ym as SettingsOrganizationLogoChanged,
  mm as SettingsProfileFormSubmitted,
  km as SettingsQueueAdded,
  wm as SettingsQueueAgentDeleted,
  _m as SettingsQueueAgentSearchSubmitted,
  Sm as SettingsQueueAgentSorted,
  bm as SettingsQueueAlertsSaved,
  Am as SettingsQueueSaved,
  Im as SettingsQueueTeamsAddTeamButtonClicked,
  Tm as SettingsQueueTeamsAddTeamFormSubmitted,
  Em as SettingsQueueTeamsDeleteTeamButtonClicked,
  Om as SettingsQueuesAddQueueClicked,
  Pm as SettingsQueuesArchiveQueueClicked,
  Rm as SettingsQueuesEditQueueClicked,
  Mm as SettingsQueuesUnarchiveQueueClicked,
  Fm as SettingsRolesCustomRoleCreated,
  Dm as SettingsRolesCustomRoleDeleted,
  Um as SettingsRolesCustomRoleEdited,
  Lm as SettingsSummarizationSaveChangesClicked,
  Nm as SettingsSummarizationShowAutomaticallyClicked,
  Vm as SettingsSummarizationShowOnDemandClicked,
  Bm as SettingsTagsAddTagButtonClicked,
  Hm as SettingsTagsTagActivated,
  Wm as SettingsTagsTagDeactivated,
  xm as SettingsTeamAddTeamButtonClicked,
  Qm as SettingsTeamDetailsAddAgentsButtonClicked,
  Km as SettingsTeamEditTeamButtonClicked,
  Gm as SettingsTeamModalFormSubmitted,
  qm as SettingsTeamRemoveTeamButtonClicked,
  zm as SettingsTeamRemoveTeamConfirmed,
  $m as SettingsTemplatesAddTemplateButtonClicked,
  jm as SettingsTemplatesEditTemplateButtonClicked,
  Jm as SettingsTemplatesModalFormSubmitted,
  Ym as SettingsTemplatesRemoveTemplateButtonClicked,
  Xm as SettingsTemplatesRemoveTemplateConfirmed,
  Zm as SettingsTemplatesTabClicked,
  ek as SharedWorkerTabOrWindowChanged,
  tk as SharedWorkerTabOrWindowClosed,
  nk as SharedWorkerTabOrWindowOpened,
  rk as SidebarAddAgentButtonClicked,
  ik as SidebarCollapsed,
  sk as SidebarExpanded,
  ok as SidebarNavClicked,
  ak as SignOutAborted,
  ck as SignOutConfirmed,
  uk as SimultaneousRingUpdated,
  lk as SmartConversationReplyButtonClicked,
  dk as SubflowBackToMainFlowNodeReused,
  pk as SubflowBackToMainFlowNodeUsed,
  hk as SubflowCreatedFromHighlightedNodes,
  vk as SubflowCreatedFromScratch,
  gk as SubflowReused,
  fk as TagSelectCreateNewTagClicked,
  Ck as TagsCreateModalColorChanged,
  yk as TagsCreateModalFormSubmitted,
  mk as TagsCreateModalOpened,
  kk as TeamAgentActionsMenuItemClicked,
  wk as TeamAgentActionsMenuOpened,
  _k as TeamAgentCollapsed,
  Sk as TeamAgentExpanded,
  bk as TeamAssignedAgentsOnlyClicked,
  Ak as TeamConversationActionsMenuItemClicked,
  Ik as TeamConversationActionsMenuOpened,
  Tk as TeamConversationStatusLinkClicked,
  Ek as TeamConversationTitleLinkClicked,
  Ok as TeamFavoriteToggled,
  Pk as TeamFilterMenuItemClicked,
  Rk as TeamFilterMenuOpened,
  Mk as TeamNextPageClicked,
  Fk as TeamPreviousPageClicked,
  Dk as TopbarBeamerOpened,
  Uk as TopbarEmailOpened,
  Lk as TopbarNotificationsOpened,
  Nk as TopbarPhonesOpened,
  Vk as TopbarSearchQuickActionClicked,
  Bk as TopbarSupportOpened,
  Hk as UserModalFormSubmitted,
  Wk as UserModalRoleChanged,
  xk as UserModalUserTypeChanged,
  Qk as WebsocketActiveConnectionChanged,
  Kk as WebsocketCloseEventReceived,
  Gk as WebsocketConnectionClosed,
  qk as WebsocketConnectionCreated,
  zk as WebsocketReconnectAttemptStarted,
  yn as ampli,
  Yk as groupIdentify
};
//# sourceMappingURL=index.js.map
